export const categories = [
  {
    _id: '635fed0f2837c5001c268a06',
    published_at: '2022-11-07T11:36:10.135Z',
    slug: 'air-conditioner',
    bannerSection: {
      _id: '636747cd6f10f9001b2ffd3f',
      title:
        '<p><strong>ซ่อม-ติดตั้ง-ขนย้าย สะดวกครบ</strong><br><strong>จบเรื่องแอร์</strong></p>',
      button: {
        _id: '636747cd6f10f9001b2ffd40',
        title: 'จองบริการ',
        url: 'https://fix.24x.co.th/air-conditioner/booking',
        __v: 0,
        id: '636747cd6f10f9001b2ffd40',
      },
      __v: 1,
      image: {
        _id: '6367d9b26f10f9001b2ffd9f',
        name: '24FIX_LD_BANNER-03.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_03_358bfd9322',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 629,
        width: 6001,
        height: 2634,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_03_358bfd9322.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER-03.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_03_358bfd9322',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 108,
            size: 4.27,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_03_358bfd9322.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER-03.jpg',
            hash: 'large_24_FIX_LD_BANNER_03_358bfd9322',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 439,
            size: 29.14,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_03_358bfd9322.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER-03.jpg',
            hash: 'medium_24_FIX_LD_BANNER_03_358bfd9322',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 329,
            size: 19.14,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_03_358bfd9322.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER-03.jpg',
            hash: 'small_24_FIX_LD_BANNER_03_358bfd9322',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 219,
            size: 11.17,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_03_358bfd9322.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-11-06T15:58:42.427Z',
        updatedAt: '2022-11-06T16:42:58.599Z',
        __v: 0,
        id: '6367d9b26f10f9001b2ffd9f',
      },
      mobileImage: {
        _id: '6367d9c96f10f9001b2ffda0',
        name: '24FIX_LD_BANNER_MOBILE-03.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_MOBILE_03_ab4bc2533c',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 79.36,
        width: 1501,
        height: 930,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_MOBILE_03_ab4bc2533c.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER_MOBILE-03.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_MOBILE_03_ab4bc2533c',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 152,
            size: 5.82,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_MOBILE_03_ab4bc2533c.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER_MOBILE-03.jpg',
            hash: 'large_24_FIX_LD_BANNER_MOBILE_03_ab4bc2533c',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 620,
            size: 43.56,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_MOBILE_03_ab4bc2533c.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER_MOBILE-03.jpg',
            hash: 'medium_24_FIX_LD_BANNER_MOBILE_03_ab4bc2533c',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 465,
            size: 27.68,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_MOBILE_03_ab4bc2533c.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER_MOBILE-03.jpg',
            hash: 'small_24_FIX_LD_BANNER_MOBILE_03_ab4bc2533c',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 310,
            size: 16.03,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_MOBILE_03_ab4bc2533c.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-11-06T15:59:05.317Z',
        updatedAt: '2022-11-06T16:42:58.599Z',
        __v: 0,
        id: '6367d9c96f10f9001b2ffda0',
      },
      id: '636747cd6f10f9001b2ffd3f',
    },
    uspSection: [
      {
        _id: '636747cd6f10f9001b2ffd43',
        __v: 0,
        description:
          '<p><strong>ทำไมต้องจองกับ 24FIX?</strong></p><ul><li>มีบริการหลังการขายและรับประกันสูงสุด 60 วัน</li><li>ทีมช่างเข้าตรวจหน้างานก่อนให้บริการภายใน 1 วัน</li><li>ราคางานซ่อมที่ได้มาตรฐาน คุ้มค่ากับคุณภาพบริการ</li></ul>',
        subTitle:
          'หมดปัญหาเรื่องจุกจิก ให้คุณมั่นใจเรื่องซ่อมแอร์ พร้อมหมดห่วงเรื่องติดตั้ง-ขนย้าย เราดูแลให้บริการด้วยมาตรฐานเพื่อให้แอร์ของคุณมีประสิทธภาพตลอดการใช้งาน',
        title: 'ซ่อม-ติดตั้ง-ขนย้าย สะดวกครบจบเรื่องแอร์',
        image: {
          _id: '6367d9fc6f10f9001b2ffda1',
          name: 'Service_Desktop-03.jpg',
          alternativeText: '',
          caption: '',
          hash: 'Service_Desktop_03_90e1fe0011',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 329.04,
          width: 2122,
          height: 1425,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/Service_Desktop_03_90e1fe0011.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_Service_Desktop-03.jpg',
              hash: 'thumbnail_Service_Desktop_03_90e1fe0011',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 232,
              height: 156,
              size: 9.62,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_Service_Desktop_03_90e1fe0011.jpg',
            },
            large: {
              name: 'large_Service_Desktop-03.jpg',
              hash: 'large_Service_Desktop_03_90e1fe0011',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 1000,
              height: 672,
              size: 94.67,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/large_Service_Desktop_03_90e1fe0011.jpg',
            },
            medium: {
              name: 'medium_Service_Desktop-03.jpg',
              hash: 'medium_Service_Desktop_03_90e1fe0011',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 504,
              size: 60.12,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_Service_Desktop_03_90e1fe0011.jpg',
            },
            small: {
              name: 'small_Service_Desktop-03.jpg',
              hash: 'small_Service_Desktop_03_90e1fe0011',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 336,
              size: 30.68,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_Service_Desktop_03_90e1fe0011.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-11-06T15:59:56.522Z',
          updatedAt: '2022-11-06T16:42:58.599Z',
          __v: 0,
          id: '6367d9fc6f10f9001b2ffda1',
        },
        id: '636747cd6f10f9001b2ffd43',
      },
    ],
    faqSection: [
      {
        _id: '635fedf42837c5001c268a1d',
        question: 'ทำไมถึงต้องมีการสำรวจหน้างาน',
        answer:
          '<p>การสำรวจหน้างาน จะสามารถทำให้เราได้ร่วมวางแผนกับคุณลูกค้า เพื่อให้รายละเอียดงานครบถ้วนและอยู่ในงบประมาณที่ได้ตกลงกันไว้</p>',
        __v: 0,
        id: '635fedf42837c5001c268a1d',
      },
      {
        _id: '635fedf42837c5001c268a1e',
        question: 'บริการอะไรบ้างที่ต้องมีการสำรวจหน้างานก่อน',
        answer:
          '<p>งานซ่อมทุกประเภท เราจะแนะนำให้ตรวจหน้างานก่อน เพื่อป้องกันการผิดพลาดในการเตรียมอุปกรณ์ และการประเมิณราคา</p>',
        __v: 0,
        id: '635fedf42837c5001c268a1e',
      },
      {
        _id: '635fedf42837c5001c268a1f',
        question: 'ค่าใช้จ่ายในการสำรวจ นำมาเป็นส่วนลดได้ไหม',
        answer: '<p>ค่าสำรวจสามารถนำไปลดได้ต่อเมื่อยอดงานบริการ มากกว่า 3,000 บาทขึ้นไป</p>',
        __v: 0,
        id: '635fedf42837c5001c268a1f',
      },
      {
        _id: '635fedf42837c5001c268a20',
        answer:
          '<p>ปัจจัยที่มีผลต่อราคาค่าบริการ มีดังนี้ครับ</p><ul><li>ขนาด BTU ของแอร์</li><li>ข้อจำกัด สถานที่หน้างาน (ความสูงของแอร์)</li><li>ความเสียหายของหน้างาน</li></ul>',
        question: 'ปัจจัยที่มีผลต่อราคาค่าบริการ',
        __v: 0,
        id: '635fedf42837c5001c268a20',
      },
      {
        _id: '635fedf42837c5001c268a21',
        answer:
          '<p>การรับประกันงานผลงาน 60 วัน หลังจากการให้บริการ ทางบริษัทจะรับประกันผลงานที่เกิดจากการติดตั้ง (หลุดร่วง, ไม่เย็น, น้ำหยดหรือมีกลิ่นเหม็น) ตามขอบเขตการให้บริการในเอกสารเสนอราคาเท่านั้น</p>',
        question: 'มีการรับประกันอย่างไร',
        __v: 0,
        id: '635fedf42837c5001c268a21',
      },
      {
        _id: '635fedf42837c5001c268a22',
        question: 'พื้นที่ที่ให้บริการมีอะไรบ้าง',
        answer: '<p>พื้นที่ให้บริการครอบคลุมในเขตกรุงเทพมหานคร นนทบุรี ปทุมธานี และสมุทรปราการ</p>',
        __v: 0,
        id: '635fedf42837c5001c268a22',
      },
      {
        _id: '635fedf42837c5001c268a23',
        question: 'แอร์ไม่เย็นเกิดจากอะไร',
        answer:
          '<p>แอร์ไม่เย็นเกิดได้จากหลายสาเหตุ ซึ่งสาเหตุส่วนใหญ่จะเกิดจากการไม่ล้างแอร์ เนื่องจากสิ่งสกปรกสะสมโดยเฉพาะฝุ่นต่าง ๆ &nbsp;ซึ่งสามารถเป็นแหล่งรวมของเชื้อโรค เมื่อเข้าไปอุดตันในไส้กรองอากาศของเครื่องแอร์ในห้อง และที่คอมเพรสเซอร์แอร์ด้านนอกจนทำให้แอร์ระบายความร้อนได้ไม่ดีพอ และไม่สามารถทำความเย็นได้ตามต้องการ วิธีแก้ไข้ที่ทาง 24Fix แนะนำคือให้ล้างแอร์ตามกำหนดเป็นประจำ เช่น ทุกๆ 4 – 6 เดือน</p>',
        __v: 0,
        id: '635fedf42837c5001c268a23',
      },
      {
        _id: '635fedf42837c5001c268a24',
        question: 'คิวเรียกช่างเร็วสุดเมื่อไหร่',
        answer: '<p>1 วันนับจากวันที่ลูกค้าชำระค่าบริการ</p>',
        __v: 0,
        id: '635fedf42837c5001c268a24',
      },
      {
        _id: '635fedf42837c5001c268a25',
        question: 'เรียกบริการผ่านเว็บไซต์ดีอย่างไร',
        answer:
          '<p>ลูกค้าสามารถติดตามสถานะงานผ่านทางเว็บไซต์ได้ตลอดเวลา และยังสามารถใช้โค้ดส่วนลดสำหรับลูกค้าที่ซื้อผ่านบนเว็บไซต์อีกด้วย</p>',
        __v: 0,
        id: '635fedf42837c5001c268a25',
      },
      {
        _id: '635fedf42837c5001c268a26',
        question: 'ใบเสนอราคาจะได้เมื่อไหร่ หลังจากที่ช่างเข้าสำรวจหน้างานเรียบร้อยแล้ว',
        answer:
          '<p>ใบเสนอราคาจะถูกส่งให้ลูกค้าตรวจสอบ ภายใน 24 ชม. หลังจากวันที่ช่างเข้าตรวจหน้างาน</p>',
        __v: 0,
        id: '635fedf42837c5001c268a26',
      },
    ],
    promotionSection: {
      _id: '6367414f6f10f9001b2ffb9a',
      title: 'โปรโมชั่น',
      promotions: [
        {
          _id: '6367414f6f10f9001b2ffb9b',
          url: 'https://fix.24x.co.th/voucher/firstfix-1',
          __v: 0,
          image: {
            _id: '637614b137fd76001b532030',
            name: '24FIX_NOV_BANNER4-02 (1).jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 94.2,
            width: 1500,
            height: 490,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 245,
                height: 80,
                size: 6.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              large: {
                name: 'large_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 327,
                size: 50.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              medium: {
                name: 'medium_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 245,
                size: 32.89,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              small: {
                name: 'small_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 163,
                size: 18.03,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
            },
            provider: 'aws-s3',
            related: ['636a17dc1e519e001c14731c'],
            createdAt: '2022-11-17T11:02:09.052Z',
            updatedAt: '2022-11-21T05:30:58.272Z',
            __v: 0,
            id: '637614b137fd76001b532030',
          },
          mobileImage: {
            _id: '636a6d86e6895d001ce68cc3',
            name: '24FIX_NOV_BANNER1-01.jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_1_01_3663796871',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 149.63,
            width: 1500,
            height: 1021,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_1_01_3663796871.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24FIX_NOV_BANNER1-01.jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 229,
                height: 156,
                size: 8.94,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              large: {
                name: 'large_24FIX_NOV_BANNER1-01.jpg',
                hash: 'large_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 681,
                size: 78.97,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              medium: {
                name: 'medium_24FIX_NOV_BANNER1-01.jpg',
                hash: 'medium_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 511,
                size: 51.21,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              small: {
                name: 'small_24FIX_NOV_BANNER1-01.jpg',
                hash: 'small_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 340,
                size: 27.91,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
            },
            provider: 'aws-s3',
            related: [],
            createdAt: '2022-11-08T14:53:58.508Z',
            updatedAt: '2022-11-08T16:06:16.745Z',
            __v: 0,
            id: '636a6d86e6895d001ce68cc3',
          },
          id: '6367414f6f10f9001b2ffb9b',
        },
      ],
      __v: 1,
      button: null,
      id: '6367414f6f10f9001b2ffb9a',
    },
    stepSection: null,
    successStorySection: {
      contents: [
        {
          relatedArticles: [],
          categories: ['62a768dbe9dde5001b3c6b0d'],
          _id: '636a372d1e519e001c14737a',
          published_at: '2022-11-08T11:02:16.014Z',
          slug: '3-1-air',
          shortDescription:
            'ใช้แอร์มานาน ไม่ได้ฤกษ์ล้างสักที ใช้ไปสักพักอาการแอร์เริ่มส่อความผิดปกติ Home check up ครั้งนี้ ช่างอุ่นใจมาพร้อม 3 สัญญาณเตือน ให้คุณลูกค้าได้ตรวจสอบว่าอาการของแอร์แบบไหนที่เริ่มส่งสัญญาณน่ากังวล จะมีอะไรบ้างไปอ่านพร้อมกันได้เลยครับ ​',
          title: '3 สัญญาณเตือนสำคัญ ถึงเวลาต้องล้างแอร์',
          contents: [
            {
              __component: 'article.images',
              id: '636a372d1e519e001c14737b',
            },
            {
              __component: 'article.content',
              id: '636a372d1e519e001c14737c',
            },
            {
              __component: 'article.images',
              id: '636a372d1e519e001c14737d',
            },
            {
              __component: 'article.content',
              id: '636a372d1e519e001c14737e',
            },
            {
              __component: 'article.images',
              id: '636a372d1e519e001c14737f',
            },
            {
              __component: 'article.content',
              id: '636a372d1e519e001c147380',
            },
            {
              __component: 'article.images',
              id: '636a372d1e519e001c147381',
            },
            {
              __component: 'article.content',
              id: '636a372d1e519e001c147382',
            },
            {
              __component: 'article.content',
              id: '636a372d1e519e001c147383',
            },
          ],
          link: null,
          createdAt: '2022-11-08T11:02:05.362Z',
          updatedAt: '2022-12-21T03:52:19.946Z',
          __v: 1,
          coverImage: {
            _id: '636def55d42554001c0d0260',
            name: '0adaf0ae-a07b-4d42-8ebe-00df1eeb1670.jpeg',
            alternativeText: '',
            caption: '',
            hash: '0adaf0ae_a07b_4d42_8ebe_00df1eeb1670_2366fa1f16',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 30.99,
            width: 471,
            height: 314,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/0adaf0ae_a07b_4d42_8ebe_00df1eeb1670_2366fa1f16.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_0adaf0ae-a07b-4d42-8ebe-00df1eeb1670.jpeg',
                hash: 'thumbnail_0adaf0ae_a07b_4d42_8ebe_00df1eeb1670_2366fa1f16',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 7.87,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_0adaf0ae_a07b_4d42_8ebe_00df1eeb1670_2366fa1f16.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['636a372d1e519e001c14737a'],
            createdAt: '2022-11-11T06:44:37.606Z',
            updatedAt: '2022-11-11T06:44:58.339Z',
            __v: 0,
            id: '636def55d42554001c0d0260',
          },
          metadata: '63a282f3c091d3001c2ea6f4',
          id: '636a372d1e519e001c14737a',
        },
        {
          relatedArticles: ['60fef2feea7297001be8c5f3'],
          categories: ['60d1fe825749bf001bbb11e4', '62a76933e9dde5001b3c6b15'],
          _id: '60fef555ea7297001be8c617',
          published_at: '2021-07-26T17:58:58.311Z',
          slug: 'ac-with-installation',
          shortDescription:
            '#ซื้อแอร์วันนี้แถมฟรีติดตั้ง\n\n☀ ถ้าจะบอกว่าเมืองไทย ‘อากาศร้อน’ เฉพาะในช่วงหน้าร้อนก็คงจะไม่ถูก เพราะไม่ว่าฤดูไหนๆ จะร้อน หนาว ฝน อากาศก็ร้อนอยู่ดี!\nวันนี้มาดับร้อนกันดีกว่า ❄ ด้วยบริการซื้อแอร์พร้อมติดตั้งฟรี โดยทีมช่างมืออาชีพ 24 FIX 😊',
          title: 'บริการซื้อแอร์พร้อมติดตั้ง',
          contents: [
            {
              __component: 'article.content',
              id: '60fef7daea7297001be8c649',
            },
            {
              __component: 'article.images',
              id: '60fef7daea7297001be8c64a',
            },
          ],
          link: null,
          createdAt: '2021-07-26T17:48:05.531Z',
          updatedAt: '2022-07-13T05:50:55.237Z',
          __v: 0,
          views: 1124,
          coverImage: {
            _id: '60fef76eea7297001be8c634',
            name: '117956473_738009603440532_2359157732673622296_n.jpeg',
            alternativeText: '',
            caption: '',
            hash: '117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 253.58,
            width: 1801,
            height: 1201,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'thumbnail_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 8.33,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              large: {
                name: 'large_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'large_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 1000,
                height: 667,
                size: 83.31,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              medium: {
                name: 'medium_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'medium_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 750,
                height: 500,
                size: 50.16,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              small: {
                name: 'small_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'small_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 26.25,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['60fef555ea7297001be8c617'],
            createdAt: '2021-07-26T17:57:02.195Z',
            updatedAt: '2021-07-30T03:43:47.943Z',
            __v: 0,
            id: '60fef76eea7297001be8c634',
          },
          metadata: null,
          id: '60fef555ea7297001be8c617',
        },
        {
          relatedArticles: [],
          categories: [
            '60d1fe825749bf001bbb11e4',
            '62a76933e9dde5001b3c6b15',
            '62de67ecb31a7a001bba2d60',
          ],
          _id: '60fef2feea7297001be8c5f3',
          title: 'รีวิวผลงานจริง ล้างแอร์บ้านคุณเมย์ รัชนก อินทนนท์',
          slug: 'pro-may-onsite-review',
          shortDescription:
            'เพราะประเทศไทยมีแต่ฤดูร้อน ร้อนมาก และร้อนที่สุด! ดังนั้นการดูแล ทำความสะอาด ล้างแอร์ ก็ควรทำอย่างสม่ำเสมอนะ\n#งานล้างแอร์ #ล้างแอร์ฆ่าเชื้อ #เมย์ รัชนก อินทนนท์ #แอร์ไม่เย็น #ตรวจสภาพแอร์ #ล้างแอร์ #ซ่อมแอร์ ',
          views: 3549,
          published_at: '2021-07-26T17:38:13.448Z',
          contents: [
            {
              __component: 'article.content',
              id: '60fef2feea7297001be8c5f4',
            },
            {
              __component: 'article.images',
              id: '60fef2feea7297001be8c5f5',
            },
            {
              __component: 'article.content',
              id: '60fef2feea7297001be8c5f6',
            },
            {
              __component: 'article.images',
              id: '60fef2feea7297001be8c5f7',
            },
            {
              __component: 'article.content',
              id: '62cd0500df69b2001b4a8f1a',
            },
            {
              __component: 'article.images',
              id: '62cd0687df69b2001b4a8f39',
            },
            {
              __component: 'article.content',
              id: '62cd0687df69b2001b4a8f3a',
            },
            {
              __component: 'article.images',
              id: '62cd0687df69b2001b4a8f3b',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fbc',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fbd',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fbe',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fbf',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc0',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc1',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc2',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc3',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc4',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc5',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc6',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc7',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc8',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc9',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fca',
            },
          ],
          link: null,
          createdAt: '2021-07-26T17:38:06.604Z',
          updatedAt: '2022-07-25T10:08:01.825Z',
          __v: 2,
          coverImage: {
            _id: '60feef59ea7297001be8c5ed',
            name: '20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
            alternativeText: '',
            caption: '',
            hash: '20210510_On_site_Review_Artboard_v2_e9212db564',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 657.65,
            width: 2501,
            height: 1667,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'thumbnail_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 12.97,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              large: {
                name: 'large_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'large_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 1000,
                height: 667,
                size: 146.8,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              medium: {
                name: 'medium_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'medium_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 750,
                height: 500,
                size: 92.52,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              small: {
                name: 'small_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'small_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 46.42,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['60fef2feea7297001be8c5f3'],
            createdAt: '2021-07-26T17:22:33.885Z',
            updatedAt: '2021-07-30T03:43:47.943Z',
            __v: 0,
            id: '60feef59ea7297001be8c5ed',
          },
          metadata: null,
          id: '60fef2feea7297001be8c5f3',
        },
      ],
      _id: '6368eda41e519e001c146ec7',
      title: 'ผลงานของเรา',
      __v: 0,
      button: null,
      id: '6368eda41e519e001c146ec7',
    },
    reviewSection: {
      _id: '635fed0f2837c5001c268a07',
      title: 'รีวิวจากผู้ใช้บริการของเรา',
      reviewContent: [
        {
          image: [
            {
              _id: '636733786f10f9001b2ff956',
              name: 'rn_image_picker_lib_temp_2abc3149_6028_4f1c_b83f_4203b026d0e6_5f9099b133.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_2abc3149_6028_4f1c_b83f_4203b026d0e6_5f9099b133_b60ce9ecfb',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 35.3,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_2abc3149_6028_4f1c_b83f_4203b026d0e6_5f9099b133_b60ce9ecfb.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_2abc3149_6028_4f1c_b83f_4203b026d0e6_5f9099b133.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_2abc3149_6028_4f1c_b83f_4203b026d0e6_5f9099b133_b60ce9ecfb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.06,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_2abc3149_6028_4f1c_b83f_4203b026d0e6_5f9099b133_b60ce9ecfb.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_2abc3149_6028_4f1c_b83f_4203b026d0e6_5f9099b133.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_2abc3149_6028_4f1c_b83f_4203b026d0e6_5f9099b133_b60ce9ecfb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 32.13,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_2abc3149_6028_4f1c_b83f_4203b026d0e6_5f9099b133_b60ce9ecfb.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_2abc3149_6028_4f1c_b83f_4203b026d0e6_5f9099b133.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_2abc3149_6028_4f1c_b83f_4203b026d0e6_5f9099b133_b60ce9ecfb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 16.67,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_2abc3149_6028_4f1c_b83f_4203b026d0e6_5f9099b133_b60ce9ecfb.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:09:28.717Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636733786f10f9001b2ff956',
            },
            {
              _id: '636733786f10f9001b2ff957',
              name: 'rn_image_picker_lib_temp_1fb79d69_0eef_4dda_9faf_9001f3415956_3353cd5a97.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_1fb79d69_0eef_4dda_9faf_9001f3415956_3353cd5a97_2060b471e1',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 37.27,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_1fb79d69_0eef_4dda_9faf_9001f3415956_3353cd5a97_2060b471e1.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_1fb79d69_0eef_4dda_9faf_9001f3415956_3353cd5a97.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_1fb79d69_0eef_4dda_9faf_9001f3415956_3353cd5a97_2060b471e1',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.25,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_1fb79d69_0eef_4dda_9faf_9001f3415956_3353cd5a97_2060b471e1.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_1fb79d69_0eef_4dda_9faf_9001f3415956_3353cd5a97.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_1fb79d69_0eef_4dda_9faf_9001f3415956_3353cd5a97_2060b471e1',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 33.83,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_1fb79d69_0eef_4dda_9faf_9001f3415956_3353cd5a97_2060b471e1.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_1fb79d69_0eef_4dda_9faf_9001f3415956_3353cd5a97.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_1fb79d69_0eef_4dda_9faf_9001f3415956_3353cd5a97_2060b471e1',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 17.95,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_1fb79d69_0eef_4dda_9faf_9001f3415956_3353cd5a97_2060b471e1.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:09:28.760Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636733786f10f9001b2ff957',
            },
          ],
          _id: '635fed0f2837c5001c268a09',
          name: 'ขวัญxxxxxx',
          description: 'แอร์ที่คอนโดในห้องมีปัญหา เรียกช่างจาก 24 FIX ไปซ่อมให้ เรียบร้อยดีค่ะ ',
          score: 5,
          __v: 0,
          id: '635fed0f2837c5001c268a09',
        },
        {
          image: [
            {
              _id: '636733936f10f9001b2ff958',
              name: 'rn_image_picker_lib_temp_ff30921d_53cb_46ae_a2e9_b0b7d6a66dbd_51a62250bf.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_ff30921d_53cb_46ae_a2e9_b0b7d6a66dbd_51a62250bf_55d29251c0',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 42.39,
              width: 602,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_ff30921d_53cb_46ae_a2e9_b0b7d6a66dbd_51a62250bf_55d29251c0.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_ff30921d_53cb_46ae_a2e9_b0b7d6a66dbd_51a62250bf.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_ff30921d_53cb_46ae_a2e9_b0b7d6a66dbd_51a62250bf_55d29251c0',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.63,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_ff30921d_53cb_46ae_a2e9_b0b7d6a66dbd_51a62250bf_55d29251c0.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_ff30921d_53cb_46ae_a2e9_b0b7d6a66dbd_51a62250bf.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_ff30921d_53cb_46ae_a2e9_b0b7d6a66dbd_51a62250bf_55d29251c0',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 564,
                  height: 750,
                  size: 38.34,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_ff30921d_53cb_46ae_a2e9_b0b7d6a66dbd_51a62250bf_55d29251c0.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_ff30921d_53cb_46ae_a2e9_b0b7d6a66dbd_51a62250bf.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_ff30921d_53cb_46ae_a2e9_b0b7d6a66dbd_51a62250bf_55d29251c0',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 376,
                  height: 500,
                  size: 20.21,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_ff30921d_53cb_46ae_a2e9_b0b7d6a66dbd_51a62250bf_55d29251c0.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:09:55.592Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636733936f10f9001b2ff958',
            },
            {
              _id: '636733936f10f9001b2ff959',
              name: 'rn_image_picker_lib_temp_8aefe3dd_4850_4e2b_8cbe_4cc2f3b7336e_2b98f56b4c.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_8aefe3dd_4850_4e2b_8cbe_4cc2f3b7336e_2b98f56b4c_963f6444c9',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 56.43,
              width: 602,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_8aefe3dd_4850_4e2b_8cbe_4cc2f3b7336e_2b98f56b4c_963f6444c9.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_8aefe3dd_4850_4e2b_8cbe_4cc2f3b7336e_2b98f56b4c.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_8aefe3dd_4850_4e2b_8cbe_4cc2f3b7336e_2b98f56b4c_963f6444c9',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 4.87,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_8aefe3dd_4850_4e2b_8cbe_4cc2f3b7336e_2b98f56b4c_963f6444c9.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_8aefe3dd_4850_4e2b_8cbe_4cc2f3b7336e_2b98f56b4c.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_8aefe3dd_4850_4e2b_8cbe_4cc2f3b7336e_2b98f56b4c_963f6444c9',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 564,
                  height: 750,
                  size: 51.66,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_8aefe3dd_4850_4e2b_8cbe_4cc2f3b7336e_2b98f56b4c_963f6444c9.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_8aefe3dd_4850_4e2b_8cbe_4cc2f3b7336e_2b98f56b4c.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_8aefe3dd_4850_4e2b_8cbe_4cc2f3b7336e_2b98f56b4c_963f6444c9',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 376,
                  height: 500,
                  size: 28.06,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_8aefe3dd_4850_4e2b_8cbe_4cc2f3b7336e_2b98f56b4c_963f6444c9.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:09:55.635Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636733936f10f9001b2ff959',
            },
          ],
          _id: '635fed0f2837c5001c268a0a',
          name: 'ชนxxxxxx',
          description: 'แก้ไขได้เรียบร้อยดี แอร์กลับมาใช้งานได้ปกติครับ ',
          score: 5,
          __v: 0,
          id: '635fed0f2837c5001c268a0a',
        },
        {
          image: [
            {
              _id: '636733ae6f10f9001b2ff95a',
              name: 'rn_image_picker_lib_temp_5b8793cb_6367_42b0_b848_8df5574c54f0_7b50a4d10d.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_5b8793cb_6367_42b0_b848_8df5574c54f0_7b50a4d10d_c8b5d75a9f',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 39.54,
              width: 602,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_5b8793cb_6367_42b0_b848_8df5574c54f0_7b50a4d10d_c8b5d75a9f.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_5b8793cb_6367_42b0_b848_8df5574c54f0_7b50a4d10d.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_5b8793cb_6367_42b0_b848_8df5574c54f0_7b50a4d10d_c8b5d75a9f',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.05,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_5b8793cb_6367_42b0_b848_8df5574c54f0_7b50a4d10d_c8b5d75a9f.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_5b8793cb_6367_42b0_b848_8df5574c54f0_7b50a4d10d.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_5b8793cb_6367_42b0_b848_8df5574c54f0_7b50a4d10d_c8b5d75a9f',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 564,
                  height: 750,
                  size: 35.92,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_5b8793cb_6367_42b0_b848_8df5574c54f0_7b50a4d10d_c8b5d75a9f.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_5b8793cb_6367_42b0_b848_8df5574c54f0_7b50a4d10d.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_5b8793cb_6367_42b0_b848_8df5574c54f0_7b50a4d10d_c8b5d75a9f',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 376,
                  height: 500,
                  size: 18.53,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_5b8793cb_6367_42b0_b848_8df5574c54f0_7b50a4d10d_c8b5d75a9f.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:10:22.536Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636733ae6f10f9001b2ff95a',
            },
            {
              _id: '636733ae6f10f9001b2ff95b',
              name: 'rn_image_picker_lib_temp_668e7a6f_37db_4bef_9588_caab1f9dbd9d_78f80e9f75.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_668e7a6f_37db_4bef_9588_caab1f9dbd9d_78f80e9f75_4f6a2bf1c9',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 32.56,
              width: 602,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_668e7a6f_37db_4bef_9588_caab1f9dbd9d_78f80e9f75_4f6a2bf1c9.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_668e7a6f_37db_4bef_9588_caab1f9dbd9d_78f80e9f75.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_668e7a6f_37db_4bef_9588_caab1f9dbd9d_78f80e9f75_4f6a2bf1c9',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.09,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_668e7a6f_37db_4bef_9588_caab1f9dbd9d_78f80e9f75_4f6a2bf1c9.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_668e7a6f_37db_4bef_9588_caab1f9dbd9d_78f80e9f75.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_668e7a6f_37db_4bef_9588_caab1f9dbd9d_78f80e9f75_4f6a2bf1c9',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 564,
                  height: 750,
                  size: 29.88,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_668e7a6f_37db_4bef_9588_caab1f9dbd9d_78f80e9f75_4f6a2bf1c9.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_668e7a6f_37db_4bef_9588_caab1f9dbd9d_78f80e9f75.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_668e7a6f_37db_4bef_9588_caab1f9dbd9d_78f80e9f75_4f6a2bf1c9',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 376,
                  height: 500,
                  size: 16.02,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_668e7a6f_37db_4bef_9588_caab1f9dbd9d_78f80e9f75_4f6a2bf1c9.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:10:22.571Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636733ae6f10f9001b2ff95b',
            },
          ],
          _id: '635fed0f2837c5001c268a0c',
          name: 'เตxxxxx',
          description:
            'ใช้บริการช่างจากที่นี่ให้มาซ่อมแอร์ที่บ้านครับ เจ้าหน้าที่ตอบค่อนข้างไว ช่างสุภาพ เรียบร้อยให้บริการงานดีครับ',
          score: 5,
          __v: 0,
          id: '635fed0f2837c5001c268a0c',
        },
        {
          image: [
            {
              _id: '636733c96f10f9001b2ff95c',
              name: 'rn_image_picker_lib_temp_8e30787b_291a_4de4_a7c8_00ab3a875572_cc63ef832b.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_8e30787b_291a_4de4_a7c8_00ab3a875572_cc63ef832b_8c839345ee',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 51.06,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_8e30787b_291a_4de4_a7c8_00ab3a875572_cc63ef832b_8c839345ee.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_8e30787b_291a_4de4_a7c8_00ab3a875572_cc63ef832b.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_8e30787b_291a_4de4_a7c8_00ab3a875572_cc63ef832b_8c839345ee',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.72,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_8e30787b_291a_4de4_a7c8_00ab3a875572_cc63ef832b_8c839345ee.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_8e30787b_291a_4de4_a7c8_00ab3a875572_cc63ef832b.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_8e30787b_291a_4de4_a7c8_00ab3a875572_cc63ef832b_8c839345ee',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 46.27,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_8e30787b_291a_4de4_a7c8_00ab3a875572_cc63ef832b_8c839345ee.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_8e30787b_291a_4de4_a7c8_00ab3a875572_cc63ef832b.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_8e30787b_291a_4de4_a7c8_00ab3a875572_cc63ef832b_8c839345ee',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 23.65,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_8e30787b_291a_4de4_a7c8_00ab3a875572_cc63ef832b_8c839345ee.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:10:49.276Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636733c96f10f9001b2ff95c',
            },
            {
              _id: '636733c96f10f9001b2ff95d',
              name: 'rn_image_picker_lib_temp_8dde4002_91bd_4199_aa1a_a1de61ebd8a2_a9222c2427.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_8dde4002_91bd_4199_aa1a_a1de61ebd8a2_a9222c2427_8562611116',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 74.73,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_8dde4002_91bd_4199_aa1a_a1de61ebd8a2_a9222c2427_8562611116.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_8dde4002_91bd_4199_aa1a_a1de61ebd8a2_a9222c2427.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_8dde4002_91bd_4199_aa1a_a1de61ebd8a2_a9222c2427_8562611116',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 5,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_8dde4002_91bd_4199_aa1a_a1de61ebd8a2_a9222c2427_8562611116.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_8dde4002_91bd_4199_aa1a_a1de61ebd8a2_a9222c2427.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_8dde4002_91bd_4199_aa1a_a1de61ebd8a2_a9222c2427_8562611116',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 66.86,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_8dde4002_91bd_4199_aa1a_a1de61ebd8a2_a9222c2427_8562611116.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_8dde4002_91bd_4199_aa1a_a1de61ebd8a2_a9222c2427.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_8dde4002_91bd_4199_aa1a_a1de61ebd8a2_a9222c2427_8562611116',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 33.25,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_8dde4002_91bd_4199_aa1a_a1de61ebd8a2_a9222c2427_8562611116.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:10:49.300Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636733c96f10f9001b2ff95d',
            },
          ],
          _id: '635fed0f2837c5001c268a0f',
          name: 'พชรxxxx',
          description:
            'เจ้าหน้าให้บริการค่อนข้างไวครับ ทำงานได้เรียบร้อยดี ส่วนช่างก็ให้เก็บงานเรียบร้อยครับ ',
          score: 3,
          __v: 0,
          id: '635fed0f2837c5001c268a0f',
        },
        {
          image: [
            {
              _id: '636733e46f10f9001b2ff95e',
              name: 'rn_image_picker_lib_temp_4303e946_03ac_43e6_9cc0_cce200905d9a_7783457c26.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_4303e946_03ac_43e6_9cc0_cce200905d9a_7783457c26_cec04c4651',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 39.28,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_4303e946_03ac_43e6_9cc0_cce200905d9a_7783457c26_cec04c4651.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_4303e946_03ac_43e6_9cc0_cce200905d9a_7783457c26.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_4303e946_03ac_43e6_9cc0_cce200905d9a_7783457c26_cec04c4651',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.64,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_4303e946_03ac_43e6_9cc0_cce200905d9a_7783457c26_cec04c4651.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_4303e946_03ac_43e6_9cc0_cce200905d9a_7783457c26.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_4303e946_03ac_43e6_9cc0_cce200905d9a_7783457c26_cec04c4651',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 35.77,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_4303e946_03ac_43e6_9cc0_cce200905d9a_7783457c26_cec04c4651.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_4303e946_03ac_43e6_9cc0_cce200905d9a_7783457c26.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_4303e946_03ac_43e6_9cc0_cce200905d9a_7783457c26_cec04c4651',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 19.23,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_4303e946_03ac_43e6_9cc0_cce200905d9a_7783457c26_cec04c4651.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:11:16.123Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636733e46f10f9001b2ff95e',
            },
            {
              _id: '636733e46f10f9001b2ff95f',
              name: 'rn_image_picker_lib_temp_16336223_a6e4_45df_893b_ff25296d37e5_8d3864181c.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_16336223_a6e4_45df_893b_ff25296d37e5_8d3864181c_cb356ed1eb',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 26.36,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_16336223_a6e4_45df_893b_ff25296d37e5_8d3864181c_cb356ed1eb.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_16336223_a6e4_45df_893b_ff25296d37e5_8d3864181c.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_16336223_a6e4_45df_893b_ff25296d37e5_8d3864181c_cb356ed1eb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.74,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_16336223_a6e4_45df_893b_ff25296d37e5_8d3864181c_cb356ed1eb.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_16336223_a6e4_45df_893b_ff25296d37e5_8d3864181c.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_16336223_a6e4_45df_893b_ff25296d37e5_8d3864181c_cb356ed1eb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 24.1,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_16336223_a6e4_45df_893b_ff25296d37e5_8d3864181c_cb356ed1eb.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_16336223_a6e4_45df_893b_ff25296d37e5_8d3864181c.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_16336223_a6e4_45df_893b_ff25296d37e5_8d3864181c_cb356ed1eb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 13,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_16336223_a6e4_45df_893b_ff25296d37e5_8d3864181c_cb356ed1eb.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:11:16.181Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636733e46f10f9001b2ff95f',
            },
          ],
          _id: '635fed0f2837c5001c268a10',
          name: 'ยลรxxxx',
          description:
            'ใช้บริการช่างมาซ่อมแอร์ให้ค่ะ เนื่องจากแอร์มีเสียงดังเลยให้เจ้าหน้าที่เข้ามาตรวจสอบดู เจ้าหน้าที่ให้คำปรึกษาแนะนำดีนะคะ คุ้มราคาไม่แพงมากค่ะ ',
          score: 4,
          __v: 0,
          id: '635fed0f2837c5001c268a10',
        },
        {
          image: [
            {
              _id: '636734036f10f9001b2ff960',
              name: 'rn_image_picker_lib_temp_5f6da7b4_a214_427f_8268_3540560237f4_c598141ada.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_5f6da7b4_a214_427f_8268_3540560237f4_c598141ada_038bb541a9',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 44.55,
              width: 602,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_5f6da7b4_a214_427f_8268_3540560237f4_c598141ada_038bb541a9.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_5f6da7b4_a214_427f_8268_3540560237f4_c598141ada.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_5f6da7b4_a214_427f_8268_3540560237f4_c598141ada_038bb541a9',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.96,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_5f6da7b4_a214_427f_8268_3540560237f4_c598141ada_038bb541a9.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_5f6da7b4_a214_427f_8268_3540560237f4_c598141ada.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_5f6da7b4_a214_427f_8268_3540560237f4_c598141ada_038bb541a9',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 564,
                  height: 750,
                  size: 40.43,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_5f6da7b4_a214_427f_8268_3540560237f4_c598141ada_038bb541a9.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_5f6da7b4_a214_427f_8268_3540560237f4_c598141ada.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_5f6da7b4_a214_427f_8268_3540560237f4_c598141ada_038bb541a9',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 376,
                  height: 500,
                  size: 22.15,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_5f6da7b4_a214_427f_8268_3540560237f4_c598141ada_038bb541a9.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:11:47.654Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636734036f10f9001b2ff960',
            },
          ],
          _id: '635fed0f2837c5001c268a11',
          name: 'ไวxxxx',
          description: 'ช่างให้บริการดี เก็บงานเรียบร้อยครับ ',
          score: 5,
          __v: 0,
          id: '635fed0f2837c5001c268a11',
        },
        {
          image: [],
          _id: '635fed0f2837c5001c268a0b',
          name: 'ฐิตาxxxxxx',
          description:
            'ต้องการย้ายแอร์จากที่บ้านเก่าไปยังบ้านใหม่ค่ะ ได้ช่างจากที่นี่เข้าไปดำเนินการย้ายแอร์ให้ นอกจากนี้ยังได้ใช้บริการในการติดตั้งแอร์เพิ่มเติมสำหรับห้องอื่นๆ ด้วยค่ะ ทีมช่างทำงานกันแบบมือโปรมากค่ะ เก็บงานเรียบร้อย ออกมาสวยเลยค่ะ ',
          score: 4,
          __v: 0,
          id: '635fed0f2837c5001c268a0b',
        },
        {
          image: [],
          _id: '635fed0f2837c5001c268a0d',
          name: 'ธนxxxxx',
          description:
            'ที่บ้านต้องการเปลี่ยนแอร์ติดผนังครับ เลยลองค้นหาแล้วมาเจอที่นี่ ใช้บริการดูแล้วทำงานค่อนข้างดีครับ ใช้บริการอีกแน่นอนครับ',
          score: 5,
          __v: 0,
          id: '635fed0f2837c5001c268a0d',
        },
        {
          image: [],
          _id: '635fed0f2837c5001c268a0e',
          name: 'ปรีxxxx',
          description:
            'แอร์เสียใช้งานไม่ได้ เรียกช่างจาก 24 FIX มาช่วยตรวจสอบหน้างาน จนพบปัญหาและช่างเสนอแนวทางแก้ไขให้ แนะนำให้คำปรึกษาดีเลยค่ะ ตอนนี้แอร์กลับมาใช้งานได้ปกติดีแล้วค่ะ ',
          score: 4,
          __v: 0,
          id: '635fed0f2837c5001c268a0e',
        },
        {
          image: [],
          _id: '635fed0f2837c5001c268a08',
          name: 'จักรxxxxxx',
          description:
            'เรียกช่างให้มาติดตั้งแอร์ใหม่ที่บ้านครับ ดูแลระบบติดตั้งเรียบร้อยดี ทำงานค่อนข้างเรียบร้อยครับ ',
          score: 4,
          __v: 0,
          id: '635fed0f2837c5001c268a08',
        },
      ],
      __v: 1,
      id: '635fed0f2837c5001c268a07',
    },
    ctaSection: {
      _id: '636747ce6f10f9001b2ffd5c',
      title: '<p>ซ่อม-ติดตั้ง-ขนย้าย สะดวกครบจบเรื่องแอร์</p>',
      button: {
        _id: '636747ce6f10f9001b2ffd5d',
        url: 'https://fix.24x.co.th/air-conditioner/booking',
        title: 'จองบริการ',
        __v: 0,
        id: '636747ce6f10f9001b2ffd5d',
      },
      __v: 1,
      id: '636747ce6f10f9001b2ffd5c',
    },
    createdAt: '2022-10-31T15:43:11.673Z',
    updatedAt: '2023-01-11T09:45:12.901Z',
    __v: 1,
    metadata: {
      twitterCardType: 'summary',
      _id: '63a27f12c091d3001c2ea671',
      metaTitle: 'ซ่อม ติดตั้ง ขนย้าย สะดวกครบจบเรื่องแอร์',
      metaDescription: 'ต้องการติดแอร์ใหม่หรือย้ายแอร์เก่า ทีมช่างพร้อมให้บริการ',
      keywords: 'ล้างแอร์, ช่างแอร์, ช่างแอร์ใกล้ฉัน,ซ่อมแอร์,ซ่อมแอร์บ้าน',
      __v: 0,
      id: '63a27f12c091d3001c2ea671',
    },
    installationSection: null,
    id: '635fed0f2837c5001c268a06',
  },
  {
    _id: '63863551dda467001cc0c6a8',
    published_at: '2022-11-29T16:52:12.127Z',
    slug: 'washing-machine',
    bannerSection: {
      _id: '63863551dda467001cc0c6a9',
      title:
        '<p><strong>ล้างเครื่องซักผ้าสะอาดปลอดภัยไร้แบคทีเรีย&nbsp;</strong><br><strong>ป้องกันกลิ่นผ้าอับได้ 100%</strong></p>',
      button: {
        _id: '63863551dda467001cc0c6aa',
        title: 'จองบริการ',
        url: 'https://fix.24x.co.th/washing-machine/booking',
        __v: 0,
        id: '63863551dda467001cc0c6aa',
      },
      __v: 1,
      image: {
        _id: '63863416dda467001cc0c6a6',
        name: '24FIX_LD_BANNER-14.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_14_0cb164b9fd',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 576.28,
        width: 6000,
        height: 2633,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_14_0cb164b9fd.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER-14.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_14_0cb164b9fd',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 108,
            size: 5.58,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_14_0cb164b9fd.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER-14.jpg',
            hash: 'large_24_FIX_LD_BANNER_14_0cb164b9fd',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 439,
            size: 40.32,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_14_0cb164b9fd.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER-14.jpg',
            hash: 'medium_24_FIX_LD_BANNER_14_0cb164b9fd',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 329,
            size: 26.34,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_14_0cb164b9fd.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER-14.jpg',
            hash: 'small_24_FIX_LD_BANNER_14_0cb164b9fd',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 219,
            size: 14.95,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_14_0cb164b9fd.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-11-29T16:32:22.719Z',
        updatedAt: '2022-11-30T05:43:07.180Z',
        __v: 0,
        id: '63863416dda467001cc0c6a6',
      },
      mobileImage: {
        _id: '6386342bdda467001cc0c6a7',
        name: '24FIX_LD_BANNER_MOBILE-14.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_MOBILE_14_8ce7f3f40d',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 107.02,
        width: 1500,
        height: 929,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_MOBILE_14_8ce7f3f40d.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER_MOBILE-14.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_MOBILE_14_8ce7f3f40d',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 152,
            size: 7.61,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_MOBILE_14_8ce7f3f40d.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER_MOBILE-14.jpg',
            hash: 'large_24_FIX_LD_BANNER_MOBILE_14_8ce7f3f40d',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 619,
            size: 58.78,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_MOBILE_14_8ce7f3f40d.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER_MOBILE-14.jpg',
            hash: 'medium_24_FIX_LD_BANNER_MOBILE_14_8ce7f3f40d',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 465,
            size: 38.69,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_MOBILE_14_8ce7f3f40d.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER_MOBILE-14.jpg',
            hash: 'small_24_FIX_LD_BANNER_MOBILE_14_8ce7f3f40d',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 310,
            size: 21.39,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_MOBILE_14_8ce7f3f40d.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-11-29T16:32:43.683Z',
        updatedAt: '2022-11-30T05:43:07.180Z',
        __v: 0,
        id: '6386342bdda467001cc0c6a7',
      },
      id: '63863551dda467001cc0c6a9',
    },
    uspSection: [
      {
        _id: '638638b0dda467001cc0c6b8',
        title: 'ล้างเครื่องซักผ้าสะอาดปลอดภัยไร้แบคทีเรีย  ป้องกันกลิ่นผ้าอับได้ 100%',
        subTitle:
          'บริการล้างเครื่องซักผ้า มั่นใจด้วยมาตรฐานความสะอาดจากช่างผู้เชียวชาญ ให้คุณซํกผ้าปลอดภัยไร้แบคทีเรีย',
        description:
          '<p><strong>ทำไมต้องจองกับ 24FIX?</strong></p><ul><li>ทีมช่างเข้าตรวจหน้างานก่อนให้บริการภายใน&nbsp; 1&nbsp; วัน</li><li>มีบริการหลังการขายและรับประกันสูงสุด 30 วัน</li><li>ราคางานซ่อมที่ได้มาตรฐาน คุ้มค่ากับคุณภาพบริการ</li></ul>',
        __v: 0,
        image: {
          _id: '63863607dda467001cc0c6b3',
          name: 'Service_USP-02.jpg',
          alternativeText: '',
          caption: '',
          hash: 'Service_USP_02_ffa6179431',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 31.07,
          width: 509,
          height: 342,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/Service_USP_02_ffa6179431.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_Service_USP-02.jpg',
              hash: 'thumbnail_Service_USP_02_ffa6179431',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 232,
              height: 156,
              size: 9.54,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_Service_USP_02_ffa6179431.jpg',
            },
            small: {
              name: 'small_Service_USP-02.jpg',
              hash: 'small_Service_USP_02_ffa6179431',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 336,
              size: 29.73,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_Service_USP_02_ffa6179431.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-11-29T16:40:39.983Z',
          updatedAt: '2022-11-30T05:43:07.180Z',
          __v: 0,
          id: '63863607dda467001cc0c6b3',
        },
        id: '638638b0dda467001cc0c6b8',
      },
    ],
    faqSection: [
      {
        _id: '638638b0dda467001cc0c6bb',
        question: 'ล้างเครื่องซักผ้า ล้างอย่างไรบ้าง',
        answer: '<p>ถอดและทำความสะอาดกล่องผงซักฟอก น้ำยาปรับผ้านุ่ม และถังซักสแตนเลส</p>',
        __v: 0,
        id: '638638b0dda467001cc0c6bb',
      },
      {
        _id: '638638b0dda467001cc0c6bc',
        question: 'เครื่องซักผ้าควรล้างบ่อยแค่ไหน',
        answer:
          '<p>ควรล้างทุกๆ 4 เดือน เพื่อกำจัดเชื้อโรค คราบผงซักฟอก คราบน้ำยาปรับผ้านุ่ม และสิ่งสกปรกต่างๆ</p>',
        __v: 0,
        id: '638638b0dda467001cc0c6bc',
      },
      {
        _id: '638638b0dda467001cc0c6bd',
        question: 'ยี่ห้อเครื่องซักผ้าที่ทางบริษัทรับบริการล้าง',
        answer:
          '<p>ฝาบนและฝาหน้า</p><ul><li>Electrolux</li><li>LG</li><li>Samsung</li><li>Haier</li><li>Sharp</li><li>Toshiba</li><li>Imarflex</li></ul><p>เฉพาะฝาหน้า&nbsp;</p><ul><li>Hitachi</li></ul>',
        __v: 0,
        id: '638638b0dda467001cc0c6bd',
      },
      {
        _id: '638638b0dda467001cc0c6be',
        question: 'น้ำหนักเครื่องซักผ้าดูตรงไหน',
        answer: '<p>หน้าเครื่องซักผ้ามุมบนซ้าย จะมีเขียนจำนวนกิโลกรัมของเครื่องซักผ้า</p>',
        __v: 0,
        id: '638638b0dda467001cc0c6be',
      },
      {
        _id: '638638b0dda467001cc0c6bf',
        question: 'คิวเข้าบริการได้เร็วสุดเมื่อไหร่',
        answer: '<p>ช่างเข้าบริการได้ในวันถัดไป นับจากวันที่ลูกค้าชำระเงินก่อนเวลา 15.00 น.</p>',
        __v: 0,
        id: '638638b0dda467001cc0c6bf',
      },
      {
        _id: '638638b0dda467001cc0c6c0',
        question: 'ใช้เวลาในการบริการเท่าไหร่',
        answer: '<p>ระยะเวลาดำเนินการโดยประมาณ 3 ชม.</p>',
        __v: 0,
        id: '638638b0dda467001cc0c6c0',
      },
      {
        _id: '638638b0dda467001cc0c6c1',
        question: 'พื้นที่ที่ให้บริการมีอะไรบ้าง',
        answer: '<p>พื้นที่ให้บริการครอบคลุมในเขตกรุงเทพมหานคร นนทบุรี ปทุมธานี และสมุทรปราการ</p>',
        __v: 0,
        id: '638638b0dda467001cc0c6c1',
      },
      {
        _id: '638638b0dda467001cc0c6c2',
        question: 'มีการรับประกันอย่างไร',
        answer: '<p>การรับประกันผลงาน 30 วัน หลังจากการให้บริการ</p>',
        __v: 0,
        id: '638638b0dda467001cc0c6c2',
      },
    ],
    promotionSection: {
      _id: '638638b1dda467001cc0c6cb',
      title: 'โปรโมชั่น',
      promotions: [
        {
          _id: '638638b1dda467001cc0c6cc',
          url: 'https://fix.24x.co.th/voucher/firstfix-1',
          __v: 0,
          image: {
            _id: '63863681dda467001cc0c6b4',
            name: '24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_dee6bb8bb5',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 93.59,
            width: 1500,
            height: 490,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_dee6bb8bb5.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_dee6bb8bb5',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 245,
                height: 80,
                size: 6.03,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_dee6bb8bb5.jpg',
              },
              large: {
                name: 'large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
                hash: 'large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_dee6bb8bb5',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 327,
                size: 49.83,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_dee6bb8bb5.jpg',
              },
              medium: {
                name: 'medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
                hash: 'medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_dee6bb8bb5',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 245,
                size: 32.68,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_dee6bb8bb5.jpg',
              },
              small: {
                name: 'small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
                hash: 'small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_dee6bb8bb5',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 163,
                size: 17.92,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_dee6bb8bb5.jpg',
              },
            },
            provider: 'aws-s3',
            related: [],
            createdAt: '2022-11-29T16:42:41.977Z',
            updatedAt: '2022-11-30T05:43:07.180Z',
            __v: 0,
            id: '63863681dda467001cc0c6b4',
          },
          mobileImage: {
            _id: '63863699dda467001cc0c6b5',
            name: '24_FIX_NOV_BANNER_1_01_3663796871.jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_1_01_3663796871_6bab255394',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 149.12,
            width: 1500,
            height: 1021,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_1_01_3663796871_6bab255394.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_1_01_3663796871_6bab255394',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 229,
                height: 156,
                size: 8.91,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_1_01_3663796871_6bab255394.jpg',
              },
              large: {
                name: 'large_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
                hash: 'large_24_FIX_NOV_BANNER_1_01_3663796871_6bab255394',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 681,
                size: 78.68,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_1_01_3663796871_6bab255394.jpg',
              },
              medium: {
                name: 'medium_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
                hash: 'medium_24_FIX_NOV_BANNER_1_01_3663796871_6bab255394',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 511,
                size: 50.95,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_1_01_3663796871_6bab255394.jpg',
              },
              small: {
                name: 'small_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
                hash: 'small_24_FIX_NOV_BANNER_1_01_3663796871_6bab255394',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 340,
                size: 27.8,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_1_01_3663796871_6bab255394.jpg',
              },
            },
            provider: 'aws-s3',
            related: [],
            createdAt: '2022-11-29T16:43:05.597Z',
            updatedAt: '2022-11-30T05:43:07.180Z',
            __v: 0,
            id: '63863699dda467001cc0c6b5',
          },
          id: '638638b1dda467001cc0c6cc',
        },
      ],
      button: {
        _id: '638638b1dda467001cc0c6d0',
        __v: 0,
        id: '638638b1dda467001cc0c6d0',
      },
      __v: 2,
      id: '638638b1dda467001cc0c6cb',
    },
    stepSection: null,
    successStorySection: {
      contents: [
        {
          relatedArticles: [],
          categories: [
            '60d1fe825749bf001bbb11e4',
            '62a76933e9dde5001b3c6b15',
            '62de67ecb31a7a001bba2d60',
          ],
          _id: '60fef2feea7297001be8c5f3',
          title: 'รีวิวผลงานจริง ล้างแอร์บ้านคุณเมย์ รัชนก อินทนนท์',
          slug: 'pro-may-onsite-review',
          shortDescription:
            'เพราะประเทศไทยมีแต่ฤดูร้อน ร้อนมาก และร้อนที่สุด! ดังนั้นการดูแล ทำความสะอาด ล้างแอร์ ก็ควรทำอย่างสม่ำเสมอนะ\n#งานล้างแอร์ #ล้างแอร์ฆ่าเชื้อ #เมย์ รัชนก อินทนนท์ #แอร์ไม่เย็น #ตรวจสภาพแอร์ #ล้างแอร์ #ซ่อมแอร์ ',
          views: 3549,
          published_at: '2021-07-26T17:38:13.448Z',
          contents: [
            {
              __component: 'article.content',
              id: '60fef2feea7297001be8c5f4',
            },
            {
              __component: 'article.images',
              id: '60fef2feea7297001be8c5f5',
            },
            {
              __component: 'article.content',
              id: '60fef2feea7297001be8c5f6',
            },
            {
              __component: 'article.images',
              id: '60fef2feea7297001be8c5f7',
            },
            {
              __component: 'article.content',
              id: '62cd0500df69b2001b4a8f1a',
            },
            {
              __component: 'article.images',
              id: '62cd0687df69b2001b4a8f39',
            },
            {
              __component: 'article.content',
              id: '62cd0687df69b2001b4a8f3a',
            },
            {
              __component: 'article.images',
              id: '62cd0687df69b2001b4a8f3b',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fbc',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fbd',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fbe',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fbf',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc0',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc1',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc2',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc3',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc4',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc5',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc6',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc7',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc8',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc9',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fca',
            },
          ],
          link: null,
          createdAt: '2021-07-26T17:38:06.604Z',
          updatedAt: '2022-07-25T10:08:01.825Z',
          __v: 2,
          coverImage: {
            _id: '60feef59ea7297001be8c5ed',
            name: '20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
            alternativeText: '',
            caption: '',
            hash: '20210510_On_site_Review_Artboard_v2_e9212db564',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 657.65,
            width: 2501,
            height: 1667,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'thumbnail_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 12.97,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              large: {
                name: 'large_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'large_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 1000,
                height: 667,
                size: 146.8,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              medium: {
                name: 'medium_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'medium_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 750,
                height: 500,
                size: 92.52,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              small: {
                name: 'small_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'small_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 46.42,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['60fef2feea7297001be8c5f3'],
            createdAt: '2021-07-26T17:22:33.885Z',
            updatedAt: '2021-07-30T03:43:47.943Z',
            __v: 0,
            id: '60feef59ea7297001be8c5ed',
          },
          metadata: null,
          id: '60fef2feea7297001be8c5f3',
        },
        {
          relatedArticles: ['60fef2feea7297001be8c5f3', '62cd8d63df69b2001b4a9b5c'],
          categories: [
            '62a76933e9dde5001b3c6b15',
            '60d1fe825749bf001bbb11e4',
            '62de67ecb31a7a001bba2d60',
          ],
          _id: '62cda1d7df69b2001b4a9c2a',
          published_at: '2022-07-12T16:36:03.404Z',
          slug: '911-assistant-rama-ix-porsche-service',
          shortDescription:
            'คุณลูกค้าได้ติดต่อให้ช่างอุ่นใจเข้ามาตรวจสอบปัญหาชักโครกมีกลิ่นเเละน้ำรั่วซึม ซึ่งช่างอุ่นใจได้รับโจทย์ในงานซ่อมแบ่งเป็น 2 ส่วนได้แก่ การซ่อมโถชักโครกและโถปัสสาวะชาย\n#งานเปลี่ยนสุขภัณฑ์ #รีวิว #กลิ่นโถส้วม',
          views: 244,
          title: 'รีวิวผลงานจริง @911 ASSISTANT RAMA IX (Porsche Service)',
          contents: [
            {
              __component: 'article.content',
              id: '62cda1d7df69b2001b4a9c2b',
            },
            {
              __component: 'article.content',
              id: '62cda1d7df69b2001b4a9c2c',
            },
          ],
          link: null,
          createdAt: '2022-07-12T16:31:19.223Z',
          updatedAt: '2022-07-25T10:08:01.825Z',
          __v: 1,
          coverImage: {
            _id: '62cd994fdf69b2001b4a9bbe',
            name: '144302486_851532738754884_6271739837459506095_n (Small).jpg',
            alternativeText: '',
            caption: '',
            hash: '144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 75.25,
            width: 720,
            height: 480,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_144302486_851532738754884_6271739837459506095_n (Small).jpg',
                hash: 'thumbnail_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 11.42,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
              },
              small: {
                name: 'small_144302486_851532738754884_6271739837459506095_n (Small).jpg',
                hash: 'small_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 40.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
              },
            },
            provider: 'aws-s3',
            related: ['62cda1d7df69b2001b4a9c2a'],
            createdAt: '2022-07-12T15:54:55.834Z',
            updatedAt: '2022-07-12T16:31:19.369Z',
            __v: 0,
            id: '62cd994fdf69b2001b4a9bbe',
          },
          metadata: null,
          id: '62cda1d7df69b2001b4a9c2a',
        },
        {
          relatedArticles: ['60fef2feea7297001be8c5f3'],
          categories: ['60d1fe825749bf001bbb11e4', '62a76933e9dde5001b3c6b15'],
          _id: '60fef555ea7297001be8c617',
          published_at: '2021-07-26T17:58:58.311Z',
          slug: 'ac-with-installation',
          shortDescription:
            '#ซื้อแอร์วันนี้แถมฟรีติดตั้ง\n\n☀ ถ้าจะบอกว่าเมืองไทย ‘อากาศร้อน’ เฉพาะในช่วงหน้าร้อนก็คงจะไม่ถูก เพราะไม่ว่าฤดูไหนๆ จะร้อน หนาว ฝน อากาศก็ร้อนอยู่ดี!\nวันนี้มาดับร้อนกันดีกว่า ❄ ด้วยบริการซื้อแอร์พร้อมติดตั้งฟรี โดยทีมช่างมืออาชีพ 24 FIX 😊',
          title: 'บริการซื้อแอร์พร้อมติดตั้ง',
          contents: [
            {
              __component: 'article.content',
              id: '60fef7daea7297001be8c649',
            },
            {
              __component: 'article.images',
              id: '60fef7daea7297001be8c64a',
            },
          ],
          link: null,
          createdAt: '2021-07-26T17:48:05.531Z',
          updatedAt: '2022-07-13T05:50:55.237Z',
          __v: 0,
          views: 1124,
          coverImage: {
            _id: '60fef76eea7297001be8c634',
            name: '117956473_738009603440532_2359157732673622296_n.jpeg',
            alternativeText: '',
            caption: '',
            hash: '117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 253.58,
            width: 1801,
            height: 1201,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'thumbnail_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 8.33,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              large: {
                name: 'large_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'large_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 1000,
                height: 667,
                size: 83.31,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              medium: {
                name: 'medium_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'medium_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 750,
                height: 500,
                size: 50.16,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              small: {
                name: 'small_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'small_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 26.25,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['60fef555ea7297001be8c617'],
            createdAt: '2021-07-26T17:57:02.195Z',
            updatedAt: '2021-07-30T03:43:47.943Z',
            __v: 0,
            id: '60fef76eea7297001be8c634',
          },
          metadata: null,
          id: '60fef555ea7297001be8c617',
        },
      ],
      _id: '638638b1dda467001cc0c6d3',
      title: 'บทความ',
      button: {
        _id: '638638b1dda467001cc0c6d4',
        title: 'ดูบทความทั้งหมด',
        url: 'https://fix.24x.co.th/blog/',
        __v: 0,
        id: '638638b1dda467001cc0c6d4',
      },
      __v: 1,
      id: '638638b1dda467001cc0c6d3',
    },
    reviewSection: {
      _id: '63863c8ddda467001cc0c733',
      title: 'รีวิวจากผู้ใช้บริการของเรา',
      reviewContent: [
        {
          image: [],
          _id: '63863c8ddda467001cc0c734',
          name: 'พรxxxx',
          score: 5,
          description:
            'ถ้าเรียกช่างไม่มาล้างไม่รู้เลยว่าสกปรกมากกกกกกก น้องแนะนำมาว่าช่างดี ล้างดีจริงราคาเหมาะสมไม่แพง',
          __v: 0,
          id: '63863c8ddda467001cc0c734',
        },
        {
          image: [],
          _id: '63863c8ddda467001cc0c735',
          name: 'ชลิxxx',
          score: 5,
          description:
            'ช่างล้างสะอาดดีค่ะ จากผ้าที่เคยซักล้วหมองตอนนี้หายแล้วเกือยซื้อเครื่องซักผ้าใหม่แล้ว ',
          __v: 0,
          id: '63863c8ddda467001cc0c735',
        },
        {
          image: [],
          _id: '63863c8ddda467001cc0c736',
          name: 'สุภxxxxx',
          score: 4,
          description: 'ช่างมาช้าค่ะ แต่บริการดีให้อภัยได้ ',
          __v: 0,
          id: '63863c8ddda467001cc0c736',
        },
        {
          image: [],
          _id: '63863c8ddda467001cc0c737',
          description:
            ' หัก 1 คะแนนครับ ช่างเลื่อนวันเข้ามาล้างแต่งานออกมาดี ยืนดูช่างล้างเครื่องได้ละเอียดสะอาดพร้อมบอกวิธีดูแลเครื่องซักผ้า',
          name: 'คณาxxxx',
          score: 4,
          __v: 0,
          id: '63863c8ddda467001cc0c737',
        },
        {
          image: [],
          _id: '63863c8ddda467001cc0c738',
          name: 'ภูวxxxxx',
          score: 5,
          description:
            'ล้างดีครับ ช่างมาก่อนเวลานัดอีก รักษาเวลาดีมากทำงานเร็วเรียบร้อยสะอาดดีครับ',
          __v: 0,
          id: '63863c8ddda467001cc0c738',
        },
        {
          image: [],
          _id: '63863c8ddda467001cc0c739',
          name: 'วิชุxxx',
          score: 4,
          description: 'ล้างครั้งที่ 2 แล้ว ช่างพูดจาดีมีมารยาท ล้างสะอาด ราคาไม่แพงเลยแนะนำค่ะ',
          __v: 0,
          id: '63863c8ddda467001cc0c739',
        },
        {
          image: [],
          _id: '63863c8ddda467001cc0c73a',
          name: 'ตุลxxx',
          score: 3,
          description:
            'ล้างดีครับเครื่องสะอาดเหมือนได้ใหม่ เสียอย่างเดียวมาช้าไปนิดไม่รู้เพราะแต่ช่างขอโทษและน้อมรับผิดแล้วให้อภัยได้ครับ',
          __v: 0,
          id: '63863c8ddda467001cc0c73a',
        },
        {
          image: [],
          _id: '63863c8ddda467001cc0c73b',
          name: 'ภูรxxxx',
          score: 5,
          description: 'ราคาล้างเครื่องซักผ้ากับที่นี่ไป ราคาไม่แพงครับ ช่างเข้างานตรงเวลา พูดจาดี',
          __v: 0,
          id: '63863c8ddda467001cc0c73b',
        },
        {
          image: [],
          _id: '63863c8ddda467001cc0c73c',
          name: 'กมลxxxx',
          score: 4,
          description:
            'ล้างเครื่องซักผ้ากับทาง 24FIX ไป ช่างล้างสิ่งสกปรกออกมาได้เยอะมาก ไม่เคยรู้มาก่อนว่าต้องล้างเครื่องซักผ้า',
          __v: 0,
          id: '63863c8ddda467001cc0c73c',
        },
        {
          image: [],
          _id: '63863c8ddda467001cc0c73d',
          name: 'ภักxxxx',
          score: 5,
          description: 'ใช้บริการล้างเครื่องซักผ้า ช่างเข้างานตรงเวลา เจ้าหน้าที่ให้บริการดีครับ ',
          __v: 0,
          id: '63863c8ddda467001cc0c73d',
        },
      ],
      __v: 1,
      id: '63863c8ddda467001cc0c733',
    },
    ctaSection: {
      _id: '63863551dda467001cc0c6af',
      title: '<p>ล้างเครื่องซักผ้าสะอาดปลอดภัย</p>',
      button: {
        _id: '63863551dda467001cc0c6b0',
        title: 'จองบริการ',
        __v: 0,
        url: 'https://fix.24x.co.th/washing-machine/booking',
        id: '63863551dda467001cc0c6b0',
      },
      __v: 1,
      id: '63863551dda467001cc0c6af',
    },
    metadata: {
      twitterCardType: 'summary',
      _id: '63bd0a84c37f54001cf15e0e',
      metaTitle: 'ล้างเครื่องซักผ้าสะอาดปลอดภัย',
      metaDescription:
        'บริการล้างเครื่องซักผ้า มั่นใจด้วยมาตรฐานความสะอาดจากช่างผู้เชียวชาญ ให้คุณซํกผ้าปลอดภัยไร้แบคทีเรีย',
      keywords: 'เครื่องซักผ้า, ล้างเครื่องซักผ้า, ',
      __v: 0,
      id: '63bd0a84c37f54001cf15e0e',
    },
    createdAt: '2022-11-29T16:37:37.873Z',
    updatedAt: '2023-01-10T06:49:40.482Z',
    __v: 2,
    installationSection: null,
    id: '63863551dda467001cc0c6a8',
  },
  {
    _id: '636008a451f79b001dee9936',
    published_at: '2022-11-07T11:44:52.068Z',
    slug: 'electrical',
    bannerSection: {
      _id: '6367dc196f10f9001b2ffe2b',
      title:
        '<p><strong>แก้ไขทุกปัญหางานไฟฟ้า ปลอดภัย&nbsp;</strong><br><strong>รับประกันคุณภาพ</strong></p>',
      button: {
        _id: '6367dc196f10f9001b2ffe2c',
        title: 'จองบริการ',
        url: 'https://fix.24x.co.th/electrical/booking',
        __v: 0,
        id: '6367dc196f10f9001b2ffe2c',
      },
      __v: 1,
      image: {
        _id: '6367db996f10f9001b2ffe28',
        name: '24FIX_LD_BANNER-05.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_05_0e46289b79',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 428.29,
        width: 6000,
        height: 2634,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_05_0e46289b79.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER-05.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_05_0e46289b79',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 108,
            size: 3.4,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_05_0e46289b79.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER-05.jpg',
            hash: 'large_24_FIX_LD_BANNER_05_0e46289b79',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 439,
            size: 21.55,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_05_0e46289b79.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER-05.jpg',
            hash: 'medium_24_FIX_LD_BANNER_05_0e46289b79',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 329,
            size: 14.3,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_05_0e46289b79.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER-05.jpg',
            hash: 'small_24_FIX_LD_BANNER_05_0e46289b79',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 220,
            size: 8.37,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_05_0e46289b79.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-11-06T16:06:49.943Z',
        updatedAt: '2022-11-06T16:42:58.599Z',
        __v: 0,
        id: '6367db996f10f9001b2ffe28',
      },
      mobileImage: {
        _id: '6367dbb96f10f9001b2ffe29',
        name: '24FIX_LD_BANNER_MOBILE-05.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_MOBILE_05_6261788328',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 65.77,
        width: 1501,
        height: 930,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_MOBILE_05_6261788328.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER_MOBILE-05.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_MOBILE_05_6261788328',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 152,
            size: 4.74,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_MOBILE_05_6261788328.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER_MOBILE-05.jpg',
            hash: 'large_24_FIX_LD_BANNER_MOBILE_05_6261788328',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 620,
            size: 34.72,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_MOBILE_05_6261788328.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER_MOBILE-05.jpg',
            hash: 'medium_24_FIX_LD_BANNER_MOBILE_05_6261788328',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 465,
            size: 21.61,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_MOBILE_05_6261788328.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER_MOBILE-05.jpg',
            hash: 'small_24_FIX_LD_BANNER_MOBILE_05_6261788328',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 310,
            size: 12.5,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_MOBILE_05_6261788328.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-11-06T16:07:21.763Z',
        updatedAt: '2022-11-06T16:42:58.599Z',
        __v: 0,
        id: '6367dbb96f10f9001b2ffe29',
      },
      id: '6367dc196f10f9001b2ffe2b',
    },
    uspSection: [
      {
        _id: '6367dc196f10f9001b2ffe31',
        __v: 0,
        image: {
          _id: '6367dbf86f10f9001b2ffe2a',
          name: 'Service_Desktop-08.jpg',
          alternativeText: '',
          caption: '',
          hash: 'Service_Desktop_08_1cca9c8e49',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 166.69,
          width: 2122,
          height: 1426,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/Service_Desktop_08_1cca9c8e49.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_Service_Desktop-08.jpg',
              hash: 'thumbnail_Service_Desktop_08_1cca9c8e49',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 232,
              height: 156,
              size: 4.63,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_Service_Desktop_08_1cca9c8e49.jpg',
            },
            large: {
              name: 'large_Service_Desktop-08.jpg',
              hash: 'large_Service_Desktop_08_1cca9c8e49',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 1000,
              height: 672,
              size: 38.61,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/large_Service_Desktop_08_1cca9c8e49.jpg',
            },
            medium: {
              name: 'medium_Service_Desktop-08.jpg',
              hash: 'medium_Service_Desktop_08_1cca9c8e49',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 504,
              size: 24.11,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_Service_Desktop_08_1cca9c8e49.jpg',
            },
            small: {
              name: 'small_Service_Desktop-08.jpg',
              hash: 'small_Service_Desktop_08_1cca9c8e49',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 336,
              size: 12.89,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_Service_Desktop_08_1cca9c8e49.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-11-06T16:08:24.761Z',
          updatedAt: '2022-11-06T16:42:58.599Z',
          __v: 0,
          id: '6367dbf86f10f9001b2ffe2a',
        },
        description:
          '<p><strong>ทำไมต้องจองกับ 24FIX?</strong></p><ul><li>ทีมช่างเข้าตรวจหน้างานก่อนให้บริการภายใน 1 วัน</li><li>ไม่มีค่าใช้จ่ายเพิ่มเติม หากเป็นบริการที่สามารถซ่อมได้ทันที</li><li>มีบริการหลังการขายและรับประกันสูงสุด 60 วัน</li><li>ราคางานซ่อมที่ได้มาตรฐาน คุ้มค่ากับคุณภาพบริการ</li></ul>',
        subTitle:
          'ติดตั้ง เปลี่ยน ซ่อมระบบไฟฟ้าครบวงจร โดยทีมช่างมากประสบการณ์ ส่งมอบงานไวไม่เสียเวลา รับประกันราคามาตรฐาน',
        title: 'แก้ไขทุกปัญหางานไฟฟ้า ปลอดภัย รับประกันคุณภาพ',
        id: '6367dc196f10f9001b2ffe31',
      },
    ],
    faqSection: [
      {
        _id: '63614991b87e30001c208c73',
        question: 'ทำไมถึงต้องมีการสำรวจหน้างาน',
        answer:
          '<p>การสำรวจหน้างาน จะสามารถทำให้เราได้ร่วมวางแผนกับคุณลูกค้า เพื่อให้รายละเอียดงานครบถ้วนและอยู่ในงบประมาณที่ได้ตกลงกันไว้</p>',
        __v: 0,
        id: '63614991b87e30001c208c73',
      },
      {
        _id: '63614991b87e30001c208c74',
        question: 'บริการอะไรบ้างที่ต้องมีการสำรวจหน้างานก่อน',
        answer:
          '<p>งานซ่อมทุกประเภท เราจะแนะนำให้ตรวจหน้างานก่อน เพื่อป้องกันการผิดพลาดในการเตรียมอุปกรณ์ และการประเมิณราคา&nbsp;</p>',
        __v: 0,
        id: '63614991b87e30001c208c74',
      },
      {
        _id: '63614991b87e30001c208c75',
        question: 'ค่าใช้จ่ายในการสำรวจ นำมาเป็นส่วนลดได้ไหม',
        answer: '<p>ค่าสำรวจสามารถนำไปลดได้ต่อเมื่อยอดงานบริการ มากกว่า 3,000 บาทขึ้นไป</p>',
        __v: 0,
        id: '63614991b87e30001c208c75',
      },
      {
        _id: '63614991b87e30001c208c76',
        answer:
          '<p>ปัจจัยที่มีผลต่อราคาค่าบริการ มีดังนี้ครับ</p><ul><li>ข้อจำกัด สถานที่หน้างาน (งานไฟฟ้า)</li><li>ความเสียหายของหน้างาน</li><li>จำนวนจุด ในการติดตั้ง (ยิ่งติดตั้งหลายจุด ราคาจะยิ่งถูกลง)</li></ul>',
        question: 'ปัจจัยที่มีผลต่อราคาค่าบริการ',
        __v: 0,
        id: '63614991b87e30001c208c76',
      },
      {
        _id: '63614991b87e30001c208c77',
        question: 'มีการรับประกันอย่างไร',
        answer:
          '<p>การรับประกันงานผลงาน 60 วัน หลังจากการให้บริการ ทางบริษัทจะรับประกันผลงานที่เกิดจากการติดตั้ง (หลุดร่อน, ดับหรือเสียงรบกวน) ตามขอบเขตการให้บริการในเอกสารเสนอราคาเท่านั้น</p>',
        __v: 0,
        id: '63614991b87e30001c208c77',
      },
      {
        _id: '63614991b87e30001c208c78',
        question: 'พื้นที่ที่ให้บริการมีอะไรบ้าง',
        answer: '<p>พื้นที่ให้บริการครอบคลุมในเขตกรุงเทพมหานคร นนทบุรี ปทุมธานี และสมุทรปราการ</p>',
        __v: 0,
        id: '63614991b87e30001c208c78',
      },
      {
        _id: '63614991b87e30001c208c79',
        question: 'งานบริการไฟฟ้า ครอบคลุมเรื่องอะไรบ้าง',
        answer:
          '<ul><li>งานเดินสายไฟ</li><li>ไฟช๊อต ไฟรั่ว ไฟดับ ไฟ 1 เฟส/ 3 เฟส</li><li>งานติดตั้งอุปกรณ์ไฟฟ้าทั้งหมด</li></ul>',
        __v: 0,
        id: '63614991b87e30001c208c79',
      },
      {
        _id: '63614991b87e30001c208c7a',
        question: 'มีบริการจัดหาวัสดุด้วยไหม',
        answer:
          '<p>เรามีบริการจัดหาวัสดุให้ ถ้าทางลูกค้าไม่สะดวกจัดหาวัสดุเอง ซึ่งจะใช้ระยะเวลาในการจัดหาประมาณ 1-2 อาทิตย์ขึ้นไป&nbsp;</p>',
        __v: 0,
        id: '63614991b87e30001c208c7a',
      },
      {
        _id: '63614991b87e30001c208c7b',
        answer:
          '<p>ค่าแรงและค่าวัสดุสิ้นเปลือง ซึ่งสามารถอ่านเพิ่มเติมได้จากหน้าบริการแต่ละการบริการเพิ่มเติมได้ ก่อนหน้าชำระค่าบริการ เช่น&nbsp;<br>งานติดตั้งเพิ่มจุดปลั๊กไฟ ราคารวมค่าแรง และวัสดุดังต่อไปนี้</p><ol><li>สายไฟมาตรฐานมอก. 2x2.5 sq.mm&nbsp;</li><li>สายดินมาตรฐานมอก. 1x1.5 sq.mm&nbsp;</li><li>ท่อสายไฟ PVC สีขาว</li><li>เต้ารับกราวน์คู่พร้อมกรอบ HACO สีขาว/สวิตซ์ไฟ พร้อมกรอบ HACO"</li></ol>',
        question: 'ราคาค่าบริการครอบคลุมอะไรบ้าง',
        __v: 0,
        id: '63614991b87e30001c208c7b',
      },
      {
        _id: '63614991b87e30001c208c7c',
        question: 'คิวเรียกช่างเร็วสุดเมื่อไหร่',
        answer:
          '<p>ช่างเข้าสำรวจหน้างานภายใน 2-3 วัน หลังอนุมัติงานสำรวจ และ 1 วันนับจากวันที่ลูกค้าชำระค่าบริการ</p>',
        __v: 0,
        id: '63614991b87e30001c208c7c',
      },
      {
        _id: '63614991b87e30001c208c7d',
        question: 'เรียกบริการผ่านเว็บไซต์ดีอย่างไร',
        answer:
          '<p>ลูกค้าสามารถติดตามสถานะงานผ่านทางเว็บไซต์ได้ตลอดเวลา และยังสามารถใช้โค้ดส่วนลดสำหรับลูกค้าที่ซื้อผ่านบนเว็บไซต์อีกด้วย</p>',
        __v: 0,
        id: '63614991b87e30001c208c7d',
      },
      {
        _id: '63614991b87e30001c208c7e',
        question: 'ใบเสนอราคาจะได้เมื่อไหร่ หลังจากที่ช่างเข้าสำรวจหน้างานเรียบร้อยแล้ว',
        answer:
          '<p>ใบเสนอราคาจะถูกส่งให้ลูกค้าตรวจสอบ ภายใน 24 ชม. หลังจากวันที่ช่างเข้าตรวจหน้างาน</p>',
        __v: 0,
        id: '63614991b87e30001c208c7e',
      },
    ],
    promotionSection: {
      _id: '636742da6f10f9001b2ffbf1',
      title: 'โปรโมชั่น',
      promotions: [
        {
          _id: '636742da6f10f9001b2ffbf2',
          url: 'https://fix.24x.co.th/voucher/firstfix-1',
          __v: 0,
          image: {
            _id: '637614b137fd76001b532030',
            name: '24FIX_NOV_BANNER4-02 (1).jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 94.2,
            width: 1500,
            height: 490,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 245,
                height: 80,
                size: 6.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              large: {
                name: 'large_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 327,
                size: 50.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              medium: {
                name: 'medium_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 245,
                size: 32.89,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              small: {
                name: 'small_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 163,
                size: 18.03,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
            },
            provider: 'aws-s3',
            related: ['636a17dc1e519e001c14731c'],
            createdAt: '2022-11-17T11:02:09.052Z',
            updatedAt: '2022-11-21T05:30:58.272Z',
            __v: 0,
            id: '637614b137fd76001b532030',
          },
          mobileImage: {
            _id: '636a6d86e6895d001ce68cc3',
            name: '24FIX_NOV_BANNER1-01.jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_1_01_3663796871',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 149.63,
            width: 1500,
            height: 1021,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_1_01_3663796871.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24FIX_NOV_BANNER1-01.jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 229,
                height: 156,
                size: 8.94,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              large: {
                name: 'large_24FIX_NOV_BANNER1-01.jpg',
                hash: 'large_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 681,
                size: 78.97,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              medium: {
                name: 'medium_24FIX_NOV_BANNER1-01.jpg',
                hash: 'medium_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 511,
                size: 51.21,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              small: {
                name: 'small_24FIX_NOV_BANNER1-01.jpg',
                hash: 'small_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 340,
                size: 27.91,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
            },
            provider: 'aws-s3',
            related: [],
            createdAt: '2022-11-08T14:53:58.508Z',
            updatedAt: '2022-11-08T16:06:16.745Z',
            __v: 0,
            id: '636a6d86e6895d001ce68cc3',
          },
          id: '636742da6f10f9001b2ffbf2',
        },
      ],
      __v: 1,
      button: null,
      id: '636742da6f10f9001b2ffbf1',
    },
    stepSection: null,
    successStorySection: {
      contents: [
        {
          relatedArticles: [],
          categories: [
            '60d1fe825749bf001bbb11e4',
            '62a76933e9dde5001b3c6b15',
            '62de67ecb31a7a001bba2d60',
          ],
          _id: '60fef2feea7297001be8c5f3',
          title: 'รีวิวผลงานจริง ล้างแอร์บ้านคุณเมย์ รัชนก อินทนนท์',
          slug: 'pro-may-onsite-review',
          shortDescription:
            'เพราะประเทศไทยมีแต่ฤดูร้อน ร้อนมาก และร้อนที่สุด! ดังนั้นการดูแล ทำความสะอาด ล้างแอร์ ก็ควรทำอย่างสม่ำเสมอนะ\n#งานล้างแอร์ #ล้างแอร์ฆ่าเชื้อ #เมย์ รัชนก อินทนนท์ #แอร์ไม่เย็น #ตรวจสภาพแอร์ #ล้างแอร์ #ซ่อมแอร์ ',
          views: 3549,
          published_at: '2021-07-26T17:38:13.448Z',
          contents: [
            {
              __component: 'article.content',
              id: '60fef2feea7297001be8c5f4',
            },
            {
              __component: 'article.images',
              id: '60fef2feea7297001be8c5f5',
            },
            {
              __component: 'article.content',
              id: '60fef2feea7297001be8c5f6',
            },
            {
              __component: 'article.images',
              id: '60fef2feea7297001be8c5f7',
            },
            {
              __component: 'article.content',
              id: '62cd0500df69b2001b4a8f1a',
            },
            {
              __component: 'article.images',
              id: '62cd0687df69b2001b4a8f39',
            },
            {
              __component: 'article.content',
              id: '62cd0687df69b2001b4a8f3a',
            },
            {
              __component: 'article.images',
              id: '62cd0687df69b2001b4a8f3b',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fbc',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fbd',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fbe',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fbf',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc0',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc1',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc2',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc3',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc4',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc5',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc6',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc7',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc8',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc9',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fca',
            },
          ],
          link: null,
          createdAt: '2021-07-26T17:38:06.604Z',
          updatedAt: '2022-07-25T10:08:01.825Z',
          __v: 2,
          coverImage: {
            _id: '60feef59ea7297001be8c5ed',
            name: '20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
            alternativeText: '',
            caption: '',
            hash: '20210510_On_site_Review_Artboard_v2_e9212db564',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 657.65,
            width: 2501,
            height: 1667,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'thumbnail_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 12.97,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              large: {
                name: 'large_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'large_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 1000,
                height: 667,
                size: 146.8,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              medium: {
                name: 'medium_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'medium_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 750,
                height: 500,
                size: 92.52,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              small: {
                name: 'small_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'small_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 46.42,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['60fef2feea7297001be8c5f3'],
            createdAt: '2021-07-26T17:22:33.885Z',
            updatedAt: '2021-07-30T03:43:47.943Z',
            __v: 0,
            id: '60feef59ea7297001be8c5ed',
          },
          metadata: null,
          id: '60fef2feea7297001be8c5f3',
        },
        {
          relatedArticles: ['60fef2feea7297001be8c5f3', '62cd8d63df69b2001b4a9b5c'],
          categories: [
            '62a76933e9dde5001b3c6b15',
            '60d1fe825749bf001bbb11e4',
            '62de67ecb31a7a001bba2d60',
          ],
          _id: '62cda1d7df69b2001b4a9c2a',
          published_at: '2022-07-12T16:36:03.404Z',
          slug: '911-assistant-rama-ix-porsche-service',
          shortDescription:
            'คุณลูกค้าได้ติดต่อให้ช่างอุ่นใจเข้ามาตรวจสอบปัญหาชักโครกมีกลิ่นเเละน้ำรั่วซึม ซึ่งช่างอุ่นใจได้รับโจทย์ในงานซ่อมแบ่งเป็น 2 ส่วนได้แก่ การซ่อมโถชักโครกและโถปัสสาวะชาย\n#งานเปลี่ยนสุขภัณฑ์ #รีวิว #กลิ่นโถส้วม',
          views: 244,
          title: 'รีวิวผลงานจริง @911 ASSISTANT RAMA IX (Porsche Service)',
          contents: [
            {
              __component: 'article.content',
              id: '62cda1d7df69b2001b4a9c2b',
            },
            {
              __component: 'article.content',
              id: '62cda1d7df69b2001b4a9c2c',
            },
          ],
          link: null,
          createdAt: '2022-07-12T16:31:19.223Z',
          updatedAt: '2022-07-25T10:08:01.825Z',
          __v: 1,
          coverImage: {
            _id: '62cd994fdf69b2001b4a9bbe',
            name: '144302486_851532738754884_6271739837459506095_n (Small).jpg',
            alternativeText: '',
            caption: '',
            hash: '144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 75.25,
            width: 720,
            height: 480,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_144302486_851532738754884_6271739837459506095_n (Small).jpg',
                hash: 'thumbnail_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 11.42,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
              },
              small: {
                name: 'small_144302486_851532738754884_6271739837459506095_n (Small).jpg',
                hash: 'small_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 40.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
              },
            },
            provider: 'aws-s3',
            related: ['62cda1d7df69b2001b4a9c2a'],
            createdAt: '2022-07-12T15:54:55.834Z',
            updatedAt: '2022-07-12T16:31:19.369Z',
            __v: 0,
            id: '62cd994fdf69b2001b4a9bbe',
          },
          metadata: null,
          id: '62cda1d7df69b2001b4a9c2a',
        },
        {
          relatedArticles: ['60fef2feea7297001be8c5f3'],
          categories: ['60d1fe825749bf001bbb11e4', '62a76933e9dde5001b3c6b15'],
          _id: '60fef555ea7297001be8c617',
          published_at: '2021-07-26T17:58:58.311Z',
          slug: 'ac-with-installation',
          shortDescription:
            '#ซื้อแอร์วันนี้แถมฟรีติดตั้ง\n\n☀ ถ้าจะบอกว่าเมืองไทย ‘อากาศร้อน’ เฉพาะในช่วงหน้าร้อนก็คงจะไม่ถูก เพราะไม่ว่าฤดูไหนๆ จะร้อน หนาว ฝน อากาศก็ร้อนอยู่ดี!\nวันนี้มาดับร้อนกันดีกว่า ❄ ด้วยบริการซื้อแอร์พร้อมติดตั้งฟรี โดยทีมช่างมืออาชีพ 24 FIX 😊',
          title: 'บริการซื้อแอร์พร้อมติดตั้ง',
          contents: [
            {
              __component: 'article.content',
              id: '60fef7daea7297001be8c649',
            },
            {
              __component: 'article.images',
              id: '60fef7daea7297001be8c64a',
            },
          ],
          link: null,
          createdAt: '2021-07-26T17:48:05.531Z',
          updatedAt: '2022-07-13T05:50:55.237Z',
          __v: 0,
          views: 1124,
          coverImage: {
            _id: '60fef76eea7297001be8c634',
            name: '117956473_738009603440532_2359157732673622296_n.jpeg',
            alternativeText: '',
            caption: '',
            hash: '117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 253.58,
            width: 1801,
            height: 1201,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'thumbnail_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 8.33,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              large: {
                name: 'large_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'large_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 1000,
                height: 667,
                size: 83.31,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              medium: {
                name: 'medium_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'medium_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 750,
                height: 500,
                size: 50.16,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              small: {
                name: 'small_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'small_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 26.25,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['60fef555ea7297001be8c617'],
            createdAt: '2021-07-26T17:57:02.195Z',
            updatedAt: '2021-07-30T03:43:47.943Z',
            __v: 0,
            id: '60fef76eea7297001be8c634',
          },
          metadata: null,
          id: '60fef555ea7297001be8c617',
        },
      ],
      _id: '6368ef801e519e001c146f43',
      title: 'ผลงานของเรา',
      __v: 0,
      button: null,
      id: '6368ef801e519e001c146f43',
    },
    reviewSection: {
      _id: '636008a451f79b001dee9937',
      title: 'รีวิวจากผู้ใช้บริการของเรา',
      reviewContent: [
        {
          image: [
            {
              _id: '636736926f10f9001b2ff9c8',
              name: 'rn_image_picker_lib_temp_b0e7a46f_ec25_453f_810c_b0955f1aef35_d44e90952a.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_b0e7a46f_ec25_453f_810c_b0955f1aef35_d44e90952a_3c4bf7ed8a',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 17.19,
              width: 800,
              height: 452,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_b0e7a46f_ec25_453f_810c_b0955f1aef35_d44e90952a_3c4bf7ed8a.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_b0e7a46f_ec25_453f_810c_b0955f1aef35_d44e90952a.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_b0e7a46f_ec25_453f_810c_b0955f1aef35_d44e90952a_3c4bf7ed8a',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 245,
                  height: 138,
                  size: 3.67,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_b0e7a46f_ec25_453f_810c_b0955f1aef35_d44e90952a_3c4bf7ed8a.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_b0e7a46f_ec25_453f_810c_b0955f1aef35_d44e90952a.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_b0e7a46f_ec25_453f_810c_b0955f1aef35_d44e90952a_3c4bf7ed8a',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 424,
                  size: 15.65,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_b0e7a46f_ec25_453f_810c_b0955f1aef35_d44e90952a_3c4bf7ed8a.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_b0e7a46f_ec25_453f_810c_b0955f1aef35_d44e90952a.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_b0e7a46f_ec25_453f_810c_b0955f1aef35_d44e90952a_3c4bf7ed8a',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 500,
                  height: 283,
                  size: 9.06,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_b0e7a46f_ec25_453f_810c_b0955f1aef35_d44e90952a_3c4bf7ed8a.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:22:42.946Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636736926f10f9001b2ff9c8',
            },
            {
              _id: '636736926f10f9001b2ff9c9',
              name: 'rn_image_picker_lib_temp_d92492a7_0f42_4922_8c9f_12d91434678a_2a42205ffd.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_d92492a7_0f42_4922_8c9f_12d91434678a_2a42205ffd_02957871eb',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 35.1,
              width: 800,
              height: 452,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_d92492a7_0f42_4922_8c9f_12d91434678a_2a42205ffd_02957871eb.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_d92492a7_0f42_4922_8c9f_12d91434678a_2a42205ffd.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_d92492a7_0f42_4922_8c9f_12d91434678a_2a42205ffd_02957871eb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 245,
                  height: 138,
                  size: 6.34,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_d92492a7_0f42_4922_8c9f_12d91434678a_2a42205ffd_02957871eb.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_d92492a7_0f42_4922_8c9f_12d91434678a_2a42205ffd.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_d92492a7_0f42_4922_8c9f_12d91434678a_2a42205ffd_02957871eb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 424,
                  size: 31.36,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_d92492a7_0f42_4922_8c9f_12d91434678a_2a42205ffd_02957871eb.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_d92492a7_0f42_4922_8c9f_12d91434678a_2a42205ffd.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_d92492a7_0f42_4922_8c9f_12d91434678a_2a42205ffd_02957871eb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 500,
                  height: 283,
                  size: 17.39,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_d92492a7_0f42_4922_8c9f_12d91434678a_2a42205ffd_02957871eb.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:22:42.990Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636736926f10f9001b2ff9c9',
            },
          ],
          _id: '636008a451f79b001dee9941',
          name: 'อภิxxxx',
          description: 'ใช้บริการติดตั้งโคมไฟค่ะ ช่างทำงานเรียบร้อย มาก่อนเวลาค่ะ',
          score: 4,
          __v: 0,
          id: '636008a451f79b001dee9941',
        },
        {
          image: [
            {
              _id: '636735cb6f10f9001b2ff9bc',
              name: 'AE_073599_F58_E_4_EE_7_B8_F8_086_CA_5_EEE_142_0419d4a6d9.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'AE_073599_F58_E_4_EE_7_B8_F8_086_CA_5_EEE_142_0419d4a6d9_a5717512b6',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 55.24,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/AE_073599_F58_E_4_EE_7_B8_F8_086_CA_5_EEE_142_0419d4a6d9_a5717512b6.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_AE_073599_F58_E_4_EE_7_B8_F8_086_CA_5_EEE_142_0419d4a6d9.jpeg',
                  hash: 'thumbnail_AE_073599_F58_E_4_EE_7_B8_F8_086_CA_5_EEE_142_0419d4a6d9_a5717512b6',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.92,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_AE_073599_F58_E_4_EE_7_B8_F8_086_CA_5_EEE_142_0419d4a6d9_a5717512b6.jpeg',
                },
                medium: {
                  name: 'medium_AE_073599_F58_E_4_EE_7_B8_F8_086_CA_5_EEE_142_0419d4a6d9.jpeg',
                  hash: 'medium_AE_073599_F58_E_4_EE_7_B8_F8_086_CA_5_EEE_142_0419d4a6d9_a5717512b6',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 49.5,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_AE_073599_F58_E_4_EE_7_B8_F8_086_CA_5_EEE_142_0419d4a6d9_a5717512b6.jpeg',
                },
                small: {
                  name: 'small_AE_073599_F58_E_4_EE_7_B8_F8_086_CA_5_EEE_142_0419d4a6d9.jpeg',
                  hash: 'small_AE_073599_F58_E_4_EE_7_B8_F8_086_CA_5_EEE_142_0419d4a6d9_a5717512b6',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 25.69,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_AE_073599_F58_E_4_EE_7_B8_F8_086_CA_5_EEE_142_0419d4a6d9_a5717512b6.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:19:23.249Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636735cb6f10f9001b2ff9bc',
            },
            {
              _id: '636735cb6f10f9001b2ff9bd',
              name: 'A285_B22_A_957_C_478_C_AB_49_FC_924_FA_8_F0_B0_c39606eb6b.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'A285_B22_A_957_C_478_C_AB_49_FC_924_FA_8_F0_B0_c39606eb6b_1ab84092bd',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 43.45,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/A285_B22_A_957_C_478_C_AB_49_FC_924_FA_8_F0_B0_c39606eb6b_1ab84092bd.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_A285_B22_A_957_C_478_C_AB_49_FC_924_FA_8_F0_B0_c39606eb6b.jpeg',
                  hash: 'thumbnail_A285_B22_A_957_C_478_C_AB_49_FC_924_FA_8_F0_B0_c39606eb6b_1ab84092bd',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.14,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_A285_B22_A_957_C_478_C_AB_49_FC_924_FA_8_F0_B0_c39606eb6b_1ab84092bd.jpeg',
                },
                medium: {
                  name: 'medium_A285_B22_A_957_C_478_C_AB_49_FC_924_FA_8_F0_B0_c39606eb6b.jpeg',
                  hash: 'medium_A285_B22_A_957_C_478_C_AB_49_FC_924_FA_8_F0_B0_c39606eb6b_1ab84092bd',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 38.72,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_A285_B22_A_957_C_478_C_AB_49_FC_924_FA_8_F0_B0_c39606eb6b_1ab84092bd.jpeg',
                },
                small: {
                  name: 'small_A285_B22_A_957_C_478_C_AB_49_FC_924_FA_8_F0_B0_c39606eb6b.jpeg',
                  hash: 'small_A285_B22_A_957_C_478_C_AB_49_FC_924_FA_8_F0_B0_c39606eb6b_1ab84092bd',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 19.69,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_A285_B22_A_957_C_478_C_AB_49_FC_924_FA_8_F0_B0_c39606eb6b_1ab84092bd.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:19:23.292Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636735cb6f10f9001b2ff9bd',
            },
          ],
          _id: '636008a451f79b001dee9939',
          name: 'ธนxxxxxx',
          description: 'เจ้าหน้าที่ให้บริการค่อนข้างดี ช่างเข้างานตรงเวลาครับ',
          score: 4,
          __v: 0,
          id: '636008a451f79b001dee9939',
        },
        {
          image: [
            {
              _id: '636735e86f10f9001b2ff9be',
              name: 'rn_image_picker_lib_temp_a87210ca_7bd0_42b4_a42c_94c6f98ed2fc_2f9447884a.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_a87210ca_7bd0_42b4_a42c_94c6f98ed2fc_2f9447884a_3bbfd2e197',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 28.7,
              width: 360,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_a87210ca_7bd0_42b4_a42c_94c6f98ed2fc_2f9447884a_3bbfd2e197.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_a87210ca_7bd0_42b4_a42c_94c6f98ed2fc_2f9447884a.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_a87210ca_7bd0_42b4_a42c_94c6f98ed2fc_2f9447884a_3bbfd2e197',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 70,
                  height: 156,
                  size: 2.83,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_a87210ca_7bd0_42b4_a42c_94c6f98ed2fc_2f9447884a_3bbfd2e197.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_a87210ca_7bd0_42b4_a42c_94c6f98ed2fc_2f9447884a.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_a87210ca_7bd0_42b4_a42c_94c6f98ed2fc_2f9447884a_3bbfd2e197',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 338,
                  height: 750,
                  size: 27.07,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_a87210ca_7bd0_42b4_a42c_94c6f98ed2fc_2f9447884a_3bbfd2e197.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_a87210ca_7bd0_42b4_a42c_94c6f98ed2fc_2f9447884a.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_a87210ca_7bd0_42b4_a42c_94c6f98ed2fc_2f9447884a_3bbfd2e197',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 225,
                  height: 500,
                  size: 15.12,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_a87210ca_7bd0_42b4_a42c_94c6f98ed2fc_2f9447884a_3bbfd2e197.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:19:52.959Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636735e86f10f9001b2ff9be',
            },
            {
              _id: '636735e96f10f9001b2ff9bf',
              name: 'rn_image_picker_lib_temp_19879f76_def5_4609_aae7_1685ef377fd9_9af8e84a0b.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_19879f76_def5_4609_aae7_1685ef377fd9_9af8e84a0b_14cca352f7',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 37.64,
              width: 360,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_19879f76_def5_4609_aae7_1685ef377fd9_9af8e84a0b_14cca352f7.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_19879f76_def5_4609_aae7_1685ef377fd9_9af8e84a0b.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_19879f76_def5_4609_aae7_1685ef377fd9_9af8e84a0b_14cca352f7',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 70,
                  height: 156,
                  size: 1.57,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_19879f76_def5_4609_aae7_1685ef377fd9_9af8e84a0b_14cca352f7.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_19879f76_def5_4609_aae7_1685ef377fd9_9af8e84a0b.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_19879f76_def5_4609_aae7_1685ef377fd9_9af8e84a0b_14cca352f7',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 338,
                  height: 750,
                  size: 31.86,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_19879f76_def5_4609_aae7_1685ef377fd9_9af8e84a0b_14cca352f7.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_19879f76_def5_4609_aae7_1685ef377fd9_9af8e84a0b.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_19879f76_def5_4609_aae7_1685ef377fd9_9af8e84a0b_14cca352f7',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 225,
                  height: 500,
                  size: 11.98,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_19879f76_def5_4609_aae7_1685ef377fd9_9af8e84a0b_14cca352f7.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:19:53.060Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636735e96f10f9001b2ff9bf',
            },
          ],
          _id: '636008a451f79b001dee993a',
          name: 'ภาxxxxx',
          description: 'ใช้บริการช่างในการติดตั้งสวิตซ์ไฟเพิ่ม ทำงานรวดเร็วดีค่ะ',
          score: 4,
          __v: 0,
          id: '636008a451f79b001dee993a',
        },
        {
          image: [
            {
              _id: '636735af6f10f9001b2ff9ba',
              name: 'rn_image_picker_lib_temp_11e05000_9d22_47b7_9862_5a2682d8d572_64bcc60c28.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_11e05000_9d22_47b7_9862_5a2682d8d572_64bcc60c28_7f0678e423',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 46.31,
              width: 450,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_11e05000_9d22_47b7_9862_5a2682d8d572_64bcc60c28_7f0678e423.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_11e05000_9d22_47b7_9862_5a2682d8d572_64bcc60c28.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_11e05000_9d22_47b7_9862_5a2682d8d572_64bcc60c28_7f0678e423',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 88,
                  height: 156,
                  size: 4.11,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_11e05000_9d22_47b7_9862_5a2682d8d572_64bcc60c28_7f0678e423.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_11e05000_9d22_47b7_9862_5a2682d8d572_64bcc60c28.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_11e05000_9d22_47b7_9862_5a2682d8d572_64bcc60c28_7f0678e423',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 422,
                  height: 750,
                  size: 42.08,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_11e05000_9d22_47b7_9862_5a2682d8d572_64bcc60c28_7f0678e423.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_11e05000_9d22_47b7_9862_5a2682d8d572_64bcc60c28.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_11e05000_9d22_47b7_9862_5a2682d8d572_64bcc60c28_7f0678e423',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 281,
                  height: 500,
                  size: 22.83,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_11e05000_9d22_47b7_9862_5a2682d8d572_64bcc60c28_7f0678e423.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:18:55.242Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636735af6f10f9001b2ff9ba',
            },
            {
              _id: '636735af6f10f9001b2ff9bb',
              name: 'rn_image_picker_lib_temp_daafe8ce_4de0_451b_9bfd_8dc05588a5d3_1d92173971.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_daafe8ce_4de0_451b_9bfd_8dc05588a5d3_1d92173971_3d6b1a2ea4',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 38.46,
              width: 450,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_daafe8ce_4de0_451b_9bfd_8dc05588a5d3_1d92173971_3d6b1a2ea4.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_daafe8ce_4de0_451b_9bfd_8dc05588a5d3_1d92173971.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_daafe8ce_4de0_451b_9bfd_8dc05588a5d3_1d92173971_3d6b1a2ea4',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 88,
                  height: 156,
                  size: 3.42,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_daafe8ce_4de0_451b_9bfd_8dc05588a5d3_1d92173971_3d6b1a2ea4.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_daafe8ce_4de0_451b_9bfd_8dc05588a5d3_1d92173971.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_daafe8ce_4de0_451b_9bfd_8dc05588a5d3_1d92173971_3d6b1a2ea4',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 422,
                  height: 750,
                  size: 34.94,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_daafe8ce_4de0_451b_9bfd_8dc05588a5d3_1d92173971_3d6b1a2ea4.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_daafe8ce_4de0_451b_9bfd_8dc05588a5d3_1d92173971.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_daafe8ce_4de0_451b_9bfd_8dc05588a5d3_1d92173971_3d6b1a2ea4',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 281,
                  height: 500,
                  size: 19.04,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_daafe8ce_4de0_451b_9bfd_8dc05588a5d3_1d92173971_3d6b1a2ea4.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:18:55.252Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636735af6f10f9001b2ff9bb',
            },
          ],
          _id: '636008a451f79b001dee9938',
          name: 'ทิxxxxxx',
          description:
            'เรียกช่างมาตรวจสอบระบบไฟฟ้าที่บ้านค่ะ ช่างให้คำแนะนำค่อนข้างดีค่ะเลยตัดสินใจใช้บริการกับที่นี่ค่ะ ',
          score: 4,
          __v: 0,
          id: '636008a451f79b001dee9938',
        },
        {
          image: [],
          _id: '636008a451f79b001dee993b',
          name: 'ลภัxxxxx',
          description:
            'ที่บ้านต้องการเดินระบบไฟฟ้าสำหรับ EV-charger เพิ่มเติมค่ะ เห็นที่นี่ให้บริการเลยติดต่อขอคำปรึกษา ให้คำแนะนำดีนะคะ เลยตัดสินใจใช้บริการที่นี่ ตอนนี้งานเสร็จเรียบร้อยแล้วค่ะ ออกมาค่อนข้างดีเลยค่ะ',
          score: 4,
          __v: 0,
          id: '636008a451f79b001dee993b',
        },
        {
          image: [
            {
              _id: '636736036f10f9001b2ff9c0',
              name: 'rn_image_picker_lib_temp_82f5fbd8_e158_48a3_b0c7_a94a83ddcb64_182c2ad76a.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_82f5fbd8_e158_48a3_b0c7_a94a83ddcb64_182c2ad76a_c74898d59f',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 27.48,
              width: 360,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_82f5fbd8_e158_48a3_b0c7_a94a83ddcb64_182c2ad76a_c74898d59f.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_82f5fbd8_e158_48a3_b0c7_a94a83ddcb64_182c2ad76a.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_82f5fbd8_e158_48a3_b0c7_a94a83ddcb64_182c2ad76a_c74898d59f',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 70,
                  height: 156,
                  size: 2.6,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_82f5fbd8_e158_48a3_b0c7_a94a83ddcb64_182c2ad76a_c74898d59f.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_82f5fbd8_e158_48a3_b0c7_a94a83ddcb64_182c2ad76a.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_82f5fbd8_e158_48a3_b0c7_a94a83ddcb64_182c2ad76a_c74898d59f',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 338,
                  height: 750,
                  size: 25.11,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_82f5fbd8_e158_48a3_b0c7_a94a83ddcb64_182c2ad76a_c74898d59f.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_82f5fbd8_e158_48a3_b0c7_a94a83ddcb64_182c2ad76a.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_82f5fbd8_e158_48a3_b0c7_a94a83ddcb64_182c2ad76a_c74898d59f',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 225,
                  height: 500,
                  size: 13.38,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_82f5fbd8_e158_48a3_b0c7_a94a83ddcb64_182c2ad76a_c74898d59f.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:20:19.380Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636736036f10f9001b2ff9c0',
            },
          ],
          _id: '636008a451f79b001dee993c',
          name: 'หรรษxxxxx',
          description: 'ติดตั้งเครื่องทำน้ำอุ่นกับ 24 FIX ไปครับ งานเรียบร้อยครับ ',
          score: 5,
          __v: 0,
          id: '636008a451f79b001dee993c',
        },
        {
          image: [
            {
              _id: '636736256f10f9001b2ff9c1',
              name: '244_AD_2_B0_B8_E9_45_CD_83_FA_291_F856_C5804_ad5067b560.jpeg',
              alternativeText: '',
              caption: '',
              hash: '244_AD_2_B0_B8_E9_45_CD_83_FA_291_F856_C5804_ad5067b560_dd62b5012d',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 71.77,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/244_AD_2_B0_B8_E9_45_CD_83_FA_291_F856_C5804_ad5067b560_dd62b5012d.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_244_AD_2_B0_B8_E9_45_CD_83_FA_291_F856_C5804_ad5067b560.jpeg',
                  hash: 'thumbnail_244_AD_2_B0_B8_E9_45_CD_83_FA_291_F856_C5804_ad5067b560_dd62b5012d',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 4.47,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_244_AD_2_B0_B8_E9_45_CD_83_FA_291_F856_C5804_ad5067b560_dd62b5012d.jpeg',
                },
                medium: {
                  name: 'medium_244_AD_2_B0_B8_E9_45_CD_83_FA_291_F856_C5804_ad5067b560.jpeg',
                  hash: 'medium_244_AD_2_B0_B8_E9_45_CD_83_FA_291_F856_C5804_ad5067b560_dd62b5012d',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 64.34,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_244_AD_2_B0_B8_E9_45_CD_83_FA_291_F856_C5804_ad5067b560_dd62b5012d.jpeg',
                },
                small: {
                  name: 'small_244_AD_2_B0_B8_E9_45_CD_83_FA_291_F856_C5804_ad5067b560.jpeg',
                  hash: 'small_244_AD_2_B0_B8_E9_45_CD_83_FA_291_F856_C5804_ad5067b560_dd62b5012d',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 31.15,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_244_AD_2_B0_B8_E9_45_CD_83_FA_291_F856_C5804_ad5067b560_dd62b5012d.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:20:53.628Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636736256f10f9001b2ff9c1',
            },
            {
              _id: '636736256f10f9001b2ff9c2',
              name: 'ECFD_4_FC_2_5_DBF_4_F07_896_B_E2960_F7_FBCB_4_39fa2822f2.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'ECFD_4_FC_2_5_DBF_4_F07_896_B_E2960_F7_FBCB_4_39fa2822f2_52ca3d5340',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 61.42,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/ECFD_4_FC_2_5_DBF_4_F07_896_B_E2960_F7_FBCB_4_39fa2822f2_52ca3d5340.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_ECFD_4_FC_2_5_DBF_4_F07_896_B_E2960_F7_FBCB_4_39fa2822f2.jpeg',
                  hash: 'thumbnail_ECFD_4_FC_2_5_DBF_4_F07_896_B_E2960_F7_FBCB_4_39fa2822f2_52ca3d5340',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 4.52,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_ECFD_4_FC_2_5_DBF_4_F07_896_B_E2960_F7_FBCB_4_39fa2822f2_52ca3d5340.jpeg',
                },
                medium: {
                  name: 'medium_ECFD_4_FC_2_5_DBF_4_F07_896_B_E2960_F7_FBCB_4_39fa2822f2.jpeg',
                  hash: 'medium_ECFD_4_FC_2_5_DBF_4_F07_896_B_E2960_F7_FBCB_4_39fa2822f2_52ca3d5340',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 56.46,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_ECFD_4_FC_2_5_DBF_4_F07_896_B_E2960_F7_FBCB_4_39fa2822f2_52ca3d5340.jpeg',
                },
                small: {
                  name: 'small_ECFD_4_FC_2_5_DBF_4_F07_896_B_E2960_F7_FBCB_4_39fa2822f2.jpeg',
                  hash: 'small_ECFD_4_FC_2_5_DBF_4_F07_896_B_E2960_F7_FBCB_4_39fa2822f2_52ca3d5340',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 30.15,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_ECFD_4_FC_2_5_DBF_4_F07_896_B_E2960_F7_FBCB_4_39fa2822f2_52ca3d5340.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:20:53.715Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636736256f10f9001b2ff9c2',
            },
          ],
          _id: '636008a451f79b001dee993d',
          name: 'อภิxxx',
          description:
            'พนักงานขายให้คำปรึกษาดีค่ะ ติดตั้งปลั๊กไฟที่บ้าน ช่างเก็บงานสะอาด มาตรงเวลาค่ะ',
          score: 4,
          __v: 0,
          id: '636008a451f79b001dee993d',
        },
        {
          image: [
            {
              _id: '636736416f10f9001b2ff9c3',
              name: 'rn_image_picker_lib_temp_c1315450_9e43_4e6c_acc8_51ff5840cce3_437da162f0.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_c1315450_9e43_4e6c_acc8_51ff5840cce3_437da162f0_b655cd186e',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 55.24,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_c1315450_9e43_4e6c_acc8_51ff5840cce3_437da162f0_b655cd186e.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_c1315450_9e43_4e6c_acc8_51ff5840cce3_437da162f0.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_c1315450_9e43_4e6c_acc8_51ff5840cce3_437da162f0_b655cd186e',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 4.32,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_c1315450_9e43_4e6c_acc8_51ff5840cce3_437da162f0_b655cd186e.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_c1315450_9e43_4e6c_acc8_51ff5840cce3_437da162f0.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_c1315450_9e43_4e6c_acc8_51ff5840cce3_437da162f0_b655cd186e',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 49.63,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_c1315450_9e43_4e6c_acc8_51ff5840cce3_437da162f0_b655cd186e.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_c1315450_9e43_4e6c_acc8_51ff5840cce3_437da162f0.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_c1315450_9e43_4e6c_acc8_51ff5840cce3_437da162f0_b655cd186e',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 24.4,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_c1315450_9e43_4e6c_acc8_51ff5840cce3_437da162f0_b655cd186e.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:21:21.189Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636736416f10f9001b2ff9c3',
            },
          ],
          _id: '636008a451f79b001dee993e',
          name: 'ศิวxxx',
          description: 'ใช้บริการติดตั้งปลั๊กไฟมาครับ ค่อนข้างคุ้มราคาครับ แนะนำให้มาใช้บริการครับ',
          score: 5,
          __v: 0,
          id: '636008a451f79b001dee993e',
        },
        {
          image: [
            {
              _id: '6367365c6f10f9001b2ff9c4',
              name: 'B40789_E9_36_A5_49_CD_ABBD_19_D7_D1_B28_B8_D_8ed50d5b79.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'B40789_E9_36_A5_49_CD_ABBD_19_D7_D1_B28_B8_D_8ed50d5b79_dd58ebb368',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 41.22,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/B40789_E9_36_A5_49_CD_ABBD_19_D7_D1_B28_B8_D_8ed50d5b79_dd58ebb368.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_B40789_E9_36_A5_49_CD_ABBD_19_D7_D1_B28_B8_D_8ed50d5b79.jpeg',
                  hash: 'thumbnail_B40789_E9_36_A5_49_CD_ABBD_19_D7_D1_B28_B8_D_8ed50d5b79_dd58ebb368',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.2,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_B40789_E9_36_A5_49_CD_ABBD_19_D7_D1_B28_B8_D_8ed50d5b79_dd58ebb368.jpeg',
                },
                medium: {
                  name: 'medium_B40789_E9_36_A5_49_CD_ABBD_19_D7_D1_B28_B8_D_8ed50d5b79.jpeg',
                  hash: 'medium_B40789_E9_36_A5_49_CD_ABBD_19_D7_D1_B28_B8_D_8ed50d5b79_dd58ebb368',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 37.54,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_B40789_E9_36_A5_49_CD_ABBD_19_D7_D1_B28_B8_D_8ed50d5b79_dd58ebb368.jpeg',
                },
                small: {
                  name: 'small_B40789_E9_36_A5_49_CD_ABBD_19_D7_D1_B28_B8_D_8ed50d5b79.jpeg',
                  hash: 'small_B40789_E9_36_A5_49_CD_ABBD_19_D7_D1_B28_B8_D_8ed50d5b79_dd58ebb368',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 19.5,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_B40789_E9_36_A5_49_CD_ABBD_19_D7_D1_B28_B8_D_8ed50d5b79_dd58ebb368.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:21:48.393Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '6367365c6f10f9001b2ff9c4',
            },
            {
              _id: '6367365c6f10f9001b2ff9c5',
              name: '0_B08_CA_71_7866_409_A_9214_C3672_B428184_584d75e870.jpeg',
              alternativeText: '',
              caption: '',
              hash: '0_B08_CA_71_7866_409_A_9214_C3672_B428184_584d75e870_b5b23e24bf',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 19.48,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/0_B08_CA_71_7866_409_A_9214_C3672_B428184_584d75e870_b5b23e24bf.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_0_B08_CA_71_7866_409_A_9214_C3672_B428184_584d75e870.jpeg',
                  hash: 'thumbnail_0_B08_CA_71_7866_409_A_9214_C3672_B428184_584d75e870_b5b23e24bf',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 1.97,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_0_B08_CA_71_7866_409_A_9214_C3672_B428184_584d75e870_b5b23e24bf.jpeg',
                },
                medium: {
                  name: 'medium_0_B08_CA_71_7866_409_A_9214_C3672_B428184_584d75e870.jpeg',
                  hash: 'medium_0_B08_CA_71_7866_409_A_9214_C3672_B428184_584d75e870_b5b23e24bf',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 17.84,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_0_B08_CA_71_7866_409_A_9214_C3672_B428184_584d75e870_b5b23e24bf.jpeg',
                },
                small: {
                  name: 'small_0_B08_CA_71_7866_409_A_9214_C3672_B428184_584d75e870.jpeg',
                  hash: 'small_0_B08_CA_71_7866_409_A_9214_C3672_B428184_584d75e870_b5b23e24bf',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 9.38,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_0_B08_CA_71_7866_409_A_9214_C3672_B428184_584d75e870_b5b23e24bf.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:21:48.397Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '6367365c6f10f9001b2ff9c5',
            },
          ],
          _id: '636008a451f79b001dee993f',
          name: 'ณิชxxxxx',
          description:
            'ซื้อโคมไฟมาใหม่แต่ไม่มีช่างติดตั้งให้ เพื่อนแนะนำมาว่าเคยใช้บริการกับที่นี่เลยลองติดต่อเข้ามาใช้บริการกับที่นี่ดูค่ะ ติดต่อประสานงานวันเวลาให้เข้ามาติดตั้งให้ค่อนข้างรวดเร็ว ทำจริงๆ วันเดียวก็เสร็จแล้วช่างเก็บงานเรียบร้อยดีค่ะ ',
          score: 5,
          __v: 0,
          id: '636008a451f79b001dee993f',
        },
        {
          image: [
            {
              _id: '636736776f10f9001b2ff9c6',
              name: 'rn_image_picker_lib_temp_6df332b1_cb68_4040_87b1_55327675af1e_dc50ef4acc.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_6df332b1_cb68_4040_87b1_55327675af1e_dc50ef4acc_83e8cf121c',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 20.93,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_6df332b1_cb68_4040_87b1_55327675af1e_dc50ef4acc_83e8cf121c.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_6df332b1_cb68_4040_87b1_55327675af1e_dc50ef4acc.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_6df332b1_cb68_4040_87b1_55327675af1e_dc50ef4acc_83e8cf121c',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.09,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_6df332b1_cb68_4040_87b1_55327675af1e_dc50ef4acc_83e8cf121c.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_6df332b1_cb68_4040_87b1_55327675af1e_dc50ef4acc.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_6df332b1_cb68_4040_87b1_55327675af1e_dc50ef4acc_83e8cf121c',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 18.96,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_6df332b1_cb68_4040_87b1_55327675af1e_dc50ef4acc_83e8cf121c.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_6df332b1_cb68_4040_87b1_55327675af1e_dc50ef4acc.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_6df332b1_cb68_4040_87b1_55327675af1e_dc50ef4acc_83e8cf121c',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 9.64,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_6df332b1_cb68_4040_87b1_55327675af1e_dc50ef4acc_83e8cf121c.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:22:15.412Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636736776f10f9001b2ff9c6',
            },
            {
              _id: '636736776f10f9001b2ff9c7',
              name: 'rn_image_picker_lib_temp_e284a153_d797_4158_b765_cc101db1c68b_1aa83566f0.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_e284a153_d797_4158_b765_cc101db1c68b_1aa83566f0_7f22f9623e',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 21.39,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_e284a153_d797_4158_b765_cc101db1c68b_1aa83566f0_7f22f9623e.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_e284a153_d797_4158_b765_cc101db1c68b_1aa83566f0.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_e284a153_d797_4158_b765_cc101db1c68b_1aa83566f0_7f22f9623e',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.32,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_e284a153_d797_4158_b765_cc101db1c68b_1aa83566f0_7f22f9623e.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_e284a153_d797_4158_b765_cc101db1c68b_1aa83566f0.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_e284a153_d797_4158_b765_cc101db1c68b_1aa83566f0_7f22f9623e',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 19.85,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_e284a153_d797_4158_b765_cc101db1c68b_1aa83566f0_7f22f9623e.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_e284a153_d797_4158_b765_cc101db1c68b_1aa83566f0.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_e284a153_d797_4158_b765_cc101db1c68b_1aa83566f0_7f22f9623e',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 10.62,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_e284a153_d797_4158_b765_cc101db1c68b_1aa83566f0_7f22f9623e.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:22:15.500Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636736776f10f9001b2ff9c7',
            },
          ],
          _id: '636008a451f79b001dee9940',
          name: 'ธนัตxxxx',
          description: 'ช่างดูมีประสบการณ์ แก้ไขปัญหาได้ดีครับ ',
          score: 5,
          __v: 0,
          id: '636008a451f79b001dee9940',
        },
      ],
      __v: 1,
      id: '636008a451f79b001dee9937',
    },
    ctaSection: {
      _id: '6367dc196f10f9001b2ffe4d',
      title: '<p>แก้ไขทุกปัญหางานไฟฟ้า ปลอดภัย รับประกัน</p>',
      button: {
        _id: '6367dc196f10f9001b2ffe4e',
        url: 'https://fix.24x.co.th/electrical/booking',
        title: 'จองบริการ',
        __v: 0,
        id: '6367dc196f10f9001b2ffe4e',
      },
      __v: 1,
      id: '6367dc196f10f9001b2ffe4d',
    },
    createdAt: '2022-10-31T17:40:52.929Z',
    updatedAt: '2023-01-11T09:48:09.374Z',
    __v: 1,
    metadata: {
      twitterCardType: 'summary',
      _id: '63bd0620c37f54001cf15c74',
      metaTitle: 'แก้ไขทุกปัญหางานไฟฟ้า ปลอดภัย รับประกัน',
      metaDescription:
        'ติดตั้ง เปลี่ยน ซ่อมระบบไฟฟ้าครบวงจร โดยทีมช่างมากประสบการณ์ ส่งมอบงานไวไม่เสียเวลา รับประกันราคามาตรฐาน',
      keywords:
        'ไฟฟ้าดับ,ไฟช๊อต,ช่าง ซ่อม ไฟฟ้า,ร้าน ซ่อม ไฟฟ้า ใกล้ ฉัน,ซ่อม ไฟฟ้า, ช่าง ไฟฟ้า,ช่างไฟ, หา ช่าง ไฟฟ้า',
      __v: 0,
      id: '63bd0620c37f54001cf15c74',
    },
    installationSection: null,
    id: '636008a451f79b001dee9936',
  },
  {
    _id: '6360081a51f79b001dee9907',
    published_at: '2022-11-07T11:40:52.470Z',
    slug: 'piping',
    bannerSection: {
      _id: '636748926f10f9001b2ffd60',
      title:
        '<p><strong>ซ่อมแซมและดูแลงานประปา&nbsp;</strong><br><strong>โดยช่างมืออาชีพ</strong></p>',
      button: {
        _id: '636748926f10f9001b2ffd61',
        title: 'จองบริการ',
        url: 'https://fix.24x.co.th/piping/booking',
        __v: 0,
        id: '636748926f10f9001b2ffd61',
      },
      __v: 1,
      image: {
        _id: '6367db146f10f9001b2ffde6',
        name: '24FIX_LD_BANNER-04.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_04_03866a6cfa',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 754.27,
        width: 6000,
        height: 2634,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_04_03866a6cfa.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER-04.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_04_03866a6cfa',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 108,
            size: 4.62,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_04_03866a6cfa.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER-04.jpg',
            hash: 'large_24_FIX_LD_BANNER_04_03866a6cfa',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 439,
            size: 34.46,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_04_03866a6cfa.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER-04.jpg',
            hash: 'medium_24_FIX_LD_BANNER_04_03866a6cfa',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 329,
            size: 22.24,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_04_03866a6cfa.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER-04.jpg',
            hash: 'small_24_FIX_LD_BANNER_04_03866a6cfa',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 220,
            size: 12.48,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_04_03866a6cfa.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-11-06T16:04:36.919Z',
        updatedAt: '2022-11-06T16:42:58.599Z',
        __v: 0,
        id: '6367db146f10f9001b2ffde6',
      },
      mobileImage: {
        _id: '6367dae86f10f9001b2ffde5',
        name: '24FIX_LD_BANNER_MOBILE-04.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_MOBILE_04_b138de2d93',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 84.04,
        width: 1501,
        height: 930,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_MOBILE_04_b138de2d93.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER_MOBILE-04.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_MOBILE_04_b138de2d93',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 152,
            size: 5.69,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_MOBILE_04_b138de2d93.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER_MOBILE-04.jpg',
            hash: 'large_24_FIX_LD_BANNER_MOBILE_04_b138de2d93',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 620,
            size: 45.11,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_MOBILE_04_b138de2d93.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER_MOBILE-04.jpg',
            hash: 'medium_24_FIX_LD_BANNER_MOBILE_04_b138de2d93',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 465,
            size: 28.32,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_MOBILE_04_b138de2d93.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER_MOBILE-04.jpg',
            hash: 'small_24_FIX_LD_BANNER_MOBILE_04_b138de2d93',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 310,
            size: 16.07,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_MOBILE_04_b138de2d93.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-11-06T16:03:52.620Z',
        updatedAt: '2022-11-06T16:42:58.599Z',
        __v: 0,
        id: '6367dae86f10f9001b2ffde5',
      },
      id: '636748926f10f9001b2ffd60',
    },
    uspSection: [
      {
        _id: '636748926f10f9001b2ffd64',
        title: 'ซ่อมแซมทุกงานประปา โดยช่างมืออาชีพ',
        subTitle:
          'เรามีทีมช่างผู้เชียวชาญด้านการติดตั้งสุขภัณฑ์ และซ่อมแซมประปา รับประกันงานผลงานนาน 30 วัน',
        description:
          '<p><strong>ทำไมต้องจองกับ 24FIX?</strong></p><ul><li>ทีมช่างเข้าตรวจหน้างานก่อนให้บริการภายใน 1 วัน</li><li>ไม่มีค่าใช้จ่ายเพิ่มเติม หากเป็นบริการที่สามารถซ่อมได้ทันที</li><li>มีบริการหลังการขายและรับประกันสูงสุด 60 วัน</li><li>ราคางานซ่อมที่ได้มาตรฐาน คุ้มค่ากับคุณภาพบริการ</li></ul>',
        __v: 0,
        image: {
          _id: '6367db476f10f9001b2ffe07',
          name: 'Service_Desktop-05.jpg',
          alternativeText: '',
          caption: '',
          hash: 'Service_Desktop_05_6fcbdb6489',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 240.95,
          width: 2121,
          height: 1426,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/Service_Desktop_05_6fcbdb6489.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_Service_Desktop-05.jpg',
              hash: 'thumbnail_Service_Desktop_05_6fcbdb6489',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 232,
              height: 156,
              size: 6.48,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_Service_Desktop_05_6fcbdb6489.jpg',
            },
            large: {
              name: 'large_Service_Desktop-05.jpg',
              hash: 'large_Service_Desktop_05_6fcbdb6489',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 1000,
              height: 672,
              size: 60.26,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/large_Service_Desktop_05_6fcbdb6489.jpg',
            },
            medium: {
              name: 'medium_Service_Desktop-05.jpg',
              hash: 'medium_Service_Desktop_05_6fcbdb6489',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 504,
              size: 38.55,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_Service_Desktop_05_6fcbdb6489.jpg',
            },
            small: {
              name: 'small_Service_Desktop-05.jpg',
              hash: 'small_Service_Desktop_05_6fcbdb6489',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 336,
              size: 20.45,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_Service_Desktop_05_6fcbdb6489.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-11-06T16:05:27.644Z',
          updatedAt: '2022-11-06T16:42:58.599Z',
          __v: 0,
          id: '6367db476f10f9001b2ffe07',
        },
        id: '636748926f10f9001b2ffd64',
      },
    ],
    faqSection: [
      {
        _id: '6360081a51f79b001dee9908',
        question: 'ทำไมถึงต้องมีการสำรวจหน้างาน',
        answer:
          '<p>การสำรวจหน้างาน จะสามารถทำให้เราได้ร่วมวางแผนกับคุณลูกค้า เพื่อให้รายละเอียดงานครบถ้วนและอยู่ในงบประมาณที่ได้ตกลงกันไว้</p>',
        __v: 0,
        id: '6360081a51f79b001dee9908',
      },
      {
        _id: '6360081a51f79b001dee9909',
        question: 'บริการอะไรบ้างที่ต้องมีการสำรวจหน้างานก่อน',
        answer:
          '<p>งานซ่อมทุกประเภท เราจะแนะนำให้ตรวจหน้างานก่อน เพื่อป้องกันการผิดพลาดในการเตรียมอุปกรณ์ และการประเมิณราคา</p>',
        __v: 0,
        id: '6360081a51f79b001dee9909',
      },
      {
        _id: '6360081a51f79b001dee990a',
        question: 'ค่าใช้จ่ายในการสำรวจ นำมาเป็นส่วนลดได้ไหม',
        answer: '<p>ค่าสำรวจสามารถนำไปลดได้ต่อเมื่อยอดงานบริการ มากกว่า 3,000 บาทขึ้นไป</p>',
        __v: 0,
        id: '6360081a51f79b001dee990a',
      },
      {
        _id: '6360081a51f79b001dee990b',
        answer:
          '<p>ปัจจัยที่มีผลต่อราคาค่าบริการ มีดังนี้ครับ</p><ul><li>ข้อจำกัด สถานที่หน้างาน (ระบบประปา)</li><li>ความเสียหายของหน้างาน</li><li>จำนวนจุด ในการติดตั้ง (ยิ่งติดตั้งหลายจุด ราคาจะยิ่งถูกลง)</li></ul>',
        question: 'ปัจจัยที่มีผลต่อราคาค่าบริการ',
        __v: 0,
        id: '6360081a51f79b001dee990b',
      },
      {
        _id: '6360081a51f79b001dee990c',
        question: 'มีการรับประกันอย่างไร',
        answer:
          '<p>การรับประกันงานผลงาน 60 วัน หลังจากการให้บริการ ทางบริษัทจะรับประกันผลงานที่เกิดจากการติดตั้ง (รั่วซึมหรืออุดตัน) ตามขอบเขตการให้บริการในเอกสารเสนอราคาเท่านั้น</p>',
        __v: 0,
        id: '6360081a51f79b001dee990c',
      },
      {
        _id: '6360081a51f79b001dee990d',
        question: 'พื้นที่ที่ให้บริการมีอะไรบ้าง',
        answer: '<p>พื้นที่ให้บริการครอบคลุมในเขตกรุงเทพมหานคร นนทบุรี ปทุมธานี และสมุทรปราการ</p>',
        __v: 0,
        id: '6360081a51f79b001dee990d',
      },
      {
        _id: '6360081a51f79b001dee990e',
        answer:
          '<ul><li>ตัด ต่อ ท่อ PVC</li><li>แยงงูเหล็ก (แก้ปัญหาท่ออุดตัน)</li><li>ตัด ต่อ ท่อ PPR</li><li>ตัด ต่อ ท่อกัลวาไนช์</li><li>ปั๊มน้ำเสีย / น้ำรั่วซึม / ทำงานไม่หยุด</li><li>ชักโครกมีกลิ่น / น้ำรั่วซึม</li><li>งานติดตั้งสุขภัณฑ์และอุปกรณ์งานประปาทั้งหมด</li></ul>',
        question: 'งานบริการประปา ครอบคลุมเรื่องอะไรบ้าง',
        __v: 0,
        id: '6360081a51f79b001dee990e',
      },
      {
        _id: '6360081a51f79b001dee990f',
        question: 'มีบริการจัดหาวัสดุด้วยไหม',
        answer:
          '<p>เรามีบริการจัดหาวัสดุให้ ถ้าทางลูกค้าไม่สะดวกจัดหาวัสดุเอง ซึ่งจะใช้ระยะเวลาในการจัดหาประมาณ 2 อาทิตย์ขึ้นไป&nbsp;</p>',
        __v: 0,
        id: '6360081a51f79b001dee990f',
      },
      {
        _id: '6360081a51f79b001dee9910',
        answer:
          '<p>ค่าแรงและค่าวัสดุสิ้นเปลือง ซึ่งสามารถอ่านเพิ่มเติมได้จากหน้าบริการแต่ละการบริการเพิ่มเติมได้ ก่อนหน้าชำระค่าบริการ ตัวอย่างเช่น&nbsp;<br>งานตัดต่อท่อ ราคารวมค่าแรง และค่าอุปกรณ์ดังต่อไปนี้</p><ol><li>ท่อ PPR (PN-10) ขนาดไม่เกิน 2 นิ้ว ยาวไม่เกิน 4 เมตร</li><li>วัสดุสิ้นเปลือง (น็อต สกรู เทปพันเกลียว ซิลิโคนขาวกันเชื้อรา)</li></ol>',
        question: 'ราคาค่าบริการครอบคลุมอะไรบ้าง',
        __v: 0,
        id: '6360081a51f79b001dee9910',
      },
      {
        _id: '6360081a51f79b001dee9911',
        question: 'คิวเรียกช่างเร็วสุดเมื่อไหร่',
        answer:
          '<p>ช่างเข้าสำรวจหน้างานภายใน 2-3 วัน หลังอนุมัติงานสำรวจ และ 1 วันนับจากวันที่ลูกค้าชำระค่าบริการ ส่วนของงานท่อและงานปั๊มน้ำ จะสามารถเข้าบริการภายใน 4-5 วัน</p>',
        __v: 0,
        id: '6360081a51f79b001dee9911',
      },
      {
        _id: '6360081a51f79b001dee9912',
        question: 'เรียกบริการผ่านเว็บไซต์ดีอย่างไร',
        answer:
          '<p>ลูกค้าสามารถติดตามสถานะงานผ่านทางเว็บไซต์ได้ตลอดเวลา และยังสามารถใช้โค้ดส่วนลดสำหรับลูกค้าที่ซื้อผ่านบนเว็บไซต์อีกด้วย</p>',
        __v: 0,
        id: '6360081a51f79b001dee9912',
      },
      {
        _id: '6360081a51f79b001dee9913',
        question: 'ใบเสนอราคาจะได้เมื่อไหร่ หลังจากที่ช่างเข้าสำรวจหน้างานเรียบร้อยแล้ว',
        answer:
          '<p>ใบเสนอราคาจะถูกส่งให้ลูกค้าตรวจสอบ ภายใน 24 ชม. หลังจากวันที่ช่างเข้าตรวจหน้างาน</p>',
        __v: 0,
        id: '6360081a51f79b001dee9913',
      },
    ],
    promotionSection: {
      _id: '636742806f10f9001b2ffbd2',
      title: 'โปรโมชั่น',
      promotions: [
        {
          _id: '636742806f10f9001b2ffbd3',
          url: 'https://fix.24x.co.th/voucher/firstfix-1',
          __v: 0,
          image: {
            _id: '637614b137fd76001b532030',
            name: '24FIX_NOV_BANNER4-02 (1).jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 94.2,
            width: 1500,
            height: 490,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 245,
                height: 80,
                size: 6.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              large: {
                name: 'large_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 327,
                size: 50.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              medium: {
                name: 'medium_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 245,
                size: 32.89,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              small: {
                name: 'small_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 163,
                size: 18.03,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
            },
            provider: 'aws-s3',
            related: ['636a17dc1e519e001c14731c'],
            createdAt: '2022-11-17T11:02:09.052Z',
            updatedAt: '2022-11-21T05:30:58.272Z',
            __v: 0,
            id: '637614b137fd76001b532030',
          },
          mobileImage: {
            _id: '636a6d86e6895d001ce68cc3',
            name: '24FIX_NOV_BANNER1-01.jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_1_01_3663796871',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 149.63,
            width: 1500,
            height: 1021,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_1_01_3663796871.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24FIX_NOV_BANNER1-01.jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 229,
                height: 156,
                size: 8.94,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              large: {
                name: 'large_24FIX_NOV_BANNER1-01.jpg',
                hash: 'large_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 681,
                size: 78.97,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              medium: {
                name: 'medium_24FIX_NOV_BANNER1-01.jpg',
                hash: 'medium_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 511,
                size: 51.21,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              small: {
                name: 'small_24FIX_NOV_BANNER1-01.jpg',
                hash: 'small_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 340,
                size: 27.91,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
            },
            provider: 'aws-s3',
            related: [],
            createdAt: '2022-11-08T14:53:58.508Z',
            updatedAt: '2022-11-08T16:06:16.745Z',
            __v: 0,
            id: '636a6d86e6895d001ce68cc3',
          },
          id: '636742806f10f9001b2ffbd3',
        },
      ],
      __v: 1,
      button: null,
      id: '636742806f10f9001b2ffbd2',
    },
    stepSection: null,
    successStorySection: {
      contents: [
        {
          relatedArticles: [],
          categories: [
            '60d1fe825749bf001bbb11e4',
            '62a76933e9dde5001b3c6b15',
            '62de67ecb31a7a001bba2d60',
          ],
          _id: '60fef2feea7297001be8c5f3',
          title: 'รีวิวผลงานจริง ล้างแอร์บ้านคุณเมย์ รัชนก อินทนนท์',
          slug: 'pro-may-onsite-review',
          shortDescription:
            'เพราะประเทศไทยมีแต่ฤดูร้อน ร้อนมาก และร้อนที่สุด! ดังนั้นการดูแล ทำความสะอาด ล้างแอร์ ก็ควรทำอย่างสม่ำเสมอนะ\n#งานล้างแอร์ #ล้างแอร์ฆ่าเชื้อ #เมย์ รัชนก อินทนนท์ #แอร์ไม่เย็น #ตรวจสภาพแอร์ #ล้างแอร์ #ซ่อมแอร์ ',
          views: 3549,
          published_at: '2021-07-26T17:38:13.448Z',
          contents: [
            {
              __component: 'article.content',
              id: '60fef2feea7297001be8c5f4',
            },
            {
              __component: 'article.images',
              id: '60fef2feea7297001be8c5f5',
            },
            {
              __component: 'article.content',
              id: '60fef2feea7297001be8c5f6',
            },
            {
              __component: 'article.images',
              id: '60fef2feea7297001be8c5f7',
            },
            {
              __component: 'article.content',
              id: '62cd0500df69b2001b4a8f1a',
            },
            {
              __component: 'article.images',
              id: '62cd0687df69b2001b4a8f39',
            },
            {
              __component: 'article.content',
              id: '62cd0687df69b2001b4a8f3a',
            },
            {
              __component: 'article.images',
              id: '62cd0687df69b2001b4a8f3b',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fbc',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fbd',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fbe',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fbf',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc0',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc1',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc2',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc3',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc4',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc5',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc6',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc7',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc8',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc9',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fca',
            },
          ],
          link: null,
          createdAt: '2021-07-26T17:38:06.604Z',
          updatedAt: '2022-07-25T10:08:01.825Z',
          __v: 2,
          coverImage: {
            _id: '60feef59ea7297001be8c5ed',
            name: '20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
            alternativeText: '',
            caption: '',
            hash: '20210510_On_site_Review_Artboard_v2_e9212db564',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 657.65,
            width: 2501,
            height: 1667,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'thumbnail_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 12.97,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              large: {
                name: 'large_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'large_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 1000,
                height: 667,
                size: 146.8,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              medium: {
                name: 'medium_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'medium_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 750,
                height: 500,
                size: 92.52,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              small: {
                name: 'small_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'small_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 46.42,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['60fef2feea7297001be8c5f3'],
            createdAt: '2021-07-26T17:22:33.885Z',
            updatedAt: '2021-07-30T03:43:47.943Z',
            __v: 0,
            id: '60feef59ea7297001be8c5ed',
          },
          metadata: null,
          id: '60fef2feea7297001be8c5f3',
        },
        {
          relatedArticles: ['60fef2feea7297001be8c5f3', '62cd8d63df69b2001b4a9b5c'],
          categories: [
            '62a76933e9dde5001b3c6b15',
            '60d1fe825749bf001bbb11e4',
            '62de67ecb31a7a001bba2d60',
          ],
          _id: '62cda1d7df69b2001b4a9c2a',
          published_at: '2022-07-12T16:36:03.404Z',
          slug: '911-assistant-rama-ix-porsche-service',
          shortDescription:
            'คุณลูกค้าได้ติดต่อให้ช่างอุ่นใจเข้ามาตรวจสอบปัญหาชักโครกมีกลิ่นเเละน้ำรั่วซึม ซึ่งช่างอุ่นใจได้รับโจทย์ในงานซ่อมแบ่งเป็น 2 ส่วนได้แก่ การซ่อมโถชักโครกและโถปัสสาวะชาย\n#งานเปลี่ยนสุขภัณฑ์ #รีวิว #กลิ่นโถส้วม',
          views: 244,
          title: 'รีวิวผลงานจริง @911 ASSISTANT RAMA IX (Porsche Service)',
          contents: [
            {
              __component: 'article.content',
              id: '62cda1d7df69b2001b4a9c2b',
            },
            {
              __component: 'article.content',
              id: '62cda1d7df69b2001b4a9c2c',
            },
          ],
          link: null,
          createdAt: '2022-07-12T16:31:19.223Z',
          updatedAt: '2022-07-25T10:08:01.825Z',
          __v: 1,
          coverImage: {
            _id: '62cd994fdf69b2001b4a9bbe',
            name: '144302486_851532738754884_6271739837459506095_n (Small).jpg',
            alternativeText: '',
            caption: '',
            hash: '144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 75.25,
            width: 720,
            height: 480,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_144302486_851532738754884_6271739837459506095_n (Small).jpg',
                hash: 'thumbnail_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 11.42,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
              },
              small: {
                name: 'small_144302486_851532738754884_6271739837459506095_n (Small).jpg',
                hash: 'small_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 40.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
              },
            },
            provider: 'aws-s3',
            related: ['62cda1d7df69b2001b4a9c2a'],
            createdAt: '2022-07-12T15:54:55.834Z',
            updatedAt: '2022-07-12T16:31:19.369Z',
            __v: 0,
            id: '62cd994fdf69b2001b4a9bbe',
          },
          metadata: null,
          id: '62cda1d7df69b2001b4a9c2a',
        },
        {
          relatedArticles: ['60fef2feea7297001be8c5f3'],
          categories: ['60d1fe825749bf001bbb11e4', '62a76933e9dde5001b3c6b15'],
          _id: '60fef555ea7297001be8c617',
          published_at: '2021-07-26T17:58:58.311Z',
          slug: 'ac-with-installation',
          shortDescription:
            '#ซื้อแอร์วันนี้แถมฟรีติดตั้ง\n\n☀ ถ้าจะบอกว่าเมืองไทย ‘อากาศร้อน’ เฉพาะในช่วงหน้าร้อนก็คงจะไม่ถูก เพราะไม่ว่าฤดูไหนๆ จะร้อน หนาว ฝน อากาศก็ร้อนอยู่ดี!\nวันนี้มาดับร้อนกันดีกว่า ❄ ด้วยบริการซื้อแอร์พร้อมติดตั้งฟรี โดยทีมช่างมืออาชีพ 24 FIX 😊',
          title: 'บริการซื้อแอร์พร้อมติดตั้ง',
          contents: [
            {
              __component: 'article.content',
              id: '60fef7daea7297001be8c649',
            },
            {
              __component: 'article.images',
              id: '60fef7daea7297001be8c64a',
            },
          ],
          link: null,
          createdAt: '2021-07-26T17:48:05.531Z',
          updatedAt: '2022-07-13T05:50:55.237Z',
          __v: 0,
          views: 1124,
          coverImage: {
            _id: '60fef76eea7297001be8c634',
            name: '117956473_738009603440532_2359157732673622296_n.jpeg',
            alternativeText: '',
            caption: '',
            hash: '117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 253.58,
            width: 1801,
            height: 1201,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'thumbnail_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 8.33,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              large: {
                name: 'large_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'large_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 1000,
                height: 667,
                size: 83.31,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              medium: {
                name: 'medium_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'medium_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 750,
                height: 500,
                size: 50.16,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              small: {
                name: 'small_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'small_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 26.25,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['60fef555ea7297001be8c617'],
            createdAt: '2021-07-26T17:57:02.195Z',
            updatedAt: '2021-07-30T03:43:47.943Z',
            __v: 0,
            id: '60fef76eea7297001be8c634',
          },
          metadata: null,
          id: '60fef555ea7297001be8c617',
        },
      ],
      _id: '6368ee8c1e519e001c146f04',
      title: 'ผลงานของเรา',
      __v: 0,
      button: null,
      id: '6368ee8c1e519e001c146f04',
    },
    reviewSection: {
      _id: '6360081b51f79b001dee9920',
      title: 'รีวิวจากผู้ใช้บริการของเรา',
      reviewContent: [
        {
          image: [
            {
              _id: '636734416f10f9001b2ff982',
              name: 'rn_image_picker_lib_temp_8e731987_a759_44c4_80f0_eed1131d207e_05c5e6dd4a.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_8e731987_a759_44c4_80f0_eed1131d207e_05c5e6dd4a_c5d876917a',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 26.92,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_8e731987_a759_44c4_80f0_eed1131d207e_05c5e6dd4a_c5d876917a.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_8e731987_a759_44c4_80f0_eed1131d207e_05c5e6dd4a.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_8e731987_a759_44c4_80f0_eed1131d207e_05c5e6dd4a_c5d876917a',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.85,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_8e731987_a759_44c4_80f0_eed1131d207e_05c5e6dd4a_c5d876917a.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_8e731987_a759_44c4_80f0_eed1131d207e_05c5e6dd4a.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_8e731987_a759_44c4_80f0_eed1131d207e_05c5e6dd4a_c5d876917a',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 25.46,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_8e731987_a759_44c4_80f0_eed1131d207e_05c5e6dd4a_c5d876917a.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_8e731987_a759_44c4_80f0_eed1131d207e_05c5e6dd4a.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_8e731987_a759_44c4_80f0_eed1131d207e_05c5e6dd4a_c5d876917a',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 14.37,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_8e731987_a759_44c4_80f0_eed1131d207e_05c5e6dd4a_c5d876917a.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:12:49.645Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636734416f10f9001b2ff982',
            },
            {
              _id: '636734416f10f9001b2ff981',
              name: 'rn_image_picker_lib_temp_bec918e3_02b5_4a7d_997c_8a0de41032bc_22e3830a59.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_bec918e3_02b5_4a7d_997c_8a0de41032bc_22e3830a59_410c7a46ac',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 38.87,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_bec918e3_02b5_4a7d_997c_8a0de41032bc_22e3830a59_410c7a46ac.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_bec918e3_02b5_4a7d_997c_8a0de41032bc_22e3830a59.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_bec918e3_02b5_4a7d_997c_8a0de41032bc_22e3830a59_410c7a46ac',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.62,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_bec918e3_02b5_4a7d_997c_8a0de41032bc_22e3830a59_410c7a46ac.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_bec918e3_02b5_4a7d_997c_8a0de41032bc_22e3830a59.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_bec918e3_02b5_4a7d_997c_8a0de41032bc_22e3830a59_410c7a46ac',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 35.67,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_bec918e3_02b5_4a7d_997c_8a0de41032bc_22e3830a59_410c7a46ac.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_bec918e3_02b5_4a7d_997c_8a0de41032bc_22e3830a59.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_bec918e3_02b5_4a7d_997c_8a0de41032bc_22e3830a59_410c7a46ac',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 19.14,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_bec918e3_02b5_4a7d_997c_8a0de41032bc_22e3830a59_410c7a46ac.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:12:49.629Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636734416f10f9001b2ff981',
            },
          ],
          _id: '6360081b51f79b001dee9921',
          name: 'วีxxxxxx',
          description: 'เรียกช่างมาซ่อมแซมท่อในห้องน้ำครับ ช่างให้บริการค่อนข้างดี รวดเร็วครับ ',
          score: 5,
          __v: 0,
          id: '6360081b51f79b001dee9921',
        },
        {
          image: [
            {
              _id: '6367345c6f10f9001b2ff983',
              name: 'rn_image_picker_lib_temp_27774ce7_1238_4282_95cb_fcdb9ee7e401_dbadb429d5.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_27774ce7_1238_4282_95cb_fcdb9ee7e401_dbadb429d5_badb18003a',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 62.19,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_27774ce7_1238_4282_95cb_fcdb9ee7e401_dbadb429d5_badb18003a.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_27774ce7_1238_4282_95cb_fcdb9ee7e401_dbadb429d5.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_27774ce7_1238_4282_95cb_fcdb9ee7e401_dbadb429d5_badb18003a',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 4.08,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_27774ce7_1238_4282_95cb_fcdb9ee7e401_dbadb429d5_badb18003a.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_27774ce7_1238_4282_95cb_fcdb9ee7e401_dbadb429d5.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_27774ce7_1238_4282_95cb_fcdb9ee7e401_dbadb429d5_badb18003a',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 56.03,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_27774ce7_1238_4282_95cb_fcdb9ee7e401_dbadb429d5_badb18003a.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_27774ce7_1238_4282_95cb_fcdb9ee7e401_dbadb429d5.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_27774ce7_1238_4282_95cb_fcdb9ee7e401_dbadb429d5_badb18003a',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 28.1,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_27774ce7_1238_4282_95cb_fcdb9ee7e401_dbadb429d5_badb18003a.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:13:16.300Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '6367345c6f10f9001b2ff983',
            },
            {
              _id: '6367345c6f10f9001b2ff984',
              name: 'rn_image_picker_lib_temp_0f016b67_3d18_4578_9ce3_e95dcbd5e84c_72eb016760.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_0f016b67_3d18_4578_9ce3_e95dcbd5e84c_72eb016760_e7968c3397',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 66.24,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_0f016b67_3d18_4578_9ce3_e95dcbd5e84c_72eb016760_e7968c3397.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_0f016b67_3d18_4578_9ce3_e95dcbd5e84c_72eb016760.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_0f016b67_3d18_4578_9ce3_e95dcbd5e84c_72eb016760_e7968c3397',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.99,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_0f016b67_3d18_4578_9ce3_e95dcbd5e84c_72eb016760_e7968c3397.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_0f016b67_3d18_4578_9ce3_e95dcbd5e84c_72eb016760.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_0f016b67_3d18_4578_9ce3_e95dcbd5e84c_72eb016760_e7968c3397',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 58.58,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_0f016b67_3d18_4578_9ce3_e95dcbd5e84c_72eb016760_e7968c3397.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_0f016b67_3d18_4578_9ce3_e95dcbd5e84c_72eb016760.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_0f016b67_3d18_4578_9ce3_e95dcbd5e84c_72eb016760_e7968c3397',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 28,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_0f016b67_3d18_4578_9ce3_e95dcbd5e84c_72eb016760_e7968c3397.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:13:16.313Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '6367345c6f10f9001b2ff984',
            },
          ],
          _id: '6360081b51f79b001dee9922',
          name: 'อธิxxxxx',
          description:
            'ชักโครกที่บ้านตัน แก้ไขเองแล้วไม่หาย เลยเรียกช่างมาให้บริการ แก้ไขงานได้เรียบร้อยดีครับ ',
          score: 4,
          __v: 0,
          id: '6360081b51f79b001dee9922',
        },
        {
          image: [
            {
              _id: '6367349e6f10f9001b2ff985',
              name: 'rn_image_picker_lib_temp_b9a497da_6e36_434e_aaf0_c1ac0ccafe09_53d2017f54.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_b9a497da_6e36_434e_aaf0_c1ac0ccafe09_53d2017f54_f5e9c4051b',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 44.37,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_b9a497da_6e36_434e_aaf0_c1ac0ccafe09_53d2017f54_f5e9c4051b.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_b9a497da_6e36_434e_aaf0_c1ac0ccafe09_53d2017f54.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_b9a497da_6e36_434e_aaf0_c1ac0ccafe09_53d2017f54_f5e9c4051b',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.6,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_b9a497da_6e36_434e_aaf0_c1ac0ccafe09_53d2017f54_f5e9c4051b.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_b9a497da_6e36_434e_aaf0_c1ac0ccafe09_53d2017f54.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_b9a497da_6e36_434e_aaf0_c1ac0ccafe09_53d2017f54_f5e9c4051b',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 40.29,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_b9a497da_6e36_434e_aaf0_c1ac0ccafe09_53d2017f54_f5e9c4051b.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_b9a497da_6e36_434e_aaf0_c1ac0ccafe09_53d2017f54.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_b9a497da_6e36_434e_aaf0_c1ac0ccafe09_53d2017f54_f5e9c4051b',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 21.02,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_b9a497da_6e36_434e_aaf0_c1ac0ccafe09_53d2017f54_f5e9c4051b.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:14:22.752Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '6367349e6f10f9001b2ff985',
            },
          ],
          _id: '6360081b51f79b001dee9923',
          name: 'อรนxxxx',
          description: 'ช่างมาแก้ไขท่อน้ำบริเวณซิงค์ล้างจานให้ค่ะ ช่างแก้ไขเรียบร้อยดีค่ะ',
          score: 5,
          __v: 0,
          id: '6360081b51f79b001dee9923',
        },
        {
          image: [
            {
              _id: '636734ba6f10f9001b2ff986',
              name: 'A63_A4_B7_D_D6_E5_453_D_B733_5460_A03_D5_E3_D_cd39118eed.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'A63_A4_B7_D_D6_E5_453_D_B733_5460_A03_D5_E3_D_cd39118eed_a150c04665',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 81.35,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/A63_A4_B7_D_D6_E5_453_D_B733_5460_A03_D5_E3_D_cd39118eed_a150c04665.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_A63_A4_B7_D_D6_E5_453_D_B733_5460_A03_D5_E3_D_cd39118eed.jpeg',
                  hash: 'thumbnail_A63_A4_B7_D_D6_E5_453_D_B733_5460_A03_D5_E3_D_cd39118eed_a150c04665',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 5.72,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_A63_A4_B7_D_D6_E5_453_D_B733_5460_A03_D5_E3_D_cd39118eed_a150c04665.jpeg',
                },
                medium: {
                  name: 'medium_A63_A4_B7_D_D6_E5_453_D_B733_5460_A03_D5_E3_D_cd39118eed.jpeg',
                  hash: 'medium_A63_A4_B7_D_D6_E5_453_D_B733_5460_A03_D5_E3_D_cd39118eed_a150c04665',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 73.42,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_A63_A4_B7_D_D6_E5_453_D_B733_5460_A03_D5_E3_D_cd39118eed_a150c04665.jpeg',
                },
                small: {
                  name: 'small_A63_A4_B7_D_D6_E5_453_D_B733_5460_A03_D5_E3_D_cd39118eed.jpeg',
                  hash: 'small_A63_A4_B7_D_D6_E5_453_D_B733_5460_A03_D5_E3_D_cd39118eed_a150c04665',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 37.97,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_A63_A4_B7_D_D6_E5_453_D_B733_5460_A03_D5_E3_D_cd39118eed_a150c04665.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:14:50.676Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636734ba6f10f9001b2ff986',
            },
            {
              _id: '636734ba6f10f9001b2ff987',
              name: 'B6031438_4_F03_4_EC_7_B023_84_E0_A2_EA_6_A49_7c91585962.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'B6031438_4_F03_4_EC_7_B023_84_E0_A2_EA_6_A49_7c91585962_6659871419',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 44.92,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/B6031438_4_F03_4_EC_7_B023_84_E0_A2_EA_6_A49_7c91585962_6659871419.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_B6031438_4_F03_4_EC_7_B023_84_E0_A2_EA_6_A49_7c91585962.jpeg',
                  hash: 'thumbnail_B6031438_4_F03_4_EC_7_B023_84_E0_A2_EA_6_A49_7c91585962_6659871419',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.69,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_B6031438_4_F03_4_EC_7_B023_84_E0_A2_EA_6_A49_7c91585962_6659871419.jpeg',
                },
                medium: {
                  name: 'medium_B6031438_4_F03_4_EC_7_B023_84_E0_A2_EA_6_A49_7c91585962.jpeg',
                  hash: 'medium_B6031438_4_F03_4_EC_7_B023_84_E0_A2_EA_6_A49_7c91585962_6659871419',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 40.86,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_B6031438_4_F03_4_EC_7_B023_84_E0_A2_EA_6_A49_7c91585962_6659871419.jpeg',
                },
                small: {
                  name: 'small_B6031438_4_F03_4_EC_7_B023_84_E0_A2_EA_6_A49_7c91585962.jpeg',
                  hash: 'small_B6031438_4_F03_4_EC_7_B023_84_E0_A2_EA_6_A49_7c91585962_6659871419',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 21.34,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_B6031438_4_F03_4_EC_7_B023_84_E0_A2_EA_6_A49_7c91585962_6659871419.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:14:50.689Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636734ba6f10f9001b2ff987',
            },
          ],
          _id: '6360081b51f79b001dee9924',
          name: 'คมxxxx',
          description: 'ช่างมาตรงเวลา ให้บริการดีครับ',
          score: 5,
          __v: 0,
          id: '6360081b51f79b001dee9924',
        },
        {
          image: [
            {
              _id: '636734e36f10f9001b2ff988',
              name: 'rn_image_picker_lib_temp_b2a1ca83_4dfd_45c7_8bf4_085d72133ba6_e3758168d2.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_b2a1ca83_4dfd_45c7_8bf4_085d72133ba6_e3758168d2_01f92bd7bb',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 35.92,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_b2a1ca83_4dfd_45c7_8bf4_085d72133ba6_e3758168d2_01f92bd7bb.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_b2a1ca83_4dfd_45c7_8bf4_085d72133ba6_e3758168d2.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_b2a1ca83_4dfd_45c7_8bf4_085d72133ba6_e3758168d2_01f92bd7bb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.55,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_b2a1ca83_4dfd_45c7_8bf4_085d72133ba6_e3758168d2_01f92bd7bb.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_b2a1ca83_4dfd_45c7_8bf4_085d72133ba6_e3758168d2.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_b2a1ca83_4dfd_45c7_8bf4_085d72133ba6_e3758168d2_01f92bd7bb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 32.6,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_b2a1ca83_4dfd_45c7_8bf4_085d72133ba6_e3758168d2_01f92bd7bb.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_b2a1ca83_4dfd_45c7_8bf4_085d72133ba6_e3758168d2.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_b2a1ca83_4dfd_45c7_8bf4_085d72133ba6_e3758168d2_01f92bd7bb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 16.42,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_b2a1ca83_4dfd_45c7_8bf4_085d72133ba6_e3758168d2_01f92bd7bb.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:15:31.028Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636734e36f10f9001b2ff988',
            },
            {
              _id: '636734e36f10f9001b2ff989',
              name: 'rn_image_picker_lib_temp_eed1503f_1882_4b88_976f_3e48b3f2c785_3f5ab39bc9.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_eed1503f_1882_4b88_976f_3e48b3f2c785_3f5ab39bc9_7457ca08c8',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 41.98,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_eed1503f_1882_4b88_976f_3e48b3f2c785_3f5ab39bc9_7457ca08c8.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_eed1503f_1882_4b88_976f_3e48b3f2c785_3f5ab39bc9.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_eed1503f_1882_4b88_976f_3e48b3f2c785_3f5ab39bc9_7457ca08c8',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.98,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_eed1503f_1882_4b88_976f_3e48b3f2c785_3f5ab39bc9_7457ca08c8.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_eed1503f_1882_4b88_976f_3e48b3f2c785_3f5ab39bc9.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_eed1503f_1882_4b88_976f_3e48b3f2c785_3f5ab39bc9_7457ca08c8',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 37.73,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_eed1503f_1882_4b88_976f_3e48b3f2c785_3f5ab39bc9_7457ca08c8.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_eed1503f_1882_4b88_976f_3e48b3f2c785_3f5ab39bc9.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_eed1503f_1882_4b88_976f_3e48b3f2c785_3f5ab39bc9_7457ca08c8',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 18.24,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_eed1503f_1882_4b88_976f_3e48b3f2c785_3f5ab39bc9_7457ca08c8.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:15:31.048Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636734e36f10f9001b2ff989',
            },
          ],
          _id: '6360081b51f79b001dee9925',
          name: 'ชวxxxx',
          description: 'เจ้าหน้าที่ให้บริการดีครับ ช่างเข้างานตรงเวลา',
          score: 4,
          __v: 0,
          id: '6360081b51f79b001dee9925',
        },
        {
          image: [
            {
              _id: '636735346f10f9001b2ff98c',
              name: 'rn_image_picker_lib_temp_7b5bbe5a_de2d_4eb7_ba31_c7ed43303dfe_37c985347d.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_7b5bbe5a_de2d_4eb7_ba31_c7ed43303dfe_37c985347d_193edd9806',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 30.65,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_7b5bbe5a_de2d_4eb7_ba31_c7ed43303dfe_37c985347d_193edd9806.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_7b5bbe5a_de2d_4eb7_ba31_c7ed43303dfe_37c985347d.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_7b5bbe5a_de2d_4eb7_ba31_c7ed43303dfe_37c985347d_193edd9806',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.42,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_7b5bbe5a_de2d_4eb7_ba31_c7ed43303dfe_37c985347d_193edd9806.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_7b5bbe5a_de2d_4eb7_ba31_c7ed43303dfe_37c985347d.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_7b5bbe5a_de2d_4eb7_ba31_c7ed43303dfe_37c985347d_193edd9806',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 28.66,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_7b5bbe5a_de2d_4eb7_ba31_c7ed43303dfe_37c985347d_193edd9806.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_7b5bbe5a_de2d_4eb7_ba31_c7ed43303dfe_37c985347d.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_7b5bbe5a_de2d_4eb7_ba31_c7ed43303dfe_37c985347d_193edd9806',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 16.42,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_7b5bbe5a_de2d_4eb7_ba31_c7ed43303dfe_37c985347d_193edd9806.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:16:52.302Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636735346f10f9001b2ff98c',
            },
            {
              _id: '636735346f10f9001b2ff98d',
              name: 'rn_image_picker_lib_temp_6b870900_8dce_42d5_b85b_c01d7d3548e4_28812be735.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_6b870900_8dce_42d5_b85b_c01d7d3548e4_28812be735_c09d9417f8',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 38.48,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_6b870900_8dce_42d5_b85b_c01d7d3548e4_28812be735_c09d9417f8.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_6b870900_8dce_42d5_b85b_c01d7d3548e4_28812be735.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_6b870900_8dce_42d5_b85b_c01d7d3548e4_28812be735_c09d9417f8',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.96,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_6b870900_8dce_42d5_b85b_c01d7d3548e4_28812be735_c09d9417f8.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_6b870900_8dce_42d5_b85b_c01d7d3548e4_28812be735.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_6b870900_8dce_42d5_b85b_c01d7d3548e4_28812be735_c09d9417f8',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 35.57,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_6b870900_8dce_42d5_b85b_c01d7d3548e4_28812be735_c09d9417f8.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_6b870900_8dce_42d5_b85b_c01d7d3548e4_28812be735.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_6b870900_8dce_42d5_b85b_c01d7d3548e4_28812be735_c09d9417f8',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 20.07,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_6b870900_8dce_42d5_b85b_c01d7d3548e4_28812be735_c09d9417f8.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:16:52.334Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636735346f10f9001b2ff98d',
            },
          ],
          _id: '6360081b51f79b001dee9928',
          name: 'พงxxxx',
          description:
            'เรียกใช้บริการช่างมาเปลี่ยนชักโครกกับอ่างล้างหน้าที่บ้านครับ เจ้าหน้าที่ให้คำแนะนำดีตอบไว และช่วยประสานงานกับช่างให้เข้ามาดำเนินการให้ออกมาเรียบร้อยดีครับ ',
          score: 4,
          __v: 0,
          id: '6360081b51f79b001dee9928',
        },
        {
          image: [
            {
              _id: '636735506f10f9001b2ff98e',
              name: 'rn_image_picker_lib_temp_5e81cdc3_c0dc_4fa0_9fd8_ed141642267c_505472abd9.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_5e81cdc3_c0dc_4fa0_9fd8_ed141642267c_505472abd9_ec0705f887',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 85.35,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_5e81cdc3_c0dc_4fa0_9fd8_ed141642267c_505472abd9_ec0705f887.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_5e81cdc3_c0dc_4fa0_9fd8_ed141642267c_505472abd9.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_5e81cdc3_c0dc_4fa0_9fd8_ed141642267c_505472abd9_ec0705f887',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 5.01,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_5e81cdc3_c0dc_4fa0_9fd8_ed141642267c_505472abd9_ec0705f887.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_5e81cdc3_c0dc_4fa0_9fd8_ed141642267c_505472abd9.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_5e81cdc3_c0dc_4fa0_9fd8_ed141642267c_505472abd9_ec0705f887',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 75.47,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_5e81cdc3_c0dc_4fa0_9fd8_ed141642267c_505472abd9_ec0705f887.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_5e81cdc3_c0dc_4fa0_9fd8_ed141642267c_505472abd9.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_5e81cdc3_c0dc_4fa0_9fd8_ed141642267c_505472abd9_ec0705f887',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 35.92,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_5e81cdc3_c0dc_4fa0_9fd8_ed141642267c_505472abd9_ec0705f887.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:17:20.158Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636735506f10f9001b2ff98e',
            },
            {
              _id: '636735506f10f9001b2ff98f',
              name: 'd289827f_dd75_4a83_a08d_5699fe8abf16_794fec590d.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'd289827f_dd75_4a83_a08d_5699fe8abf16_794fec590d_fb894dbf03',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 91.42,
              width: 1125,
              height: 1126,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/d289827f_dd75_4a83_a08d_5699fe8abf16_794fec590d_fb894dbf03.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_d289827f_dd75_4a83_a08d_5699fe8abf16_794fec590d.jpeg',
                  hash: 'thumbnail_d289827f_dd75_4a83_a08d_5699fe8abf16_794fec590d_fb894dbf03',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 156,
                  height: 156,
                  size: 5.45,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_d289827f_dd75_4a83_a08d_5699fe8abf16_794fec590d_fb894dbf03.jpeg',
                },
                large: {
                  name: 'large_d289827f_dd75_4a83_a08d_5699fe8abf16_794fec590d.jpeg',
                  hash: 'large_d289827f_dd75_4a83_a08d_5699fe8abf16_794fec590d_fb894dbf03',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 999,
                  height: 1000,
                  size: 85.88,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_d289827f_dd75_4a83_a08d_5699fe8abf16_794fec590d_fb894dbf03.jpeg',
                },
                medium: {
                  name: 'medium_d289827f_dd75_4a83_a08d_5699fe8abf16_794fec590d.jpeg',
                  hash: 'medium_d289827f_dd75_4a83_a08d_5699fe8abf16_794fec590d_fb894dbf03',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 749,
                  height: 750,
                  size: 57.07,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_d289827f_dd75_4a83_a08d_5699fe8abf16_794fec590d_fb894dbf03.jpeg',
                },
                small: {
                  name: 'small_d289827f_dd75_4a83_a08d_5699fe8abf16_794fec590d.jpeg',
                  hash: 'small_d289827f_dd75_4a83_a08d_5699fe8abf16_794fec590d_fb894dbf03',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 500,
                  height: 500,
                  size: 30.63,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_d289827f_dd75_4a83_a08d_5699fe8abf16_794fec590d_fb894dbf03.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:17:20.233Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636735506f10f9001b2ff98f',
            },
          ],
          _id: '6360081b51f79b001dee9929',
          name: 'ภรxxxx',
          description:
            'ก๊อกน้ำที่ห้องครัวพังเลยเรียกช่างจาก 24 FIX มาช่วยดำเนินการติดตั้งให้ใหม่ค่ะ ช่างดูเป็นมืออาชีพมากๆ ค่ะ ทำงานออกมาไม่มีปัญหาเลยค่ะ ',
          score: 4,
          __v: 0,
          id: '6360081b51f79b001dee9929',
        },
        {
          image: [
            {
              _id: '6367356a6f10f9001b2ff991',
              name: '8425_F367_35_FC_4_AA_4_9210_FEF_64735_CE_50_6781237cf4.jpeg',
              alternativeText: '',
              caption: '',
              hash: '8425_F367_35_FC_4_AA_4_9210_FEF_64735_CE_50_6781237cf4_5956e145fd',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 65.99,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/8425_F367_35_FC_4_AA_4_9210_FEF_64735_CE_50_6781237cf4_5956e145fd.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_8425_F367_35_FC_4_AA_4_9210_FEF_64735_CE_50_6781237cf4.jpeg',
                  hash: 'thumbnail_8425_F367_35_FC_4_AA_4_9210_FEF_64735_CE_50_6781237cf4_5956e145fd',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 5.11,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_8425_F367_35_FC_4_AA_4_9210_FEF_64735_CE_50_6781237cf4_5956e145fd.jpeg',
                },
                medium: {
                  name: 'medium_8425_F367_35_FC_4_AA_4_9210_FEF_64735_CE_50_6781237cf4.jpeg',
                  hash: 'medium_8425_F367_35_FC_4_AA_4_9210_FEF_64735_CE_50_6781237cf4_5956e145fd',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 60.11,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_8425_F367_35_FC_4_AA_4_9210_FEF_64735_CE_50_6781237cf4_5956e145fd.jpeg',
                },
                small: {
                  name: 'small_8425_F367_35_FC_4_AA_4_9210_FEF_64735_CE_50_6781237cf4.jpeg',
                  hash: 'small_8425_F367_35_FC_4_AA_4_9210_FEF_64735_CE_50_6781237cf4_5956e145fd',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 31.96,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_8425_F367_35_FC_4_AA_4_9210_FEF_64735_CE_50_6781237cf4_5956e145fd.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:17:46.969Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '6367356a6f10f9001b2ff991',
            },
            {
              _id: '6367356a6f10f9001b2ff990',
              name: '16_DD_1_CA_0_65_D7_456_F_A36_A_65_C95239_E427_516337ab8e.jpeg',
              alternativeText: '',
              caption: '',
              hash: '16_DD_1_CA_0_65_D7_456_F_A36_A_65_C95239_E427_516337ab8e_135213abc7',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 78.63,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/16_DD_1_CA_0_65_D7_456_F_A36_A_65_C95239_E427_516337ab8e_135213abc7.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_16_DD_1_CA_0_65_D7_456_F_A36_A_65_C95239_E427_516337ab8e.jpeg',
                  hash: 'thumbnail_16_DD_1_CA_0_65_D7_456_F_A36_A_65_C95239_E427_516337ab8e_135213abc7',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 5.65,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_16_DD_1_CA_0_65_D7_456_F_A36_A_65_C95239_E427_516337ab8e_135213abc7.jpeg',
                },
                medium: {
                  name: 'medium_16_DD_1_CA_0_65_D7_456_F_A36_A_65_C95239_E427_516337ab8e.jpeg',
                  hash: 'medium_16_DD_1_CA_0_65_D7_456_F_A36_A_65_C95239_E427_516337ab8e_135213abc7',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 71.34,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_16_DD_1_CA_0_65_D7_456_F_A36_A_65_C95239_E427_516337ab8e_135213abc7.jpeg',
                },
                small: {
                  name: 'small_16_DD_1_CA_0_65_D7_456_F_A36_A_65_C95239_E427_516337ab8e.jpeg',
                  hash: 'small_16_DD_1_CA_0_65_D7_456_F_A36_A_65_C95239_E427_516337ab8e_135213abc7',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 36.98,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_16_DD_1_CA_0_65_D7_456_F_A36_A_65_C95239_E427_516337ab8e_135213abc7.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:17:46.965Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '6367356a6f10f9001b2ff990',
            },
          ],
          _id: '6360081b51f79b001dee992a',
          name: 'วรรณxxxx',
          description: 'ช่างให้บริการดีค่ะ เข้างานตรงเวลา เก็บงานเรียบร้อยค่ะ ',
          score: 5,
          __v: 0,
          id: '6360081b51f79b001dee992a',
        },
        {
          image: [
            {
              _id: '636735196f10f9001b2ff98b',
              name: 'C2_AAEF_67_EDE_0_42_E9_8_F59_8_D5130556_B5_B_3f3b9e75d6.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'C2_AAEF_67_EDE_0_42_E9_8_F59_8_D5130556_B5_B_3f3b9e75d6_7ff8f2d5e1',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 37.76,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/C2_AAEF_67_EDE_0_42_E9_8_F59_8_D5130556_B5_B_3f3b9e75d6_7ff8f2d5e1.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_C2_AAEF_67_EDE_0_42_E9_8_F59_8_D5130556_B5_B_3f3b9e75d6.jpeg',
                  hash: 'thumbnail_C2_AAEF_67_EDE_0_42_E9_8_F59_8_D5130556_B5_B_3f3b9e75d6_7ff8f2d5e1',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.93,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_C2_AAEF_67_EDE_0_42_E9_8_F59_8_D5130556_B5_B_3f3b9e75d6_7ff8f2d5e1.jpeg',
                },
                medium: {
                  name: 'medium_C2_AAEF_67_EDE_0_42_E9_8_F59_8_D5130556_B5_B_3f3b9e75d6.jpeg',
                  hash: 'medium_C2_AAEF_67_EDE_0_42_E9_8_F59_8_D5130556_B5_B_3f3b9e75d6_7ff8f2d5e1',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 33.94,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_C2_AAEF_67_EDE_0_42_E9_8_F59_8_D5130556_B5_B_3f3b9e75d6_7ff8f2d5e1.jpeg',
                },
                small: {
                  name: 'small_C2_AAEF_67_EDE_0_42_E9_8_F59_8_D5130556_B5_B_3f3b9e75d6.jpeg',
                  hash: 'small_C2_AAEF_67_EDE_0_42_E9_8_F59_8_D5130556_B5_B_3f3b9e75d6_7ff8f2d5e1',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 17.19,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_C2_AAEF_67_EDE_0_42_E9_8_F59_8_D5130556_B5_B_3f3b9e75d6_7ff8f2d5e1.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:16:25.410Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636735196f10f9001b2ff98b',
            },
          ],
          _id: '6360081b51f79b001dee9927',
          name: 'นภัสxxxx',
          description: 'ใช้บริการติดตั้งเครื่องทำน้ำอุ่นค่ะ ช่างทำงานดี เก็บงานเรียบร้อยค่ะ',
          score: 4,
          __v: 0,
          id: '6360081b51f79b001dee9927',
        },
        {
          image: [
            {
              _id: '636735016f10f9001b2ff98a',
              name: 'rn_image_picker_lib_temp_bc098a64_274e_4751_a4d0_999f4fa8c901_f73f4f4866.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_bc098a64_274e_4751_a4d0_999f4fa8c901_f73f4f4866_cd5db51ed6',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 37.47,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_bc098a64_274e_4751_a4d0_999f4fa8c901_f73f4f4866_cd5db51ed6.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_bc098a64_274e_4751_a4d0_999f4fa8c901_f73f4f4866.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_bc098a64_274e_4751_a4d0_999f4fa8c901_f73f4f4866_cd5db51ed6',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.53,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_bc098a64_274e_4751_a4d0_999f4fa8c901_f73f4f4866_cd5db51ed6.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_bc098a64_274e_4751_a4d0_999f4fa8c901_f73f4f4866.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_bc098a64_274e_4751_a4d0_999f4fa8c901_f73f4f4866_cd5db51ed6',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 33.97,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_bc098a64_274e_4751_a4d0_999f4fa8c901_f73f4f4866_cd5db51ed6.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_bc098a64_274e_4751_a4d0_999f4fa8c901_f73f4f4866.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_bc098a64_274e_4751_a4d0_999f4fa8c901_f73f4f4866_cd5db51ed6',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 18.28,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_bc098a64_274e_4751_a4d0_999f4fa8c901_f73f4f4866_cd5db51ed6.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:16:01.735Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636735016f10f9001b2ff98a',
            },
          ],
          _id: '6360081b51f79b001dee9926',
          name: 'ธัญxxxx',
          description:
            'เรียกช่างจากที่นี่มาติดตั้งปั๊มน้ำให้ค่ะ ช่างดูแลดีในทุกขั้นตอนและให้คำปรึกษาดีค่ะ งานแก้ไขเรียบร้อยดี และช่างก็มาก่อนเวลานัดหมายด้วยค่ะ ',
          score: 4,
          __v: 0,
          id: '6360081b51f79b001dee9926',
        },
      ],
      __v: 1,
      id: '6360081b51f79b001dee9920',
    },
    ctaSection: {
      _id: '636748936f10f9001b2ffd7f',
      title: '<p>ซ่อมแซมและดูแลงานประปา โดยช่างมืออาชีพ</p>',
      button: {
        _id: '636748936f10f9001b2ffd80',
        url: 'https://fix.24x.co.th/piping/booking',
        title: 'จองบริการ',
        __v: 0,
        id: '636748936f10f9001b2ffd80',
      },
      __v: 1,
      id: '636748936f10f9001b2ffd7f',
    },
    createdAt: '2022-10-31T17:38:34.893Z',
    updatedAt: '2023-01-11T09:47:14.296Z',
    __v: 2,
    metadata: {
      twitterCardType: 'summary',
      _id: '63bd0699c37f54001cf15cb5',
      metaTitle: 'ซ่อมแซมและดูแลงานประปา',
      metaDescription:
        'เรามีทีมช่างผู้เชียวชาญด้านการติดตั้งสุขภัณฑ์ และซ่อมแซมประปา รับประกันงานผลงานนาน 30 วัน',
      keywords:
        'ระบบประปา,ท่อน้ำ, ช่าง ประปา ใกล้ ฉัน,ช่าง ซ่อม ประปา, ซ่อม ท่อ ประปา รั่ว, ช่าง ประปา, ช่าง ซ่อม ประปา',
      __v: 0,
      id: '63bd0699c37f54001cf15cb5',
    },
    installationSection: null,
    id: '6360081a51f79b001dee9907',
  },
  {
    _id: '635fec772837c5001c2689d9',
    published_at: '2022-11-07T11:32:54.154Z',
    slug: 'tile',
    bannerSection: {
      _id: '6367471c6f10f9001b2ffd00',
      title: '<p><strong>บริการปูกระเบื้องพื้นและผนังเรียบเนียนสวยด้วยทีมช่างมืออาชีพ</strong></p>',
      button: {
        _id: '6367471c6f10f9001b2ffd01',
        title: 'จองบริการ',
        url: 'https://fix.24x.co.th/tile/booking',
        __v: 0,
        id: '6367471c6f10f9001b2ffd01',
      },
      __v: 1,
      image: {
        _id: '6367da6d6f10f9001b2ffdc2',
        name: '24FIX_LD_BANNER-02.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_02_143373d6bd',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 658.51,
        width: 6001,
        height: 2634,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_02_143373d6bd.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER-02.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_02_143373d6bd',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 108,
            size: 4.39,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_02_143373d6bd.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER-02.jpg',
            hash: 'large_24_FIX_LD_BANNER_02_143373d6bd',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 439,
            size: 38.71,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_02_143373d6bd.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER-02.jpg',
            hash: 'medium_24_FIX_LD_BANNER_02_143373d6bd',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 329,
            size: 23.59,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_02_143373d6bd.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER-02.jpg',
            hash: 'small_24_FIX_LD_BANNER_02_143373d6bd',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 219,
            size: 12.78,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_02_143373d6bd.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-11-06T16:01:49.353Z',
        updatedAt: '2022-11-06T16:42:58.599Z',
        __v: 0,
        id: '6367da6d6f10f9001b2ffdc2',
      },
      mobileImage: {
        _id: '6367da846f10f9001b2ffdc3',
        name: '24FIX_LD_BANNER_MOBILE-02.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_MOBILE_02_6bc6ed6468',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 90.9,
        width: 1501,
        height: 930,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_MOBILE_02_6bc6ed6468.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER_MOBILE-02.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_MOBILE_02_6bc6ed6468',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 152,
            size: 4.84,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_MOBILE_02_6bc6ed6468.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER_MOBILE-02.jpg',
            hash: 'large_24_FIX_LD_BANNER_MOBILE_02_6bc6ed6468',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 620,
            size: 47.91,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_MOBILE_02_6bc6ed6468.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER_MOBILE-02.jpg',
            hash: 'medium_24_FIX_LD_BANNER_MOBILE_02_6bc6ed6468',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 465,
            size: 28.26,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_MOBILE_02_6bc6ed6468.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER_MOBILE-02.jpg',
            hash: 'small_24_FIX_LD_BANNER_MOBILE_02_6bc6ed6468',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 310,
            size: 15.11,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_MOBILE_02_6bc6ed6468.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-11-06T16:02:12.307Z',
        updatedAt: '2022-11-06T16:42:58.599Z',
        __v: 0,
        id: '6367da846f10f9001b2ffdc3',
      },
      id: '6367471c6f10f9001b2ffd00',
    },
    uspSection: [
      {
        _id: '6367471c6f10f9001b2ffd04',
        title: 'บริการปูกระเบื้องพื้นและผนังเรียบเนียนสวยด้วยทีมช่างมืออาชีพ',
        subTitle:
          'บริการปูกระเบื้องพื้นและผนั่งทุกรูปแบบ สวยเรียบเนียนด้วยเทคนิคเฉพาะจากช่างมืออาชีพ ปูกระเบื้องใหม่หรือซ่อมแซมกระเบื้องเก่า เราเชียวชาญทุกงานกระเบื้อง',
        description:
          '<p><strong>ทำไมต้องจองกับ 24FIX?</strong></p><ul><li>รับประกันหลังงานซ่อม สูงสุด 60 วัน</li><li>มั่นใจในคุณภาพ จากวัสดุเกรดพรีเมี่ยม</li><li>ทีมช่างเข้าตรวจหน้างานก่อนให้บริการภายใน 2 วัน</li><li>ราคางานซ่อมที่ได้มาตรฐาน คุ้มค่ากับคุณภาพบริการ</li></ul>',
        __v: 0,
        image: {
          _id: '6367da546f10f9001b2ffdc1',
          name: 'Service_Desktop-02.jpg',
          alternativeText: '',
          caption: '',
          hash: 'Service_Desktop_02_a0d876d44d',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 245.87,
          width: 2121,
          height: 1425,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/Service_Desktop_02_a0d876d44d.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_Service_Desktop-02.jpg',
              hash: 'thumbnail_Service_Desktop_02_a0d876d44d',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 232,
              height: 156,
              size: 6.4,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_Service_Desktop_02_a0d876d44d.jpg',
            },
            large: {
              name: 'large_Service_Desktop-02.jpg',
              hash: 'large_Service_Desktop_02_a0d876d44d',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 1000,
              height: 672,
              size: 66.02,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/large_Service_Desktop_02_a0d876d44d.jpg',
            },
            medium: {
              name: 'medium_Service_Desktop-02.jpg',
              hash: 'medium_Service_Desktop_02_a0d876d44d',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 504,
              size: 41,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_Service_Desktop_02_a0d876d44d.jpg',
            },
            small: {
              name: 'small_Service_Desktop-02.jpg',
              hash: 'small_Service_Desktop_02_a0d876d44d',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 336,
              size: 20.84,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_Service_Desktop_02_a0d876d44d.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-11-06T16:01:24.559Z',
          updatedAt: '2022-11-06T16:42:58.599Z',
          __v: 0,
          id: '6367da546f10f9001b2ffdc1',
        },
        id: '6367471c6f10f9001b2ffd04',
      },
    ],
    faqSection: [
      {
        _id: '635fec772837c5001c2689da',
        question: 'ราคาบนเว็บไซต์ รวมอะไรบ้าง',
        answer:
          '<p>ค่าบริการดังกล่าวรวมค่าแรง ค่าปรับระดับพื้นด้วยปูนทรายหนาไม่เกิน 2-5 ซม. ปูนกาวมาตรฐานจากจระเข้ ยาแนว และวัสดุสิ้นเปลือง</p>',
        __v: 0,
        id: '635fec772837c5001c2689da',
      },
      {
        _id: '635fec772837c5001c2689db',
        question: 'คิวช่างได้เร็วสุดเมื่อไหร่',
        answer:
          '<p>คิวช่างเข้าสำรวจหน้างานภายใน 2-3 วัน หลังอนุมัติงานสำรวจ และคิวช่างเข้าปูกระเบื้องภายใน 3 วันนับจากวันที่ชำระเงิน</p>',
        __v: 0,
        id: '635fec772837c5001c2689db',
      },
      {
        _id: '635fec772837c5001c2689dc',
        question: 'ใช้เวลาในการทำเท่าไหร่',
        answer:
          '<p>ระยะเวลาขึ้นอยู่กับขนาดพื้นที่และอุปสรรคหน้างานครับ โดยปกติแล้ว สำหรับพื้นที่ไม่เกิน 10 ตรม. งานสามารถเสร็จได้ภายใน 1-3 วันครับ</p>',
        __v: 0,
        id: '635fec772837c5001c2689dc',
      },
      {
        _id: '635fec772837c5001c2689dd',
        question: 'ทำไมต้องสำรวจหน้างานก่อน ให้ช่างเข้าทำงานเลยได้หรือไม่',
        answer:
          '<p>การสำรวจหน้างาน จะสามารถทำให้เราได้ร่วมวางแผนกับคุณลูกค้า เพื่อให้รายละเอียดงานครบถ้วนและอยู่ในงบประมาณที่ได้ตกลงกันไว้ครับ</p>',
        __v: 0,
        id: '635fec772837c5001c2689dd',
      },
      {
        _id: '635fec772837c5001c2689de',
        question: 'ค่าใช้จ่ายในการสำรวจ นำมาเป็นส่วนลดได้ไหม',
        answer:
          '<p>ค่าใช้จ่ายในการสำรวจพื้นที่ สามารถนำมาเป็นส่วนลดงานปูกระเบื้องได้เต็มจำนวนครับ</p>',
        __v: 0,
        id: '635fec772837c5001c2689de',
      },
      {
        _id: '635fec772837c5001c2689df',
        answer:
          '<p>ปัจจัยที่มีผลต่อราคาค่าบริการ มีดังนี้ครับ</p><ul><li>ขนาดพื้นที่</li><li>ขนาดกระเบื้อง (ไซส์มาตรฐาน 30*30 cm ถึง 60*60 cm)</li><li>สภาพพื้นเดิม (พื้นเปล่า หรือ พื้นที่มีกระเบื้องเดิมอยู่แล้ว รวมถึงสภาพพื้นเดิมใต้กระเบื้อง)</li><li>วัสดุที่ต้องการปู (กระเบื้องพื้น, ผนัง, กระเบื้องยาง, ลามิเนต)</li><li>ห้องที่ต้องการปู (บริเวณห้องน้ำจะมีค่าบริการทำกันซึมเพื่อป้องกันน้ำรั่วซึมตามมาในภายหลังด้วย)</li></ul>',
        question: 'ปัจจัยที่มีผลต่อราคาค่าบริการ',
        __v: 0,
        id: '635fec772837c5001c2689df',
      },
      {
        _id: '635fec772837c5001c2689e0',
        question: 'ราคานี้ รวมปรับพื้นด้วยหรือไม่',
        answer:
          '<p>ค่าบริการดังกล่าว รวมการปรับพื้นด้วยปูนทราย ความหนา 2-5 ซม.ให้เรียบร้อยแล้ว กรณีที่หน้างานจำเป็นต้องสกัดพื้นใต้กระเบื้อง เพื่อให้พื้นใหม่หลังปูกระเบื้องได้ระดับที่ต้องการ จะมีค่าบริการเพิ่มเติมตามราคามาตรฐาน</p>',
        __v: 0,
        id: '635fec772837c5001c2689e0',
      },
      {
        _id: '635fec772837c5001c2689e1',
        question: 'มีการรับประกันอย่างไร',
        answer:
          '<p>การรับประกันงาน มีระยะเวลาการรับประกัน 60 วัน โดยการรับประกันจะครอบคลุมผลงานที่เกิดจากการติดตั้ง (หลุดร่อน) ตามขอบเขตการให้บริการในเอกสารเสนอราคาเท่านั้น</p>',
        __v: 0,
        id: '635fec772837c5001c2689e1',
      },
      {
        _id: '635fec772837c5001c2689e2',
        question: 'พื้นที่ที่ให้บริการมีอะไรบ้าง',
        answer: '<p>พื้นที่ให้บริการครอบคลุมในเขตกรุงเทพมหานคร นนทบุรี ปทุมธานี และสมุทรปราการ</p>',
        __v: 0,
        id: '635fec772837c5001c2689e2',
      },
      {
        _id: '635fec772837c5001c2689e3',
        question: 'วิธีคำนวณขนาดพื้นที่คร่าวๆ เพื่อประเมิณราคาเบื้องต้น',
        answer:
          '<p>วัดพื้นที่ฝั่งด้านกว้าง และฝั่งด้านยาวของพื้นที่ นำตัวเลข “กว้าง” มาคูณ กับตัวเลข “ยาว” ซึ่งตัวเลขกว้าง กับ ตัวเลขยาว จะมีหน่วยเป็น “เมตร” แล้วนำ “เมตร” คูณกับ “เมตร” ก็จะได้ขนาดพื้นที่ เป็น “ตารางเมตร”&nbsp;</p>',
        __v: 0,
        id: '635fec772837c5001c2689e3',
      },
      {
        _id: '635fec772837c5001c2689e4',
        question: 'มีบริการจัดหาวัสดุด้วยไหม',
        answer:
          '<p>เรามีบริการจัดหาวัสดุให้ ถ้าทางลูกค้าไม่สะดวกจัดหาวัสดุเอง ซึ่งจะใช้ระยะเวลาในการจัดหาประมาณ 2 อาทิตย์ขึ้นไป&nbsp;</p>',
        __v: 0,
        id: '635fec772837c5001c2689e4',
      },
    ],
    promotionSection: {
      _id: '63673ff56f10f9001b2ffb65',
      title: 'โปรโมชั่น',
      promotions: [
        {
          _id: '63673ff56f10f9001b2ffb66',
          url: 'https://fix.24x.co.th/voucher/firstfix-1',
          __v: 0,
          image: {
            _id: '637614b137fd76001b532030',
            name: '24FIX_NOV_BANNER4-02 (1).jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 94.2,
            width: 1500,
            height: 490,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 245,
                height: 80,
                size: 6.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              large: {
                name: 'large_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 327,
                size: 50.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              medium: {
                name: 'medium_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 245,
                size: 32.89,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              small: {
                name: 'small_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 163,
                size: 18.03,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
            },
            provider: 'aws-s3',
            related: ['636a17dc1e519e001c14731c'],
            createdAt: '2022-11-17T11:02:09.052Z',
            updatedAt: '2022-11-21T05:30:58.272Z',
            __v: 0,
            id: '637614b137fd76001b532030',
          },
          mobileImage: {
            _id: '636a6d86e6895d001ce68cc3',
            name: '24FIX_NOV_BANNER1-01.jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_1_01_3663796871',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 149.63,
            width: 1500,
            height: 1021,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_1_01_3663796871.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24FIX_NOV_BANNER1-01.jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 229,
                height: 156,
                size: 8.94,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              large: {
                name: 'large_24FIX_NOV_BANNER1-01.jpg',
                hash: 'large_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 681,
                size: 78.97,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              medium: {
                name: 'medium_24FIX_NOV_BANNER1-01.jpg',
                hash: 'medium_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 511,
                size: 51.21,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              small: {
                name: 'small_24FIX_NOV_BANNER1-01.jpg',
                hash: 'small_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 340,
                size: 27.91,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
            },
            provider: 'aws-s3',
            related: [],
            createdAt: '2022-11-08T14:53:58.508Z',
            updatedAt: '2022-11-08T16:06:16.745Z',
            __v: 0,
            id: '636a6d86e6895d001ce68cc3',
          },
          id: '63673ff56f10f9001b2ffb66',
        },
      ],
      __v: 1,
      button: null,
      id: '63673ff56f10f9001b2ffb65',
    },
    stepSection: null,
    successStorySection: {
      contents: [
        {
          relatedArticles: [
            '60fef2feea7297001be8c5f3',
            '60ff8705ea7297001be8c699',
            '62cd66d9df69b2001b4a97c2',
          ],
          categories: ['60892879f735dd001d56a31c'],
          _id: '6364f4136f10f9001b2ff850',
          title: 'ช่างรู้คู้บ้าน วิธีปูกระเบื้องใหม่ทับกระเบื้องเก่า',
          slug: 'how-to-clean-tiles',
          shortDescription:
            'เมื่อกระเบื้องเริ่มเก่า เริ่มมีรอย ขัดไม่ออก 🏠​\nอาจทำให้รู้สึกอยากเปลี่ยนกระเบื้องใหม่แต่ไม่อยากรื้อกระเบื้องเดิม ​เพราะการรื้อของเก่านอกจากราคารื้อจะสูงแล้ว ยังก่อให้เกิดฝุ่นอีกด้วย ',
          published_at: '2022-11-04T11:16:19.031Z',
          contents: [
            {
              __component: 'article.images',
              id: '636dfbb5d42554001c0d0321',
            },
            {
              __component: 'article.content',
              id: '6364f4136f10f9001b2ff851',
            },
            {
              __component: 'article.images',
              id: '6364f4136f10f9001b2ff852',
            },
            {
              __component: 'article.content',
              id: '6364f4136f10f9001b2ff853',
            },
            {
              __component: 'article.images',
              id: '6364f4136f10f9001b2ff854',
            },
            {
              __component: 'article.content',
              id: '6364f4136f10f9001b2ff855',
            },
            {
              __component: 'article.images',
              id: '6364f4136f10f9001b2ff856',
            },
            {
              __component: 'article.content',
              id: '6364f4136f10f9001b2ff857',
            },
            {
              __component: 'article.images',
              id: '6364f4136f10f9001b2ff858',
            },
            {
              __component: 'article.content',
              id: '6364f4136f10f9001b2ff859',
            },
            {
              __component: 'article.images',
              id: '6364f4136f10f9001b2ff85a',
            },
            {
              __component: 'article.content',
              id: '6364f4136f10f9001b2ff85b',
            },
          ],
          link: null,
          createdAt: '2022-11-04T11:14:27.879Z',
          updatedAt: '2022-11-11T07:37:25.297Z',
          __v: 2,
          coverImage: {
            _id: '636dfb78d42554001c0d0313',
            name: '70385bf1-0beb-4cfd-8390-c15c0f90cd16.jpeg',
            alternativeText: '',
            caption: '',
            hash: '70385bf1_0beb_4cfd_8390_c15c0f90cd16_c65864ef98',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 37.26,
            width: 471,
            height: 314,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/70385bf1_0beb_4cfd_8390_c15c0f90cd16_c65864ef98.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_70385bf1-0beb-4cfd-8390-c15c0f90cd16.jpeg',
                hash: 'thumbnail_70385bf1_0beb_4cfd_8390_c15c0f90cd16_c65864ef98',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 8.71,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_70385bf1_0beb_4cfd_8390_c15c0f90cd16_c65864ef98.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['6364f4136f10f9001b2ff850'],
            createdAt: '2022-11-11T07:36:24.240Z',
            updatedAt: '2022-11-14T03:22:13.496Z',
            __v: 0,
            id: '636dfb78d42554001c0d0313',
          },
          metadata: null,
          id: '6364f4136f10f9001b2ff850',
        },
        {
          relatedArticles: [],
          categories: ['60892879f735dd001d56a31c'],
          _id: '6364eaf26f10f9001b2ff829',
          published_at: '2022-11-04T10:36:17.207Z',
          slug: 'Look-at-the-cause-of-broken-tiles-A-silent-threat-to-prevent',
          shortDescription:
            'ปัญหากระเบื้องร้าวแตกหนึ่งครั้ง ก็ต้องเสียเงินหลายบาทเพื่อซ่อมแซม​เพื่อเปลี่ยนกระเบื้องใหม่ จะดีกว่าไหมถ้าเราสามารถป้องกันไม่ให้ปัญหานั้นเกิดขึ้นได้ ​',
          title: 'ช่างรู้คู่บ้าน ส่องสาเหตุกระเบื้องแตก ภัยเงียบที่ต้องป้องกัน',
          contents: [
            {
              __component: 'article.images',
              id: '636e0326d42554001c0d03ae',
            },
            {
              __component: 'article.content',
              id: '6364eaf26f10f9001b2ff82a',
            },
            {
              __component: 'article.images',
              id: '6364eaf26f10f9001b2ff82b',
            },
            {
              __component: 'article.content',
              id: '6364eaf26f10f9001b2ff82c',
            },
            {
              __component: 'article.images',
              id: '6364eaf26f10f9001b2ff82d',
            },
            {
              __component: 'article.content',
              id: '6364eaf26f10f9001b2ff82e',
            },
            {
              __component: 'article.images',
              id: '6364eaf26f10f9001b2ff82f',
            },
            {
              __component: 'article.content',
              id: '6364eaf26f10f9001b2ff830',
            },
          ],
          link: null,
          createdAt: '2022-11-04T10:35:30.779Z',
          updatedAt: '2022-11-11T08:09:10.929Z',
          __v: 1,
          coverImage: {
            _id: '636e02ffd42554001c0d03ac',
            name: '54d24da6-6c78-4efb-8df8-2f7c5da85b4e.jpeg',
            alternativeText: '',
            caption: '',
            hash: '54d24da6_6c78_4efb_8df8_2f7c5da85b4e_0510d478c3',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 30.23,
            width: 470,
            height: 314,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/54d24da6_6c78_4efb_8df8_2f7c5da85b4e_0510d478c3.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_54d24da6-6c78-4efb-8df8-2f7c5da85b4e.jpeg',
                hash: 'thumbnail_54d24da6_6c78_4efb_8df8_2f7c5da85b4e_0510d478c3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 7.58,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_54d24da6_6c78_4efb_8df8_2f7c5da85b4e_0510d478c3.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['6364eaf26f10f9001b2ff829'],
            createdAt: '2022-11-11T08:08:31.543Z',
            updatedAt: '2022-11-11T08:09:10.923Z',
            __v: 0,
            id: '636e02ffd42554001c0d03ac',
          },
          metadata: null,
          id: '6364eaf26f10f9001b2ff829',
        },
        {
          relatedArticles: ['636a07631e519e001c1472e1', '60fef555ea7297001be8c617'],
          categories: ['60892879f735dd001d56a31c'],
          _id: '636a07631e519e001c1472e1',
          published_at: '2022-11-08T07:38:39.918Z',
          slug: '3-spc',
          shortDescription:
            'คุณสมบัติระดับพรีเมี่ยม ลวดลายถูกใจดีไซน์สวย ติดตั้งไม่ยาก ถูกใจสายรักบ้านที่กำลังมองหากระเบื้องที่คงทนและสวยงาม  ',
          title: '3 เหตุผล ที่ควรเปลี่ยนมาใช้ กระเบื้อง SPC',
          contents: [
            {
              __component: 'article.images',
              id: '636a07631e519e001c1472e2',
            },
            {
              __component: 'article.content',
              id: '636a07631e519e001c1472e3',
            },
            {
              __component: 'article.content',
              id: '636a07631e519e001c1472e4',
            },
            {
              __component: 'article.images',
              id: '636a07631e519e001c1472e5',
            },
            {
              __component: 'article.content',
              id: '636a07631e519e001c1472e6',
            },
            {
              __component: 'article.content',
              id: '636a07631e519e001c1472e7',
            },
            {
              __component: 'article.images',
              id: '636a07631e519e001c1472e8',
            },
            {
              __component: 'article.content',
              id: '636a07631e519e001c1472e9',
            },
            {
              __component: 'article.content',
              id: '636a07631e519e001c1472ea',
            },
            {
              __component: 'article.images',
              id: '636a07631e519e001c1472eb',
            },
            {
              __component: 'article.content',
              id: '636a07631e519e001c1472ec',
            },
            {
              __component: 'article.images',
              id: '636a07631e519e001c1472ed',
            },
            {
              __component: 'article.content',
              id: '636a07631e519e001c1472ee',
            },
          ],
          link: null,
          createdAt: '2022-11-08T07:38:11.817Z',
          updatedAt: '2022-12-21T03:56:18.410Z',
          __v: 1,
          coverImage: {
            _id: '636df023d42554001c0d0271',
            name: '304db395-187c-436a-9491-79f412f12bc9.jpeg',
            alternativeText: '',
            caption: '',
            hash: '304db395_187c_436a_9491_79f412f12bc9_332a1dacfc',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 36.39,
            width: 471,
            height: 314,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/304db395_187c_436a_9491_79f412f12bc9_332a1dacfc.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_304db395-187c-436a-9491-79f412f12bc9.jpeg',
                hash: 'thumbnail_304db395_187c_436a_9491_79f412f12bc9_332a1dacfc',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 8.72,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_304db395_187c_436a_9491_79f412f12bc9_332a1dacfc.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['636a07631e519e001c1472e1'],
            createdAt: '2022-11-11T06:48:03.906Z',
            updatedAt: '2022-11-14T03:22:13.496Z',
            __v: 0,
            id: '636df023d42554001c0d0271',
          },
          metadata: '63a283e2c091d3001c2ea709',
          id: '636a07631e519e001c1472e1',
        },
      ],
      _id: '6368ec8e1e519e001c146e8b',
      title: 'ผลงานของเรา',
      __v: 0,
      button: null,
      id: '6368ec8e1e519e001c146e8b',
    },
    reviewSection: {
      _id: '635fec782837c5001c2689f0',
      title: 'รีวิวจากผู้ใช้บริการของเรา',
      reviewContent: [
        {
          image: [
            {
              _id: '636731956f10f9001b2ff902',
              name: 'rn_image_picker_lib_temp_f659b83e_8249_459f_9143_c94962f7851f_f018532b2b.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_f659b83e_8249_459f_9143_c94962f7851f_f018532b2b_6a7cc964e8',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 34.87,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_f659b83e_8249_459f_9143_c94962f7851f_f018532b2b_6a7cc964e8.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_f659b83e_8249_459f_9143_c94962f7851f_f018532b2b.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_f659b83e_8249_459f_9143_c94962f7851f_f018532b2b_6a7cc964e8',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.71,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_f659b83e_8249_459f_9143_c94962f7851f_f018532b2b_6a7cc964e8.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_f659b83e_8249_459f_9143_c94962f7851f_f018532b2b.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_f659b83e_8249_459f_9143_c94962f7851f_f018532b2b_6a7cc964e8',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 31.47,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_f659b83e_8249_459f_9143_c94962f7851f_f018532b2b_6a7cc964e8.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_f659b83e_8249_459f_9143_c94962f7851f_f018532b2b.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_f659b83e_8249_459f_9143_c94962f7851f_f018532b2b_6a7cc964e8',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 16.01,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_f659b83e_8249_459f_9143_c94962f7851f_f018532b2b_6a7cc964e8.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:01:25.663Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636731956f10f9001b2ff902',
            },
            {
              _id: '636731956f10f9001b2ff903',
              name: 'rn_image_picker_lib_temp_456c7c44_5390_4d72_bba8_7fe577b8ef17_6c87eb0065.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_456c7c44_5390_4d72_bba8_7fe577b8ef17_6c87eb0065_b8dd4ba961',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 28.73,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_456c7c44_5390_4d72_bba8_7fe577b8ef17_6c87eb0065_b8dd4ba961.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_456c7c44_5390_4d72_bba8_7fe577b8ef17_6c87eb0065.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_456c7c44_5390_4d72_bba8_7fe577b8ef17_6c87eb0065_b8dd4ba961',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.12,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_456c7c44_5390_4d72_bba8_7fe577b8ef17_6c87eb0065_b8dd4ba961.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_456c7c44_5390_4d72_bba8_7fe577b8ef17_6c87eb0065.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_456c7c44_5390_4d72_bba8_7fe577b8ef17_6c87eb0065_b8dd4ba961',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 26.84,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_456c7c44_5390_4d72_bba8_7fe577b8ef17_6c87eb0065_b8dd4ba961.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_456c7c44_5390_4d72_bba8_7fe577b8ef17_6c87eb0065.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_456c7c44_5390_4d72_bba8_7fe577b8ef17_6c87eb0065_b8dd4ba961',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 15.06,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_456c7c44_5390_4d72_bba8_7fe577b8ef17_6c87eb0065_b8dd4ba961.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:01:25.669Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636731956f10f9001b2ff903',
            },
          ],
          _id: '635fec782837c5001c2689f1',
          name: 'ชาญxxxx',
          description:
            'ที่บ้านเรียกใช้บริการจาก 24 FIX มารื้อและปูกระเบื้องห้องน้ำใหม่ครับ ช่างทำงาน เรียบร้อยดีครับ ',
          score: 5,
          __v: 0,
          id: '635fec782837c5001c2689f1',
        },
        {
          image: [
            {
              _id: '636731b16f10f9001b2ff905',
              name: 'rn_image_picker_lib_temp_784d20f3_dd4c_446d_b117_e6a962b4c1eb_250c2d5432.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_784d20f3_dd4c_446d_b117_e6a962b4c1eb_250c2d5432_f5f3f36fec',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 15.19,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_784d20f3_dd4c_446d_b117_e6a962b4c1eb_250c2d5432_f5f3f36fec.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_784d20f3_dd4c_446d_b117_e6a962b4c1eb_250c2d5432.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_784d20f3_dd4c_446d_b117_e6a962b4c1eb_250c2d5432_f5f3f36fec',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 1.46,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_784d20f3_dd4c_446d_b117_e6a962b4c1eb_250c2d5432_f5f3f36fec.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_784d20f3_dd4c_446d_b117_e6a962b4c1eb_250c2d5432.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_784d20f3_dd4c_446d_b117_e6a962b4c1eb_250c2d5432_f5f3f36fec',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 14.18,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_784d20f3_dd4c_446d_b117_e6a962b4c1eb_250c2d5432_f5f3f36fec.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_784d20f3_dd4c_446d_b117_e6a962b4c1eb_250c2d5432.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_784d20f3_dd4c_446d_b117_e6a962b4c1eb_250c2d5432_f5f3f36fec',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 7.2,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_784d20f3_dd4c_446d_b117_e6a962b4c1eb_250c2d5432_f5f3f36fec.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:01:53.992Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636731b16f10f9001b2ff905',
            },
            {
              _id: '636731b16f10f9001b2ff904',
              name: 'rn_image_picker_lib_temp_9ea15855_5876_485d_a7ba_9d5ceda36144_54679f3b4b.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_9ea15855_5876_485d_a7ba_9d5ceda36144_54679f3b4b_22e14750e4',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 15.44,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_9ea15855_5876_485d_a7ba_9d5ceda36144_54679f3b4b_22e14750e4.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_9ea15855_5876_485d_a7ba_9d5ceda36144_54679f3b4b.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_9ea15855_5876_485d_a7ba_9d5ceda36144_54679f3b4b_22e14750e4',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 1.54,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_9ea15855_5876_485d_a7ba_9d5ceda36144_54679f3b4b_22e14750e4.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_9ea15855_5876_485d_a7ba_9d5ceda36144_54679f3b4b.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_9ea15855_5876_485d_a7ba_9d5ceda36144_54679f3b4b_22e14750e4',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 14.12,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_9ea15855_5876_485d_a7ba_9d5ceda36144_54679f3b4b_22e14750e4.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_9ea15855_5876_485d_a7ba_9d5ceda36144_54679f3b4b.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_9ea15855_5876_485d_a7ba_9d5ceda36144_54679f3b4b_22e14750e4',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 7.29,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_9ea15855_5876_485d_a7ba_9d5ceda36144_54679f3b4b_22e14750e4.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:01:53.990Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636731b16f10f9001b2ff904',
            },
          ],
          _id: '635fec782837c5001c2689f2',
          name: 'สุxxxx',
          description:
            'ต้องการปูกระเบื้องใหม่ เลยลองใช้บริการดู ทำงานออกมาค่อนข้างดีค่ะ ช่างมาตรงเวลา เก็บงานเรียบร้อยค่ะ',
          score: 4,
          __v: 0,
          id: '635fec782837c5001c2689f2',
        },
        {
          image: [
            {
              _id: '636731dd6f10f9001b2ff906',
              name: 'rn_image_picker_lib_temp_db0b1faf_8910_403a_817e_27fb77169a08_763e9a7664.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_db0b1faf_8910_403a_817e_27fb77169a08_763e9a7664_cb8ee4bdd7',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 56.29,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_db0b1faf_8910_403a_817e_27fb77169a08_763e9a7664_cb8ee4bdd7.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_db0b1faf_8910_403a_817e_27fb77169a08_763e9a7664.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_db0b1faf_8910_403a_817e_27fb77169a08_763e9a7664_cb8ee4bdd7',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 4.03,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_db0b1faf_8910_403a_817e_27fb77169a08_763e9a7664_cb8ee4bdd7.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_db0b1faf_8910_403a_817e_27fb77169a08_763e9a7664.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_db0b1faf_8910_403a_817e_27fb77169a08_763e9a7664_cb8ee4bdd7',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 50.51,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_db0b1faf_8910_403a_817e_27fb77169a08_763e9a7664_cb8ee4bdd7.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_db0b1faf_8910_403a_817e_27fb77169a08_763e9a7664.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_db0b1faf_8910_403a_817e_27fb77169a08_763e9a7664_cb8ee4bdd7',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 25.61,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_db0b1faf_8910_403a_817e_27fb77169a08_763e9a7664_cb8ee4bdd7.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:02:37.753Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636731dd6f10f9001b2ff906',
            },
            {
              _id: '636731dd6f10f9001b2ff907',
              name: 'rn_image_picker_lib_temp_c5fc17b3_a8ae_4676_aac7_495403766680_a11ce94ba1.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_c5fc17b3_a8ae_4676_aac7_495403766680_a11ce94ba1_7f031e3bb6',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 54.09,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_c5fc17b3_a8ae_4676_aac7_495403766680_a11ce94ba1_7f031e3bb6.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_c5fc17b3_a8ae_4676_aac7_495403766680_a11ce94ba1.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_c5fc17b3_a8ae_4676_aac7_495403766680_a11ce94ba1_7f031e3bb6',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 4.24,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_c5fc17b3_a8ae_4676_aac7_495403766680_a11ce94ba1_7f031e3bb6.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_c5fc17b3_a8ae_4676_aac7_495403766680_a11ce94ba1.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_c5fc17b3_a8ae_4676_aac7_495403766680_a11ce94ba1_7f031e3bb6',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 49,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_c5fc17b3_a8ae_4676_aac7_495403766680_a11ce94ba1_7f031e3bb6.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_c5fc17b3_a8ae_4676_aac7_495403766680_a11ce94ba1.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_c5fc17b3_a8ae_4676_aac7_495403766680_a11ce94ba1_7f031e3bb6',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 25.35,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_c5fc17b3_a8ae_4676_aac7_495403766680_a11ce94ba1_7f031e3bb6.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:02:37.787Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636731dd6f10f9001b2ff907',
            },
          ],
          _id: '635fec782837c5001c2689f3',
          name: 'ภัทxxxx',
          description:
            'รื้อกระเบื้องที่บ้านและปูใหม่ค่ะ ช่างเข้างานตรงเวลาทำงานเสร็จทำความสะอาดให้ด้วยค่ะ เรียบร้อยดีค่ะ ',
          score: 4,
          __v: 0,
          id: '635fec782837c5001c2689f3',
        },
        {
          image: [
            {
              _id: '636732046f10f9001b2ff908',
              name: '7954d0a5_36ac_430e_bb93_d94555f8bb86_866ca2d77d.jpeg',
              alternativeText: '',
              caption: '',
              hash: '7954d0a5_36ac_430e_bb93_d94555f8bb86_866ca2d77d_9ccb5c3dd0',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 22.44,
              width: 449,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/7954d0a5_36ac_430e_bb93_d94555f8bb86_866ca2d77d_9ccb5c3dd0.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_7954d0a5_36ac_430e_bb93_d94555f8bb86_866ca2d77d.jpeg',
                  hash: 'thumbnail_7954d0a5_36ac_430e_bb93_d94555f8bb86_866ca2d77d_9ccb5c3dd0',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 88,
                  height: 156,
                  size: 2.02,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_7954d0a5_36ac_430e_bb93_d94555f8bb86_866ca2d77d_9ccb5c3dd0.jpeg',
                },
                medium: {
                  name: 'medium_7954d0a5_36ac_430e_bb93_d94555f8bb86_866ca2d77d.jpeg',
                  hash: 'medium_7954d0a5_36ac_430e_bb93_d94555f8bb86_866ca2d77d_9ccb5c3dd0',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 421,
                  height: 750,
                  size: 21.02,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_7954d0a5_36ac_430e_bb93_d94555f8bb86_866ca2d77d_9ccb5c3dd0.jpeg',
                },
                small: {
                  name: 'small_7954d0a5_36ac_430e_bb93_d94555f8bb86_866ca2d77d.jpeg',
                  hash: 'small_7954d0a5_36ac_430e_bb93_d94555f8bb86_866ca2d77d_9ccb5c3dd0',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 281,
                  height: 500,
                  size: 10.9,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_7954d0a5_36ac_430e_bb93_d94555f8bb86_866ca2d77d_9ccb5c3dd0.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:03:16.437Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636732046f10f9001b2ff908',
            },
            {
              _id: '636732116f10f9001b2ff909',
              name: '59983710_533c_4b08_a721_ae955910ca34_476e4defbf.jpeg',
              alternativeText: '',
              caption: '',
              hash: '59983710_533c_4b08_a721_ae955910ca34_476e4defbf_3ef1bd97c7',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 24.36,
              width: 449,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/59983710_533c_4b08_a721_ae955910ca34_476e4defbf_3ef1bd97c7.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_59983710_533c_4b08_a721_ae955910ca34_476e4defbf.jpeg',
                  hash: 'thumbnail_59983710_533c_4b08_a721_ae955910ca34_476e4defbf_3ef1bd97c7',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 88,
                  height: 156,
                  size: 2.12,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_59983710_533c_4b08_a721_ae955910ca34_476e4defbf_3ef1bd97c7.jpeg',
                },
                medium: {
                  name: 'medium_59983710_533c_4b08_a721_ae955910ca34_476e4defbf.jpeg',
                  hash: 'medium_59983710_533c_4b08_a721_ae955910ca34_476e4defbf_3ef1bd97c7',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 421,
                  height: 750,
                  size: 22.82,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_59983710_533c_4b08_a721_ae955910ca34_476e4defbf_3ef1bd97c7.jpeg',
                },
                small: {
                  name: 'small_59983710_533c_4b08_a721_ae955910ca34_476e4defbf.jpeg',
                  hash: 'small_59983710_533c_4b08_a721_ae955910ca34_476e4defbf_3ef1bd97c7',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 281,
                  height: 500,
                  size: 11.96,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_59983710_533c_4b08_a721_ae955910ca34_476e4defbf_3ef1bd97c7.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:03:29.134Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636732116f10f9001b2ff909',
            },
          ],
          _id: '635fec782837c5001c2689f4',
          name: 'ประxxxx',
          description:
            'เจ้าหน้าที่ให้บริการประสานงานดีครับ ตอบแชทค่อนข้างไว สำหรับช่างก็ เข้างานก่อนเวลา พูดจาดีครับ ',
          score: 5,
          __v: 0,
          id: '635fec782837c5001c2689f4',
        },
        {
          image: [
            {
              _id: '636732556f10f9001b2ff90a',
              name: 'rn_image_picker_lib_temp_246cd954_a012_4750_aa8c_6a0bdbee19db_07aeb4736e.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_246cd954_a012_4750_aa8c_6a0bdbee19db_07aeb4736e_64ba7a0c6f',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 34.26,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_246cd954_a012_4750_aa8c_6a0bdbee19db_07aeb4736e_64ba7a0c6f.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_246cd954_a012_4750_aa8c_6a0bdbee19db_07aeb4736e.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_246cd954_a012_4750_aa8c_6a0bdbee19db_07aeb4736e_64ba7a0c6f',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.48,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_246cd954_a012_4750_aa8c_6a0bdbee19db_07aeb4736e_64ba7a0c6f.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_246cd954_a012_4750_aa8c_6a0bdbee19db_07aeb4736e.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_246cd954_a012_4750_aa8c_6a0bdbee19db_07aeb4736e_64ba7a0c6f',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 31.26,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_246cd954_a012_4750_aa8c_6a0bdbee19db_07aeb4736e_64ba7a0c6f.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_246cd954_a012_4750_aa8c_6a0bdbee19db_07aeb4736e.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_246cd954_a012_4750_aa8c_6a0bdbee19db_07aeb4736e_64ba7a0c6f',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 15.76,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_246cd954_a012_4750_aa8c_6a0bdbee19db_07aeb4736e_64ba7a0c6f.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:04:37.773Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636732556f10f9001b2ff90a',
            },
            {
              _id: '636732556f10f9001b2ff90b',
              name: 'rn_image_picker_lib_temp_3efba9b4_547c_4804_820c_78178b802af2_d6fb1e8a57.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_3efba9b4_547c_4804_820c_78178b802af2_d6fb1e8a57_ca2eaee4d8',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 41.86,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_3efba9b4_547c_4804_820c_78178b802af2_d6fb1e8a57_ca2eaee4d8.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_3efba9b4_547c_4804_820c_78178b802af2_d6fb1e8a57.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_3efba9b4_547c_4804_820c_78178b802af2_d6fb1e8a57_ca2eaee4d8',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.28,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_3efba9b4_547c_4804_820c_78178b802af2_d6fb1e8a57_ca2eaee4d8.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_3efba9b4_547c_4804_820c_78178b802af2_d6fb1e8a57.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_3efba9b4_547c_4804_820c_78178b802af2_d6fb1e8a57_ca2eaee4d8',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 38,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_3efba9b4_547c_4804_820c_78178b802af2_d6fb1e8a57_ca2eaee4d8.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_3efba9b4_547c_4804_820c_78178b802af2_d6fb1e8a57.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_3efba9b4_547c_4804_820c_78178b802af2_d6fb1e8a57_ca2eaee4d8',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 19.77,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_3efba9b4_547c_4804_820c_78178b802af2_d6fb1e8a57_ca2eaee4d8.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:04:37.976Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636732556f10f9001b2ff90b',
            },
          ],
          _id: '635fec782837c5001c2689f5',
          name: 'ลลิตxxxx',
          description:
            'เรียกใช้บริการมาซ่อมยาแนวพื้นห้องน้ำค่ะ ทำออกมาได้เรียบร้อยดีค่ะ  ออกมาเหมือนใหม่ ',
          score: 4,
          __v: 0,
          id: '635fec782837c5001c2689f5',
        },
        {
          image: [
            {
              _id: '636732a36f10f9001b2ff92c',
              name: 'rn_image_picker_lib_temp_38dc5068_0f1b_4a1b_9f1b_24732ddb8f1e_e2a4805ef8.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_38dc5068_0f1b_4a1b_9f1b_24732ddb8f1e_e2a4805ef8_e1572ff161',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 27.99,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_38dc5068_0f1b_4a1b_9f1b_24732ddb8f1e_e2a4805ef8_e1572ff161.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_38dc5068_0f1b_4a1b_9f1b_24732ddb8f1e_e2a4805ef8.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_38dc5068_0f1b_4a1b_9f1b_24732ddb8f1e_e2a4805ef8_e1572ff161',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.6,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_38dc5068_0f1b_4a1b_9f1b_24732ddb8f1e_e2a4805ef8_e1572ff161.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_38dc5068_0f1b_4a1b_9f1b_24732ddb8f1e_e2a4805ef8.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_38dc5068_0f1b_4a1b_9f1b_24732ddb8f1e_e2a4805ef8_e1572ff161',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 25.31,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_38dc5068_0f1b_4a1b_9f1b_24732ddb8f1e_e2a4805ef8_e1572ff161.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_38dc5068_0f1b_4a1b_9f1b_24732ddb8f1e_e2a4805ef8.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_38dc5068_0f1b_4a1b_9f1b_24732ddb8f1e_e2a4805ef8_e1572ff161',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 12.97,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_38dc5068_0f1b_4a1b_9f1b_24732ddb8f1e_e2a4805ef8_e1572ff161.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:05:55.481Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636732a36f10f9001b2ff92c',
            },
            {
              _id: '636732a36f10f9001b2ff92d',
              name: 'rn_image_picker_lib_temp_3620aed3_012e_493e_9083_335bb5a4889d_e3d78b58dc.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_3620aed3_012e_493e_9083_335bb5a4889d_e3d78b58dc_0086519620',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 31.27,
              width: 800,
              height: 600,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_3620aed3_012e_493e_9083_335bb5a4889d_e3d78b58dc_0086519620.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_3620aed3_012e_493e_9083_335bb5a4889d_e3d78b58dc.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_3620aed3_012e_493e_9083_335bb5a4889d_e3d78b58dc_0086519620',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 208,
                  height: 156,
                  size: 3.49,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_3620aed3_012e_493e_9083_335bb5a4889d_e3d78b58dc_0086519620.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_3620aed3_012e_493e_9083_335bb5a4889d_e3d78b58dc.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_3620aed3_012e_493e_9083_335bb5a4889d_e3d78b58dc_0086519620',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 563,
                  size: 27.57,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_3620aed3_012e_493e_9083_335bb5a4889d_e3d78b58dc_0086519620.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_3620aed3_012e_493e_9083_335bb5a4889d_e3d78b58dc.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_3620aed3_012e_493e_9083_335bb5a4889d_e3d78b58dc_0086519620',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 500,
                  height: 375,
                  size: 13.09,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_3620aed3_012e_493e_9083_335bb5a4889d_e3d78b58dc_0086519620.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:05:55.493Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636732a36f10f9001b2ff92d',
            },
          ],
          _id: '635fec782837c5001c2689f6',
          name: 'ชาญxxxx',
          description:
            'หาช่างที่มาปูกระเบื้องใหม่ให้ เจ้าหน้าที่แนะนำให้คำปรึกษาดี ช่างเก็บงานเรียบร้อยครับ ',
          score: 5,
          __v: 0,
          id: '635fec782837c5001c2689f6',
        },
        {
          image: [
            {
              _id: '636732c66f10f9001b2ff92e',
              name: '0_B98_DB_9_F_1_B23_4962_A979_D13418601511_a995c20013.jpeg',
              alternativeText: '',
              caption: '',
              hash: '0_B98_DB_9_F_1_B23_4962_A979_D13418601511_a995c20013_a2b993ad72',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 43.49,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/0_B98_DB_9_F_1_B23_4962_A979_D13418601511_a995c20013_a2b993ad72.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_0_B98_DB_9_F_1_B23_4962_A979_D13418601511_a995c20013.jpeg',
                  hash: 'thumbnail_0_B98_DB_9_F_1_B23_4962_A979_D13418601511_a995c20013_a2b993ad72',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.48,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_0_B98_DB_9_F_1_B23_4962_A979_D13418601511_a995c20013_a2b993ad72.jpeg',
                },
                medium: {
                  name: 'medium_0_B98_DB_9_F_1_B23_4962_A979_D13418601511_a995c20013.jpeg',
                  hash: 'medium_0_B98_DB_9_F_1_B23_4962_A979_D13418601511_a995c20013_a2b993ad72',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 39.73,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_0_B98_DB_9_F_1_B23_4962_A979_D13418601511_a995c20013_a2b993ad72.jpeg',
                },
                small: {
                  name: 'small_0_B98_DB_9_F_1_B23_4962_A979_D13418601511_a995c20013.jpeg',
                  hash: 'small_0_B98_DB_9_F_1_B23_4962_A979_D13418601511_a995c20013_a2b993ad72',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 21.06,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_0_B98_DB_9_F_1_B23_4962_A979_D13418601511_a995c20013_a2b993ad72.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:06:30.570Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636732c66f10f9001b2ff92e',
            },
            {
              _id: '636732c66f10f9001b2ff92f',
              name: '020_E3_C26_E2_B8_422_B_8765_8_AAB_4_DF_713_A2_be36fe7d63.jpeg',
              alternativeText: '',
              caption: '',
              hash: '020_E3_C26_E2_B8_422_B_8765_8_AAB_4_DF_713_A2_be36fe7d63_fb1696910d',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 42.58,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/020_E3_C26_E2_B8_422_B_8765_8_AAB_4_DF_713_A2_be36fe7d63_fb1696910d.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_020_E3_C26_E2_B8_422_B_8765_8_AAB_4_DF_713_A2_be36fe7d63.jpeg',
                  hash: 'thumbnail_020_E3_C26_E2_B8_422_B_8765_8_AAB_4_DF_713_A2_be36fe7d63_fb1696910d',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.87,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_020_E3_C26_E2_B8_422_B_8765_8_AAB_4_DF_713_A2_be36fe7d63_fb1696910d.jpeg',
                },
                medium: {
                  name: 'medium_020_E3_C26_E2_B8_422_B_8765_8_AAB_4_DF_713_A2_be36fe7d63.jpeg',
                  hash: 'medium_020_E3_C26_E2_B8_422_B_8765_8_AAB_4_DF_713_A2_be36fe7d63_fb1696910d',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 39.62,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_020_E3_C26_E2_B8_422_B_8765_8_AAB_4_DF_713_A2_be36fe7d63_fb1696910d.jpeg',
                },
                small: {
                  name: 'small_020_E3_C26_E2_B8_422_B_8765_8_AAB_4_DF_713_A2_be36fe7d63.jpeg',
                  hash: 'small_020_E3_C26_E2_B8_422_B_8765_8_AAB_4_DF_713_A2_be36fe7d63_fb1696910d',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 21.65,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_020_E3_C26_E2_B8_422_B_8765_8_AAB_4_DF_713_A2_be36fe7d63_fb1696910d.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:06:30.683Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636732c66f10f9001b2ff92f',
            },
          ],
          _id: '635fec782837c5001c2689f7',
          name: 'สุxxxxxx',
          description:
            'เจ้าหน้าที่ให้บริการดีครับ ให้คำแนะนำและให้คำปรึกษาตั้งแต่ต้น ประสานงานกับช่างให้ ส่วนช่างก็เข้ามาทำงานตรงเวลาทำงานเรียบร้อยดีมากครับ อนาคตเรียกใช้บริการอีกแน่นอนครับ ',
          score: 4,
          __v: 0,
          id: '635fec782837c5001c2689f7',
        },
        {
          image: [
            {
              _id: '636732e26f10f9001b2ff930',
              name: 'rn_image_picker_lib_temp_8ab7044e_4c9f_4985_85f8_bce456cf19b8_aea7b80d1c.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_8ab7044e_4c9f_4985_85f8_bce456cf19b8_aea7b80d1c_6aba47a771',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 21.43,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_8ab7044e_4c9f_4985_85f8_bce456cf19b8_aea7b80d1c_6aba47a771.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_8ab7044e_4c9f_4985_85f8_bce456cf19b8_aea7b80d1c.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_8ab7044e_4c9f_4985_85f8_bce456cf19b8_aea7b80d1c_6aba47a771',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.19,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_8ab7044e_4c9f_4985_85f8_bce456cf19b8_aea7b80d1c_6aba47a771.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_8ab7044e_4c9f_4985_85f8_bce456cf19b8_aea7b80d1c.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_8ab7044e_4c9f_4985_85f8_bce456cf19b8_aea7b80d1c_6aba47a771',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 20.16,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_8ab7044e_4c9f_4985_85f8_bce456cf19b8_aea7b80d1c_6aba47a771.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_8ab7044e_4c9f_4985_85f8_bce456cf19b8_aea7b80d1c.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_8ab7044e_4c9f_4985_85f8_bce456cf19b8_aea7b80d1c_6aba47a771',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 11.25,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_8ab7044e_4c9f_4985_85f8_bce456cf19b8_aea7b80d1c_6aba47a771.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:06:58.030Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636732e26f10f9001b2ff930',
            },
            {
              _id: '636732e26f10f9001b2ff931',
              name: 'rn_image_picker_lib_temp_b85b9461_793a_4892_a624_4621e87b1d20_ee4c214d2c.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_b85b9461_793a_4892_a624_4621e87b1d20_ee4c214d2c_f80869bd63',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 22.66,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_b85b9461_793a_4892_a624_4621e87b1d20_ee4c214d2c_f80869bd63.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_b85b9461_793a_4892_a624_4621e87b1d20_ee4c214d2c.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_b85b9461_793a_4892_a624_4621e87b1d20_ee4c214d2c_f80869bd63',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.08,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_b85b9461_793a_4892_a624_4621e87b1d20_ee4c214d2c_f80869bd63.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_b85b9461_793a_4892_a624_4621e87b1d20_ee4c214d2c.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_b85b9461_793a_4892_a624_4621e87b1d20_ee4c214d2c_f80869bd63',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 21.24,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_b85b9461_793a_4892_a624_4621e87b1d20_ee4c214d2c_f80869bd63.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_b85b9461_793a_4892_a624_4621e87b1d20_ee4c214d2c.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_b85b9461_793a_4892_a624_4621e87b1d20_ee4c214d2c_f80869bd63',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 11.45,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_b85b9461_793a_4892_a624_4621e87b1d20_ee4c214d2c_f80869bd63.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:06:58.145Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636732e26f10f9001b2ff931',
            },
          ],
          _id: '635fec782837c5001c2689f8',
          name: 'วิกาxxxxxx',
          description: 'ช่างทำงานเรียบร้อยดีค่ะ เจอโปรโมชันของทาง 24 FIX เลยลองใช้บริการดูค่ะ ',
          score: 4,
          __v: 0,
          id: '635fec782837c5001c2689f8',
        },
        {
          image: [
            {
              _id: '636732ff6f10f9001b2ff932',
              name: 'rn_image_picker_lib_temp_9b0424c1_11d3_44fb_bc7e_0cd45cd17b45_6b907a5a92.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_9b0424c1_11d3_44fb_bc7e_0cd45cd17b45_6b907a5a92_2dba87e4ba',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 33.94,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_9b0424c1_11d3_44fb_bc7e_0cd45cd17b45_6b907a5a92_2dba87e4ba.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_9b0424c1_11d3_44fb_bc7e_0cd45cd17b45_6b907a5a92.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_9b0424c1_11d3_44fb_bc7e_0cd45cd17b45_6b907a5a92_2dba87e4ba',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.37,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_9b0424c1_11d3_44fb_bc7e_0cd45cd17b45_6b907a5a92_2dba87e4ba.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_9b0424c1_11d3_44fb_bc7e_0cd45cd17b45_6b907a5a92.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_9b0424c1_11d3_44fb_bc7e_0cd45cd17b45_6b907a5a92_2dba87e4ba',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 31.5,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_9b0424c1_11d3_44fb_bc7e_0cd45cd17b45_6b907a5a92_2dba87e4ba.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_9b0424c1_11d3_44fb_bc7e_0cd45cd17b45_6b907a5a92.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_9b0424c1_11d3_44fb_bc7e_0cd45cd17b45_6b907a5a92_2dba87e4ba',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 17.29,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_9b0424c1_11d3_44fb_bc7e_0cd45cd17b45_6b907a5a92_2dba87e4ba.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:07:27.890Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636732ff6f10f9001b2ff932',
            },
            {
              _id: '636732ff6f10f9001b2ff933',
              name: 'rn_image_picker_lib_temp_cfc70ff1_b0a4_4924_b2e4_292f1eada0e8_134be36bc9.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_cfc70ff1_b0a4_4924_b2e4_292f1eada0e8_134be36bc9_6a38ac93e9',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 44.87,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_cfc70ff1_b0a4_4924_b2e4_292f1eada0e8_134be36bc9_6a38ac93e9.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_cfc70ff1_b0a4_4924_b2e4_292f1eada0e8_134be36bc9.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_cfc70ff1_b0a4_4924_b2e4_292f1eada0e8_134be36bc9_6a38ac93e9',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 4.15,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_cfc70ff1_b0a4_4924_b2e4_292f1eada0e8_134be36bc9_6a38ac93e9.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_cfc70ff1_b0a4_4924_b2e4_292f1eada0e8_134be36bc9.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_cfc70ff1_b0a4_4924_b2e4_292f1eada0e8_134be36bc9_6a38ac93e9',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 41.32,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_cfc70ff1_b0a4_4924_b2e4_292f1eada0e8_134be36bc9_6a38ac93e9.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_cfc70ff1_b0a4_4924_b2e4_292f1eada0e8_134be36bc9.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_cfc70ff1_b0a4_4924_b2e4_292f1eada0e8_134be36bc9_6a38ac93e9',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 22.96,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_cfc70ff1_b0a4_4924_b2e4_292f1eada0e8_134be36bc9_6a38ac93e9.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:07:27.961Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636732ff6f10f9001b2ff933',
            },
          ],
          _id: '635fec782837c5001c2689f9',
          name: 'ณัฐxxxxxx',
          description: 'ต้องการรื้อและติดตั้งบัวไม้อัดใหม่ เลยเลือกใช้บริการกับที่นี่ ทำงานไวครับ',
          score: 5,
          __v: 0,
          id: '635fec782837c5001c2689f9',
        },
        {
          image: [
            {
              _id: '636733256f10f9001b2ff934',
              name: 'rn_image_picker_lib_temp_000487c4_850a_41b0_9549_bdd4ae8626f8_b979b413fb.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_000487c4_850a_41b0_9549_bdd4ae8626f8_b979b413fb_b0d70cab01',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 27.64,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_000487c4_850a_41b0_9549_bdd4ae8626f8_b979b413fb_b0d70cab01.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_000487c4_850a_41b0_9549_bdd4ae8626f8_b979b413fb.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_000487c4_850a_41b0_9549_bdd4ae8626f8_b979b413fb_b0d70cab01',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.46,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_000487c4_850a_41b0_9549_bdd4ae8626f8_b979b413fb_b0d70cab01.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_000487c4_850a_41b0_9549_bdd4ae8626f8_b979b413fb.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_000487c4_850a_41b0_9549_bdd4ae8626f8_b979b413fb_b0d70cab01',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 25.17,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_000487c4_850a_41b0_9549_bdd4ae8626f8_b979b413fb_b0d70cab01.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_000487c4_850a_41b0_9549_bdd4ae8626f8_b979b413fb.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_000487c4_850a_41b0_9549_bdd4ae8626f8_b979b413fb_b0d70cab01',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 13.26,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_000487c4_850a_41b0_9549_bdd4ae8626f8_b979b413fb_b0d70cab01.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:08:05.636Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636733256f10f9001b2ff934',
            },
            {
              _id: '636733256f10f9001b2ff935',
              name: 'rn_image_picker_lib_temp_96feed8c_d768_4677_a65c_a24bef0e2a37_6801c5a86c.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_96feed8c_d768_4677_a65c_a24bef0e2a37_6801c5a86c_d542ddf9a3',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 29.5,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_96feed8c_d768_4677_a65c_a24bef0e2a37_6801c5a86c_d542ddf9a3.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_96feed8c_d768_4677_a65c_a24bef0e2a37_6801c5a86c.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_96feed8c_d768_4677_a65c_a24bef0e2a37_6801c5a86c_d542ddf9a3',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.49,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_96feed8c_d768_4677_a65c_a24bef0e2a37_6801c5a86c_d542ddf9a3.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_96feed8c_d768_4677_a65c_a24bef0e2a37_6801c5a86c.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_96feed8c_d768_4677_a65c_a24bef0e2a37_6801c5a86c_d542ddf9a3',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 27,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_96feed8c_d768_4677_a65c_a24bef0e2a37_6801c5a86c_d542ddf9a3.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_96feed8c_d768_4677_a65c_a24bef0e2a37_6801c5a86c.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_96feed8c_d768_4677_a65c_a24bef0e2a37_6801c5a86c_d542ddf9a3',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 14.22,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_96feed8c_d768_4677_a65c_a24bef0e2a37_6801c5a86c_d542ddf9a3.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:08:05.644Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636733256f10f9001b2ff935',
            },
          ],
          _id: '635fec782837c5001c2689fa',
          name: 'กัญxxxxxx',
          description:
            'เรียกช่างมารื้อและปูกระเบื้องห้องน้ำใหม่ค่ะ ช่างพูดจาเรียบร้อย เก็บงานได้เรียบร้อยดีค่ะ ',
          score: 4,
          __v: 0,
          id: '635fec782837c5001c2689fa',
        },
      ],
      __v: 1,
      id: '635fec782837c5001c2689f0',
    },
    ctaSection: {
      _id: '6367471d6f10f9001b2ffd1e',
      title: '<p>บริการปูกระเบื้องพื้นและผนังด้วยทีมช่างมืออาชีพ</p>',
      button: {
        _id: '6367471d6f10f9001b2ffd1f',
        title: 'จองบริการ',
        url: 'https://fix.24x.co.th/tile/booking',
        __v: 0,
        id: '6367471d6f10f9001b2ffd1f',
      },
      __v: 1,
      id: '6367471d6f10f9001b2ffd1e',
    },
    createdAt: '2022-10-31T15:40:39.940Z',
    updatedAt: '2023-01-11T09:46:01.685Z',
    __v: 2,
    metadata: {
      twitterCardType: 'summary',
      _id: '63a27e6ec091d3001c2ea652',
      metaTitle: 'บริการปูกระเบื้องพื้นและผนังเรียบเนียนสวยด้วยทีมช่างมืออาชีพ',
      metaDescription: 'ซ่อมแซม รื้อ ปูกระเบื้อง เรามีช่างบริการทุกประเภททั้งกระเบื้องพื้นและผนัง',
      keywords: 'ปูกระเบื้อง, ช่างปูกระเบื้อง, ราคาปูกระเบื้อง',
      __v: 0,
      id: '63a27e6ec091d3001c2ea652',
    },
    installationSection: null,
    id: '635fec772837c5001c2689d9',
  },
  {
    _id: '63614819b87e30001c208c45',
    published_at: '2022-11-07T12:04:25.470Z',
    slug: 'floor',
    bannerSection: {
      _id: '6367e18d6f10f9001b2fff64',
      title: '<p><strong>งานพื้นครบวงจร ด้วยทีมช่างมาตรฐาน</strong></p>',
      button: {
        _id: '6367e18d6f10f9001b2fff65',
        title: 'จองบริการ',
        url: 'https://fix.24x.co.th/floor/booking',
        __v: 0,
        id: '6367e18d6f10f9001b2fff65',
      },
      __v: 1,
      image: {
        _id: '636a6dbce6895d001ce68cdf',
        name: '24FIX_LD_BANNER-13.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_13_83ce981b61',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 707.04,
        width: 6000,
        height: 2634,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_13_83ce981b61.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER-13.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_13_83ce981b61',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 108,
            size: 4.81,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_13_83ce981b61.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER-13.jpg',
            hash: 'large_24_FIX_LD_BANNER_13_83ce981b61',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 439,
            size: 39.38,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_13_83ce981b61.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER-13.jpg',
            hash: 'medium_24_FIX_LD_BANNER_13_83ce981b61',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 329,
            size: 24.92,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_13_83ce981b61.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER-13.jpg',
            hash: 'small_24_FIX_LD_BANNER_13_83ce981b61',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 220,
            size: 13.43,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_13_83ce981b61.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-11-08T14:54:52.689Z',
        updatedAt: '2022-11-08T16:06:16.745Z',
        __v: 0,
        id: '636a6dbce6895d001ce68cdf',
      },
      mobileImage: {
        _id: '636a6dd4e6895d001ce68ce0',
        name: '24FIX_LD_BANNER_MOBILE2-13.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_MOBILE_2_13_6e6caf355b',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 135.2,
        width: 1501,
        height: 930,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_MOBILE_2_13_6e6caf355b.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER_MOBILE2-13.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_MOBILE_2_13_6e6caf355b',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 152,
            size: 6.21,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_MOBILE_2_13_6e6caf355b.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER_MOBILE2-13.jpg',
            hash: 'large_24_FIX_LD_BANNER_MOBILE_2_13_6e6caf355b',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 620,
            size: 66.47,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_MOBILE_2_13_6e6caf355b.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER_MOBILE2-13.jpg',
            hash: 'medium_24_FIX_LD_BANNER_MOBILE_2_13_6e6caf355b',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 465,
            size: 38.72,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_MOBILE_2_13_6e6caf355b.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER_MOBILE2-13.jpg',
            hash: 'small_24_FIX_LD_BANNER_MOBILE_2_13_6e6caf355b',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 310,
            size: 20.17,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_MOBILE_2_13_6e6caf355b.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-11-08T14:55:16.007Z',
        updatedAt: '2022-11-08T16:06:16.745Z',
        __v: 0,
        id: '636a6dd4e6895d001ce68ce0',
      },
      id: '6367e18d6f10f9001b2fff64',
    },
    uspSection: [
      {
        _id: '6367e18d6f10f9001b2fff68',
        title: 'งานพื้นครบวงจร ด้วยทีมช่างมาตรฐาน',
        subTitle:
          'บริการเรื่องพื้นครบวงจร ไม่ว่าจะติดตั้ง รื้อ เปลี่ยน ให้บริการอย่างมืออาชีพ ทรุด พัง ร้าว เราซ่อมได้ด้วยทีมช่างมากประสบการณ์ พร้อมส่งมอบงานที่ดีที่สุดให้บ้านคุณ',
        description:
          '<p><strong>ทำไมต้องจองกับ 24FIX?</strong></p><ul><li>ทีมช่างเข้าตรวจหน้างานก่อนให้บริการภายใน 5 วัน</li><li>รับประกันงานพื้นสูงสุด 1 ปี</li><li>ราคางานซ่อมที่ได้มาตรฐาน คุ้มค่ากับคุณภาพบริการ</li></ul>',
        __v: 0,
        image: {
          _id: '6367e1716f10f9001b2fff63',
          name: 'Service_Desktop-11.jpg',
          alternativeText: '',
          caption: '',
          hash: 'Service_Desktop_11_6abf9ff7a8',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 267.89,
          width: 2122,
          height: 1426,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/Service_Desktop_11_6abf9ff7a8.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_Service_Desktop-11.jpg',
              hash: 'thumbnail_Service_Desktop_11_6abf9ff7a8',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 232,
              height: 156,
              size: 5.63,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_Service_Desktop_11_6abf9ff7a8.jpg',
            },
            large: {
              name: 'large_Service_Desktop-11.jpg',
              hash: 'large_Service_Desktop_11_6abf9ff7a8',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 1000,
              height: 672,
              size: 67.38,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/large_Service_Desktop_11_6abf9ff7a8.jpg',
            },
            medium: {
              name: 'medium_Service_Desktop-11.jpg',
              hash: 'medium_Service_Desktop_11_6abf9ff7a8',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 504,
              size: 40.97,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_Service_Desktop_11_6abf9ff7a8.jpg',
            },
            small: {
              name: 'small_Service_Desktop-11.jpg',
              hash: 'small_Service_Desktop_11_6abf9ff7a8',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 336,
              size: 19.76,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_Service_Desktop_11_6abf9ff7a8.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-11-06T16:31:45.732Z',
          updatedAt: '2022-11-06T16:42:58.599Z',
          __v: 0,
          id: '6367e1716f10f9001b2fff63',
        },
        id: '6367e18d6f10f9001b2fff68',
      },
    ],
    faqSection: [
      {
        _id: '636153a1b87e30001c208d7a',
        question: 'งานพื้นและผนังต้องมีการสำรวจหน้างานไหม',
        answer:
          '<p>ไม่จำเป็น ถ้าลูกค้าทราบขนาดพื้นที่ของประตูแล้ว จะมีแค่บริการติดตั้งประตูที่ต้องมีการสำรวจหน้างานเบื้องต้น เพื่อวัดพื้นที่ก่อนเริ่มงานจริง</p>',
        __v: 0,
        id: '636153a1b87e30001c208d7a',
      },
      {
        _id: '636153a1b87e30001c208d7b',
        question: 'ค่าใช้จ่ายในการสำรวจ นำมาเป็นส่วนลดได้ไหม',
        answer: '<p>ค่าสำรวจสามารถนำไปลดได้ต่อเมื่อยอดงานบริการ มากกว่า 3,000 บาทขึ้นไป</p>',
        __v: 0,
        id: '636153a1b87e30001c208d7b',
      },
      {
        _id: '636153a1b87e30001c208d7c',
        answer:
          '<p>ปัจจัยที่มีผลต่อราคาค่าบริการ มีดังนี้ครับ</p><ul><li>ขนาดพื้นที่ในการบริการ (ยิ่งใหญ่ยิ่งถูก)</li><li>บริเวณพื้นที่หน้างาน (พื้นทรุด)</li><li>ประเภทพื้นที่ต้องการทำ</li></ul>',
        question: 'ปัจจัยที่มีผลต่อราคาค่าบริการ',
        __v: 0,
        id: '636153a1b87e30001c208d7c',
      },
      {
        _id: '636153a1b87e30001c208d7d',
        question: 'มีการรับประกันอย่างไร',
        answer:
          '<p>การรับประกันผลงาน 60 วัน หลังจากการให้บริการ บริษัทจะรับประกันผลงานที่เกิดจากการติดตั้ง (หลุดร่อน, โกงตัว หรือ บิดงอ) ตามขอบเขตการให้บริการในเอกสารเสนอราคาเท่านั้น</p>',
        __v: 0,
        id: '636153a1b87e30001c208d7d',
      },
      {
        _id: '636153a1b87e30001c208d7e',
        question: 'พื้นที่ที่ให้บริการมีอะไรบ้าง',
        answer: '<p>พื้นที่ให้บริการครอบคลุมในเขตกรุงเทพมหานคร นนทบุรี ปทุมธานี และสมุทรปราการ</p>',
        __v: 0,
        id: '636153a1b87e30001c208d7e',
      },
      {
        _id: '636153a1b87e30001c208d7f',
        answer:
          '<ul><li>ทำพื้นคอนกรีตพิมพ์ลาย</li><li>ปูกระเบื้องยาง ไม้ปาร์เก้ ลามิเนต</li><li>เทพื้น ปรับพื้น&nbsp;</li><li>บริการลงเสาเข็ม</li><li>ซ่อมแซมผนังซึม ผนังร้าว</li></ul>',
        question: 'งานพื้นและผนังรับบริการส่วนไหนบ้าง',
        __v: 0,
        id: '636153a1b87e30001c208d7f',
      },
      {
        _id: '636153a1b87e30001c208d80',
        answer:
          '<p>คิวช่างเข้าสำรวจหน้างานภายใน 2-3 วัน หลังอนุมัติงานสำรวจ และ 5 วันนับจากวันที่ลูกค้าชำระค่าบริการ</p>',
        question: 'คิวเรียกช่างเร็วสุดเมื่อไหร่',
        __v: 0,
        id: '636153a1b87e30001c208d80',
      },
      {
        _id: '636153a1b87e30001c208d81',
        answer:
          '<ul><li>ลูกค้าสามารถติดตามสถานะงานผ่านทางเว็บไซต์ได้ตลอดเวลา</li><li>สามารถใช้โค้ดส่วนลดสำหรับลูกค้าที่ซื้อผ่านบนเว็บไซต์อีกด้วย</li><li>สามารถจองวันและเวลาเข้ารับบริการด้วยตนเอง</li></ul>',
        question: 'เรียกบริการผ่านเว็บไซต์ดีอย่างไร',
        __v: 0,
        id: '636153a1b87e30001c208d81',
      },
      {
        _id: '636153a1b87e30001c208d82',
        answer:
          '<p>ใบเสนอราคาจะถูกส่งให้ลูกค้าตรวจสอบ ภายใน 24 ชม. หลังจากวันที่ช่างเข้าตรวจหน้างาน</p>',
        question: 'ใบเสนอราคาจะได้เมื่อไหร่ หลังจากที่ช่างเข้าสำรวจหน้างานเรียบร้อยแล้ว',
        __v: 0,
        id: '636153a1b87e30001c208d82',
      },
      {
        _id: '636153a1b87e30001c208d83',
        question: 'ทางบริษัทจัดหาวัสดุให้ด้วยไหม',
        answer:
          '<p>ทางบริษัทมีบริการช่วยจัดหาวัสดุให้ ถ้าทางลูกค้าไม่สะดวกจัดหาวัสดุเอง ซึ่งจะใช้ระยะเวลาในการจัดหาประมาณ 1-2 อาทิตย์ขึ้นไป&nbsp;</p>',
        __v: 0,
        id: '636153a1b87e30001c208d83',
      },
      {
        _id: '636153a1b87e30001c208d84',
        question: 'ราคาค่าบริการรวมอะไรบ้าง',
        answer: '<p>ค่าแรงและวัสดุในการติดตั้งกระเบื้อง รวมปรับพื้น</p>',
        __v: 0,
        id: '636153a1b87e30001c208d84',
      },
      {
        _id: '636153a1b87e30001c208d85',
        question: 'บริการทำพื้นคอนกรีตสแตมป์ ราคารวมอะไรบ้าง',
        answer:
          '<p>ค่าบริการดังกล่าวรวมค่าแรง, ค่าเตรียมพื้นที่ แผ่นพลาสติกปิดผนังเพื่อกันคราบสกปรกในพื้นที่งาน คอนกรีตผสมเสร็จ กำลังอัด 280 ksc. ที่ความหนา 5 ซม., สีคอนกรีต, พิมพ์ลาย, เคลือบผิวงาน เหล็กไวร์เมชขนาด 3 มม. และล้างทำความสะอาดพื้นที่หลังเสร็จงาน</p>',
        __v: 0,
        id: '636153a1b87e30001c208d85',
      },
      {
        _id: '636153a1b87e30001c208d86',
        question: 'มีบริการจัดหาวัสดุด้วยไหม',
        answer:
          '<p>เรามีบริการจัดหาวัสดุให้ ถ้าทางลูกค้าไม่สะดวกจัดหาวัสดุเอง ซึ่งจะใช้ระยะเวลาในการจัดหาประมาณ 2 อาทิตย์ขึ้นไป&nbsp;</p>',
        __v: 0,
        id: '636153a1b87e30001c208d86',
      },
    ],
    promotionSection: {
      _id: '636745b96f10f9001b2ffcbf',
      title: 'โปรโมชั่น',
      promotions: [
        {
          _id: '636745b96f10f9001b2ffcc0',
          url: 'https://fix.24x.co.th/voucher/firstfix-1',
          __v: 0,
          image: {
            _id: '637614b137fd76001b532030',
            name: '24FIX_NOV_BANNER4-02 (1).jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 94.2,
            width: 1500,
            height: 490,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 245,
                height: 80,
                size: 6.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              large: {
                name: 'large_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 327,
                size: 50.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              medium: {
                name: 'medium_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 245,
                size: 32.89,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              small: {
                name: 'small_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 163,
                size: 18.03,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
            },
            provider: 'aws-s3',
            related: ['636a17dc1e519e001c14731c'],
            createdAt: '2022-11-17T11:02:09.052Z',
            updatedAt: '2022-11-21T05:30:58.272Z',
            __v: 0,
            id: '637614b137fd76001b532030',
          },
          mobileImage: {
            _id: '636a6d86e6895d001ce68cc3',
            name: '24FIX_NOV_BANNER1-01.jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_1_01_3663796871',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 149.63,
            width: 1500,
            height: 1021,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_1_01_3663796871.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24FIX_NOV_BANNER1-01.jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 229,
                height: 156,
                size: 8.94,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              large: {
                name: 'large_24FIX_NOV_BANNER1-01.jpg',
                hash: 'large_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 681,
                size: 78.97,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              medium: {
                name: 'medium_24FIX_NOV_BANNER1-01.jpg',
                hash: 'medium_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 511,
                size: 51.21,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              small: {
                name: 'small_24FIX_NOV_BANNER1-01.jpg',
                hash: 'small_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 340,
                size: 27.91,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
            },
            provider: 'aws-s3',
            related: [],
            createdAt: '2022-11-08T14:53:58.508Z',
            updatedAt: '2022-11-08T16:06:16.745Z',
            __v: 0,
            id: '636a6d86e6895d001ce68cc3',
          },
          id: '636745b96f10f9001b2ffcc0',
        },
      ],
      __v: 1,
      button: null,
      id: '636745b96f10f9001b2ffcbf',
    },
    stepSection: null,
    successStorySection: {
      contents: [
        {
          relatedArticles: [],
          categories: [
            '60d1fe825749bf001bbb11e4',
            '62a76933e9dde5001b3c6b15',
            '62de67ecb31a7a001bba2d60',
          ],
          _id: '60fef2feea7297001be8c5f3',
          title: 'รีวิวผลงานจริง ล้างแอร์บ้านคุณเมย์ รัชนก อินทนนท์',
          slug: 'pro-may-onsite-review',
          shortDescription:
            'เพราะประเทศไทยมีแต่ฤดูร้อน ร้อนมาก และร้อนที่สุด! ดังนั้นการดูแล ทำความสะอาด ล้างแอร์ ก็ควรทำอย่างสม่ำเสมอนะ\n#งานล้างแอร์ #ล้างแอร์ฆ่าเชื้อ #เมย์ รัชนก อินทนนท์ #แอร์ไม่เย็น #ตรวจสภาพแอร์ #ล้างแอร์ #ซ่อมแอร์ ',
          views: 3549,
          published_at: '2021-07-26T17:38:13.448Z',
          contents: [
            {
              __component: 'article.content',
              id: '60fef2feea7297001be8c5f4',
            },
            {
              __component: 'article.images',
              id: '60fef2feea7297001be8c5f5',
            },
            {
              __component: 'article.content',
              id: '60fef2feea7297001be8c5f6',
            },
            {
              __component: 'article.images',
              id: '60fef2feea7297001be8c5f7',
            },
            {
              __component: 'article.content',
              id: '62cd0500df69b2001b4a8f1a',
            },
            {
              __component: 'article.images',
              id: '62cd0687df69b2001b4a8f39',
            },
            {
              __component: 'article.content',
              id: '62cd0687df69b2001b4a8f3a',
            },
            {
              __component: 'article.images',
              id: '62cd0687df69b2001b4a8f3b',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fbc',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fbd',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fbe',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fbf',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc0',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc1',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc2',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc3',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc4',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc5',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc6',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc7',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc8',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc9',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fca',
            },
          ],
          link: null,
          createdAt: '2021-07-26T17:38:06.604Z',
          updatedAt: '2022-07-25T10:08:01.825Z',
          __v: 2,
          coverImage: {
            _id: '60feef59ea7297001be8c5ed',
            name: '20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
            alternativeText: '',
            caption: '',
            hash: '20210510_On_site_Review_Artboard_v2_e9212db564',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 657.65,
            width: 2501,
            height: 1667,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'thumbnail_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 12.97,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              large: {
                name: 'large_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'large_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 1000,
                height: 667,
                size: 146.8,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              medium: {
                name: 'medium_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'medium_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 750,
                height: 500,
                size: 92.52,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              small: {
                name: 'small_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'small_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 46.42,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['60fef2feea7297001be8c5f3'],
            createdAt: '2021-07-26T17:22:33.885Z',
            updatedAt: '2021-07-30T03:43:47.943Z',
            __v: 0,
            id: '60feef59ea7297001be8c5ed',
          },
          metadata: null,
          id: '60fef2feea7297001be8c5f3',
        },
        {
          relatedArticles: ['60fef2feea7297001be8c5f3', '62cd8d63df69b2001b4a9b5c'],
          categories: [
            '62a76933e9dde5001b3c6b15',
            '60d1fe825749bf001bbb11e4',
            '62de67ecb31a7a001bba2d60',
          ],
          _id: '62cda1d7df69b2001b4a9c2a',
          published_at: '2022-07-12T16:36:03.404Z',
          slug: '911-assistant-rama-ix-porsche-service',
          shortDescription:
            'คุณลูกค้าได้ติดต่อให้ช่างอุ่นใจเข้ามาตรวจสอบปัญหาชักโครกมีกลิ่นเเละน้ำรั่วซึม ซึ่งช่างอุ่นใจได้รับโจทย์ในงานซ่อมแบ่งเป็น 2 ส่วนได้แก่ การซ่อมโถชักโครกและโถปัสสาวะชาย\n#งานเปลี่ยนสุขภัณฑ์ #รีวิว #กลิ่นโถส้วม',
          views: 244,
          title: 'รีวิวผลงานจริง @911 ASSISTANT RAMA IX (Porsche Service)',
          contents: [
            {
              __component: 'article.content',
              id: '62cda1d7df69b2001b4a9c2b',
            },
            {
              __component: 'article.content',
              id: '62cda1d7df69b2001b4a9c2c',
            },
          ],
          link: null,
          createdAt: '2022-07-12T16:31:19.223Z',
          updatedAt: '2022-07-25T10:08:01.825Z',
          __v: 1,
          coverImage: {
            _id: '62cd994fdf69b2001b4a9bbe',
            name: '144302486_851532738754884_6271739837459506095_n (Small).jpg',
            alternativeText: '',
            caption: '',
            hash: '144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 75.25,
            width: 720,
            height: 480,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_144302486_851532738754884_6271739837459506095_n (Small).jpg',
                hash: 'thumbnail_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 11.42,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
              },
              small: {
                name: 'small_144302486_851532738754884_6271739837459506095_n (Small).jpg',
                hash: 'small_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 40.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
              },
            },
            provider: 'aws-s3',
            related: ['62cda1d7df69b2001b4a9c2a'],
            createdAt: '2022-07-12T15:54:55.834Z',
            updatedAt: '2022-07-12T16:31:19.369Z',
            __v: 0,
            id: '62cd994fdf69b2001b4a9bbe',
          },
          metadata: null,
          id: '62cda1d7df69b2001b4a9c2a',
        },
        {
          relatedArticles: ['60fef2feea7297001be8c5f3'],
          categories: ['60d1fe825749bf001bbb11e4', '62a76933e9dde5001b3c6b15'],
          _id: '60fef555ea7297001be8c617',
          published_at: '2021-07-26T17:58:58.311Z',
          slug: 'ac-with-installation',
          shortDescription:
            '#ซื้อแอร์วันนี้แถมฟรีติดตั้ง\n\n☀ ถ้าจะบอกว่าเมืองไทย ‘อากาศร้อน’ เฉพาะในช่วงหน้าร้อนก็คงจะไม่ถูก เพราะไม่ว่าฤดูไหนๆ จะร้อน หนาว ฝน อากาศก็ร้อนอยู่ดี!\nวันนี้มาดับร้อนกันดีกว่า ❄ ด้วยบริการซื้อแอร์พร้อมติดตั้งฟรี โดยทีมช่างมืออาชีพ 24 FIX 😊',
          title: 'บริการซื้อแอร์พร้อมติดตั้ง',
          contents: [
            {
              __component: 'article.content',
              id: '60fef7daea7297001be8c649',
            },
            {
              __component: 'article.images',
              id: '60fef7daea7297001be8c64a',
            },
          ],
          link: null,
          createdAt: '2021-07-26T17:48:05.531Z',
          updatedAt: '2022-07-13T05:50:55.237Z',
          __v: 0,
          views: 1124,
          coverImage: {
            _id: '60fef76eea7297001be8c634',
            name: '117956473_738009603440532_2359157732673622296_n.jpeg',
            alternativeText: '',
            caption: '',
            hash: '117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 253.58,
            width: 1801,
            height: 1201,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'thumbnail_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 8.33,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              large: {
                name: 'large_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'large_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 1000,
                height: 667,
                size: 83.31,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              medium: {
                name: 'medium_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'medium_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 750,
                height: 500,
                size: 50.16,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              small: {
                name: 'small_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'small_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 26.25,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['60fef555ea7297001be8c617'],
            createdAt: '2021-07-26T17:57:02.195Z',
            updatedAt: '2021-07-30T03:43:47.943Z',
            __v: 0,
            id: '60fef76eea7297001be8c634',
          },
          metadata: null,
          id: '60fef555ea7297001be8c617',
        },
      ],
      _id: '6368f6961e519e001c14718f',
      title: 'ผลงานของเรา',
      __v: 0,
      button: null,
      id: '6368f6961e519e001c14718f',
    },
    reviewSection: {
      _id: '63614819b87e30001c208c46',
      title: 'รีวิวจากผู้ใช้บริการของเรา',
      reviewContent: [
        {
          image: [
            {
              _id: '63673d956f10f9001b2ffaec',
              name: 'f4e93ddc_fbc3_4e4d_a7f6_cbd4570d1742_f299d88885.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'f4e93ddc_fbc3_4e4d_a7f6_cbd4570d1742_f299d88885_41e40f1e90',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 92.26,
              width: 858,
              height: 1907,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/f4e93ddc_fbc3_4e4d_a7f6_cbd4570d1742_f299d88885_41e40f1e90.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_f4e93ddc_fbc3_4e4d_a7f6_cbd4570d1742_f299d88885.jpeg',
                  hash: 'thumbnail_f4e93ddc_fbc3_4e4d_a7f6_cbd4570d1742_f299d88885_41e40f1e90',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 70,
                  height: 156,
                  size: 1.95,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_f4e93ddc_fbc3_4e4d_a7f6_cbd4570d1742_f299d88885_41e40f1e90.jpeg',
                },
                large: {
                  name: 'large_f4e93ddc_fbc3_4e4d_a7f6_cbd4570d1742_f299d88885.jpeg',
                  hash: 'large_f4e93ddc_fbc3_4e4d_a7f6_cbd4570d1742_f299d88885_41e40f1e90',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 450,
                  height: 1000,
                  size: 39.29,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_f4e93ddc_fbc3_4e4d_a7f6_cbd4570d1742_f299d88885_41e40f1e90.jpeg',
                },
                medium: {
                  name: 'medium_f4e93ddc_fbc3_4e4d_a7f6_cbd4570d1742_f299d88885.jpeg',
                  hash: 'medium_f4e93ddc_fbc3_4e4d_a7f6_cbd4570d1742_f299d88885_41e40f1e90',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 337,
                  height: 750,
                  size: 23.89,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_f4e93ddc_fbc3_4e4d_a7f6_cbd4570d1742_f299d88885_41e40f1e90.jpeg',
                },
                small: {
                  name: 'small_f4e93ddc_fbc3_4e4d_a7f6_cbd4570d1742_f299d88885.jpeg',
                  hash: 'small_f4e93ddc_fbc3_4e4d_a7f6_cbd4570d1742_f299d88885_41e40f1e90',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 225,
                  height: 500,
                  size: 12.24,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_f4e93ddc_fbc3_4e4d_a7f6_cbd4570d1742_f299d88885_41e40f1e90.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:52:37.328Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673d956f10f9001b2ffaec',
            },
            {
              _id: '63673d956f10f9001b2ffaed',
              name: 'c49315a3_f30b_4a82_a60d_0cd6291b63d5_71074bfee8.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'c49315a3_f30b_4a82_a60d_0cd6291b63d5_71074bfee8_ec0decdbdd',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 136.72,
              width: 858,
              height: 1907,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/c49315a3_f30b_4a82_a60d_0cd6291b63d5_71074bfee8_ec0decdbdd.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_c49315a3_f30b_4a82_a60d_0cd6291b63d5_71074bfee8.jpeg',
                  hash: 'thumbnail_c49315a3_f30b_4a82_a60d_0cd6291b63d5_71074bfee8_ec0decdbdd',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 70,
                  height: 156,
                  size: 3.03,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_c49315a3_f30b_4a82_a60d_0cd6291b63d5_71074bfee8_ec0decdbdd.jpeg',
                },
                large: {
                  name: 'large_c49315a3_f30b_4a82_a60d_0cd6291b63d5_71074bfee8.jpeg',
                  hash: 'large_c49315a3_f30b_4a82_a60d_0cd6291b63d5_71074bfee8_ec0decdbdd',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 450,
                  height: 1000,
                  size: 58.12,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_c49315a3_f30b_4a82_a60d_0cd6291b63d5_71074bfee8_ec0decdbdd.jpeg',
                },
                medium: {
                  name: 'medium_c49315a3_f30b_4a82_a60d_0cd6291b63d5_71074bfee8.jpeg',
                  hash: 'medium_c49315a3_f30b_4a82_a60d_0cd6291b63d5_71074bfee8_ec0decdbdd',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 337,
                  height: 750,
                  size: 35.53,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_c49315a3_f30b_4a82_a60d_0cd6291b63d5_71074bfee8_ec0decdbdd.jpeg',
                },
                small: {
                  name: 'small_c49315a3_f30b_4a82_a60d_0cd6291b63d5_71074bfee8.jpeg',
                  hash: 'small_c49315a3_f30b_4a82_a60d_0cd6291b63d5_71074bfee8_ec0decdbdd',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 225,
                  height: 500,
                  size: 18.52,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_c49315a3_f30b_4a82_a60d_0cd6291b63d5_71074bfee8_ec0decdbdd.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:52:37.384Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673d956f10f9001b2ffaed',
            },
          ],
          _id: '63614819b87e30001c208c4c',
          name: 'ไปรxxx',
          description:
            'เจ้าหน้าที่ให้คำแนะนำและคำปรึกษาดีค่ะ ใช้บริการติดตั้งพื้นคอนกรีตแสตมป์ มีให้เลือกหลายลายดีค่ะ ',
          score: 5,
          __v: 0,
          id: '63614819b87e30001c208c4c',
        },
        {
          image: [
            {
              _id: '63673d416f10f9001b2ffae6',
              name: 'ED_0_D1973_A2_FF_412_E_9873_475_F2_A83_B314_8f39d1ad59.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'ED_0_D1973_A2_FF_412_E_9873_475_F2_A83_B314_8f39d1ad59_5b2bcc1bf6',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 97.37,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/ED_0_D1973_A2_FF_412_E_9873_475_F2_A83_B314_8f39d1ad59_5b2bcc1bf6.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_ED_0_D1973_A2_FF_412_E_9873_475_F2_A83_B314_8f39d1ad59.jpeg',
                  hash: 'thumbnail_ED_0_D1973_A2_FF_412_E_9873_475_F2_A83_B314_8f39d1ad59_5b2bcc1bf6',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 5.24,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_ED_0_D1973_A2_FF_412_E_9873_475_F2_A83_B314_8f39d1ad59_5b2bcc1bf6.jpeg',
                },
                medium: {
                  name: 'medium_ED_0_D1973_A2_FF_412_E_9873_475_F2_A83_B314_8f39d1ad59.jpeg',
                  hash: 'medium_ED_0_D1973_A2_FF_412_E_9873_475_F2_A83_B314_8f39d1ad59_5b2bcc1bf6',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 87.2,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_ED_0_D1973_A2_FF_412_E_9873_475_F2_A83_B314_8f39d1ad59_5b2bcc1bf6.jpeg',
                },
                small: {
                  name: 'small_ED_0_D1973_A2_FF_412_E_9873_475_F2_A83_B314_8f39d1ad59.jpeg',
                  hash: 'small_ED_0_D1973_A2_FF_412_E_9873_475_F2_A83_B314_8f39d1ad59_5b2bcc1bf6',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 42.72,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_ED_0_D1973_A2_FF_412_E_9873_475_F2_A83_B314_8f39d1ad59_5b2bcc1bf6.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:51:13.989Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673d416f10f9001b2ffae6',
            },
            {
              _id: '63673d426f10f9001b2ffae7',
              name: 'B6_F35940_AFFD_4_E60_AAC_2_F1155850_E4_AF_8f2843fcbd.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'B6_F35940_AFFD_4_E60_AAC_2_F1155850_E4_AF_8f2843fcbd_3156f39ea5',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 85.4,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/B6_F35940_AFFD_4_E60_AAC_2_F1155850_E4_AF_8f2843fcbd_3156f39ea5.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_B6_F35940_AFFD_4_E60_AAC_2_F1155850_E4_AF_8f2843fcbd.jpeg',
                  hash: 'thumbnail_B6_F35940_AFFD_4_E60_AAC_2_F1155850_E4_AF_8f2843fcbd_3156f39ea5',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 4.68,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_B6_F35940_AFFD_4_E60_AAC_2_F1155850_E4_AF_8f2843fcbd_3156f39ea5.jpeg',
                },
                medium: {
                  name: 'medium_B6_F35940_AFFD_4_E60_AAC_2_F1155850_E4_AF_8f2843fcbd.jpeg',
                  hash: 'medium_B6_F35940_AFFD_4_E60_AAC_2_F1155850_E4_AF_8f2843fcbd_3156f39ea5',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 76.67,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_B6_F35940_AFFD_4_E60_AAC_2_F1155850_E4_AF_8f2843fcbd_3156f39ea5.jpeg',
                },
                small: {
                  name: 'small_B6_F35940_AFFD_4_E60_AAC_2_F1155850_E4_AF_8f2843fcbd.jpeg',
                  hash: 'small_B6_F35940_AFFD_4_E60_AAC_2_F1155850_E4_AF_8f2843fcbd_3156f39ea5',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 38.22,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_B6_F35940_AFFD_4_E60_AAC_2_F1155850_E4_AF_8f2843fcbd_3156f39ea5.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:51:14.031Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673d426f10f9001b2ffae7',
            },
          ],
          _id: '63614819b87e30001c208c49',
          name: 'นาxxxxx',
          description:
            'พื้นหน้าบ้านสวยขึ้นเยอะมากตั้งแต่ทำคอนกรีตพิมพ์ลาย ขอบคุณทีมช่างที่นี้ประสานงานเร็ว',
          score: 4,
          __v: 0,
          id: '63614819b87e30001c208c49',
        },
        {
          image: [
            {
              _id: '63673d5d6f10f9001b2ffae8',
              name: 'rn_image_picker_lib_temp_f9b7d285_b99b_4ac3_b00f_46209042fb21_45bae69863.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_f9b7d285_b99b_4ac3_b00f_46209042fb21_45bae69863_95fb22ca43',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 47.62,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_f9b7d285_b99b_4ac3_b00f_46209042fb21_45bae69863_95fb22ca43.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_f9b7d285_b99b_4ac3_b00f_46209042fb21_45bae69863.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_f9b7d285_b99b_4ac3_b00f_46209042fb21_45bae69863_95fb22ca43',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.77,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_f9b7d285_b99b_4ac3_b00f_46209042fb21_45bae69863_95fb22ca43.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_f9b7d285_b99b_4ac3_b00f_46209042fb21_45bae69863.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_f9b7d285_b99b_4ac3_b00f_46209042fb21_45bae69863_95fb22ca43',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 43.23,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_f9b7d285_b99b_4ac3_b00f_46209042fb21_45bae69863_95fb22ca43.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_f9b7d285_b99b_4ac3_b00f_46209042fb21_45bae69863.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_f9b7d285_b99b_4ac3_b00f_46209042fb21_45bae69863_95fb22ca43',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 22.58,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_f9b7d285_b99b_4ac3_b00f_46209042fb21_45bae69863_95fb22ca43.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:51:41.057Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673d5d6f10f9001b2ffae8',
            },
            {
              _id: '63673d5d6f10f9001b2ffae9',
              name: 'rn_image_picker_lib_temp_1f7d22cd_1bd6_408f_a64c_0eae3af41ada_154c78fb35.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_1f7d22cd_1bd6_408f_a64c_0eae3af41ada_154c78fb35_19af74b721',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 78.16,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_1f7d22cd_1bd6_408f_a64c_0eae3af41ada_154c78fb35_19af74b721.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_1f7d22cd_1bd6_408f_a64c_0eae3af41ada_154c78fb35.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_1f7d22cd_1bd6_408f_a64c_0eae3af41ada_154c78fb35_19af74b721',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.98,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_1f7d22cd_1bd6_408f_a64c_0eae3af41ada_154c78fb35_19af74b721.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_1f7d22cd_1bd6_408f_a64c_0eae3af41ada_154c78fb35.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_1f7d22cd_1bd6_408f_a64c_0eae3af41ada_154c78fb35_19af74b721',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 67.48,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_1f7d22cd_1bd6_408f_a64c_0eae3af41ada_154c78fb35_19af74b721.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_1f7d22cd_1bd6_408f_a64c_0eae3af41ada_154c78fb35.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_1f7d22cd_1bd6_408f_a64c_0eae3af41ada_154c78fb35_19af74b721',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 30.11,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_1f7d22cd_1bd6_408f_a64c_0eae3af41ada_154c78fb35_19af74b721.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:51:41.100Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673d5d6f10f9001b2ffae9',
            },
          ],
          _id: '63614819b87e30001c208c4a',
          name: 'แพรxxxxx',
          description: 'ช่างทำงานเร็วมาก 3 วันจบงานทุกอย่างเลย',
          score: 4,
          __v: 0,
          id: '63614819b87e30001c208c4a',
        },
        {
          image: [
            {
              _id: '63673d796f10f9001b2ffaea',
              name: '4273a1c5_2d23_4cc5_9142_01b009bd1be7_1565dde5bf.jpeg',
              alternativeText: '',
              caption: '',
              hash: '4273a1c5_2d23_4cc5_9142_01b009bd1be7_1565dde5bf_00add723ed',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 171.67,
              width: 1477,
              height: 1108,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/4273a1c5_2d23_4cc5_9142_01b009bd1be7_1565dde5bf_00add723ed.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_4273a1c5_2d23_4cc5_9142_01b009bd1be7_1565dde5bf.jpeg',
                  hash: 'thumbnail_4273a1c5_2d23_4cc5_9142_01b009bd1be7_1565dde5bf_00add723ed',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 208,
                  height: 156,
                  size: 6.24,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_4273a1c5_2d23_4cc5_9142_01b009bd1be7_1565dde5bf_00add723ed.jpeg',
                },
                large: {
                  name: 'large_4273a1c5_2d23_4cc5_9142_01b009bd1be7_1565dde5bf.jpeg',
                  hash: 'large_4273a1c5_2d23_4cc5_9142_01b009bd1be7_1565dde5bf_00add723ed',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 1000,
                  height: 750,
                  size: 101.31,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_4273a1c5_2d23_4cc5_9142_01b009bd1be7_1565dde5bf_00add723ed.jpeg',
                },
                medium: {
                  name: 'medium_4273a1c5_2d23_4cc5_9142_01b009bd1be7_1565dde5bf.jpeg',
                  hash: 'medium_4273a1c5_2d23_4cc5_9142_01b009bd1be7_1565dde5bf_00add723ed',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 563,
                  size: 60.58,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_4273a1c5_2d23_4cc5_9142_01b009bd1be7_1565dde5bf_00add723ed.jpeg',
                },
                small: {
                  name: 'small_4273a1c5_2d23_4cc5_9142_01b009bd1be7_1565dde5bf.jpeg',
                  hash: 'small_4273a1c5_2d23_4cc5_9142_01b009bd1be7_1565dde5bf_00add723ed',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 500,
                  height: 375,
                  size: 28.58,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_4273a1c5_2d23_4cc5_9142_01b009bd1be7_1565dde5bf_00add723ed.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:52:09.186Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673d796f10f9001b2ffaea',
            },
            {
              _id: '63673d796f10f9001b2ffaeb',
              name: '8f7125c6_ed22_46ab_bed1_9c725e0c1eae_2257a84f55.jpeg',
              alternativeText: '',
              caption: '',
              hash: '8f7125c6_ed22_46ab_bed1_9c725e0c1eae_2257a84f55_dd60e902b9',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 172.85,
              width: 1108,
              height: 1477,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/8f7125c6_ed22_46ab_bed1_9c725e0c1eae_2257a84f55_dd60e902b9.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_8f7125c6_ed22_46ab_bed1_9c725e0c1eae_2257a84f55.jpeg',
                  hash: 'thumbnail_8f7125c6_ed22_46ab_bed1_9c725e0c1eae_2257a84f55_dd60e902b9',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 11.77,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_8f7125c6_ed22_46ab_bed1_9c725e0c1eae_2257a84f55_dd60e902b9.jpeg',
                },
                large: {
                  name: 'large_8f7125c6_ed22_46ab_bed1_9c725e0c1eae_2257a84f55.jpeg',
                  hash: 'large_8f7125c6_ed22_46ab_bed1_9c725e0c1eae_2257a84f55_dd60e902b9',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 1000,
                  size: 118.16,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_8f7125c6_ed22_46ab_bed1_9c725e0c1eae_2257a84f55_dd60e902b9.jpeg',
                },
                medium: {
                  name: 'medium_8f7125c6_ed22_46ab_bed1_9c725e0c1eae_2257a84f55.jpeg',
                  hash: 'medium_8f7125c6_ed22_46ab_bed1_9c725e0c1eae_2257a84f55_dd60e902b9',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 75.06,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_8f7125c6_ed22_46ab_bed1_9c725e0c1eae_2257a84f55_dd60e902b9.jpeg',
                },
                small: {
                  name: 'small_8f7125c6_ed22_46ab_bed1_9c725e0c1eae_2257a84f55.jpeg',
                  hash: 'small_8f7125c6_ed22_46ab_bed1_9c725e0c1eae_2257a84f55_dd60e902b9',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 40.24,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_8f7125c6_ed22_46ab_bed1_9c725e0c1eae_2257a84f55_dd60e902b9.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:52:09.327Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673d796f10f9001b2ffaeb',
            },
          ],
          _id: '63614819b87e30001c208c4b',
          name: 'จารุxxxxx',
          description:
            'ที่บ้านใช้บริการให้ช่างจาก 24 FIX มาปูคอนกรีตพิมพ์ลายหน้าบ้านให้ค่ะ ที่นี่มีพื้นให้เลือกค่อนข้างหลากหลายดีค่ะ ส่วนช่างก็ให้คำแนะนำค่อนข้างดี ไม่มีปัญหาค่ะ ',
          score: 3,
          __v: 0,
          id: '63614819b87e30001c208c4b',
        },
        {
          image: [
            {
              _id: '63673db06f10f9001b2ffaee',
              name: '4b6d3f0f_12f8_4f39_b645_d024c1aec527_4b919e5872.jpeg',
              alternativeText: '',
              caption: '',
              hash: '4b6d3f0f_12f8_4f39_b645_d024c1aec527_4b919e5872_d031988a09',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 311.02,
              width: 1108,
              height: 1477,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/4b6d3f0f_12f8_4f39_b645_d024c1aec527_4b919e5872_d031988a09.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_4b6d3f0f_12f8_4f39_b645_d024c1aec527_4b919e5872.jpeg',
                  hash: 'thumbnail_4b6d3f0f_12f8_4f39_b645_d024c1aec527_4b919e5872_d031988a09',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 7.02,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_4b6d3f0f_12f8_4f39_b645_d024c1aec527_4b919e5872_d031988a09.jpeg',
                },
                large: {
                  name: 'large_4b6d3f0f_12f8_4f39_b645_d024c1aec527_4b919e5872.jpeg',
                  hash: 'large_4b6d3f0f_12f8_4f39_b645_d024c1aec527_4b919e5872_d031988a09',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 1000,
                  size: 185.07,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_4b6d3f0f_12f8_4f39_b645_d024c1aec527_4b919e5872_d031988a09.jpeg',
                },
                medium: {
                  name: 'medium_4b6d3f0f_12f8_4f39_b645_d024c1aec527_4b919e5872.jpeg',
                  hash: 'medium_4b6d3f0f_12f8_4f39_b645_d024c1aec527_4b919e5872_d031988a09',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 115.66,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_4b6d3f0f_12f8_4f39_b645_d024c1aec527_4b919e5872_d031988a09.jpeg',
                },
                small: {
                  name: 'small_4b6d3f0f_12f8_4f39_b645_d024c1aec527_4b919e5872.jpeg',
                  hash: 'small_4b6d3f0f_12f8_4f39_b645_d024c1aec527_4b919e5872_d031988a09',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 56.49,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_4b6d3f0f_12f8_4f39_b645_d024c1aec527_4b919e5872_d031988a09.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:53:04.552Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673db06f10f9001b2ffaee',
            },
            {
              _id: '63673db06f10f9001b2ffaef',
              name: '0e54deab_d11d_43db_8173_9e47d7d04de8_0076f39752.jpeg',
              alternativeText: '',
              caption: '',
              hash: '0e54deab_d11d_43db_8173_9e47d7d04de8_0076f39752_82544bd620',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 279.65,
              width: 1108,
              height: 1477,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/0e54deab_d11d_43db_8173_9e47d7d04de8_0076f39752_82544bd620.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_0e54deab_d11d_43db_8173_9e47d7d04de8_0076f39752.jpeg',
                  hash: 'thumbnail_0e54deab_d11d_43db_8173_9e47d7d04de8_0076f39752_82544bd620',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 5.37,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_0e54deab_d11d_43db_8173_9e47d7d04de8_0076f39752_82544bd620.jpeg',
                },
                large: {
                  name: 'large_0e54deab_d11d_43db_8173_9e47d7d04de8_0076f39752.jpeg',
                  hash: 'large_0e54deab_d11d_43db_8173_9e47d7d04de8_0076f39752_82544bd620',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 1000,
                  size: 159.09,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_0e54deab_d11d_43db_8173_9e47d7d04de8_0076f39752_82544bd620.jpeg',
                },
                medium: {
                  name: 'medium_0e54deab_d11d_43db_8173_9e47d7d04de8_0076f39752.jpeg',
                  hash: 'medium_0e54deab_d11d_43db_8173_9e47d7d04de8_0076f39752_82544bd620',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 95.37,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_0e54deab_d11d_43db_8173_9e47d7d04de8_0076f39752_82544bd620.jpeg',
                },
                small: {
                  name: 'small_0e54deab_d11d_43db_8173_9e47d7d04de8_0076f39752.jpeg',
                  hash: 'small_0e54deab_d11d_43db_8173_9e47d7d04de8_0076f39752_82544bd620',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 44.17,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_0e54deab_d11d_43db_8173_9e47d7d04de8_0076f39752_82544bd620.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:53:04.554Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673db06f10f9001b2ffaef',
            },
          ],
          _id: '63614819b87e30001c208c4d',
          name: 'หาญxxx',
          description: 'เจ้าแนะนำให้ทำการปูกระเบื้องใหม่ ช่างทำงานเรียบร้อยดี ราคาไม่แพงมากครับ',
          score: 5,
          __v: 0,
          id: '63614819b87e30001c208c4d',
        },
        {
          image: [
            {
              _id: '63673dcb6f10f9001b2ffaf0',
              name: 'rn_image_picker_lib_temp_3a0726cc_d99d_455b_bf6a_5d77e73e3298_223b70a714.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_3a0726cc_d99d_455b_bf6a_5d77e73e3298_223b70a714_8468d4cc44',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 69.81,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_3a0726cc_d99d_455b_bf6a_5d77e73e3298_223b70a714_8468d4cc44.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_3a0726cc_d99d_455b_bf6a_5d77e73e3298_223b70a714.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_3a0726cc_d99d_455b_bf6a_5d77e73e3298_223b70a714_8468d4cc44',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.79,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_3a0726cc_d99d_455b_bf6a_5d77e73e3298_223b70a714_8468d4cc44.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_3a0726cc_d99d_455b_bf6a_5d77e73e3298_223b70a714.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_3a0726cc_d99d_455b_bf6a_5d77e73e3298_223b70a714_8468d4cc44',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 61.69,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_3a0726cc_d99d_455b_bf6a_5d77e73e3298_223b70a714_8468d4cc44.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_3a0726cc_d99d_455b_bf6a_5d77e73e3298_223b70a714.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_3a0726cc_d99d_455b_bf6a_5d77e73e3298_223b70a714_8468d4cc44',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 29.81,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_3a0726cc_d99d_455b_bf6a_5d77e73e3298_223b70a714_8468d4cc44.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:53:31.500Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673dcb6f10f9001b2ffaf0',
            },
            {
              _id: '63673dcb6f10f9001b2ffaf1',
              name: 'rn_image_picker_lib_temp_28f661bd_c0be_4734_b6fd_e99e4d730de7_fa647eee81.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_28f661bd_c0be_4734_b6fd_e99e4d730de7_fa647eee81_a0650d4e23',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 56.65,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_28f661bd_c0be_4734_b6fd_e99e4d730de7_fa647eee81_a0650d4e23.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_28f661bd_c0be_4734_b6fd_e99e4d730de7_fa647eee81.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_28f661bd_c0be_4734_b6fd_e99e4d730de7_fa647eee81_a0650d4e23',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 4.18,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_28f661bd_c0be_4734_b6fd_e99e4d730de7_fa647eee81_a0650d4e23.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_28f661bd_c0be_4734_b6fd_e99e4d730de7_fa647eee81.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_28f661bd_c0be_4734_b6fd_e99e4d730de7_fa647eee81_a0650d4e23',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 51.09,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_28f661bd_c0be_4734_b6fd_e99e4d730de7_fa647eee81_a0650d4e23.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_28f661bd_c0be_4734_b6fd_e99e4d730de7_fa647eee81.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_28f661bd_c0be_4734_b6fd_e99e4d730de7_fa647eee81_a0650d4e23',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 26.3,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_28f661bd_c0be_4734_b6fd_e99e4d730de7_fa647eee81_a0650d4e23.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:53:31.580Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673dcb6f10f9001b2ffaf1',
            },
          ],
          _id: '63614819b87e30001c208c4e',
          name: 'รุ่งxxx',
          description: 'ช่างทำงานกันเป็นทีม ให้คำแนะนำดีค่ะ มาตรงเวลาทำงานเรียบร้อยค่ะ ',
          score: 5,
          __v: 0,
          id: '63614819b87e30001c208c4e',
        },
        {
          image: [
            {
              _id: '63673de66f10f9001b2ffaf2',
              name: 'a587d336_fa2f_45d6_b68f_013b3057d449_e28b5a3efe.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'a587d336_fa2f_45d6_b68f_013b3057d449_e28b5a3efe_ae920d7553',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 136.72,
              width: 1108,
              height: 1477,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/a587d336_fa2f_45d6_b68f_013b3057d449_e28b5a3efe_ae920d7553.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_a587d336_fa2f_45d6_b68f_013b3057d449_e28b5a3efe.jpeg',
                  hash: 'thumbnail_a587d336_fa2f_45d6_b68f_013b3057d449_e28b5a3efe_ae920d7553',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.56,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_a587d336_fa2f_45d6_b68f_013b3057d449_e28b5a3efe_ae920d7553.jpeg',
                },
                large: {
                  name: 'large_a587d336_fa2f_45d6_b68f_013b3057d449_e28b5a3efe.jpeg',
                  hash: 'large_a587d336_fa2f_45d6_b68f_013b3057d449_e28b5a3efe_ae920d7553',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 1000,
                  size: 84.87,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_a587d336_fa2f_45d6_b68f_013b3057d449_e28b5a3efe_ae920d7553.jpeg',
                },
                medium: {
                  name: 'medium_a587d336_fa2f_45d6_b68f_013b3057d449_e28b5a3efe.jpeg',
                  hash: 'medium_a587d336_fa2f_45d6_b68f_013b3057d449_e28b5a3efe_ae920d7553',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 52.8,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_a587d336_fa2f_45d6_b68f_013b3057d449_e28b5a3efe_ae920d7553.jpeg',
                },
                small: {
                  name: 'small_a587d336_fa2f_45d6_b68f_013b3057d449_e28b5a3efe.jpeg',
                  hash: 'small_a587d336_fa2f_45d6_b68f_013b3057d449_e28b5a3efe_ae920d7553',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 26.16,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_a587d336_fa2f_45d6_b68f_013b3057d449_e28b5a3efe_ae920d7553.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:53:58.405Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673de66f10f9001b2ffaf2',
            },
            {
              _id: '63673de66f10f9001b2ffaf3',
              name: 'c442842c_9553_4c4f_aaed_5b1ab37fff1e_2af6c1c983.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'c442842c_9553_4c4f_aaed_5b1ab37fff1e_2af6c1c983_1f5f85f945',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 216.95,
              width: 1108,
              height: 1477,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/c442842c_9553_4c4f_aaed_5b1ab37fff1e_2af6c1c983_1f5f85f945.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_c442842c_9553_4c4f_aaed_5b1ab37fff1e_2af6c1c983.jpeg',
                  hash: 'thumbnail_c442842c_9553_4c4f_aaed_5b1ab37fff1e_2af6c1c983_1f5f85f945',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 4.64,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_c442842c_9553_4c4f_aaed_5b1ab37fff1e_2af6c1c983_1f5f85f945.jpeg',
                },
                large: {
                  name: 'large_c442842c_9553_4c4f_aaed_5b1ab37fff1e_2af6c1c983.jpeg',
                  hash: 'large_c442842c_9553_4c4f_aaed_5b1ab37fff1e_2af6c1c983_1f5f85f945',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 1000,
                  size: 126.59,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_c442842c_9553_4c4f_aaed_5b1ab37fff1e_2af6c1c983_1f5f85f945.jpeg',
                },
                medium: {
                  name: 'medium_c442842c_9553_4c4f_aaed_5b1ab37fff1e_2af6c1c983.jpeg',
                  hash: 'medium_c442842c_9553_4c4f_aaed_5b1ab37fff1e_2af6c1c983_1f5f85f945',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 76.21,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_c442842c_9553_4c4f_aaed_5b1ab37fff1e_2af6c1c983_1f5f85f945.jpeg',
                },
                small: {
                  name: 'small_c442842c_9553_4c4f_aaed_5b1ab37fff1e_2af6c1c983.jpeg',
                  hash: 'small_c442842c_9553_4c4f_aaed_5b1ab37fff1e_2af6c1c983_1f5f85f945',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 36.07,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_c442842c_9553_4c4f_aaed_5b1ab37fff1e_2af6c1c983_1f5f85f945.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:53:58.463Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673de66f10f9001b2ffaf3',
            },
          ],
          _id: '63614819b87e30001c208c4f',
          name: 'ขวัญxxx',
          description:
            'เห็นรีวิวผลงานจริงคอนกรีตแสตมป์ที่หน้าเพจแล้วสวยดีค่ะ เลยเรียกมาใช้บริการที่บ้านตัวเองบ้าง ใช้เวลาค่อนข้างนาน แต่พอเสร็จงานแล้วคอนกรีตแสตมป์ทำออกมาได้สวยตามที่ต้องการเลยค่ะ มีหลายลายให้เราเลือก ใครอยากทำพื้นที่จอดรถหน้าบ้านแนะนำค่ะ',
          score: 4,
          __v: 0,
          id: '63614819b87e30001c208c4f',
        },
        {
          image: [
            {
              _id: '63673e0d6f10f9001b2ffaf4',
              name: '8_FE_35_A4_C_CEFD_49_A8_AD_61_9_AD_6_C937_BEC_2_818a477757.jpeg',
              alternativeText: '',
              caption: '',
              hash: '8_FE_35_A4_C_CEFD_49_A8_AD_61_9_AD_6_C937_BEC_2_818a477757_a9d0565ffc',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 95.84,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/8_FE_35_A4_C_CEFD_49_A8_AD_61_9_AD_6_C937_BEC_2_818a477757_a9d0565ffc.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_8_FE_35_A4_C_CEFD_49_A8_AD_61_9_AD_6_C937_BEC_2_818a477757.jpeg',
                  hash: 'thumbnail_8_FE_35_A4_C_CEFD_49_A8_AD_61_9_AD_6_C937_BEC_2_818a477757_a9d0565ffc',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 5.4,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_8_FE_35_A4_C_CEFD_49_A8_AD_61_9_AD_6_C937_BEC_2_818a477757_a9d0565ffc.jpeg',
                },
                medium: {
                  name: 'medium_8_FE_35_A4_C_CEFD_49_A8_AD_61_9_AD_6_C937_BEC_2_818a477757.jpeg',
                  hash: 'medium_8_FE_35_A4_C_CEFD_49_A8_AD_61_9_AD_6_C937_BEC_2_818a477757_a9d0565ffc',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 85.44,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_8_FE_35_A4_C_CEFD_49_A8_AD_61_9_AD_6_C937_BEC_2_818a477757_a9d0565ffc.jpeg',
                },
                small: {
                  name: 'small_8_FE_35_A4_C_CEFD_49_A8_AD_61_9_AD_6_C937_BEC_2_818a477757.jpeg',
                  hash: 'small_8_FE_35_A4_C_CEFD_49_A8_AD_61_9_AD_6_C937_BEC_2_818a477757_a9d0565ffc',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 41.45,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_8_FE_35_A4_C_CEFD_49_A8_AD_61_9_AD_6_C937_BEC_2_818a477757_a9d0565ffc.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:54:37.751Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673e0d6f10f9001b2ffaf4',
            },
            {
              _id: '63673e0d6f10f9001b2ffaf5',
              name: '663_D8078_9_ECA_4_CE_1_B433_998_B250_DBFA_1_c4b187269a.jpeg',
              alternativeText: '',
              caption: '',
              hash: '663_D8078_9_ECA_4_CE_1_B433_998_B250_DBFA_1_c4b187269a_def973fd4f',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 117.19,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/663_D8078_9_ECA_4_CE_1_B433_998_B250_DBFA_1_c4b187269a_def973fd4f.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_663_D8078_9_ECA_4_CE_1_B433_998_B250_DBFA_1_c4b187269a.jpeg',
                  hash: 'thumbnail_663_D8078_9_ECA_4_CE_1_B433_998_B250_DBFA_1_c4b187269a_def973fd4f',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 5.76,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_663_D8078_9_ECA_4_CE_1_B433_998_B250_DBFA_1_c4b187269a_def973fd4f.jpeg',
                },
                medium: {
                  name: 'medium_663_D8078_9_ECA_4_CE_1_B433_998_B250_DBFA_1_c4b187269a.jpeg',
                  hash: 'medium_663_D8078_9_ECA_4_CE_1_B433_998_B250_DBFA_1_c4b187269a_def973fd4f',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 103.73,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_663_D8078_9_ECA_4_CE_1_B433_998_B250_DBFA_1_c4b187269a_def973fd4f.jpeg',
                },
                small: {
                  name: 'small_663_D8078_9_ECA_4_CE_1_B433_998_B250_DBFA_1_c4b187269a.jpeg',
                  hash: 'small_663_D8078_9_ECA_4_CE_1_B433_998_B250_DBFA_1_c4b187269a_def973fd4f',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 49.48,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_663_D8078_9_ECA_4_CE_1_B433_998_B250_DBFA_1_c4b187269a_def973fd4f.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:54:37.820Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673e0d6f10f9001b2ffaf5',
            },
          ],
          _id: '63614819b87e30001c208c50',
          name: 'ปธาxxxx',
          description:
            'ที่บ้านต้องการปูพื้นคอนกรีตแสตมป์พื้นที่หน้าบ้านใหม่ครับ เจ้าหน้าที่ให้คำปรึกษาทำงานเรียบร้อยดีครับ',
          score: 5,
          __v: 0,
          id: '63614819b87e30001c208c50',
        },
        {
          image: [
            {
              _id: '63673d256f10f9001b2ffae5',
              name: 'C5_B24409_2_BC_8_4_ED_5_A95_F_B504_AB_70885_B_78990a1a11.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'C5_B24409_2_BC_8_4_ED_5_A95_F_B504_AB_70885_B_78990a1a11_df042caacb',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 59.5,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/C5_B24409_2_BC_8_4_ED_5_A95_F_B504_AB_70885_B_78990a1a11_df042caacb.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_C5_B24409_2_BC_8_4_ED_5_A95_F_B504_AB_70885_B_78990a1a11.jpeg',
                  hash: 'thumbnail_C5_B24409_2_BC_8_4_ED_5_A95_F_B504_AB_70885_B_78990a1a11_df042caacb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 4.11,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_C5_B24409_2_BC_8_4_ED_5_A95_F_B504_AB_70885_B_78990a1a11_df042caacb.jpeg',
                },
                medium: {
                  name: 'medium_C5_B24409_2_BC_8_4_ED_5_A95_F_B504_AB_70885_B_78990a1a11.jpeg',
                  hash: 'medium_C5_B24409_2_BC_8_4_ED_5_A95_F_B504_AB_70885_B_78990a1a11_df042caacb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 53.82,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_C5_B24409_2_BC_8_4_ED_5_A95_F_B504_AB_70885_B_78990a1a11_df042caacb.jpeg',
                },
                small: {
                  name: 'small_C5_B24409_2_BC_8_4_ED_5_A95_F_B504_AB_70885_B_78990a1a11.jpeg',
                  hash: 'small_C5_B24409_2_BC_8_4_ED_5_A95_F_B504_AB_70885_B_78990a1a11_df042caacb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 27.35,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_C5_B24409_2_BC_8_4_ED_5_A95_F_B504_AB_70885_B_78990a1a11_df042caacb.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:50:45.695Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673d256f10f9001b2ffae5',
            },
            {
              _id: '63673d256f10f9001b2ffae4',
              name: '7489_F2_E0_1_A7_D_4_D85_BCAB_E24436111_CD_7_6053789c57.jpeg',
              alternativeText: '',
              caption: '',
              hash: '7489_F2_E0_1_A7_D_4_D85_BCAB_E24436111_CD_7_6053789c57_8364142d11',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 75.06,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/7489_F2_E0_1_A7_D_4_D85_BCAB_E24436111_CD_7_6053789c57_8364142d11.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_7489_F2_E0_1_A7_D_4_D85_BCAB_E24436111_CD_7_6053789c57.jpeg',
                  hash: 'thumbnail_7489_F2_E0_1_A7_D_4_D85_BCAB_E24436111_CD_7_6053789c57_8364142d11',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 5.02,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_7489_F2_E0_1_A7_D_4_D85_BCAB_E24436111_CD_7_6053789c57_8364142d11.jpeg',
                },
                medium: {
                  name: 'medium_7489_F2_E0_1_A7_D_4_D85_BCAB_E24436111_CD_7_6053789c57.jpeg',
                  hash: 'medium_7489_F2_E0_1_A7_D_4_D85_BCAB_E24436111_CD_7_6053789c57_8364142d11',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 68.07,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_7489_F2_E0_1_A7_D_4_D85_BCAB_E24436111_CD_7_6053789c57_8364142d11.jpeg',
                },
                small: {
                  name: 'small_7489_F2_E0_1_A7_D_4_D85_BCAB_E24436111_CD_7_6053789c57.jpeg',
                  hash: 'small_7489_F2_E0_1_A7_D_4_D85_BCAB_E24436111_CD_7_6053789c57_8364142d11',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 35.09,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_7489_F2_E0_1_A7_D_4_D85_BCAB_E24436111_CD_7_6053789c57_8364142d11.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:50:45.686Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673d256f10f9001b2ffae4',
            },
          ],
          _id: '63614819b87e30001c208c48',
          name: 'ฉัตรxxxxx',
          description: 'ช่างปูพื้นคอนกรีตสวยมากค่ะ แนะนำเพื่อนให้ลองใช้บริการแน่นอนค่ะ',
          score: 5,
          __v: 0,
          id: '63614819b87e30001c208c48',
        },
      ],
      __v: 1,
      id: '63614819b87e30001c208c46',
    },
    ctaSection: {
      _id: '6367e18d6f10f9001b2fff84',
      title: '<p>งานพื้นครบวงจร ด้วยทีมช่างมาตรฐาน</p>',
      button: {
        _id: '6367e18d6f10f9001b2fff85',
        url: 'https://fix.24x.co.th/floor/booking',
        title: 'จองบริการ',
        __v: 0,
        id: '6367e18d6f10f9001b2fff85',
      },
      __v: 1,
      id: '6367e18d6f10f9001b2fff84',
    },
    createdAt: '2022-11-01T16:23:53.457Z',
    updatedAt: '2023-01-10T06:45:25.207Z',
    __v: 1,
    metadata: {
      twitterCardType: 'summary',
      _id: '63bd0985c37f54001cf15db8',
      metaTitle: 'งานพื้นครบวงจร ด้วยทีมช่างมาตรฐาน',
      metaDescription:
        'บริการเรื่องพื้นครบวงจร ไม่ว่าจะติดตั้ง รื้อ เปลี่ยน ให้บริการอย่างมืออาชีพ ทรุด พัง ร้าว เราซ่อมได้ด้วยทีมช่างมากประสบการณ์ พร้อมส่งมอบงานที่ดีที่สุดให้บ้านคุณ',
      keywords: 'งานพื้น, เปลี่ยนพื้น, ซ่อมพื้น, ช่างปูพื้น, พื้นกระเบื้อง, พื้นทรุด, พื้นร่อน',
      __v: 0,
      id: '63bd0985c37f54001cf15db8',
    },
    installationSection: null,
    id: '63614819b87e30001c208c45',
  },
  {
    _id: '6386487bdda467001cc0c74d',
    published_at: '2022-11-30T16:25:50.884Z',
    slug: 'wall',
    bannerSection: {
      _id: '6386487bdda467001cc0c74e',
      title: '<p><strong>ซ่อม-ต่อเติมผนังครบวงจร แก้ไขตรงจุดพร้อมรับประกันผลงาน</strong></p>',
      button: {
        _id: '6386487bdda467001cc0c74f',
        title: 'จองบริการ',
        url: 'https://fix.24x.co.th/wall/booking',
        __v: 0,
        id: '6386487bdda467001cc0c74f',
      },
      __v: 1,
      image: {
        _id: '639af45412b1f5001c37d9a4',
        name: '24FIX_LD_BANNER-12.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_12_2be9a2f1ec',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 470.74,
        width: 6000,
        height: 2634,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_12_2be9a2f1ec.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER-12.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_12_2be9a2f1ec',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 108,
            size: 2.94,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_12_2be9a2f1ec.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER-12.jpg',
            hash: 'large_24_FIX_LD_BANNER_12_2be9a2f1ec',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 439,
            size: 22.78,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_12_2be9a2f1ec.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER-12.jpg',
            hash: 'medium_24_FIX_LD_BANNER_12_2be9a2f1ec',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 329,
            size: 14.1,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_12_2be9a2f1ec.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER-12.jpg',
            hash: 'small_24_FIX_LD_BANNER_12_2be9a2f1ec',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 220,
            size: 7.72,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_12_2be9a2f1ec.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-12-15T10:17:56.418Z',
        updatedAt: '2022-12-16T03:41:05.445Z',
        __v: 0,
        id: '639af45412b1f5001c37d9a4',
      },
      mobileImage: {
        _id: '639af47112b1f5001c37d9a5',
        name: '24FIX_LD_BANNER_MOBILE-12.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_MOBILE_12_6e453c282c',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 73.72,
        width: 1501,
        height: 930,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_MOBILE_12_6e453c282c.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER_MOBILE-12.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_MOBILE_12_6e453c282c',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 152,
            size: 4.02,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_MOBILE_12_6e453c282c.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER_MOBILE-12.jpg',
            hash: 'large_24_FIX_LD_BANNER_MOBILE_12_6e453c282c',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 620,
            size: 36.71,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_MOBILE_12_6e453c282c.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER_MOBILE-12.jpg',
            hash: 'medium_24_FIX_LD_BANNER_MOBILE_12_6e453c282c',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 465,
            size: 21.62,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_MOBILE_12_6e453c282c.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER_MOBILE-12.jpg',
            hash: 'small_24_FIX_LD_BANNER_MOBILE_12_6e453c282c',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 310,
            size: 11.71,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_MOBILE_12_6e453c282c.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-12-15T10:18:25.678Z',
        updatedAt: '2022-12-16T03:41:05.445Z',
        __v: 0,
        id: '639af47112b1f5001c37d9a5',
      },
      id: '6386487bdda467001cc0c74e',
    },
    uspSection: [
      {
        _id: '638648ffdda467001cc0c75a',
        __v: 0,
        description:
          '<p>ทำไมต้องจองกับ 24FIX?</p><ul><li>ทีมช่างเข้าตรวจหน้างานก่อนให้บริการภายใน&nbsp; 5&nbsp; วัน</li><li>มีบริการหลังการขายและรับประกันสูงสุด 60 วัน</li><li>ราคางานซ่อมที่ได้มาตรฐาน คุ้มค่ากับคุณภาพบริการ</li></ul>',
        subTitle:
          'บริการซ่อมผนัง แตก ร้าว รั่วซึม เราแก้ปัญหาได้ตรงจุด ใช้วัสดุมีคุณภาพพร้อมปรับประกันผลงาน รวมถึงต่อเติมและงานวอเลเปเปอร์ทุกรูปแบบจากช่างมืออาชีพ',
        title: 'ซ่อม-ต่อเติมผนังครบวงจร แก้ไขตรงจุดพร้อมรับประกันผลงาน',
        image: {
          _id: '63878459dda467001cc0c88a',
          name: 'Service_USP-01.jpg',
          alternativeText: '',
          caption: '',
          hash: 'Service_USP_01_cf8843a3cf',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 19.16,
          width: 509,
          height: 342,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/Service_USP_01_cf8843a3cf.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_Service_USP-01.jpg',
              hash: 'thumbnail_Service_USP_01_cf8843a3cf',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 232,
              height: 156,
              size: 4.44,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_Service_USP_01_cf8843a3cf.jpg',
            },
            small: {
              name: 'small_Service_USP-01.jpg',
              hash: 'small_Service_USP_01_cf8843a3cf',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 336,
              size: 17.82,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_Service_USP_01_cf8843a3cf.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-11-30T16:27:05.056Z',
          updatedAt: '2022-12-01T03:06:38.322Z',
          __v: 0,
          id: '63878459dda467001cc0c88a',
        },
        id: '638648ffdda467001cc0c75a',
      },
    ],
    faqSection: [
      {
        _id: '63864d65dda467001cc0c79d',
        question: 'งานผนังมีบริการอะไรบ้าง',
        answer: '<p>ผนังร้าว ผนังรั่วซึม ก่อผนังกั้นห้องเพิ่ม รวมไปถึงงานวอลเปเปอร์ทั้งหมด</p>',
        __v: 0,
        id: '63864d65dda467001cc0c79d',
      },
      {
        _id: '63864d65dda467001cc0c79e',
        question: 'ปัจจัยที่มีผลต่อราคาค่าบริการ',
        answer:
          '<p>ปัจจัยที่มีผลต่อราคาค่าบริการ มีดังนี้ครับ</p><ul><li>จำนวนจุดที่ติดตั้ง (หลายจุดยิ่งถูก)</li><li>บริเวณพื้นที่ซ่อมแซมหรือทำใหม่</li><li>อุปกรณ์ที่จะใช้บริการ</li></ul>',
        __v: 0,
        id: '63864d65dda467001cc0c79e',
      },
      {
        _id: '63864d66dda467001cc0c79f',
        question: 'มีการรับประกันอย่างไร',
        answer: '<p>การรับประกันผลงาน 60 วัน หลังจากการให้บริการ</p>',
        __v: 0,
        id: '63864d66dda467001cc0c79f',
      },
      {
        _id: '63864d66dda467001cc0c7a0',
        question: 'พื้นที่ที่ให้บริการมีอะไรบ้าง',
        answer: '<p>พื้นที่ให้บริการครอบคลุมในเขตกรุงเทพมหานคร นนทบุรี ปทุมธานี และสมุทรปราการ</p>',
        __v: 0,
        id: '63864d66dda467001cc0c7a0',
      },
      {
        _id: '63864d66dda467001cc0c7a1',
        question: 'คิวเรียกช่างเร็วสุดเมื่อไหร่',
        answer:
          '<p>ช่างเข้าสำรวจหน้างานภายใน 2-3 วัน หลังอนุมัติงานสำรวจ และ 5 วันนับจากวันที่ลูกค้าชำระค่าบริการ</p>',
        __v: 0,
        id: '63864d66dda467001cc0c7a1',
      },
      {
        _id: '63864d66dda467001cc0c7a2',
        question: 'เรียกบริการผ่านเว็บไซต์ดีอย่างไร',
        answer:
          '<ul><li>ลูกค้าสามารถติดตามสถานะงานผ่านทางเว็บไซต์ได้ตลอดเวลา</li><li>สามารถใช้โค้ดส่วนลดสำหรับลูกค้าที่ซื้อผ่านบนเว็บไซต์อีกด้วย</li><li>สามารถจองวันและเวลาเข้ารับบริการด้วยตนเอง</li></ul>',
        __v: 0,
        id: '63864d66dda467001cc0c7a2',
      },
      {
        _id: '63864d66dda467001cc0c7a3',
        question: 'ทางบริษัทจัดหาวัสดุให้ด้วยไหม',
        answer:
          '<p>ทางบริษัทมีบริการช่วยจัดหาวัสดุให้ ถ้าทางลูกค้าไม่สะดวกจัดหาวัสดุเอง ซึ่งจะใช้ระยะเวลาในการจัดหาประมาณ 1-2 อาทิตย์ขึ้นไป</p>',
        __v: 0,
        id: '63864d66dda467001cc0c7a3',
      },
      {
        _id: '63864d66dda467001cc0c7a4',
        question: 'ราคาค่าบริการรวมอะไรบ้าง',
        answer:
          '<p>ค่าแรงและค่าวัสดุสิ้นเปลือง ซึ่งสามารถอ่านเพิ่มเติมได้จากหน้าบริการแต่ละการบริการเพิ่มเติมได้ ก่อนหน้าชำระค่าบริการ</p>',
        __v: 0,
        id: '63864d66dda467001cc0c7a4',
      },
    ],
    promotionSection: {
      _id: '63864aafdda467001cc0c763',
      title: 'โปรโมชั่น',
      promotions: [
        {
          _id: '63864aafdda467001cc0c764',
          url: 'https://fix.24x.co.th/voucher/firstfix',
          __v: 0,
          image: {
            _id: '63864956dda467001cc0c75e',
            name: '24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_7295bed764',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 93.59,
            width: 1500,
            height: 490,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_7295bed764.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_7295bed764',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 245,
                height: 80,
                size: 6.03,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_7295bed764.jpg',
              },
              large: {
                name: 'large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
                hash: 'large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_7295bed764',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 327,
                size: 49.83,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_7295bed764.jpg',
              },
              medium: {
                name: 'medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
                hash: 'medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_7295bed764',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 245,
                size: 32.68,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_7295bed764.jpg',
              },
              small: {
                name: 'small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
                hash: 'small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_7295bed764',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 163,
                size: 17.92,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab_7295bed764.jpg',
              },
            },
            provider: 'aws-s3',
            related: [],
            createdAt: '2022-11-29T18:03:02.993Z',
            updatedAt: '2022-11-30T05:43:07.180Z',
            __v: 0,
            id: '63864956dda467001cc0c75e',
          },
          mobileImage: {
            _id: '6386496fdda467001cc0c75f',
            name: '24_FIX_NOV_BANNER_1_01_3663796871.jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_1_01_3663796871_c03269f823',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 149.12,
            width: 1500,
            height: 1021,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_1_01_3663796871_c03269f823.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_1_01_3663796871_c03269f823',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 229,
                height: 156,
                size: 8.91,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_1_01_3663796871_c03269f823.jpg',
              },
              large: {
                name: 'large_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
                hash: 'large_24_FIX_NOV_BANNER_1_01_3663796871_c03269f823',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 681,
                size: 78.68,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_1_01_3663796871_c03269f823.jpg',
              },
              medium: {
                name: 'medium_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
                hash: 'medium_24_FIX_NOV_BANNER_1_01_3663796871_c03269f823',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 511,
                size: 50.95,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_1_01_3663796871_c03269f823.jpg',
              },
              small: {
                name: 'small_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
                hash: 'small_24_FIX_NOV_BANNER_1_01_3663796871_c03269f823',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 340,
                size: 27.8,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_1_01_3663796871_c03269f823.jpg',
              },
            },
            provider: 'aws-s3',
            related: [],
            createdAt: '2022-11-29T18:03:27.830Z',
            updatedAt: '2022-11-30T05:43:07.180Z',
            __v: 0,
            id: '6386496fdda467001cc0c75f',
          },
          id: '63864aafdda467001cc0c764',
        },
      ],
      button: null,
      __v: 1,
      id: '63864aafdda467001cc0c763',
    },
    stepSection: null,
    successStorySection: {
      contents: [
        {
          relatedArticles: [],
          categories: ['62a768dbe9dde5001b3c6b0d'],
          _id: '636dd6a8d42554001c0d01c3',
          title: 'เช็ก 4 ห้องสำคัญของบ้าน ก่อนเชื้อราหน้าฝนมาเยือน',
          slug: 'Mold-in-the-house',
          shortDescription:
            ' อีกหนึ่งปัญหาเล็กที่ยิ่งใหญ่ของหลาย ๆ บ้าน นอกจากจะเรื่องหลังคา ฝ้า ผนัง แล้ว... “เชื้อรา” นี่แหละครับ ที่ร้ายไม่แพ้กัน!! \n\nถ้าจะให้บรรยายออกมาเป็นสเตป ก็คงเป็นเมื่อถึงฤดูฝน > ฝนตก > เกิดความชื้น > เชื้อราก็บุกบ้านได้ทุกเมื่อ และนอกจากจะทำให้ด้านในตัวบ้านเสียหาย ไม่น่าดูแล้วนั้น บางคนอาจมีปัญหาเรื่องสุขภาพ อาการภูมิแพ้กำเริบได้ด้วยนะครับ! ',
          published_at: '2022-11-11T04:59:27.437Z',
          contents: [
            {
              __component: 'article.content',
              id: '636dd6a8d42554001c0d01c4',
            },
            {
              __component: 'article.images',
              id: '636dd6a8d42554001c0d01c5',
            },
            {
              __component: 'article.content',
              id: '636dd6a8d42554001c0d01c6',
            },
            {
              __component: 'article.content',
              id: '636dd6a8d42554001c0d01c7',
            },
          ],
          link: null,
          createdAt: '2022-11-11T04:59:20.888Z',
          updatedAt: '2022-11-11T06:03:02.550Z',
          __v: 1,
          coverImage: {
            _id: '636dd5d7d42554001c0d01c2',
            name: 'dcff96a2-594c-427c-9c9a-4dc498cf64fb.jpeg',
            alternativeText: '',
            caption: '',
            hash: 'dcff96a2_594c_427c_9c9a_4dc498cf64fb_c9216713e6',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 66.21,
            width: 470,
            height: 314,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/dcff96a2_594c_427c_9c9a_4dc498cf64fb_c9216713e6.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_dcff96a2-594c-427c-9c9a-4dc498cf64fb.jpeg',
                hash: 'thumbnail_dcff96a2_594c_427c_9c9a_4dc498cf64fb_c9216713e6',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 13.29,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_dcff96a2_594c_427c_9c9a_4dc498cf64fb_c9216713e6.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['636dd6a8d42554001c0d01c3'],
            createdAt: '2022-11-11T04:55:51.432Z',
            updatedAt: '2022-11-14T03:22:13.496Z',
            __v: 0,
            id: '636dd5d7d42554001c0d01c2',
          },
          metadata: null,
          id: '636dd6a8d42554001c0d01c3',
        },
        {
          relatedArticles: [],
          categories: ['62a768dbe9dde5001b3c6b0d'],
          _id: '636de841d42554001c0d01d6',
          published_at: '2022-11-11T06:15:02.508Z',
          slug: 'The-house-was-cracked.',
          shortDescription:
            'รอยร้าวบนผนัง สัญญานเตือนอันตรายที่หลายบ้านต้องรีบเช็คด่วน ช่างอุ่นใจเชื่อว่าปัญหารอยร้าว หลาย ๆ บ้านอาจต้องเผชิญกับปัญหานี้ บางครั้งรอยร้าวเล็ก ๆ อาจหลอกตาให้เราไม่กังวลใจ ช่างรู้คู่บ้านวันนี้จึงรวบรวมสัญญาณเตือนปัญหาบ้านจากรอยร้าวมาให้ทุกคน ไว้เพื่อตรวจสอบเช็กสุขภาพบ้านกันเบื้องต้นจะมีอะไรบ้างนั้นตามไปอ่านพร้อมกันได้เลยครับ ',
          title: 'ช่างรูู้บ้าน เช็กด่วน 3 รอยร้าว อันตรายส่อสัญญารปัญหาบ้านบานปลาย',
          contents: [
            {
              __component: 'article.images',
              id: '636de841d42554001c0d01d7',
            },
            {
              __component: 'article.content',
              id: '636de935d42554001c0d020c',
            },
            {
              __component: 'article.content',
              id: '636de841d42554001c0d01d8',
            },
            {
              __component: 'article.images',
              id: '636de841d42554001c0d01d9',
            },
            {
              __component: 'article.content',
              id: '636de841d42554001c0d01da',
            },
            {
              __component: 'article.content',
              id: '636de841d42554001c0d01db',
            },
            {
              __component: 'article.images',
              id: '636de841d42554001c0d01dc',
            },
            {
              __component: 'article.content',
              id: '636de841d42554001c0d01dd',
            },
            {
              __component: 'article.content',
              id: '636de841d42554001c0d01de',
            },
            {
              __component: 'article.images',
              id: '636de841d42554001c0d01df',
            },
            {
              __component: 'article.content',
              id: '636de841d42554001c0d01e0',
            },
            {
              __component: 'article.content',
              id: '636de841d42554001c0d01e1',
            },
            {
              __component: 'article.content',
              id: '636de841d42554001c0d01e2',
            },
          ],
          link: null,
          createdAt: '2022-11-11T06:14:25.305Z',
          updatedAt: '2022-12-21T04:44:44.624Z',
          __v: 1,
          coverImage: {
            _id: '636de644d42554001c0d01d2',
            name: 'd54995a4-018a-4751-b4fc-f913b669e340.jpeg',
            alternativeText: '',
            caption: '',
            hash: 'd54995a4_018a_4751_b4fc_f913b669e340_db10b29325',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 16.58,
            width: 471,
            height: 314,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/d54995a4_018a_4751_b4fc_f913b669e340_db10b29325.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_d54995a4-018a-4751-b4fc-f913b669e340.jpeg',
                hash: 'thumbnail_d54995a4_018a_4751_b4fc_f913b669e340_db10b29325',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 5.51,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_d54995a4_018a_4751_b4fc_f913b669e340_db10b29325.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['636de841d42554001c0d01d6'],
            createdAt: '2022-11-11T06:05:56.152Z',
            updatedAt: '2022-11-14T03:22:13.496Z',
            __v: 0,
            id: '636de644d42554001c0d01d2',
          },
          metadata: '63a28f3cc091d3001c2ea75a',
          id: '636de841d42554001c0d01d6',
        },
        {
          relatedArticles: [],
          categories: ['62a768dbe9dde5001b3c6b0d'],
          _id: '636dd539d42554001c0d019b',
          published_at: '2022-11-11T04:53:24.967Z',
          slug: 'check-up',
          shortDescription:
            'อะไรที่มากไปก็ไม่ดี... ‘ความชื้นในบ้าน’ ก็เช่นกัน! โดยเฉพาะหน้าฝนแบบนี้ \n24 FIX รู้ดีว่าหลาย ๆ คนคงชอบหน้าฝนเป็นพิเศษ เพราะมาพร้อมความชุ่มฉ่ำ เย็นสบาย แต่สิ่งที่มาพร้อมฝนนั้น... ไม่น่ารักเอาซะเลย! นั่นก็คือ ‘ความชื้น’ ที่มากเกินไป และอาจทำให้บ้านของเรามีเชื้อราขึ้นโดยไม่รู้ตัว ',
          title:
            'อะไรที่มากไปก็ไม่ดี ความชื่นก็เช่นกัน เช็กด่วน! จุดสังเกตความชื่นในบ้านที่มากเกินไป',
          contents: [
            {
              __component: 'article.content',
              id: '636dd539d42554001c0d019c',
            },
            {
              __component: 'article.images',
              id: '636dd539d42554001c0d019d',
            },
            {
              __component: 'article.content',
              id: '636dd539d42554001c0d019e',
            },
            {
              __component: 'article.images',
              id: '636dd539d42554001c0d019f',
            },
            {
              __component: 'article.content',
              id: '636dd539d42554001c0d01a0',
            },
            {
              __component: 'article.images',
              id: '636dd539d42554001c0d01a1',
            },
            {
              __component: 'article.content',
              id: '636dd539d42554001c0d01a2',
            },
            {
              __component: 'article.images',
              id: '636dd539d42554001c0d01a3',
            },
            {
              __component: 'article.content',
              id: '636dd539d42554001c0d01a4',
            },
            {
              __component: 'article.content',
              id: '636dd539d42554001c0d01a5',
            },
            {
              __component: 'article.content',
              id: '636dd539d42554001c0d01a6',
            },
          ],
          link: null,
          createdAt: '2022-11-11T04:53:13.088Z',
          updatedAt: '2022-11-11T04:53:25.020Z',
          __v: 1,
          coverImage: {
            _id: '636dd200d42554001c0d0196',
            name: 'f0bb5bdd-68ce-4b6b-a1bd-ecba54fd7b11.jpeg',
            alternativeText: '',
            caption: '',
            hash: 'f0bb5bdd_68ce_4b6b_a1bd_ecba54fd7b11_ca869520af',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 39.41,
            width: 471,
            height: 314,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/f0bb5bdd_68ce_4b6b_a1bd_ecba54fd7b11_ca869520af.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_f0bb5bdd-68ce-4b6b-a1bd-ecba54fd7b11.jpeg',
                hash: 'thumbnail_f0bb5bdd_68ce_4b6b_a1bd_ecba54fd7b11_ca869520af',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 9.23,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_f0bb5bdd_68ce_4b6b_a1bd_ecba54fd7b11_ca869520af.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['636dd539d42554001c0d019b'],
            createdAt: '2022-11-11T04:39:28.065Z',
            updatedAt: '2022-11-11T04:53:13.515Z',
            __v: 0,
            id: '636dd200d42554001c0d0196',
          },
          metadata: null,
          id: '636dd539d42554001c0d019b',
        },
      ],
      _id: '63864aafdda467001cc0c769',
      title: 'บทความ',
      button: {
        _id: '63864aafdda467001cc0c76a',
        title: 'ดูบทความทั้งหมด',
        url: 'https://fix.24x.co.th/blog',
        __v: 0,
        id: '63864aafdda467001cc0c76a',
      },
      __v: 1,
      id: '63864aafdda467001cc0c769',
    },
    reviewSection: {
      _id: '63864aafdda467001cc0c76d',
      title: 'รีวิวจากผู้ใช้บริการของเรา',
      reviewContent: [
        {
          image: [
            {
              _id: '63864b86dda467001cc0c78e',
              name: 'rn_image_picker_lib_temp_fae680d1_7598_4956_b920_8ad39f239709_cf537d3844.jpg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_fae680d1_7598_4956_b920_8ad39f239709_cf537d3844_31921d6acc',
              ext: '.jpg',
              mime: 'image/jpeg',
              size: 138.72,
              width: 900,
              height: 1200,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_fae680d1_7598_4956_b920_8ad39f239709_cf537d3844_31921d6acc.jpg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_fae680d1_7598_4956_b920_8ad39f239709_cf537d3844.jpg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_fae680d1_7598_4956_b920_8ad39f239709_cf537d3844_31921d6acc',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.34,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_fae680d1_7598_4956_b920_8ad39f239709_cf537d3844_31921d6acc.jpg',
                },
                large: {
                  name: 'large_rn_image_picker_lib_temp_fae680d1_7598_4956_b920_8ad39f239709_cf537d3844.jpg',
                  hash: 'large_rn_image_picker_lib_temp_fae680d1_7598_4956_b920_8ad39f239709_cf537d3844_31921d6acc',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 1000,
                  size: 88.17,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_rn_image_picker_lib_temp_fae680d1_7598_4956_b920_8ad39f239709_cf537d3844_31921d6acc.jpg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_fae680d1_7598_4956_b920_8ad39f239709_cf537d3844.jpg',
                  hash: 'medium_rn_image_picker_lib_temp_fae680d1_7598_4956_b920_8ad39f239709_cf537d3844_31921d6acc',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 46.32,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_fae680d1_7598_4956_b920_8ad39f239709_cf537d3844_31921d6acc.jpg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_fae680d1_7598_4956_b920_8ad39f239709_cf537d3844.jpg',
                  hash: 'small_rn_image_picker_lib_temp_fae680d1_7598_4956_b920_8ad39f239709_cf537d3844_31921d6acc',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 20.7,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_fae680d1_7598_4956_b920_8ad39f239709_cf537d3844_31921d6acc.jpg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-29T18:12:22.179Z',
              updatedAt: '2022-11-30T05:43:07.180Z',
              __v: 0,
              id: '63864b86dda467001cc0c78e',
            },
            {
              _id: '63864b86dda467001cc0c78f',
              name: 'rn_image_picker_lib_temp_477c599f_e031_4a8f_84c8_ff90b11c6b08_0da1197171.jpg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_477c599f_e031_4a8f_84c8_ff90b11c6b08_0da1197171_09c1cb7532',
              ext: '.jpg',
              mime: 'image/jpeg',
              size: 136.81,
              width: 900,
              height: 1200,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_477c599f_e031_4a8f_84c8_ff90b11c6b08_0da1197171_09c1cb7532.jpg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_477c599f_e031_4a8f_84c8_ff90b11c6b08_0da1197171.jpg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_477c599f_e031_4a8f_84c8_ff90b11c6b08_0da1197171_09c1cb7532',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.47,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_477c599f_e031_4a8f_84c8_ff90b11c6b08_0da1197171_09c1cb7532.jpg',
                },
                large: {
                  name: 'large_rn_image_picker_lib_temp_477c599f_e031_4a8f_84c8_ff90b11c6b08_0da1197171.jpg',
                  hash: 'large_rn_image_picker_lib_temp_477c599f_e031_4a8f_84c8_ff90b11c6b08_0da1197171_09c1cb7532',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 1000,
                  size: 86.07,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_rn_image_picker_lib_temp_477c599f_e031_4a8f_84c8_ff90b11c6b08_0da1197171_09c1cb7532.jpg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_477c599f_e031_4a8f_84c8_ff90b11c6b08_0da1197171.jpg',
                  hash: 'medium_rn_image_picker_lib_temp_477c599f_e031_4a8f_84c8_ff90b11c6b08_0da1197171_09c1cb7532',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 44.74,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_477c599f_e031_4a8f_84c8_ff90b11c6b08_0da1197171_09c1cb7532.jpg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_477c599f_e031_4a8f_84c8_ff90b11c6b08_0da1197171.jpg',
                  hash: 'small_rn_image_picker_lib_temp_477c599f_e031_4a8f_84c8_ff90b11c6b08_0da1197171_09c1cb7532',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 19.75,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_477c599f_e031_4a8f_84c8_ff90b11c6b08_0da1197171_09c1cb7532.jpg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-29T18:12:22.286Z',
              updatedAt: '2022-11-30T05:43:07.180Z',
              __v: 0,
              id: '63864b86dda467001cc0c78f',
            },
          ],
          _id: '63864d66dda467001cc0c7b2',
          name: 'วริxxx',
          score: 5,
          description:
            'ช่างเข้าบริการติดกระจกในห้องอาบน้ำ เข้าตรวจสอบหน้างานเร็วมากหลังจากที่จองคิวไป ค่อนข้างมืออาชีพกับการซ่อมมากค่ะ ',
          __v: 0,
          id: '63864d66dda467001cc0c7b2',
        },
        {
          image: [
            {
              _id: '63864bf9dda467001cc0c790',
              name: 'rn_image_picker_lib_temp_de8ff31f_a90e_43ae_93fd_47d2e9cdb66f_c4fc80411b.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_de8ff31f_a90e_43ae_93fd_47d2e9cdb66f_c4fc80411b_da8ac5a5fb',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 247.96,
              width: 900,
              height: 1200,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_de8ff31f_a90e_43ae_93fd_47d2e9cdb66f_c4fc80411b_da8ac5a5fb.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_de8ff31f_a90e_43ae_93fd_47d2e9cdb66f_c4fc80411b.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_de8ff31f_a90e_43ae_93fd_47d2e9cdb66f_c4fc80411b_da8ac5a5fb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 5.55,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_de8ff31f_a90e_43ae_93fd_47d2e9cdb66f_c4fc80411b_da8ac5a5fb.jpeg',
                },
                large: {
                  name: 'large_rn_image_picker_lib_temp_de8ff31f_a90e_43ae_93fd_47d2e9cdb66f_c4fc80411b.jpeg',
                  hash: 'large_rn_image_picker_lib_temp_de8ff31f_a90e_43ae_93fd_47d2e9cdb66f_c4fc80411b_da8ac5a5fb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 1000,
                  size: 165.07,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_rn_image_picker_lib_temp_de8ff31f_a90e_43ae_93fd_47d2e9cdb66f_c4fc80411b_da8ac5a5fb.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_de8ff31f_a90e_43ae_93fd_47d2e9cdb66f_c4fc80411b.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_de8ff31f_a90e_43ae_93fd_47d2e9cdb66f_c4fc80411b_da8ac5a5fb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 93.15,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_de8ff31f_a90e_43ae_93fd_47d2e9cdb66f_c4fc80411b_da8ac5a5fb.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_de8ff31f_a90e_43ae_93fd_47d2e9cdb66f_c4fc80411b.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_de8ff31f_a90e_43ae_93fd_47d2e9cdb66f_c4fc80411b_da8ac5a5fb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 41.79,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_de8ff31f_a90e_43ae_93fd_47d2e9cdb66f_c4fc80411b_da8ac5a5fb.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-29T18:14:17.936Z',
              updatedAt: '2022-11-30T05:43:07.180Z',
              __v: 0,
              id: '63864bf9dda467001cc0c790',
            },
            {
              _id: '63864bfadda467001cc0c791',
              name: 'rn_image_picker_lib_temp_25c89a92_59cb_40b4_b0c0_a2e5650509d8_94b581b3b4.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_25c89a92_59cb_40b4_b0c0_a2e5650509d8_94b581b3b4_41d5037550',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 145.18,
              width: 900,
              height: 1200,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_25c89a92_59cb_40b4_b0c0_a2e5650509d8_94b581b3b4_41d5037550.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_25c89a92_59cb_40b4_b0c0_a2e5650509d8_94b581b3b4.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_25c89a92_59cb_40b4_b0c0_a2e5650509d8_94b581b3b4_41d5037550',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 4.58,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_25c89a92_59cb_40b4_b0c0_a2e5650509d8_94b581b3b4_41d5037550.jpeg',
                },
                large: {
                  name: 'large_rn_image_picker_lib_temp_25c89a92_59cb_40b4_b0c0_a2e5650509d8_94b581b3b4.jpeg',
                  hash: 'large_rn_image_picker_lib_temp_25c89a92_59cb_40b4_b0c0_a2e5650509d8_94b581b3b4_41d5037550',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 1000,
                  size: 96.45,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_rn_image_picker_lib_temp_25c89a92_59cb_40b4_b0c0_a2e5650509d8_94b581b3b4_41d5037550.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_25c89a92_59cb_40b4_b0c0_a2e5650509d8_94b581b3b4.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_25c89a92_59cb_40b4_b0c0_a2e5650509d8_94b581b3b4_41d5037550',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 54.51,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_25c89a92_59cb_40b4_b0c0_a2e5650509d8_94b581b3b4_41d5037550.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_25c89a92_59cb_40b4_b0c0_a2e5650509d8_94b581b3b4.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_25c89a92_59cb_40b4_b0c0_a2e5650509d8_94b581b3b4_41d5037550',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 25.89,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_25c89a92_59cb_40b4_b0c0_a2e5650509d8_94b581b3b4_41d5037550.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-29T18:14:18.017Z',
              updatedAt: '2022-11-30T05:43:07.180Z',
              __v: 0,
              id: '63864bfadda467001cc0c791',
            },
          ],
          _id: '63864d66dda467001cc0c7b5',
          name: 'ฟิสิxx',
          score: 5,
          description:
            'ทีมช่างเครื่องมือพร้อมดีครับ เข้าตรวจสอบงานละเอียดดี ได้โปรสำรวจหน้างานฟรีมาด้วยคุ้มมากครับ',
          __v: 0,
          id: '63864d66dda467001cc0c7b5',
        },
        {
          image: [
            {
              _id: '63864c1ddda467001cc0c792',
              name: 'rn_image_picker_lib_temp_667ccc08_4d92_4c74_8e7e_f9cfa8925258_9079ec4d85.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_667ccc08_4d92_4c74_8e7e_f9cfa8925258_9079ec4d85_bc407533c4',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 41.33,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_667ccc08_4d92_4c74_8e7e_f9cfa8925258_9079ec4d85_bc407533c4.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_667ccc08_4d92_4c74_8e7e_f9cfa8925258_9079ec4d85.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_667ccc08_4d92_4c74_8e7e_f9cfa8925258_9079ec4d85_bc407533c4',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.44,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_667ccc08_4d92_4c74_8e7e_f9cfa8925258_9079ec4d85_bc407533c4.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_667ccc08_4d92_4c74_8e7e_f9cfa8925258_9079ec4d85.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_667ccc08_4d92_4c74_8e7e_f9cfa8925258_9079ec4d85_bc407533c4',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 36.64,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_667ccc08_4d92_4c74_8e7e_f9cfa8925258_9079ec4d85_bc407533c4.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_667ccc08_4d92_4c74_8e7e_f9cfa8925258_9079ec4d85.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_667ccc08_4d92_4c74_8e7e_f9cfa8925258_9079ec4d85_bc407533c4',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 16.07,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_667ccc08_4d92_4c74_8e7e_f9cfa8925258_9079ec4d85_bc407533c4.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-29T18:14:53.467Z',
              updatedAt: '2022-11-30T05:43:07.180Z',
              __v: 0,
              id: '63864c1ddda467001cc0c792',
            },
            {
              _id: '63864c1ddda467001cc0c793',
              name: 'rn_image_picker_lib_temp_2bedba91_0395_4f01_bd10_569e8eaf469f_99dd351d1e.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_2bedba91_0395_4f01_bd10_569e8eaf469f_99dd351d1e_5d2c7bd870',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 30.52,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_2bedba91_0395_4f01_bd10_569e8eaf469f_99dd351d1e_5d2c7bd870.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_2bedba91_0395_4f01_bd10_569e8eaf469f_99dd351d1e.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_2bedba91_0395_4f01_bd10_569e8eaf469f_99dd351d1e_5d2c7bd870',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.46,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_2bedba91_0395_4f01_bd10_569e8eaf469f_99dd351d1e_5d2c7bd870.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_2bedba91_0395_4f01_bd10_569e8eaf469f_99dd351d1e.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_2bedba91_0395_4f01_bd10_569e8eaf469f_99dd351d1e_5d2c7bd870',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 27.36,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_2bedba91_0395_4f01_bd10_569e8eaf469f_99dd351d1e_5d2c7bd870.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_2bedba91_0395_4f01_bd10_569e8eaf469f_99dd351d1e.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_2bedba91_0395_4f01_bd10_569e8eaf469f_99dd351d1e_5d2c7bd870',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 13.24,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_2bedba91_0395_4f01_bd10_569e8eaf469f_99dd351d1e_5d2c7bd870.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-29T18:14:53.485Z',
              updatedAt: '2022-11-30T05:43:07.180Z',
              __v: 0,
              id: '63864c1ddda467001cc0c793',
            },
          ],
          _id: '63864d66dda467001cc0c7b6',
          name: 'ญาณิxxx',
          score: 4,
          description:
            'เห็นรีวิวจากหน้าเพจ กดจองไปไม่คิดว่าช่างจะเข้าตรวจสอบบ้านแก้ไขปัญหาได้เร็วขนาดนี้โชคดีมากที่เจอช่างดีทำงานเก่ง ',
          __v: 0,
          id: '63864d66dda467001cc0c7b6',
        },
        {
          image: [
            {
              _id: '63864c77dda467001cc0c795',
              name: 'rn_image_picker_lib_temp_965d835f_e833_48c2_94c3_e29a7c9a04f9_2e0d37c682.jpg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_965d835f_e833_48c2_94c3_e29a7c9a04f9_2e0d37c682_3372671f59',
              ext: '.jpg',
              mime: 'image/jpeg',
              size: 110.47,
              width: 900,
              height: 1200,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_965d835f_e833_48c2_94c3_e29a7c9a04f9_2e0d37c682_3372671f59.jpg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_965d835f_e833_48c2_94c3_e29a7c9a04f9_2e0d37c682.jpg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_965d835f_e833_48c2_94c3_e29a7c9a04f9_2e0d37c682_3372671f59',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.47,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_965d835f_e833_48c2_94c3_e29a7c9a04f9_2e0d37c682_3372671f59.jpg',
                },
                large: {
                  name: 'large_rn_image_picker_lib_temp_965d835f_e833_48c2_94c3_e29a7c9a04f9_2e0d37c682.jpg',
                  hash: 'large_rn_image_picker_lib_temp_965d835f_e833_48c2_94c3_e29a7c9a04f9_2e0d37c682_3372671f59',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 1000,
                  size: 74.56,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_rn_image_picker_lib_temp_965d835f_e833_48c2_94c3_e29a7c9a04f9_2e0d37c682_3372671f59.jpg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_965d835f_e833_48c2_94c3_e29a7c9a04f9_2e0d37c682.jpg',
                  hash: 'medium_rn_image_picker_lib_temp_965d835f_e833_48c2_94c3_e29a7c9a04f9_2e0d37c682_3372671f59',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 42.39,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_965d835f_e833_48c2_94c3_e29a7c9a04f9_2e0d37c682_3372671f59.jpg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_965d835f_e833_48c2_94c3_e29a7c9a04f9_2e0d37c682.jpg',
                  hash: 'small_rn_image_picker_lib_temp_965d835f_e833_48c2_94c3_e29a7c9a04f9_2e0d37c682_3372671f59',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 19.63,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_965d835f_e833_48c2_94c3_e29a7c9a04f9_2e0d37c682_3372671f59.jpg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-29T18:16:23.941Z',
              updatedAt: '2022-11-30T05:43:07.180Z',
              __v: 0,
              id: '63864c77dda467001cc0c795',
            },
            {
              _id: '63864c77dda467001cc0c794',
              name: 'rn_image_picker_lib_temp_2d86e208_59f5_49ee_aa28_10feb2d3fca7_f12a7a36bb.jpg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_2d86e208_59f5_49ee_aa28_10feb2d3fca7_f12a7a36bb_b1d0a75d59',
              ext: '.jpg',
              mime: 'image/jpeg',
              size: 51.12,
              width: 1200,
              height: 900,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_2d86e208_59f5_49ee_aa28_10feb2d3fca7_f12a7a36bb_b1d0a75d59.jpg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_2d86e208_59f5_49ee_aa28_10feb2d3fca7_f12a7a36bb.jpg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_2d86e208_59f5_49ee_aa28_10feb2d3fca7_f12a7a36bb_b1d0a75d59',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 208,
                  height: 156,
                  size: 2.06,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_2d86e208_59f5_49ee_aa28_10feb2d3fca7_f12a7a36bb_b1d0a75d59.jpg',
                },
                large: {
                  name: 'large_rn_image_picker_lib_temp_2d86e208_59f5_49ee_aa28_10feb2d3fca7_f12a7a36bb.jpg',
                  hash: 'large_rn_image_picker_lib_temp_2d86e208_59f5_49ee_aa28_10feb2d3fca7_f12a7a36bb_b1d0a75d59',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 1000,
                  height: 750,
                  size: 33.35,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_rn_image_picker_lib_temp_2d86e208_59f5_49ee_aa28_10feb2d3fca7_f12a7a36bb_b1d0a75d59.jpg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_2d86e208_59f5_49ee_aa28_10feb2d3fca7_f12a7a36bb.jpg',
                  hash: 'medium_rn_image_picker_lib_temp_2d86e208_59f5_49ee_aa28_10feb2d3fca7_f12a7a36bb_b1d0a75d59',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 563,
                  size: 17.4,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_2d86e208_59f5_49ee_aa28_10feb2d3fca7_f12a7a36bb_b1d0a75d59.jpg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_2d86e208_59f5_49ee_aa28_10feb2d3fca7_f12a7a36bb.jpg',
                  hash: 'small_rn_image_picker_lib_temp_2d86e208_59f5_49ee_aa28_10feb2d3fca7_f12a7a36bb_b1d0a75d59',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 500,
                  height: 375,
                  size: 7.48,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_2d86e208_59f5_49ee_aa28_10feb2d3fca7_f12a7a36bb_b1d0a75d59.jpg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-29T18:16:23.936Z',
              updatedAt: '2022-11-30T05:43:07.180Z',
              __v: 0,
              id: '63864c77dda467001cc0c794',
            },
          ],
          _id: '63864d66dda467001cc0c7b8',
          name: 'กรxxxx',
          score: 5,
          description: 'ช่างดูเป็นมืออาชีพมากครับ ทำงานรวดเร็ว ราคาไม่แพง ',
          __v: 0,
          id: '63864d66dda467001cc0c7b8',
        },
        {
          image: [
            {
              _id: '63864ca2dda467001cc0c796',
              name: 'rn_image_picker_lib_temp_40f0541e_7fde_41d5_8fdb_73a166a1084b_1d5c14eb12.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_40f0541e_7fde_41d5_8fdb_73a166a1084b_1d5c14eb12_8da207c655',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 28.67,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_40f0541e_7fde_41d5_8fdb_73a166a1084b_1d5c14eb12_8da207c655.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_40f0541e_7fde_41d5_8fdb_73a166a1084b_1d5c14eb12.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_40f0541e_7fde_41d5_8fdb_73a166a1084b_1d5c14eb12_8da207c655',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 1.92,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_40f0541e_7fde_41d5_8fdb_73a166a1084b_1d5c14eb12_8da207c655.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_40f0541e_7fde_41d5_8fdb_73a166a1084b_1d5c14eb12.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_40f0541e_7fde_41d5_8fdb_73a166a1084b_1d5c14eb12_8da207c655',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 25.28,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_40f0541e_7fde_41d5_8fdb_73a166a1084b_1d5c14eb12_8da207c655.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_40f0541e_7fde_41d5_8fdb_73a166a1084b_1d5c14eb12.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_40f0541e_7fde_41d5_8fdb_73a166a1084b_1d5c14eb12_8da207c655',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 10.79,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_40f0541e_7fde_41d5_8fdb_73a166a1084b_1d5c14eb12_8da207c655.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-29T18:17:06.959Z',
              updatedAt: '2022-11-30T05:43:07.180Z',
              __v: 0,
              id: '63864ca2dda467001cc0c796',
            },
            {
              _id: '63864ca3dda467001cc0c797',
              name: 'rn_image_picker_lib_temp_cc36d460_3b42_465f_8bd0_1be2517f6ce7_1d86a15315.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_cc36d460_3b42_465f_8bd0_1be2517f6ce7_1d86a15315_8a1c92bf9b',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 35.76,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_cc36d460_3b42_465f_8bd0_1be2517f6ce7_1d86a15315_8a1c92bf9b.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_cc36d460_3b42_465f_8bd0_1be2517f6ce7_1d86a15315.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_cc36d460_3b42_465f_8bd0_1be2517f6ce7_1d86a15315_8a1c92bf9b',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.86,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_cc36d460_3b42_465f_8bd0_1be2517f6ce7_1d86a15315_8a1c92bf9b.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_cc36d460_3b42_465f_8bd0_1be2517f6ce7_1d86a15315.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_cc36d460_3b42_465f_8bd0_1be2517f6ce7_1d86a15315_8a1c92bf9b',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 32.01,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_cc36d460_3b42_465f_8bd0_1be2517f6ce7_1d86a15315_8a1c92bf9b.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_cc36d460_3b42_465f_8bd0_1be2517f6ce7_1d86a15315.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_cc36d460_3b42_465f_8bd0_1be2517f6ce7_1d86a15315_8a1c92bf9b',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 15.51,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_cc36d460_3b42_465f_8bd0_1be2517f6ce7_1d86a15315_8a1c92bf9b.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-29T18:17:07.007Z',
              updatedAt: '2022-11-30T05:43:07.180Z',
              __v: 0,
              id: '63864ca3dda467001cc0c797',
            },
          ],
          _id: '63864d66dda467001cc0c7b9',
          name: 'ตฤณxxxx',
          score: 5,
          description: 'บ้านใครผนังเป็นร้อยร้าวอยู่ แนะนำช่างที่นี้เลยครับ งานเนียบ เรียบร้อยมาก',
          __v: 0,
          id: '63864d66dda467001cc0c7b9',
        },
        {
          image: [
            {
              _id: '63864ccfdda467001cc0c798',
              name: 'rn_image_picker_lib_temp_f4fd96f7_8bb9_4a7f_ab79_9aa0bef81922_8b97acc4a6.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_f4fd96f7_8bb9_4a7f_ab79_9aa0bef81922_8b97acc4a6_2b8d1dfe63',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 25.55,
              width: 800,
              height: 600,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_f4fd96f7_8bb9_4a7f_ab79_9aa0bef81922_8b97acc4a6_2b8d1dfe63.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_f4fd96f7_8bb9_4a7f_ab79_9aa0bef81922_8b97acc4a6.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_f4fd96f7_8bb9_4a7f_ab79_9aa0bef81922_8b97acc4a6_2b8d1dfe63',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 208,
                  height: 156,
                  size: 3.59,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_f4fd96f7_8bb9_4a7f_ab79_9aa0bef81922_8b97acc4a6_2b8d1dfe63.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_f4fd96f7_8bb9_4a7f_ab79_9aa0bef81922_8b97acc4a6.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_f4fd96f7_8bb9_4a7f_ab79_9aa0bef81922_8b97acc4a6_2b8d1dfe63',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 563,
                  size: 23.84,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_f4fd96f7_8bb9_4a7f_ab79_9aa0bef81922_8b97acc4a6_2b8d1dfe63.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_f4fd96f7_8bb9_4a7f_ab79_9aa0bef81922_8b97acc4a6.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_f4fd96f7_8bb9_4a7f_ab79_9aa0bef81922_8b97acc4a6_2b8d1dfe63',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 500,
                  height: 375,
                  size: 12.88,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_f4fd96f7_8bb9_4a7f_ab79_9aa0bef81922_8b97acc4a6_2b8d1dfe63.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-29T18:17:51.892Z',
              updatedAt: '2022-11-30T05:43:07.180Z',
              __v: 0,
              id: '63864ccfdda467001cc0c798',
            },
            {
              _id: '63864ccfdda467001cc0c799',
              name: 'rn_image_picker_lib_temp_a1b54add_7d5e_4e4c_9ab3_a2283a9d30e1_342e767d34.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_a1b54add_7d5e_4e4c_9ab3_a2283a9d30e1_342e767d34_ccc1879cbe',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 42.23,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_a1b54add_7d5e_4e4c_9ab3_a2283a9d30e1_342e767d34_ccc1879cbe.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_a1b54add_7d5e_4e4c_9ab3_a2283a9d30e1_342e767d34.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_a1b54add_7d5e_4e4c_9ab3_a2283a9d30e1_342e767d34_ccc1879cbe',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.7,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_a1b54add_7d5e_4e4c_9ab3_a2283a9d30e1_342e767d34_ccc1879cbe.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_a1b54add_7d5e_4e4c_9ab3_a2283a9d30e1_342e767d34.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_a1b54add_7d5e_4e4c_9ab3_a2283a9d30e1_342e767d34_ccc1879cbe',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 38.78,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_a1b54add_7d5e_4e4c_9ab3_a2283a9d30e1_342e767d34_ccc1879cbe.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_a1b54add_7d5e_4e4c_9ab3_a2283a9d30e1_342e767d34.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_a1b54add_7d5e_4e4c_9ab3_a2283a9d30e1_342e767d34_ccc1879cbe',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 20.45,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_a1b54add_7d5e_4e4c_9ab3_a2283a9d30e1_342e767d34_ccc1879cbe.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-29T18:17:51.953Z',
              updatedAt: '2022-11-30T05:43:07.180Z',
              __v: 0,
              id: '63864ccfdda467001cc0c799',
            },
          ],
          _id: '63864d66dda467001cc0c7ba',
          name: 'นรินxxxx',
          score: 4,
          description: 'ช่างทำงานเรียบร้อยมากค่ะ คอยระวังเฟอร์นิเจอร์ของใช้ในบ้านตลอด',
          __v: 0,
          id: '63864d66dda467001cc0c7ba',
        },
        {
          image: [],
          _id: '63864d66dda467001cc0c7b1',
          name: 'เกตxxx',
          score: 4,
          description:
            'ช่างหาสาเหตุที่ผนังร้าวได้เก่งมากครับ บ้านเกือบพังโชคดีที่เจอช่างเก่งแนะนำได้ดีครับ',
          __v: 0,
          id: '63864d66dda467001cc0c7b1',
        },
        {
          image: [],
          _id: '63864d66dda467001cc0c7b3',
          name: 'มรxx',
          score: 5,
          description:
            'นึกว่าต้องทุบผนังแล้ว แต่โชคดีที่ช่างแนะนำให้ซ่อมก่อน ขอบคุณช่างมากๆครับ ทำงานดีด้วยเยี่ยมครับ',
          __v: 0,
          id: '63864d66dda467001cc0c7b3',
        },
        {
          image: [],
          _id: '63864d66dda467001cc0c7b4',
          name: 'จิราxxx',
          score: 4,
          description:
            'ช่างเบสเก่งมากครับ คุยงานเข้าใจที่ต้องการแก้ไข งานออกมาดีในเวลาที่คุยกันไว้ ',
          __v: 0,
          id: '63864d66dda467001cc0c7b4',
        },
        {
          image: [],
          _id: '63864d66dda467001cc0c7b7',
          name: 'ฐาปัxxx',
          score: 4,
          description:
            'ช่างเข้างานตามเวลาที่คุย ซ่อมตรงจุดแก้ได้ไขปัญหาได้ข่อนข้างดี คุ้มกับราคาที่จ่ายไปครับ รักษามาตรฐานต่อไปครับลูกค้าเยอะแน่นอน',
          __v: 0,
          id: '63864d66dda467001cc0c7b7',
        },
      ],
      __v: 0,
      id: '63864aafdda467001cc0c76d',
    },
    ctaSection: {
      _id: '6386487bdda467001cc0c754',
      button: {
        _id: '6386487bdda467001cc0c755',
        title: 'จองบริการ',
        url: 'https://fix.24x.co.th/wall/booking',
        __v: 0,
        id: '6386487bdda467001cc0c755',
      },
      __v: 1,
      title: '<p><strong>ซ่อม-ต่อเติมผนังครบวงจร</strong></p>',
      id: '6386487bdda467001cc0c754',
    },
    metadata: {
      twitterCardType: 'summary',
      _id: '63bd0adcc37f54001cf15e2c',
      metaTitle: 'ซ่อม-ต่อเติมผนังครบวงจร',
      metaDescription:
        'บริการซ่อมผนัง แตก ร้าว รั่วซึม เราแก้ปัญหาได้ตรงจุด ใช้วัสดุมีคุณภาพพร้อมปรับประกันผลงาน รวมถึงต่อเติมและงานวอเลเปเปอร์ทุกรูปแบบจากช่างมืออาชีพ',
      keywords: 'ผนังแตก, ผนังร้าว, ผนังรั่วซึม, ซ่อมผนัง, ช่างวอเลเปเปอร์',
      __v: 0,
      id: '63bd0adcc37f54001cf15e2c',
    },
    createdAt: '2022-11-29T17:59:23.759Z',
    updatedAt: '2023-01-10T06:51:08.275Z',
    __v: 2,
    installationSection: null,
    id: '6386487bdda467001cc0c74d',
  },
  {
    _id: '636009d451f79b001dee9964',
    published_at: '2022-11-07T11:52:38.124Z',
    slug: 'color',
    bannerSection: {
      _id: '6367dd446f10f9001b2ffe9b',
      title: '<p><strong>ผู้นำด้านการทาสีบ้าน เนียนสวยทุกมุมมอง</strong></p>',
      button: {
        _id: '6367dd446f10f9001b2ffe9c',
        title: 'จองบริการ',
        url: 'https://fix.24x.co.th/color/booking',
        __v: 0,
        id: '6367dd446f10f9001b2ffe9c',
      },
      __v: 1,
      image: {
        _id: '6367dce06f10f9001b2ffe98',
        name: '24FIX_LD_BANNER-07.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_07_91a3ff8c16',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 343.79,
        width: 6001,
        height: 2634,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_07_91a3ff8c16.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER-07.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_07_91a3ff8c16',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 108,
            size: 3.41,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_07_91a3ff8c16.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER-07.jpg',
            hash: 'large_24_FIX_LD_BANNER_07_91a3ff8c16',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 439,
            size: 20.55,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_07_91a3ff8c16.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER-07.jpg',
            hash: 'medium_24_FIX_LD_BANNER_07_91a3ff8c16',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 329,
            size: 13.76,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_07_91a3ff8c16.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER-07.jpg',
            hash: 'small_24_FIX_LD_BANNER_07_91a3ff8c16',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 219,
            size: 8.24,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_07_91a3ff8c16.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-11-06T16:12:16.517Z',
        updatedAt: '2022-11-06T16:42:58.599Z',
        __v: 0,
        id: '6367dce06f10f9001b2ffe98',
      },
      mobileImage: {
        _id: '6367dcf86f10f9001b2ffe99',
        name: '24FIX_LD_BANNER_MOBILE-07.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_MOBILE_07_d1cea41e81',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 46.53,
        width: 1501,
        height: 930,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_MOBILE_07_d1cea41e81.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER_MOBILE-07.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_MOBILE_07_d1cea41e81',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 152,
            size: 3.96,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_MOBILE_07_d1cea41e81.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER_MOBILE-07.jpg',
            hash: 'large_24_FIX_LD_BANNER_MOBILE_07_d1cea41e81',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 620,
            size: 26.23,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_MOBILE_07_d1cea41e81.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER_MOBILE-07.jpg',
            hash: 'medium_24_FIX_LD_BANNER_MOBILE_07_d1cea41e81',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 465,
            size: 16.56,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_MOBILE_07_d1cea41e81.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER_MOBILE-07.jpg',
            hash: 'small_24_FIX_LD_BANNER_MOBILE_07_d1cea41e81',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 310,
            size: 9.97,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_MOBILE_07_d1cea41e81.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-11-06T16:12:40.896Z',
        updatedAt: '2022-11-06T16:42:58.599Z',
        __v: 0,
        id: '6367dcf86f10f9001b2ffe99',
      },
      id: '6367dd446f10f9001b2ffe9b',
    },
    uspSection: [
      {
        _id: '6367dd446f10f9001b2ffea1',
        title: 'ผู้นำด้านการทาสีบ้าน เนียนสวยทุกมุมมอง',
        subTitle:
          'บริการทาสีภายในบ้านและภายนอกบ้านเนียนสวยอย่างมืออาชีพได้สีตรงใจ เพื่อมอบสีสันสดใสให้บ้านคุณเนียนสวยทุกมุมมอง',
        description:
          '<p><strong>ทำไมต้องจองกับ 24FIX?</strong></p><ul><li>รับประกันงานทาสีสูงสุด 60 วัน</li><li>ทีมช่างเข้าตรวจหน้างานก่อนให้บริการภายใน&nbsp;3 วัน</li><li>ราคางานซ่อมที่ได้มาตรฐาน คุ้มค่ากับคุณภาพบริการ</li></ul>',
        __v: 0,
        image: {
          _id: '6367dd266f10f9001b2ffe9a',
          name: 'Service_Desktop-09.jpg',
          alternativeText: '',
          caption: '',
          hash: 'Service_Desktop_09_07043dbc71',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 139.9,
          width: 2121,
          height: 1426,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/Service_Desktop_09_07043dbc71.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_Service_Desktop-09.jpg',
              hash: 'thumbnail_Service_Desktop_09_07043dbc71',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 232,
              height: 156,
              size: 4.01,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_Service_Desktop_09_07043dbc71.jpg',
            },
            large: {
              name: 'large_Service_Desktop-09.jpg',
              hash: 'large_Service_Desktop_09_07043dbc71',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 1000,
              height: 672,
              size: 38.06,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/large_Service_Desktop_09_07043dbc71.jpg',
            },
            medium: {
              name: 'medium_Service_Desktop-09.jpg',
              hash: 'medium_Service_Desktop_09_07043dbc71',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 504,
              size: 23.93,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_Service_Desktop_09_07043dbc71.jpg',
            },
            small: {
              name: 'small_Service_Desktop-09.jpg',
              hash: 'small_Service_Desktop_09_07043dbc71',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 336,
              size: 12.29,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_Service_Desktop_09_07043dbc71.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-11-06T16:13:26.921Z',
          updatedAt: '2022-11-06T16:42:58.599Z',
          __v: 0,
          id: '6367dd266f10f9001b2ffe9a',
        },
        id: '6367dd446f10f9001b2ffea1',
      },
    ],
    faqSection: [
      {
        _id: '63614e99b87e30001c208cb9',
        question: 'ทำไมถึงต้องมีการสำรวจหน้างาน',
        answer:
          '<p>การสำรวจหน้างาน จะสามารถทำให้เราได้ร่วมวางแผนกับคุณลูกค้า เพื่อให้รายละเอียดงานครบถ้วนและอยู่ในงบประมาณที่ได้ตกลงกันไว้</p>',
        __v: 0,
        id: '63614e99b87e30001c208cb9',
      },
      {
        _id: '63614e99b87e30001c208cba',
        question: 'ค่าใช้จ่ายในการสำรวจ นำมาเป็นส่วนลดได้ไหม',
        answer: '<p>&nbsp;ค่าสำรวจสามารถนำไปลดได้ต่อเมื่อยอดงานบริการ มากกว่า 3,000 บาทขึ้นไป</p>',
        __v: 0,
        id: '63614e99b87e30001c208cba',
      },
      {
        _id: '63614e99b87e30001c208cbb',
        answer:
          '<p>ปัจจัยที่มีผลต่อราคาค่าบริการ มีดังนี้ครับ</p><ul><li>ความเสียหายของหน้างาน</li><li>ประเภทวัสดุที่ใช้ทาสี</li><li>ขนาดพื้นที่ในการบริการ (ยิ่งใหญ่ยิ่งถูก)</li><li>บริเวณพื้นที่ทาสี (ภายใน, ภายนอก)</li></ul>',
        question: 'ปัจจัยที่มีผลต่อราคาค่าบริการ',
        __v: 0,
        id: '63614e99b87e30001c208cbb',
      },
      {
        _id: '63614e99b87e30001c208cbc',
        answer:
          '<p>การรับประกันงานผลงาน 60 วัน หลังจากการให้บริการ ทางบริษัทจะรับประกันผลงานที่เกิดจากการติดตั้ง (แตกลาย, พองหรือลอก) ตามขอบเขตการให้บริการในเอกสารเสนอราคาเท่านั้น</p><p>&nbsp;</p>',
        question: 'มีการรับประกันอย่างไร',
        __v: 0,
        id: '63614e99b87e30001c208cbc',
      },
      {
        _id: '63614e99b87e30001c208cbd',
        answer: '<p>พื้นที่ให้บริการครอบคลุมในเขตกรุงเทพมหานคร นนทบุรี ปทุมธานี และสมุทรปราการ</p>',
        question: 'พื้นที่ที่ให้บริการครอบคลุมถึงไหนบ้าง ',
        __v: 0,
        id: '63614e99b87e30001c208cbd',
      },
      {
        _id: '63614e99b87e30001c208cbe',
        answer:
          '<p>เรามีทั้งราคาที่คิดแต่ค่าแรงกับราคาค่าแรงรวมสี ซึ่งสีที่เราใช้จะเป็นสีเกรดมาตรฐาน พร้อมการทาสีรองพื้น 2 เที่ยว ก่อนลงสีจริง</p>',
        question: 'งานทาสีรวมค่าสีด้วยไหม',
        __v: 0,
        id: '63614e99b87e30001c208cbe',
      },
      {
        _id: '63614e99b87e30001c208cbf',
        answer: '<p>ค่าแรงและค่าวัสดุสิ้นเปลือง ซึ่งค่าแรงมีการรวมงานสกิมโค้ทไปแล้ว</p>',
        question: 'ราคาค่าบริการครอบคลุมอะไรบ้าง',
        __v: 0,
        id: '63614e99b87e30001c208cbf',
      },
      {
        _id: '63614e99b87e30001c208cc0',
        answer:
          '<p>ช่างเข้าสำรวจหน้างานภายใน 2-3 วัน หลังอนุมัติงานสำรวจ และ 3 วันนับจากวันที่ลูกค้าชำระค่าบริการ</p>',
        question: 'คิวเรียกช่างเร็วสุดเมื่อไหร่',
        __v: 0,
        id: '63614e99b87e30001c208cc0',
      },
      {
        _id: '63614e99b87e30001c208cc1',
        answer:
          '<p>ลูกค้าสามารถติดตามสถานะงานผ่านทางเว็บไซต์ได้ตลอดเวลา และสามารถจองวันเวลาเข้าหน้างานได้ด้วยตัวเอง</p><p>จะได้ขนาดพื้นที่ เป็น “ตารางเมตร”&nbsp;</p>',
        question: 'เรียกบริการผ่านเว็บไซต์ดีอย่างไร',
        __v: 0,
        id: '63614e99b87e30001c208cc1',
      },
      {
        _id: '63614e99b87e30001c208cc2',
        answer:
          '<p>ใบเสนอราคาจะถูกส่งให้ลูกค้าตรวจสอบ ภายใน 24 ชม. หลังจากวันที่ช่างเข้าตรวจหน้างาน</p>',
        question: 'ใบเสนอราคาจะได้เมื่อไหร่ หลังจากที่ช่างเข้าสำรวจหน้างานเรียบร้อยแล้ว',
        __v: 0,
        id: '63614e99b87e30001c208cc2',
      },
      {
        _id: '63614e99b87e30001c208cc3',
        answer:
          '<p>ทำหน้าที่หยุดและป้องกันปัญหาที่เกิดการทาสีในอนาคต เช่น ปัญหาด่าง-เกลือ ปัญหาเชื้อรา ปัญหาฝุ่นชอล์ก ปัญหาซีดจาง ปัญหาลอกโป่งพอง ปัญหาเชื้อราตะใคร่น้ำ หรือปัญหาสนิม และช่วยให้สีทับหน้ายึดเกาะกับพื้นผิวดีขึ้น</p>',
        question: 'ทำไมต้องทาสีรองพื้น',
        __v: 0,
        id: '63614e99b87e30001c208cc3',
      },
      {
        _id: '63614e99b87e30001c208cc4',
        answer:
          '<p>วัดพื้นที่ฝั่งด้านกว้าง และฝั่งด้านยาวของพื้นที่ นำตัวเลข “กว้าง” มาคูณ กับตัวเลข “ยาว” ซึ่งตัวเลขกว้าง กับ ตัวเลขยาว จะมีหน่วยเป็น “เมตร” แล้วนำ “เมตร” คูณกับ “เมตร” ก็</p>',
        question: 'วิธีคำนวณขนาดพื้นที่คร่าวๆ เพื่อประเมิณราคาเบื้องต้น',
        __v: 0,
        id: '63614e99b87e30001c208cc4',
      },
    ],
    promotionSection: {
      _id: '636743726f10f9001b2ffc2c',
      title: 'โปรโมชั่น',
      promotions: [
        {
          _id: '636743726f10f9001b2ffc2d',
          url: 'https://fix.24x.co.th/voucher/firstfix-1',
          __v: 0,
          image: {
            _id: '637614b137fd76001b532030',
            name: '24FIX_NOV_BANNER4-02 (1).jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 94.2,
            width: 1500,
            height: 490,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 245,
                height: 80,
                size: 6.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              large: {
                name: 'large_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 327,
                size: 50.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              medium: {
                name: 'medium_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 245,
                size: 32.89,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              small: {
                name: 'small_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 163,
                size: 18.03,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
            },
            provider: 'aws-s3',
            related: ['636a17dc1e519e001c14731c'],
            createdAt: '2022-11-17T11:02:09.052Z',
            updatedAt: '2022-11-21T05:30:58.272Z',
            __v: 0,
            id: '637614b137fd76001b532030',
          },
          mobileImage: {
            _id: '636a6d86e6895d001ce68cc3',
            name: '24FIX_NOV_BANNER1-01.jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_1_01_3663796871',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 149.63,
            width: 1500,
            height: 1021,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_1_01_3663796871.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24FIX_NOV_BANNER1-01.jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 229,
                height: 156,
                size: 8.94,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              large: {
                name: 'large_24FIX_NOV_BANNER1-01.jpg',
                hash: 'large_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 681,
                size: 78.97,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              medium: {
                name: 'medium_24FIX_NOV_BANNER1-01.jpg',
                hash: 'medium_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 511,
                size: 51.21,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              small: {
                name: 'small_24FIX_NOV_BANNER1-01.jpg',
                hash: 'small_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 340,
                size: 27.91,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
            },
            provider: 'aws-s3',
            related: [],
            createdAt: '2022-11-08T14:53:58.508Z',
            updatedAt: '2022-11-08T16:06:16.745Z',
            __v: 0,
            id: '636a6d86e6895d001ce68cc3',
          },
          id: '636743726f10f9001b2ffc2d',
        },
      ],
      __v: 1,
      button: null,
      id: '636743726f10f9001b2ffc2c',
    },
    stepSection: null,
    successStorySection: {
      contents: [
        {
          relatedArticles: [],
          categories: [
            '60d1fe825749bf001bbb11e4',
            '62a76933e9dde5001b3c6b15',
            '62de67ecb31a7a001bba2d60',
          ],
          _id: '60fef2feea7297001be8c5f3',
          title: 'รีวิวผลงานจริง ล้างแอร์บ้านคุณเมย์ รัชนก อินทนนท์',
          slug: 'pro-may-onsite-review',
          shortDescription:
            'เพราะประเทศไทยมีแต่ฤดูร้อน ร้อนมาก และร้อนที่สุด! ดังนั้นการดูแล ทำความสะอาด ล้างแอร์ ก็ควรทำอย่างสม่ำเสมอนะ\n#งานล้างแอร์ #ล้างแอร์ฆ่าเชื้อ #เมย์ รัชนก อินทนนท์ #แอร์ไม่เย็น #ตรวจสภาพแอร์ #ล้างแอร์ #ซ่อมแอร์ ',
          views: 3549,
          published_at: '2021-07-26T17:38:13.448Z',
          contents: [
            {
              __component: 'article.content',
              id: '60fef2feea7297001be8c5f4',
            },
            {
              __component: 'article.images',
              id: '60fef2feea7297001be8c5f5',
            },
            {
              __component: 'article.content',
              id: '60fef2feea7297001be8c5f6',
            },
            {
              __component: 'article.images',
              id: '60fef2feea7297001be8c5f7',
            },
            {
              __component: 'article.content',
              id: '62cd0500df69b2001b4a8f1a',
            },
            {
              __component: 'article.images',
              id: '62cd0687df69b2001b4a8f39',
            },
            {
              __component: 'article.content',
              id: '62cd0687df69b2001b4a8f3a',
            },
            {
              __component: 'article.images',
              id: '62cd0687df69b2001b4a8f3b',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fbc',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fbd',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fbe',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fbf',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc0',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc1',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc2',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc3',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc4',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc5',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc6',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc7',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc8',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc9',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fca',
            },
          ],
          link: null,
          createdAt: '2021-07-26T17:38:06.604Z',
          updatedAt: '2022-07-25T10:08:01.825Z',
          __v: 2,
          coverImage: {
            _id: '60feef59ea7297001be8c5ed',
            name: '20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
            alternativeText: '',
            caption: '',
            hash: '20210510_On_site_Review_Artboard_v2_e9212db564',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 657.65,
            width: 2501,
            height: 1667,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'thumbnail_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 12.97,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              large: {
                name: 'large_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'large_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 1000,
                height: 667,
                size: 146.8,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              medium: {
                name: 'medium_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'medium_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 750,
                height: 500,
                size: 92.52,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              small: {
                name: 'small_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'small_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 46.42,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['60fef2feea7297001be8c5f3'],
            createdAt: '2021-07-26T17:22:33.885Z',
            updatedAt: '2021-07-30T03:43:47.943Z',
            __v: 0,
            id: '60feef59ea7297001be8c5ed',
          },
          metadata: null,
          id: '60fef2feea7297001be8c5f3',
        },
        {
          relatedArticles: ['60fef2feea7297001be8c5f3', '62cd8d63df69b2001b4a9b5c'],
          categories: [
            '62a76933e9dde5001b3c6b15',
            '60d1fe825749bf001bbb11e4',
            '62de67ecb31a7a001bba2d60',
          ],
          _id: '62cda1d7df69b2001b4a9c2a',
          published_at: '2022-07-12T16:36:03.404Z',
          slug: '911-assistant-rama-ix-porsche-service',
          shortDescription:
            'คุณลูกค้าได้ติดต่อให้ช่างอุ่นใจเข้ามาตรวจสอบปัญหาชักโครกมีกลิ่นเเละน้ำรั่วซึม ซึ่งช่างอุ่นใจได้รับโจทย์ในงานซ่อมแบ่งเป็น 2 ส่วนได้แก่ การซ่อมโถชักโครกและโถปัสสาวะชาย\n#งานเปลี่ยนสุขภัณฑ์ #รีวิว #กลิ่นโถส้วม',
          views: 244,
          title: 'รีวิวผลงานจริง @911 ASSISTANT RAMA IX (Porsche Service)',
          contents: [
            {
              __component: 'article.content',
              id: '62cda1d7df69b2001b4a9c2b',
            },
            {
              __component: 'article.content',
              id: '62cda1d7df69b2001b4a9c2c',
            },
          ],
          link: null,
          createdAt: '2022-07-12T16:31:19.223Z',
          updatedAt: '2022-07-25T10:08:01.825Z',
          __v: 1,
          coverImage: {
            _id: '62cd994fdf69b2001b4a9bbe',
            name: '144302486_851532738754884_6271739837459506095_n (Small).jpg',
            alternativeText: '',
            caption: '',
            hash: '144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 75.25,
            width: 720,
            height: 480,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_144302486_851532738754884_6271739837459506095_n (Small).jpg',
                hash: 'thumbnail_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 11.42,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
              },
              small: {
                name: 'small_144302486_851532738754884_6271739837459506095_n (Small).jpg',
                hash: 'small_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 40.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
              },
            },
            provider: 'aws-s3',
            related: ['62cda1d7df69b2001b4a9c2a'],
            createdAt: '2022-07-12T15:54:55.834Z',
            updatedAt: '2022-07-12T16:31:19.369Z',
            __v: 0,
            id: '62cd994fdf69b2001b4a9bbe',
          },
          metadata: null,
          id: '62cda1d7df69b2001b4a9c2a',
        },
        {
          relatedArticles: ['60fef2feea7297001be8c5f3'],
          categories: ['60d1fe825749bf001bbb11e4', '62a76933e9dde5001b3c6b15'],
          _id: '60fef555ea7297001be8c617',
          published_at: '2021-07-26T17:58:58.311Z',
          slug: 'ac-with-installation',
          shortDescription:
            '#ซื้อแอร์วันนี้แถมฟรีติดตั้ง\n\n☀ ถ้าจะบอกว่าเมืองไทย ‘อากาศร้อน’ เฉพาะในช่วงหน้าร้อนก็คงจะไม่ถูก เพราะไม่ว่าฤดูไหนๆ จะร้อน หนาว ฝน อากาศก็ร้อนอยู่ดี!\nวันนี้มาดับร้อนกันดีกว่า ❄ ด้วยบริการซื้อแอร์พร้อมติดตั้งฟรี โดยทีมช่างมืออาชีพ 24 FIX 😊',
          title: 'บริการซื้อแอร์พร้อมติดตั้ง',
          contents: [
            {
              __component: 'article.content',
              id: '60fef7daea7297001be8c649',
            },
            {
              __component: 'article.images',
              id: '60fef7daea7297001be8c64a',
            },
          ],
          link: null,
          createdAt: '2021-07-26T17:48:05.531Z',
          updatedAt: '2022-07-13T05:50:55.237Z',
          __v: 0,
          views: 1124,
          coverImage: {
            _id: '60fef76eea7297001be8c634',
            name: '117956473_738009603440532_2359157732673622296_n.jpeg',
            alternativeText: '',
            caption: '',
            hash: '117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 253.58,
            width: 1801,
            height: 1201,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'thumbnail_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 8.33,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              large: {
                name: 'large_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'large_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 1000,
                height: 667,
                size: 83.31,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              medium: {
                name: 'medium_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'medium_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 750,
                height: 500,
                size: 50.16,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              small: {
                name: 'small_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'small_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 26.25,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['60fef555ea7297001be8c617'],
            createdAt: '2021-07-26T17:57:02.195Z',
            updatedAt: '2021-07-30T03:43:47.943Z',
            __v: 0,
            id: '60fef76eea7297001be8c634',
          },
          metadata: null,
          id: '60fef555ea7297001be8c617',
        },
      ],
      _id: '6368f17f1e519e001c146fe0',
      title: 'ผลงานของเรา',
      __v: 0,
      button: null,
      id: '6368f17f1e519e001c146fe0',
    },
    reviewSection: {
      _id: '636009d451f79b001dee9965',
      title: 'รีวิวจากผู้ใช้บริการของเรา',
      reviewContent: [
        {
          image: [
            {
              _id: '636738ca6f10f9001b2ffa2b',
              name: '854357e2_98f2_499c_9b31_d18b107b4fcf_06971b8c06.jpeg',
              alternativeText: '',
              caption: '',
              hash: '854357e2_98f2_499c_9b31_d18b107b4fcf_06971b8c06_2590257c96',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 128.43,
              width: 1477,
              height: 1108,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/854357e2_98f2_499c_9b31_d18b107b4fcf_06971b8c06_2590257c96.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_854357e2_98f2_499c_9b31_d18b107b4fcf_06971b8c06.jpeg',
                  hash: 'thumbnail_854357e2_98f2_499c_9b31_d18b107b4fcf_06971b8c06_2590257c96',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 208,
                  height: 156,
                  size: 5.77,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_854357e2_98f2_499c_9b31_d18b107b4fcf_06971b8c06_2590257c96.jpeg',
                },
                large: {
                  name: 'large_854357e2_98f2_499c_9b31_d18b107b4fcf_06971b8c06.jpeg',
                  hash: 'large_854357e2_98f2_499c_9b31_d18b107b4fcf_06971b8c06_2590257c96',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 1000,
                  height: 750,
                  size: 84.76,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_854357e2_98f2_499c_9b31_d18b107b4fcf_06971b8c06_2590257c96.jpeg',
                },
                medium: {
                  name: 'medium_854357e2_98f2_499c_9b31_d18b107b4fcf_06971b8c06.jpeg',
                  hash: 'medium_854357e2_98f2_499c_9b31_d18b107b4fcf_06971b8c06_2590257c96',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 563,
                  size: 50.95,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_854357e2_98f2_499c_9b31_d18b107b4fcf_06971b8c06_2590257c96.jpeg',
                },
                small: {
                  name: 'small_854357e2_98f2_499c_9b31_d18b107b4fcf_06971b8c06.jpeg',
                  hash: 'small_854357e2_98f2_499c_9b31_d18b107b4fcf_06971b8c06_2590257c96',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 500,
                  height: 375,
                  size: 24.68,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_854357e2_98f2_499c_9b31_d18b107b4fcf_06971b8c06_2590257c96.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:32:10.542Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636738ca6f10f9001b2ffa2b',
            },
            {
              _id: '636738ca6f10f9001b2ffa2c',
              name: '06d53209_2d91_44ef_88ed_a02699d09b3d_1c61ca0033.jpeg',
              alternativeText: '',
              caption: '',
              hash: '06d53209_2d91_44ef_88ed_a02699d09b3d_1c61ca0033_fdcafdeff0',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 168.71,
              width: 1477,
              height: 1108,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/06d53209_2d91_44ef_88ed_a02699d09b3d_1c61ca0033_fdcafdeff0.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_06d53209_2d91_44ef_88ed_a02699d09b3d_1c61ca0033.jpeg',
                  hash: 'thumbnail_06d53209_2d91_44ef_88ed_a02699d09b3d_1c61ca0033_fdcafdeff0',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 208,
                  height: 156,
                  size: 6.26,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_06d53209_2d91_44ef_88ed_a02699d09b3d_1c61ca0033_fdcafdeff0.jpeg',
                },
                large: {
                  name: 'large_06d53209_2d91_44ef_88ed_a02699d09b3d_1c61ca0033.jpeg',
                  hash: 'large_06d53209_2d91_44ef_88ed_a02699d09b3d_1c61ca0033_fdcafdeff0',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 1000,
                  height: 750,
                  size: 104.31,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_06d53209_2d91_44ef_88ed_a02699d09b3d_1c61ca0033_fdcafdeff0.jpeg',
                },
                medium: {
                  name: 'medium_06d53209_2d91_44ef_88ed_a02699d09b3d_1c61ca0033.jpeg',
                  hash: 'medium_06d53209_2d91_44ef_88ed_a02699d09b3d_1c61ca0033_fdcafdeff0',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 563,
                  size: 60.04,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_06d53209_2d91_44ef_88ed_a02699d09b3d_1c61ca0033_fdcafdeff0.jpeg',
                },
                small: {
                  name: 'small_06d53209_2d91_44ef_88ed_a02699d09b3d_1c61ca0033.jpeg',
                  hash: 'small_06d53209_2d91_44ef_88ed_a02699d09b3d_1c61ca0033_fdcafdeff0',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 500,
                  height: 375,
                  size: 27.74,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_06d53209_2d91_44ef_88ed_a02699d09b3d_1c61ca0033_fdcafdeff0.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:32:10.556Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636738ca6f10f9001b2ffa2c',
            },
          ],
          _id: '636009d451f79b001dee996e',
          name: 'ฝนxxxxx',
          description:
            'เจ้าหน้าที่ให้คำปรึกษาดีค่ะ ใช้บริการช่างให้มาทาสีภายนอกบ้าน เก็บงานเรียบร้อยดีค่ะ',
          score: 5,
          __v: 0,
          id: '636009d451f79b001dee996e',
        },
        {
          image: [
            {
              _id: '636737de6f10f9001b2ffa1a',
              name: '2_D7_C05_B4_2_E73_46_EC_945_A_B43552_D0_A19_A_a40d6a108a.jpeg',
              alternativeText: '',
              caption: '',
              hash: '2_D7_C05_B4_2_E73_46_EC_945_A_B43552_D0_A19_A_a40d6a108a_8a55c71b4b',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 31.95,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/2_D7_C05_B4_2_E73_46_EC_945_A_B43552_D0_A19_A_a40d6a108a_8a55c71b4b.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_2_D7_C05_B4_2_E73_46_EC_945_A_B43552_D0_A19_A_a40d6a108a.jpeg',
                  hash: 'thumbnail_2_D7_C05_B4_2_E73_46_EC_945_A_B43552_D0_A19_A_a40d6a108a_8a55c71b4b',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.86,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_2_D7_C05_B4_2_E73_46_EC_945_A_B43552_D0_A19_A_a40d6a108a_8a55c71b4b.jpeg',
                },
                medium: {
                  name: 'medium_2_D7_C05_B4_2_E73_46_EC_945_A_B43552_D0_A19_A_a40d6a108a.jpeg',
                  hash: 'medium_2_D7_C05_B4_2_E73_46_EC_945_A_B43552_D0_A19_A_a40d6a108a_8a55c71b4b',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 29.06,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_2_D7_C05_B4_2_E73_46_EC_945_A_B43552_D0_A19_A_a40d6a108a_8a55c71b4b.jpeg',
                },
                small: {
                  name: 'small_2_D7_C05_B4_2_E73_46_EC_945_A_B43552_D0_A19_A_a40d6a108a.jpeg',
                  hash: 'small_2_D7_C05_B4_2_E73_46_EC_945_A_B43552_D0_A19_A_a40d6a108a_8a55c71b4b',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 15.37,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_2_D7_C05_B4_2_E73_46_EC_945_A_B43552_D0_A19_A_a40d6a108a_8a55c71b4b.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:28:14.308Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636737de6f10f9001b2ffa1a',
            },
            {
              _id: '636737de6f10f9001b2ffa1b',
              name: 'A8480409_E70_B_4481_88_A1_9347_F98_DED_95_9b01ff0c12.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'A8480409_E70_B_4481_88_A1_9347_F98_DED_95_9b01ff0c12_83d0b06493',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 28.22,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/A8480409_E70_B_4481_88_A1_9347_F98_DED_95_9b01ff0c12_83d0b06493.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_A8480409_E70_B_4481_88_A1_9347_F98_DED_95_9b01ff0c12.jpeg',
                  hash: 'thumbnail_A8480409_E70_B_4481_88_A1_9347_F98_DED_95_9b01ff0c12_83d0b06493',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.22,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_A8480409_E70_B_4481_88_A1_9347_F98_DED_95_9b01ff0c12_83d0b06493.jpeg',
                },
                medium: {
                  name: 'medium_A8480409_E70_B_4481_88_A1_9347_F98_DED_95_9b01ff0c12.jpeg',
                  hash: 'medium_A8480409_E70_B_4481_88_A1_9347_F98_DED_95_9b01ff0c12_83d0b06493',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 25.48,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_A8480409_E70_B_4481_88_A1_9347_F98_DED_95_9b01ff0c12_83d0b06493.jpeg',
                },
                small: {
                  name: 'small_A8480409_E70_B_4481_88_A1_9347_F98_DED_95_9b01ff0c12.jpeg',
                  hash: 'small_A8480409_E70_B_4481_88_A1_9347_F98_DED_95_9b01ff0c12_83d0b06493',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 12.95,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_A8480409_E70_B_4481_88_A1_9347_F98_DED_95_9b01ff0c12_83d0b06493.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:28:14.366Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636737de6f10f9001b2ffa1b',
            },
          ],
          _id: '636009d451f79b001dee9966',
          name: 'ชฎาxxxxxx',
          description: 'ช่างทาสีได้เนียนสวยมากประทับใจ เหมือนได้บ้านใหม่เลย',
          score: 5,
          __v: 0,
          id: '636009d451f79b001dee9966',
        },
        {
          image: [
            {
              _id: '636737fa6f10f9001b2ffa1c',
              name: '8_CA_0_A81_B_DA_0_C_4_A57_A633_473_DD_8271157_fa75165528.jpeg',
              alternativeText: '',
              caption: '',
              hash: '8_CA_0_A81_B_DA_0_C_4_A57_A633_473_DD_8271157_fa75165528_34536fec13',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 33.37,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/8_CA_0_A81_B_DA_0_C_4_A57_A633_473_DD_8271157_fa75165528_34536fec13.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_8_CA_0_A81_B_DA_0_C_4_A57_A633_473_DD_8271157_fa75165528.jpeg',
                  hash: 'thumbnail_8_CA_0_A81_B_DA_0_C_4_A57_A633_473_DD_8271157_fa75165528_34536fec13',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.07,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_8_CA_0_A81_B_DA_0_C_4_A57_A633_473_DD_8271157_fa75165528_34536fec13.jpeg',
                },
                medium: {
                  name: 'medium_8_CA_0_A81_B_DA_0_C_4_A57_A633_473_DD_8271157_fa75165528.jpeg',
                  hash: 'medium_8_CA_0_A81_B_DA_0_C_4_A57_A633_473_DD_8271157_fa75165528_34536fec13',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 30.47,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_8_CA_0_A81_B_DA_0_C_4_A57_A633_473_DD_8271157_fa75165528_34536fec13.jpeg',
                },
                small: {
                  name: 'small_8_CA_0_A81_B_DA_0_C_4_A57_A633_473_DD_8271157_fa75165528.jpeg',
                  hash: 'small_8_CA_0_A81_B_DA_0_C_4_A57_A633_473_DD_8271157_fa75165528_34536fec13',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 16.13,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_8_CA_0_A81_B_DA_0_C_4_A57_A633_473_DD_8271157_fa75165528_34536fec13.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:28:42.096Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636737fa6f10f9001b2ffa1c',
            },
            {
              _id: '636737fa6f10f9001b2ffa1d',
              name: '29_F58731_AAF_6_42_C7_9_DE_7_09_FBE_6_F1345_E_49c4e5b10e.jpeg',
              alternativeText: '',
              caption: '',
              hash: '29_F58731_AAF_6_42_C7_9_DE_7_09_FBE_6_F1345_E_49c4e5b10e_98b9caac67',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 51.4,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/29_F58731_AAF_6_42_C7_9_DE_7_09_FBE_6_F1345_E_49c4e5b10e_98b9caac67.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_29_F58731_AAF_6_42_C7_9_DE_7_09_FBE_6_F1345_E_49c4e5b10e.jpeg',
                  hash: 'thumbnail_29_F58731_AAF_6_42_C7_9_DE_7_09_FBE_6_F1345_E_49c4e5b10e_98b9caac67',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 4.63,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_29_F58731_AAF_6_42_C7_9_DE_7_09_FBE_6_F1345_E_49c4e5b10e_98b9caac67.jpeg',
                },
                medium: {
                  name: 'medium_29_F58731_AAF_6_42_C7_9_DE_7_09_FBE_6_F1345_E_49c4e5b10e.jpeg',
                  hash: 'medium_29_F58731_AAF_6_42_C7_9_DE_7_09_FBE_6_F1345_E_49c4e5b10e_98b9caac67',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 47.54,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_29_F58731_AAF_6_42_C7_9_DE_7_09_FBE_6_F1345_E_49c4e5b10e_98b9caac67.jpeg',
                },
                small: {
                  name: 'small_29_F58731_AAF_6_42_C7_9_DE_7_09_FBE_6_F1345_E_49c4e5b10e.jpeg',
                  hash: 'small_29_F58731_AAF_6_42_C7_9_DE_7_09_FBE_6_F1345_E_49c4e5b10e_98b9caac67',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 26.1,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_29_F58731_AAF_6_42_C7_9_DE_7_09_FBE_6_F1345_E_49c4e5b10e_98b9caac67.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:28:42.149Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636737fa6f10f9001b2ffa1d',
            },
          ],
          _id: '636009d451f79b001dee9967',
          description: 'พึ่งเคยลองให้บริการทาสี ชอบมากกกก เข้างานเร็วทาสีเนียนงานเสร็จเร็วด้วย ',
          name: 'ศิรัญxxxxxx',
          score: 4,
          __v: 0,
          id: '636009d451f79b001dee9967',
        },
        {
          image: [
            {
              _id: '636738186f10f9001b2ffa1e',
              name: 'rn_image_picker_lib_temp_c7e94ee4_9a76_4950_8457_cd38ebe6751b_73e62594cf.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_c7e94ee4_9a76_4950_8457_cd38ebe6751b_73e62594cf_daa2eec923',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 17.72,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_c7e94ee4_9a76_4950_8457_cd38ebe6751b_73e62594cf_daa2eec923.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_c7e94ee4_9a76_4950_8457_cd38ebe6751b_73e62594cf.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_c7e94ee4_9a76_4950_8457_cd38ebe6751b_73e62594cf_daa2eec923',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 1.56,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_c7e94ee4_9a76_4950_8457_cd38ebe6751b_73e62594cf_daa2eec923.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_c7e94ee4_9a76_4950_8457_cd38ebe6751b_73e62594cf.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_c7e94ee4_9a76_4950_8457_cd38ebe6751b_73e62594cf_daa2eec923',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 16.07,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_c7e94ee4_9a76_4950_8457_cd38ebe6751b_73e62594cf_daa2eec923.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_c7e94ee4_9a76_4950_8457_cd38ebe6751b_73e62594cf.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_c7e94ee4_9a76_4950_8457_cd38ebe6751b_73e62594cf_daa2eec923',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 7.56,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_c7e94ee4_9a76_4950_8457_cd38ebe6751b_73e62594cf_daa2eec923.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:29:12.792Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636738186f10f9001b2ffa1e',
            },
            {
              _id: '636738186f10f9001b2ffa1f',
              name: 'rn_image_picker_lib_temp_2c3ccfb7_a06c_4c36_a4c7_7b68ade7e3d9_d84eb1975a.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_2c3ccfb7_a06c_4c36_a4c7_7b68ade7e3d9_d84eb1975a_f0cfaaee83',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 30.2,
              width: 800,
              height: 600,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_2c3ccfb7_a06c_4c36_a4c7_7b68ade7e3d9_d84eb1975a_f0cfaaee83.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_2c3ccfb7_a06c_4c36_a4c7_7b68ade7e3d9_d84eb1975a.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_2c3ccfb7_a06c_4c36_a4c7_7b68ade7e3d9_d84eb1975a_f0cfaaee83',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 208,
                  height: 156,
                  size: 3.93,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_2c3ccfb7_a06c_4c36_a4c7_7b68ade7e3d9_d84eb1975a_f0cfaaee83.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_2c3ccfb7_a06c_4c36_a4c7_7b68ade7e3d9_d84eb1975a.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_2c3ccfb7_a06c_4c36_a4c7_7b68ade7e3d9_d84eb1975a_f0cfaaee83',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 563,
                  size: 27.7,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_2c3ccfb7_a06c_4c36_a4c7_7b68ade7e3d9_d84eb1975a_f0cfaaee83.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_2c3ccfb7_a06c_4c36_a4c7_7b68ade7e3d9_d84eb1975a.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_2c3ccfb7_a06c_4c36_a4c7_7b68ade7e3d9_d84eb1975a_f0cfaaee83',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 500,
                  height: 375,
                  size: 14.34,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_2c3ccfb7_a06c_4c36_a4c7_7b68ade7e3d9_d84eb1975a_f0cfaaee83.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:29:12.892Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636738186f10f9001b2ffa1f',
            },
          ],
          _id: '636009d451f79b001dee9968',
          name: 'กรxxxxxx',
          description:
            'ชอบความใส่ใจช่วยเก็บของย้ายของก่อนทาสี เก็บให้กลัวสีเลอะยิ่งกว่าเจ้าของบ้านอีก555 สีเรียบสวยสม่ำเสมอกันด้วยทำงานดีมากครับ',
          score: 5,
          __v: 0,
          id: '636009d451f79b001dee9968',
        },
        {
          image: [
            {
              _id: '636738346f10f9001b2ffa20',
              name: 'rn_image_picker_lib_temp_3641355f_aeb0_4287_afa9_0fc4419896e5_610560ae0f.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_3641355f_aeb0_4287_afa9_0fc4419896e5_610560ae0f_58dcb50987',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 22.53,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_3641355f_aeb0_4287_afa9_0fc4419896e5_610560ae0f_58dcb50987.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_3641355f_aeb0_4287_afa9_0fc4419896e5_610560ae0f.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_3641355f_aeb0_4287_afa9_0fc4419896e5_610560ae0f_58dcb50987',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.44,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_3641355f_aeb0_4287_afa9_0fc4419896e5_610560ae0f_58dcb50987.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_3641355f_aeb0_4287_afa9_0fc4419896e5_610560ae0f.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_3641355f_aeb0_4287_afa9_0fc4419896e5_610560ae0f_58dcb50987',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 20.77,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_3641355f_aeb0_4287_afa9_0fc4419896e5_610560ae0f_58dcb50987.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_3641355f_aeb0_4287_afa9_0fc4419896e5_610560ae0f.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_3641355f_aeb0_4287_afa9_0fc4419896e5_610560ae0f_58dcb50987',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 11.19,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_3641355f_aeb0_4287_afa9_0fc4419896e5_610560ae0f_58dcb50987.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:29:40.824Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636738346f10f9001b2ffa20',
            },
            {
              _id: '636738346f10f9001b2ffa21',
              name: 'rn_image_picker_lib_temp_408905b1_48d3_4a98_aea6_5e38b96c173f_edd664b68e.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_408905b1_48d3_4a98_aea6_5e38b96c173f_edd664b68e_52ef1aa950',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 37.71,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_408905b1_48d3_4a98_aea6_5e38b96c173f_edd664b68e_52ef1aa950.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_408905b1_48d3_4a98_aea6_5e38b96c173f_edd664b68e.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_408905b1_48d3_4a98_aea6_5e38b96c173f_edd664b68e_52ef1aa950',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.5,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_408905b1_48d3_4a98_aea6_5e38b96c173f_edd664b68e_52ef1aa950.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_408905b1_48d3_4a98_aea6_5e38b96c173f_edd664b68e.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_408905b1_48d3_4a98_aea6_5e38b96c173f_edd664b68e_52ef1aa950',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 34.56,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_408905b1_48d3_4a98_aea6_5e38b96c173f_edd664b68e_52ef1aa950.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_408905b1_48d3_4a98_aea6_5e38b96c173f_edd664b68e.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_408905b1_48d3_4a98_aea6_5e38b96c173f_edd664b68e_52ef1aa950',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 18.65,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_408905b1_48d3_4a98_aea6_5e38b96c173f_edd664b68e_52ef1aa950.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:29:40.899Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636738346f10f9001b2ffa21',
            },
          ],
          _id: '636009d451f79b001dee9969',
          name: 'เขมxxxxxx',
          description:
            'เพื่อนแนะนำมาว่าทำงานเรียบร้อยมาก  สมคำล้ำลือจริงครับ ช่างเค้าใส่ใจพูดจาดีสุภาพ ',
          score: 5,
          __v: 0,
          id: '636009d451f79b001dee9969',
        },
        {
          image: [
            {
              _id: '636738546f10f9001b2ffa22',
              name: 'e45e2378_da62_400a_ba59_f16ec8785c28_5f045d8bd7.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'e45e2378_da62_400a_ba59_f16ec8785c28_5f045d8bd7_ac9fd2bccc',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 78.62,
              width: 1477,
              height: 1108,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/e45e2378_da62_400a_ba59_f16ec8785c28_5f045d8bd7_ac9fd2bccc.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_e45e2378_da62_400a_ba59_f16ec8785c28_5f045d8bd7.jpeg',
                  hash: 'thumbnail_e45e2378_da62_400a_ba59_f16ec8785c28_5f045d8bd7_ac9fd2bccc',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 208,
                  height: 156,
                  size: 11.97,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_e45e2378_da62_400a_ba59_f16ec8785c28_5f045d8bd7_ac9fd2bccc.jpeg',
                },
                large: {
                  name: 'large_e45e2378_da62_400a_ba59_f16ec8785c28_5f045d8bd7.jpeg',
                  hash: 'large_e45e2378_da62_400a_ba59_f16ec8785c28_5f045d8bd7_ac9fd2bccc',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 1000,
                  height: 750,
                  size: 63.29,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_e45e2378_da62_400a_ba59_f16ec8785c28_5f045d8bd7_ac9fd2bccc.jpeg',
                },
                medium: {
                  name: 'medium_e45e2378_da62_400a_ba59_f16ec8785c28_5f045d8bd7.jpeg',
                  hash: 'medium_e45e2378_da62_400a_ba59_f16ec8785c28_5f045d8bd7_ac9fd2bccc',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 563,
                  size: 43.1,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_e45e2378_da62_400a_ba59_f16ec8785c28_5f045d8bd7_ac9fd2bccc.jpeg',
                },
                small: {
                  name: 'small_e45e2378_da62_400a_ba59_f16ec8785c28_5f045d8bd7.jpeg',
                  hash: 'small_e45e2378_da62_400a_ba59_f16ec8785c28_5f045d8bd7_ac9fd2bccc',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 500,
                  height: 375,
                  size: 25.99,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_e45e2378_da62_400a_ba59_f16ec8785c28_5f045d8bd7_ac9fd2bccc.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:30:12.273Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636738546f10f9001b2ffa22',
            },
            {
              _id: '636738546f10f9001b2ffa23',
              name: '8be50cea_6b27_4e72_a1dd_f2cc4a43fe57_19df4e4814.jpeg',
              alternativeText: '',
              caption: '',
              hash: '8be50cea_6b27_4e72_a1dd_f2cc4a43fe57_19df4e4814_a43c7c5161',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 55.66,
              width: 1477,
              height: 1108,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/8be50cea_6b27_4e72_a1dd_f2cc4a43fe57_19df4e4814_a43c7c5161.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_8be50cea_6b27_4e72_a1dd_f2cc4a43fe57_19df4e4814.jpeg',
                  hash: 'thumbnail_8be50cea_6b27_4e72_a1dd_f2cc4a43fe57_19df4e4814_a43c7c5161',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 208,
                  height: 156,
                  size: 10.59,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_8be50cea_6b27_4e72_a1dd_f2cc4a43fe57_19df4e4814_a43c7c5161.jpeg',
                },
                large: {
                  name: 'large_8be50cea_6b27_4e72_a1dd_f2cc4a43fe57_19df4e4814.jpeg',
                  hash: 'large_8be50cea_6b27_4e72_a1dd_f2cc4a43fe57_19df4e4814_a43c7c5161',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 1000,
                  height: 750,
                  size: 46.83,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_8be50cea_6b27_4e72_a1dd_f2cc4a43fe57_19df4e4814_a43c7c5161.jpeg',
                },
                medium: {
                  name: 'medium_8be50cea_6b27_4e72_a1dd_f2cc4a43fe57_19df4e4814.jpeg',
                  hash: 'medium_8be50cea_6b27_4e72_a1dd_f2cc4a43fe57_19df4e4814_a43c7c5161',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 563,
                  size: 32.07,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_8be50cea_6b27_4e72_a1dd_f2cc4a43fe57_19df4e4814_a43c7c5161.jpeg',
                },
                small: {
                  name: 'small_8be50cea_6b27_4e72_a1dd_f2cc4a43fe57_19df4e4814.jpeg',
                  hash: 'small_8be50cea_6b27_4e72_a1dd_f2cc4a43fe57_19df4e4814_a43c7c5161',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 500,
                  height: 375,
                  size: 19.92,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_8be50cea_6b27_4e72_a1dd_f2cc4a43fe57_19df4e4814_a43c7c5161.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:30:12.375Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636738546f10f9001b2ffa23',
            },
          ],
          _id: '636009d451f79b001dee996a',
          name: 'เอกxxxxxx',
          description:
            'เคยทาสีมาสองรอบล่ะไม่ตรงใจ แต่ที่นี้ช่างคุยงานเข้าใจเราว่าชอบแบบไหนงานทาสีก็ดีเก็บละเอียดทุกมุมเลยครับ ใช้บริการอีกแน่นอน',
          score: 5,
          __v: 0,
          id: '636009d451f79b001dee996a',
        },
        {
          image: [
            {
              _id: '6367386f6f10f9001b2ffa24',
              name: 'rn_image_picker_lib_temp_da8aec89_b336_427f_a4c7_60b24ae194a0_4d139f94e4.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_da8aec89_b336_427f_a4c7_60b24ae194a0_4d139f94e4_049faeba3a',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 43.56,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_da8aec89_b336_427f_a4c7_60b24ae194a0_4d139f94e4_049faeba3a.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_da8aec89_b336_427f_a4c7_60b24ae194a0_4d139f94e4.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_da8aec89_b336_427f_a4c7_60b24ae194a0_4d139f94e4_049faeba3a',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.85,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_da8aec89_b336_427f_a4c7_60b24ae194a0_4d139f94e4_049faeba3a.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_da8aec89_b336_427f_a4c7_60b24ae194a0_4d139f94e4.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_da8aec89_b336_427f_a4c7_60b24ae194a0_4d139f94e4_049faeba3a',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 39.83,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_da8aec89_b336_427f_a4c7_60b24ae194a0_4d139f94e4_049faeba3a.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_da8aec89_b336_427f_a4c7_60b24ae194a0_4d139f94e4.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_da8aec89_b336_427f_a4c7_60b24ae194a0_4d139f94e4_049faeba3a',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 21.4,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_da8aec89_b336_427f_a4c7_60b24ae194a0_4d139f94e4_049faeba3a.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:30:39.398Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '6367386f6f10f9001b2ffa24',
            },
            {
              _id: '6367386f6f10f9001b2ffa25',
              name: 'rn_image_picker_lib_temp_00f4f06c_64c7_4c4c_86f0_0a11bfdbd51b_4cc52c1263.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_00f4f06c_64c7_4c4c_86f0_0a11bfdbd51b_4cc52c1263_998949939e',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 36.05,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_00f4f06c_64c7_4c4c_86f0_0a11bfdbd51b_4cc52c1263_998949939e.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_00f4f06c_64c7_4c4c_86f0_0a11bfdbd51b_4cc52c1263.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_00f4f06c_64c7_4c4c_86f0_0a11bfdbd51b_4cc52c1263_998949939e',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.35,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_00f4f06c_64c7_4c4c_86f0_0a11bfdbd51b_4cc52c1263_998949939e.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_00f4f06c_64c7_4c4c_86f0_0a11bfdbd51b_4cc52c1263.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_00f4f06c_64c7_4c4c_86f0_0a11bfdbd51b_4cc52c1263_998949939e',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 33.51,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_00f4f06c_64c7_4c4c_86f0_0a11bfdbd51b_4cc52c1263_998949939e.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_00f4f06c_64c7_4c4c_86f0_0a11bfdbd51b_4cc52c1263.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_00f4f06c_64c7_4c4c_86f0_0a11bfdbd51b_4cc52c1263_998949939e',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 18.32,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_00f4f06c_64c7_4c4c_86f0_0a11bfdbd51b_4cc52c1263_998949939e.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:30:39.424Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '6367386f6f10f9001b2ffa25',
            },
          ],
          _id: '636009d451f79b001dee996b',
          name: 'ไวxxxx',
          description: 'ใช้บริการทาสีช่วงโปรโมชันครับ ราคาดีคุ้มราคาครับ ',
          score: 5,
          __v: 0,
          id: '636009d451f79b001dee996b',
        },
        {
          image: [
            {
              _id: '636738926f10f9001b2ffa26',
              name: 'rn_image_picker_lib_temp_22bd0382_f27c_4457_8a89_a873476561c8_4f01b83dbb.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_22bd0382_f27c_4457_8a89_a873476561c8_4f01b83dbb_c9b01745d2',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 28.42,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_22bd0382_f27c_4457_8a89_a873476561c8_4f01b83dbb_c9b01745d2.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_22bd0382_f27c_4457_8a89_a873476561c8_4f01b83dbb.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_22bd0382_f27c_4457_8a89_a873476561c8_4f01b83dbb_c9b01745d2',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.8,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_22bd0382_f27c_4457_8a89_a873476561c8_4f01b83dbb_c9b01745d2.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_22bd0382_f27c_4457_8a89_a873476561c8_4f01b83dbb.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_22bd0382_f27c_4457_8a89_a873476561c8_4f01b83dbb_c9b01745d2',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 26.33,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_22bd0382_f27c_4457_8a89_a873476561c8_4f01b83dbb_c9b01745d2.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_22bd0382_f27c_4457_8a89_a873476561c8_4f01b83dbb.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_22bd0382_f27c_4457_8a89_a873476561c8_4f01b83dbb_c9b01745d2',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 14.46,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_22bd0382_f27c_4457_8a89_a873476561c8_4f01b83dbb_c9b01745d2.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:31:14.711Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636738926f10f9001b2ffa26',
            },
            {
              _id: '636738926f10f9001b2ffa28',
              name: 'rn_image_picker_lib_temp_64736a06_6dac_41f5_b025_05d2ee7e2c74_05492c7331.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_64736a06_6dac_41f5_b025_05d2ee7e2c74_05492c7331_05c8607bb6',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 15.43,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_64736a06_6dac_41f5_b025_05d2ee7e2c74_05492c7331_05c8607bb6.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_64736a06_6dac_41f5_b025_05d2ee7e2c74_05492c7331.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_64736a06_6dac_41f5_b025_05d2ee7e2c74_05492c7331_05c8607bb6',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 1.94,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_64736a06_6dac_41f5_b025_05d2ee7e2c74_05492c7331_05c8607bb6.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_64736a06_6dac_41f5_b025_05d2ee7e2c74_05492c7331.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_64736a06_6dac_41f5_b025_05d2ee7e2c74_05492c7331_05c8607bb6',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 14.83,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_64736a06_6dac_41f5_b025_05d2ee7e2c74_05492c7331_05c8607bb6.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_64736a06_6dac_41f5_b025_05d2ee7e2c74_05492c7331.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_64736a06_6dac_41f5_b025_05d2ee7e2c74_05492c7331_05c8607bb6',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 8.41,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_64736a06_6dac_41f5_b025_05d2ee7e2c74_05492c7331_05c8607bb6.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:31:14.741Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636738926f10f9001b2ffa28',
            },
          ],
          _id: '636009d451f79b001dee996c',
          name: 'วิมลxxxx',
          description: 'เจอที่นี่จากโฆษณาค่ะ เลยลองใช้บริการดู ให้บริการดีนะคะ ',
          score: 4,
          __v: 0,
          id: '636009d451f79b001dee996c',
        },
        {
          image: [
            {
              _id: '636738ad6f10f9001b2ffa29',
              name: 'rn_image_picker_lib_temp_d246a0f2_926b_47a8_8b1e_f7a77e89f7f6_428be45ebb.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_d246a0f2_926b_47a8_8b1e_f7a77e89f7f6_428be45ebb_e781400f86',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 26.32,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_d246a0f2_926b_47a8_8b1e_f7a77e89f7f6_428be45ebb_e781400f86.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_d246a0f2_926b_47a8_8b1e_f7a77e89f7f6_428be45ebb.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_d246a0f2_926b_47a8_8b1e_f7a77e89f7f6_428be45ebb_e781400f86',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.69,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_d246a0f2_926b_47a8_8b1e_f7a77e89f7f6_428be45ebb_e781400f86.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_d246a0f2_926b_47a8_8b1e_f7a77e89f7f6_428be45ebb.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_d246a0f2_926b_47a8_8b1e_f7a77e89f7f6_428be45ebb_e781400f86',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 24.48,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_d246a0f2_926b_47a8_8b1e_f7a77e89f7f6_428be45ebb_e781400f86.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_d246a0f2_926b_47a8_8b1e_f7a77e89f7f6_428be45ebb.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_d246a0f2_926b_47a8_8b1e_f7a77e89f7f6_428be45ebb_e781400f86',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 13.61,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_d246a0f2_926b_47a8_8b1e_f7a77e89f7f6_428be45ebb_e781400f86.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:31:41.781Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636738ad6f10f9001b2ffa29',
            },
            {
              _id: '636738ad6f10f9001b2ffa2a',
              name: 'rn_image_picker_lib_temp_f8402e40_7d9b_46f0_bfa7_763d5ba42ac2_8dd2e0acff.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_f8402e40_7d9b_46f0_bfa7_763d5ba42ac2_8dd2e0acff_b046903ddf',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 34.88,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_f8402e40_7d9b_46f0_bfa7_763d5ba42ac2_8dd2e0acff_b046903ddf.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_f8402e40_7d9b_46f0_bfa7_763d5ba42ac2_8dd2e0acff.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_f8402e40_7d9b_46f0_bfa7_763d5ba42ac2_8dd2e0acff_b046903ddf',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.94,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_f8402e40_7d9b_46f0_bfa7_763d5ba42ac2_8dd2e0acff_b046903ddf.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_f8402e40_7d9b_46f0_bfa7_763d5ba42ac2_8dd2e0acff.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_f8402e40_7d9b_46f0_bfa7_763d5ba42ac2_8dd2e0acff_b046903ddf',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 32.41,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_f8402e40_7d9b_46f0_bfa7_763d5ba42ac2_8dd2e0acff_b046903ddf.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_f8402e40_7d9b_46f0_bfa7_763d5ba42ac2_8dd2e0acff.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_f8402e40_7d9b_46f0_bfa7_763d5ba42ac2_8dd2e0acff_b046903ddf',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 16.81,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_f8402e40_7d9b_46f0_bfa7_763d5ba42ac2_8dd2e0acff_b046903ddf.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:31:41.851Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636738ad6f10f9001b2ffa2a',
            },
          ],
          _id: '636009d451f79b001dee996d',
          name: 'รชาxxxxx',
          description:
            'สีผนังภายในบอกลอกล่อน เลยต้องการทาสีภายในบ้านใหม่ทั้งหมด เรียกช่างจาก 24 FIX เข้ามาช่วยจัดการแก้ไขปัญหางานผนังให้ ช่างแก้ไขงานค่อนข้างเรียบร้อยครับ ',
          score: 4,
          __v: 0,
          id: '636009d451f79b001dee996d',
        },
        {
          image: [
            {
              _id: '636738e66f10f9001b2ffa2d',
              name: 'rn_image_picker_lib_temp_c3799da1_08b1_4db4_8e46_70a24dd3d0cd_5524ea24e4.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_c3799da1_08b1_4db4_8e46_70a24dd3d0cd_5524ea24e4_55ca76ea34',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 13.99,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_c3799da1_08b1_4db4_8e46_70a24dd3d0cd_5524ea24e4_55ca76ea34.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_c3799da1_08b1_4db4_8e46_70a24dd3d0cd_5524ea24e4.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_c3799da1_08b1_4db4_8e46_70a24dd3d0cd_5524ea24e4_55ca76ea34',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 1.71,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_c3799da1_08b1_4db4_8e46_70a24dd3d0cd_5524ea24e4_55ca76ea34.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_c3799da1_08b1_4db4_8e46_70a24dd3d0cd_5524ea24e4.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_c3799da1_08b1_4db4_8e46_70a24dd3d0cd_5524ea24e4_55ca76ea34',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 13.43,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_c3799da1_08b1_4db4_8e46_70a24dd3d0cd_5524ea24e4_55ca76ea34.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_c3799da1_08b1_4db4_8e46_70a24dd3d0cd_5524ea24e4.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_c3799da1_08b1_4db4_8e46_70a24dd3d0cd_5524ea24e4_55ca76ea34',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 7.39,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_c3799da1_08b1_4db4_8e46_70a24dd3d0cd_5524ea24e4_55ca76ea34.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:32:38.856Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636738e66f10f9001b2ffa2d',
            },
            {
              _id: '636738e66f10f9001b2ffa2e',
              name: 'rn_image_picker_lib_temp_9e04bf08_c561_4319_b792_c5e97253cfb5_4e2146e0a1.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_9e04bf08_c561_4319_b792_c5e97253cfb5_4e2146e0a1_1bd90f0905',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 34.97,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_9e04bf08_c561_4319_b792_c5e97253cfb5_4e2146e0a1_1bd90f0905.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_9e04bf08_c561_4319_b792_c5e97253cfb5_4e2146e0a1.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_9e04bf08_c561_4319_b792_c5e97253cfb5_4e2146e0a1_1bd90f0905',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.39,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_9e04bf08_c561_4319_b792_c5e97253cfb5_4e2146e0a1_1bd90f0905.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_9e04bf08_c561_4319_b792_c5e97253cfb5_4e2146e0a1.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_9e04bf08_c561_4319_b792_c5e97253cfb5_4e2146e0a1_1bd90f0905',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 32.46,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_9e04bf08_c561_4319_b792_c5e97253cfb5_4e2146e0a1_1bd90f0905.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_9e04bf08_c561_4319_b792_c5e97253cfb5_4e2146e0a1.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_9e04bf08_c561_4319_b792_c5e97253cfb5_4e2146e0a1_1bd90f0905',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 17.56,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_9e04bf08_c561_4319_b792_c5e97253cfb5_4e2146e0a1_1bd90f0905.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:32:38.881Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636738e66f10f9001b2ffa2e',
            },
          ],
          _id: '636009d451f79b001dee996f',
          name: 'เตxxxxx',
          description:
            'ใช้บริการทาสีภายในบริเวณฝ้าและผนังจากที่นี่ ช่างทำงานรวดเร็ว สะอาด มีมารยาทครับ',
          score: 4,
          __v: 0,
          id: '636009d451f79b001dee996f',
        },
      ],
      __v: 1,
      id: '636009d451f79b001dee9965',
    },
    ctaSection: {
      _id: '6367dd446f10f9001b2ffebd',
      title: '<p>ผู้นำด้านการทาสีบ้าน เนียนสวยทุกมุมมอง</p>',
      button: {
        _id: '6367dd446f10f9001b2ffebe',
        url: 'https://fix.24x.co.th/color/booking',
        title: 'จองบริการ',
        __v: 0,
        id: '6367dd446f10f9001b2ffebe',
      },
      __v: 1,
      id: '6367dd446f10f9001b2ffebd',
    },
    createdAt: '2022-10-31T17:45:56.146Z',
    updatedAt: '2023-01-11T09:53:03.742Z',
    __v: 1,
    metadata: {
      twitterCardType: 'summary',
      _id: '63bd0781c37f54001cf15d18',
      metaTitle: 'ผู้นำด้านการทาสีบ้าน',
      metaDescription:
        'บริการทาสีภายในบ้านและภายนอกบ้านเนียนสวยอย่างมืออาชีพได้สีตรงใจ เพื่อมอบสีสันสดใสให้บ้านคุณเนียนสวยทุกมุมมอง',
      keywords: 'ทาสี, ช่างทาสี, ทาสี ห้อง นอนสี ทา ห้อง นอน, ทาสี บ้าน, ทาสี ห้อง, ช่างทาสี',
      __v: 0,
      id: '63bd0781c37f54001cf15d18',
    },
    installationSection: null,
    id: '636009d451f79b001dee9964',
  },
  {
    _id: '63600d37b87e30001c208b6d',
    published_at: '2022-11-07T11:58:01.341Z',
    slug: 'ceiling',
    bannerSection: {
      _id: '6367df986f10f9001b2fff15',
      title: '<p><strong>จบทุกปัญหาฝ้ารั่ว เพดานน้ำซึม</strong></p>',
      button: {
        _id: '6367df986f10f9001b2fff16',
        title: 'จองบริการ',
        url: 'https://fix.24x.co.th/ceiling/booking',
        __v: 0,
        id: '6367df986f10f9001b2fff16',
      },
      __v: 1,
      image: {
        _id: '6367df2c6f10f9001b2fff12',
        name: '24FIX_LD_BANNER-11.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_11_4ebfad3979',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 395.15,
        width: 6001,
        height: 2634,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_11_4ebfad3979.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER-11.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_11_4ebfad3979',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 108,
            size: 3.43,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_11_4ebfad3979.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER-11.jpg',
            hash: 'large_24_FIX_LD_BANNER_11_4ebfad3979',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 439,
            size: 23.94,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_11_4ebfad3979.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER-11.jpg',
            hash: 'medium_24_FIX_LD_BANNER_11_4ebfad3979',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 329,
            size: 15.1,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_11_4ebfad3979.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER-11.jpg',
            hash: 'small_24_FIX_LD_BANNER_11_4ebfad3979',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 219,
            size: 8.63,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_11_4ebfad3979.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-11-06T16:22:04.903Z',
        updatedAt: '2022-11-06T16:42:58.599Z',
        __v: 0,
        id: '6367df2c6f10f9001b2fff12',
      },
      mobileImage: {
        _id: '6367df446f10f9001b2fff13',
        name: '24FIX_LD_BANNER_MOBILE-11.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_MOBILE_11_081f8c4db1',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 58.59,
        width: 1501,
        height: 930,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_MOBILE_11_081f8c4db1.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER_MOBILE-11.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_MOBILE_11_081f8c4db1',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 152,
            size: 4.05,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_MOBILE_11_081f8c4db1.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER_MOBILE-11.jpg',
            hash: 'large_24_FIX_LD_BANNER_MOBILE_11_081f8c4db1',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 620,
            size: 31.47,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_MOBILE_11_081f8c4db1.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER_MOBILE-11.jpg',
            hash: 'medium_24_FIX_LD_BANNER_MOBILE_11_081f8c4db1',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 465,
            size: 19.49,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_MOBILE_11_081f8c4db1.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER_MOBILE-11.jpg',
            hash: 'small_24_FIX_LD_BANNER_MOBILE_11_081f8c4db1',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 310,
            size: 11.12,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_MOBILE_11_081f8c4db1.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-11-06T16:22:28.219Z',
        updatedAt: '2022-11-06T16:42:58.599Z',
        __v: 0,
        id: '6367df446f10f9001b2fff13',
      },
      id: '6367df986f10f9001b2fff15',
    },
    uspSection: [
      {
        _id: '6367df986f10f9001b2fff1b',
        title: 'จบทุกปัญหาฝ้ารั่ว เพดานน้ำซึม',
        subTitle:
          'ซ่อมฝ้ารั่ว เพดานน้ำซึมได้ตรงจุด หายจริง งานสวยเนี๊ยบเหมือนได้ฝ้าใหม่ คุมงบจบง่ายไม่บานปลาย ด้วยช่างมากประสบการณ์ที่พร้อมบริการคุณถึงบ้าน',
        description:
          '<p><strong>ทำไมต้องจองกับ 24FIX?</strong></p><ul><li>รับประกันงานซ่อมสูงสุด 60 วัน</li><li>ทีมช่างเข้าตรวจหน้างานก่อนให้บริการภายใน 4&nbsp;วัน</li><li>ราคางานซ่อมที่ได้มาตรฐาน คุ้มค่ากับคุณภาพบริการ</li></ul>',
        __v: 0,
        image: {
          _id: '6367df806f10f9001b2fff14',
          name: 'Service_Desktop-06.jpg',
          alternativeText: '',
          caption: '',
          hash: 'Service_Desktop_06_23e2d912bf',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 111.84,
          width: 2121,
          height: 1426,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/Service_Desktop_06_23e2d912bf.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_Service_Desktop-06.jpg',
              hash: 'thumbnail_Service_Desktop_06_23e2d912bf',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 232,
              height: 156,
              size: 3.95,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_Service_Desktop_06_23e2d912bf.jpg',
            },
            large: {
              name: 'large_Service_Desktop-06.jpg',
              hash: 'large_Service_Desktop_06_23e2d912bf',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 1000,
              height: 672,
              size: 34.99,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/large_Service_Desktop_06_23e2d912bf.jpg',
            },
            medium: {
              name: 'medium_Service_Desktop-06.jpg',
              hash: 'medium_Service_Desktop_06_23e2d912bf',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 504,
              size: 22.42,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_Service_Desktop_06_23e2d912bf.jpg',
            },
            small: {
              name: 'small_Service_Desktop-06.jpg',
              hash: 'small_Service_Desktop_06_23e2d912bf',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 336,
              size: 11.76,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_Service_Desktop_06_23e2d912bf.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-11-06T16:23:28.507Z',
          updatedAt: '2022-11-06T16:42:58.599Z',
          __v: 0,
          id: '6367df806f10f9001b2fff14',
        },
        id: '6367df986f10f9001b2fff1b',
      },
    ],
    faqSection: [
      {
        _id: '636151cdb87e30001c208d38',
        question: 'ทำไมต้องมีการสำรวจหน้างานไหม',
        answer:
          '<p>ไม่จำเป็น ถ้าลูกค้าทราบขนาดพื้นที่ของประตูแล้ว จะมีแค่บริการติดตั้งประตูที่ต้องมีการสำรวจหน้างานเบื้องต้น เพื่อวัดพื้นที่ก่อนเริ่มงานจริง</p>',
        __v: 0,
        id: '636151cdb87e30001c208d38',
      },
      {
        _id: '636151cdb87e30001c208d39',
        question: 'ค่าใช้จ่ายในการสำรวจ นำมาเป็นส่วนลดได้ไหม',
        answer: '<p>ค่าสำรวจสามารถนำไปลดได้ต่อเมื่อยอดงานบริการ มากกว่า 3,000 บาทขึ้นไป</p>',
        __v: 0,
        id: '636151cdb87e30001c208d39',
      },
      {
        _id: '636151cdb87e30001c208d3a',
        answer:
          '<p>ปัจจัยที่มีผลต่อราคาค่าบริการ มีดังนี้ครับ</p><ul><li>ขนาดพื้นที่ในการซ่อมแซม</li><li>ประเภทฝ้า (ฝ้าฉาบเรียบ, ฝ้าทีบาร์)</li></ul>',
        question: 'ปัจจัยที่มีผลต่อราคาค่าบริการ',
        __v: 0,
        id: '636151cdb87e30001c208d3a',
      },
      {
        _id: '636151cdb87e30001c208d3b',
        question: 'มีการรับประกันอย่างไร',
        answer:
          '<p>การรับประกันผลงาน 60 วัน หลังจากการให้บริการ ทางบริษัทจะรับประกันผลงานที่เกิดจากการติดตั้ง (หลุดร่วงหรือบิดเบี้ยว) ตามขอบเขตการให้บริการในเอกสารเสนอราคาเท่านั้น</p>',
        __v: 0,
        id: '636151cdb87e30001c208d3b',
      },
      {
        _id: '636151cdb87e30001c208d3c',
        question: 'พื้นที่ที่ให้บริการมีอะไรบ้าง',
        answer: '<p>พื้นที่ให้บริการครอบคลุมในเขตกรุงเทพมหานคร นนทบุรี ปทุมธานี และสมุทรปราการ</p>',
        __v: 0,
        id: '636151cdb87e30001c208d3c',
      },
      {
        _id: '636151cdb87e30001c208d3d',
        question: 'งานฝ้ามีบริการส่วนใดบ้าง',
        answer: '<ul><li>ขัดทาสีฝ้า</li><li>ซ่อมแซมฝ้าน้ำรั่ว</li><li>เปลี่ยนฝ้า</li></ul>',
        __v: 0,
        id: '636151cdb87e30001c208d3d',
      },
      {
        _id: '636151cdb87e30001c208d3e',
        answer:
          '<p>คิวช่างเข้าสำรวจหน้างานภายใน 2-3 วัน หลังอนุมัติงานสำรวจ และ 4 วันนับจากวันที่ลูกค้าชำระค่าบริการ</p>',
        question: 'คิวเรียกช่างเร็วสุดเมื่อไหร่',
        __v: 0,
        id: '636151cdb87e30001c208d3e',
      },
      {
        _id: '636151cdb87e30001c208d3f',
        answer:
          '<ul><li>ลูกค้าสามารถติดตามสถานะงานผ่านทางเว็บไซต์ได้ตลอดเวลา</li><li>สามารถใช้โค้ดส่วนลดสำหรับลูกค้าที่ซื้อผ่านบนเว็บไซต์อีกด้วย</li><li>สามารถจองวันและเวลาเข้ารับบริการด้วยตนเอง"</li></ul>',
        question: 'เรียกบริการผ่านเว็บไซต์ดีอย่างไร',
        __v: 0,
        id: '636151cdb87e30001c208d3f',
      },
      {
        _id: '636151cdb87e30001c208d40',
        question: 'ใบเสนอราคาจะได้เมื่อไหร่ หลังจากที่ช่างเข้าสำรวจหน้างานเรียบร้อยแล้ว',
        answer:
          '<p>ใบเสนอราคาจะถูกส่งให้ลูกค้าตรวจสอบ ภายใน 24 ชม. หลังจากวันที่ช่างเข้าตรวจหน้างาน</p>',
        __v: 0,
        id: '636151cdb87e30001c208d40',
      },
      {
        _id: '636151cdb87e30001c208d41',
        question: 'ราคาค่าบริการรวมอะไรบ้าง',
        answer: '<p>รวมค่าฝ้าและค่าแรงทั้งหมดแล้ว</p>',
        __v: 0,
        id: '636151cdb87e30001c208d41',
      },
    ],
    promotionSection: {
      _id: '636745326f10f9001b2ffc84',
      title: 'โปรโมชั่น',
      promotions: [
        {
          _id: '636745326f10f9001b2ffc85',
          url: 'https://fix.24x.co.th/voucher/firstfix-1',
          __v: 0,
          image: {
            _id: '637614b137fd76001b532030',
            name: '24FIX_NOV_BANNER4-02 (1).jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 94.2,
            width: 1500,
            height: 490,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 245,
                height: 80,
                size: 6.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              large: {
                name: 'large_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 327,
                size: 50.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              medium: {
                name: 'medium_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 245,
                size: 32.89,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              small: {
                name: 'small_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 163,
                size: 18.03,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
            },
            provider: 'aws-s3',
            related: ['636a17dc1e519e001c14731c'],
            createdAt: '2022-11-17T11:02:09.052Z',
            updatedAt: '2022-11-21T05:30:58.272Z',
            __v: 0,
            id: '637614b137fd76001b532030',
          },
          mobileImage: {
            _id: '636a6d86e6895d001ce68cc3',
            name: '24FIX_NOV_BANNER1-01.jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_1_01_3663796871',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 149.63,
            width: 1500,
            height: 1021,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_1_01_3663796871.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24FIX_NOV_BANNER1-01.jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 229,
                height: 156,
                size: 8.94,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              large: {
                name: 'large_24FIX_NOV_BANNER1-01.jpg',
                hash: 'large_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 681,
                size: 78.97,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              medium: {
                name: 'medium_24FIX_NOV_BANNER1-01.jpg',
                hash: 'medium_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 511,
                size: 51.21,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              small: {
                name: 'small_24FIX_NOV_BANNER1-01.jpg',
                hash: 'small_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 340,
                size: 27.91,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
            },
            provider: 'aws-s3',
            related: [],
            createdAt: '2022-11-08T14:53:58.508Z',
            updatedAt: '2022-11-08T16:06:16.745Z',
            __v: 0,
            id: '636a6d86e6895d001ce68cc3',
          },
          id: '636745326f10f9001b2ffc85',
        },
      ],
      __v: 1,
      button: null,
      id: '636745326f10f9001b2ffc84',
    },
    stepSection: null,
    successStorySection: {
      contents: [
        {
          relatedArticles: [],
          categories: [
            '60d1fe825749bf001bbb11e4',
            '62a76933e9dde5001b3c6b15',
            '62de67ecb31a7a001bba2d60',
          ],
          _id: '60fef2feea7297001be8c5f3',
          title: 'รีวิวผลงานจริง ล้างแอร์บ้านคุณเมย์ รัชนก อินทนนท์',
          slug: 'pro-may-onsite-review',
          shortDescription:
            'เพราะประเทศไทยมีแต่ฤดูร้อน ร้อนมาก และร้อนที่สุด! ดังนั้นการดูแล ทำความสะอาด ล้างแอร์ ก็ควรทำอย่างสม่ำเสมอนะ\n#งานล้างแอร์ #ล้างแอร์ฆ่าเชื้อ #เมย์ รัชนก อินทนนท์ #แอร์ไม่เย็น #ตรวจสภาพแอร์ #ล้างแอร์ #ซ่อมแอร์ ',
          views: 3549,
          published_at: '2021-07-26T17:38:13.448Z',
          contents: [
            {
              __component: 'article.content',
              id: '60fef2feea7297001be8c5f4',
            },
            {
              __component: 'article.images',
              id: '60fef2feea7297001be8c5f5',
            },
            {
              __component: 'article.content',
              id: '60fef2feea7297001be8c5f6',
            },
            {
              __component: 'article.images',
              id: '60fef2feea7297001be8c5f7',
            },
            {
              __component: 'article.content',
              id: '62cd0500df69b2001b4a8f1a',
            },
            {
              __component: 'article.images',
              id: '62cd0687df69b2001b4a8f39',
            },
            {
              __component: 'article.content',
              id: '62cd0687df69b2001b4a8f3a',
            },
            {
              __component: 'article.images',
              id: '62cd0687df69b2001b4a8f3b',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fbc',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fbd',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fbe',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fbf',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc0',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc1',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc2',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc3',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc4',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc5',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc6',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc7',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc8',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc9',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fca',
            },
          ],
          link: null,
          createdAt: '2021-07-26T17:38:06.604Z',
          updatedAt: '2022-07-25T10:08:01.825Z',
          __v: 2,
          coverImage: {
            _id: '60feef59ea7297001be8c5ed',
            name: '20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
            alternativeText: '',
            caption: '',
            hash: '20210510_On_site_Review_Artboard_v2_e9212db564',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 657.65,
            width: 2501,
            height: 1667,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'thumbnail_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 12.97,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              large: {
                name: 'large_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'large_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 1000,
                height: 667,
                size: 146.8,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              medium: {
                name: 'medium_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'medium_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 750,
                height: 500,
                size: 92.52,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              small: {
                name: 'small_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'small_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 46.42,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['60fef2feea7297001be8c5f3'],
            createdAt: '2021-07-26T17:22:33.885Z',
            updatedAt: '2021-07-30T03:43:47.943Z',
            __v: 0,
            id: '60feef59ea7297001be8c5ed',
          },
          metadata: null,
          id: '60fef2feea7297001be8c5f3',
        },
        {
          relatedArticles: ['60fef2feea7297001be8c5f3', '62cd8d63df69b2001b4a9b5c'],
          categories: [
            '62a76933e9dde5001b3c6b15',
            '60d1fe825749bf001bbb11e4',
            '62de67ecb31a7a001bba2d60',
          ],
          _id: '62cda1d7df69b2001b4a9c2a',
          published_at: '2022-07-12T16:36:03.404Z',
          slug: '911-assistant-rama-ix-porsche-service',
          shortDescription:
            'คุณลูกค้าได้ติดต่อให้ช่างอุ่นใจเข้ามาตรวจสอบปัญหาชักโครกมีกลิ่นเเละน้ำรั่วซึม ซึ่งช่างอุ่นใจได้รับโจทย์ในงานซ่อมแบ่งเป็น 2 ส่วนได้แก่ การซ่อมโถชักโครกและโถปัสสาวะชาย\n#งานเปลี่ยนสุขภัณฑ์ #รีวิว #กลิ่นโถส้วม',
          views: 244,
          title: 'รีวิวผลงานจริง @911 ASSISTANT RAMA IX (Porsche Service)',
          contents: [
            {
              __component: 'article.content',
              id: '62cda1d7df69b2001b4a9c2b',
            },
            {
              __component: 'article.content',
              id: '62cda1d7df69b2001b4a9c2c',
            },
          ],
          link: null,
          createdAt: '2022-07-12T16:31:19.223Z',
          updatedAt: '2022-07-25T10:08:01.825Z',
          __v: 1,
          coverImage: {
            _id: '62cd994fdf69b2001b4a9bbe',
            name: '144302486_851532738754884_6271739837459506095_n (Small).jpg',
            alternativeText: '',
            caption: '',
            hash: '144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 75.25,
            width: 720,
            height: 480,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_144302486_851532738754884_6271739837459506095_n (Small).jpg',
                hash: 'thumbnail_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 11.42,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
              },
              small: {
                name: 'small_144302486_851532738754884_6271739837459506095_n (Small).jpg',
                hash: 'small_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 40.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
              },
            },
            provider: 'aws-s3',
            related: ['62cda1d7df69b2001b4a9c2a'],
            createdAt: '2022-07-12T15:54:55.834Z',
            updatedAt: '2022-07-12T16:31:19.369Z',
            __v: 0,
            id: '62cd994fdf69b2001b4a9bbe',
          },
          metadata: null,
          id: '62cda1d7df69b2001b4a9c2a',
        },
        {
          relatedArticles: ['60fef2feea7297001be8c5f3'],
          categories: ['60d1fe825749bf001bbb11e4', '62a76933e9dde5001b3c6b15'],
          _id: '60fef555ea7297001be8c617',
          published_at: '2021-07-26T17:58:58.311Z',
          slug: 'ac-with-installation',
          shortDescription:
            '#ซื้อแอร์วันนี้แถมฟรีติดตั้ง\n\n☀ ถ้าจะบอกว่าเมืองไทย ‘อากาศร้อน’ เฉพาะในช่วงหน้าร้อนก็คงจะไม่ถูก เพราะไม่ว่าฤดูไหนๆ จะร้อน หนาว ฝน อากาศก็ร้อนอยู่ดี!\nวันนี้มาดับร้อนกันดีกว่า ❄ ด้วยบริการซื้อแอร์พร้อมติดตั้งฟรี โดยทีมช่างมืออาชีพ 24 FIX 😊',
          title: 'บริการซื้อแอร์พร้อมติดตั้ง',
          contents: [
            {
              __component: 'article.content',
              id: '60fef7daea7297001be8c649',
            },
            {
              __component: 'article.images',
              id: '60fef7daea7297001be8c64a',
            },
          ],
          link: null,
          createdAt: '2021-07-26T17:48:05.531Z',
          updatedAt: '2022-07-13T05:50:55.237Z',
          __v: 0,
          views: 1124,
          coverImage: {
            _id: '60fef76eea7297001be8c634',
            name: '117956473_738009603440532_2359157732673622296_n.jpeg',
            alternativeText: '',
            caption: '',
            hash: '117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 253.58,
            width: 1801,
            height: 1201,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'thumbnail_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 8.33,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              large: {
                name: 'large_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'large_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 1000,
                height: 667,
                size: 83.31,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              medium: {
                name: 'medium_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'medium_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 750,
                height: 500,
                size: 50.16,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              small: {
                name: 'small_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'small_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 26.25,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['60fef555ea7297001be8c617'],
            createdAt: '2021-07-26T17:57:02.195Z',
            updatedAt: '2021-07-30T03:43:47.943Z',
            __v: 0,
            id: '60fef76eea7297001be8c634',
          },
          metadata: null,
          id: '60fef555ea7297001be8c617',
        },
      ],
      _id: '6368f2bb1e519e001c14705b',
      title: 'ผลงานของเรา',
      __v: 0,
      button: null,
      id: '6368f2bb1e519e001c14705b',
    },
    reviewSection: {
      _id: '63600d37b87e30001c208b6e',
      title: 'รีวิวจากผู้ใช้บริการของเรา',
      reviewContent: [
        {
          image: [
            {
              _id: '63673b226f10f9001b2ffa91',
              name: 'rn_image_picker_lib_temp_7b0b690b_719c_44ec_a1dc_690e0b25b99e_dda01261d1.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_7b0b690b_719c_44ec_a1dc_690e0b25b99e_dda01261d1_07a17fd1b9',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 38.93,
              width: 800,
              height: 600,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_7b0b690b_719c_44ec_a1dc_690e0b25b99e_dda01261d1_07a17fd1b9.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_7b0b690b_719c_44ec_a1dc_690e0b25b99e_dda01261d1.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_7b0b690b_719c_44ec_a1dc_690e0b25b99e_dda01261d1_07a17fd1b9',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 208,
                  height: 156,
                  size: 5.32,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_7b0b690b_719c_44ec_a1dc_690e0b25b99e_dda01261d1_07a17fd1b9.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_7b0b690b_719c_44ec_a1dc_690e0b25b99e_dda01261d1.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_7b0b690b_719c_44ec_a1dc_690e0b25b99e_dda01261d1_07a17fd1b9',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 563,
                  size: 35.83,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_7b0b690b_719c_44ec_a1dc_690e0b25b99e_dda01261d1_07a17fd1b9.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_7b0b690b_719c_44ec_a1dc_690e0b25b99e_dda01261d1.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_7b0b690b_719c_44ec_a1dc_690e0b25b99e_dda01261d1_07a17fd1b9',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 500,
                  height: 375,
                  size: 19.02,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_7b0b690b_719c_44ec_a1dc_690e0b25b99e_dda01261d1_07a17fd1b9.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:42:10.297Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673b226f10f9001b2ffa91',
            },
            {
              _id: '63673b226f10f9001b2ffa92',
              name: 'rn_image_picker_lib_temp_7265ee9f_07e7_4bc4_b004_1106dc5ffd9a_9482cdcd2a.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_7265ee9f_07e7_4bc4_b004_1106dc5ffd9a_9482cdcd2a_cd24090c7f',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 43.62,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_7265ee9f_07e7_4bc4_b004_1106dc5ffd9a_9482cdcd2a_cd24090c7f.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_7265ee9f_07e7_4bc4_b004_1106dc5ffd9a_9482cdcd2a.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_7265ee9f_07e7_4bc4_b004_1106dc5ffd9a_9482cdcd2a_cd24090c7f',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 4.5,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_7265ee9f_07e7_4bc4_b004_1106dc5ffd9a_9482cdcd2a_cd24090c7f.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_7265ee9f_07e7_4bc4_b004_1106dc5ffd9a_9482cdcd2a.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_7265ee9f_07e7_4bc4_b004_1106dc5ffd9a_9482cdcd2a_cd24090c7f',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 40.82,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_7265ee9f_07e7_4bc4_b004_1106dc5ffd9a_9482cdcd2a_cd24090c7f.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_7265ee9f_07e7_4bc4_b004_1106dc5ffd9a_9482cdcd2a.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_7265ee9f_07e7_4bc4_b004_1106dc5ffd9a_9482cdcd2a_cd24090c7f',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 23.08,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_7265ee9f_07e7_4bc4_b004_1106dc5ffd9a_9482cdcd2a_cd24090c7f.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:42:10.324Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673b226f10f9001b2ffa92',
            },
          ],
          _id: '63600d37b87e30001c208b76',
          name: 'ก้องxxxx',
          description: 'เจ้าหน้าที่ให้คำปรึกษาดี มีความเชี่ยวชาญและเข้าใจงานซ่อมครับ',
          score: 4,
          __v: 0,
          id: '63600d37b87e30001c208b76',
        },
        {
          image: [
            {
              _id: '63673b426f10f9001b2ffa93',
              name: 'rn_image_picker_lib_temp_1683fc74_dea6_4517_9b7f_b1e1cbf69d6d_02b39627fd.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_1683fc74_dea6_4517_9b7f_b1e1cbf69d6d_02b39627fd_daa519d12f',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 49.16,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_1683fc74_dea6_4517_9b7f_b1e1cbf69d6d_02b39627fd_daa519d12f.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_1683fc74_dea6_4517_9b7f_b1e1cbf69d6d_02b39627fd.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_1683fc74_dea6_4517_9b7f_b1e1cbf69d6d_02b39627fd_daa519d12f',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.07,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_1683fc74_dea6_4517_9b7f_b1e1cbf69d6d_02b39627fd_daa519d12f.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_1683fc74_dea6_4517_9b7f_b1e1cbf69d6d_02b39627fd.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_1683fc74_dea6_4517_9b7f_b1e1cbf69d6d_02b39627fd_daa519d12f',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 43.53,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_1683fc74_dea6_4517_9b7f_b1e1cbf69d6d_02b39627fd_daa519d12f.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_1683fc74_dea6_4517_9b7f_b1e1cbf69d6d_02b39627fd.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_1683fc74_dea6_4517_9b7f_b1e1cbf69d6d_02b39627fd_daa519d12f',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 20.23,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_1683fc74_dea6_4517_9b7f_b1e1cbf69d6d_02b39627fd_daa519d12f.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:42:42.172Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673b426f10f9001b2ffa93',
            },
            {
              _id: '63673b426f10f9001b2ffa94',
              name: 'rn_image_picker_lib_temp_7d021897_decd_4506_9f57_e76229d70055_998d6c65a9.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_7d021897_decd_4506_9f57_e76229d70055_998d6c65a9_df2dd25a52',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 63.61,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_7d021897_decd_4506_9f57_e76229d70055_998d6c65a9_df2dd25a52.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_7d021897_decd_4506_9f57_e76229d70055_998d6c65a9.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_7d021897_decd_4506_9f57_e76229d70055_998d6c65a9_df2dd25a52',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 4.39,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_7d021897_decd_4506_9f57_e76229d70055_998d6c65a9_df2dd25a52.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_7d021897_decd_4506_9f57_e76229d70055_998d6c65a9.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_7d021897_decd_4506_9f57_e76229d70055_998d6c65a9_df2dd25a52',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 56.4,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_7d021897_decd_4506_9f57_e76229d70055_998d6c65a9_df2dd25a52.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_7d021897_decd_4506_9f57_e76229d70055_998d6c65a9.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_7d021897_decd_4506_9f57_e76229d70055_998d6c65a9_df2dd25a52',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 26.78,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_7d021897_decd_4506_9f57_e76229d70055_998d6c65a9_df2dd25a52.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:42:42.293Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673b426f10f9001b2ffa94',
            },
          ],
          _id: '63600d37b87e30001c208b77',
          name: 'อรรถxxxx',
          description: 'ช่างเปลี่ยนฝ้าที่บ้านใหม่ทำงานโอเค เก็บงานเรียบร้อยดีครับ',
          score: 5,
          __v: 0,
          id: '63600d37b87e30001c208b77',
        },
        {
          image: [
            {
              _id: '63673ae06f10f9001b2ffa8e',
              name: 'a5cb6f92_289f_4caf_b096_6990cc2e5517_5762790d68.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'a5cb6f92_289f_4caf_b096_6990cc2e5517_5762790d68_28af239dcc',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 48.59,
              width: 1108,
              height: 1477,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/a5cb6f92_289f_4caf_b096_6990cc2e5517_5762790d68_28af239dcc.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_a5cb6f92_289f_4caf_b096_6990cc2e5517_5762790d68.jpeg',
                  hash: 'thumbnail_a5cb6f92_289f_4caf_b096_6990cc2e5517_5762790d68_28af239dcc',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 8.89,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_a5cb6f92_289f_4caf_b096_6990cc2e5517_5762790d68_28af239dcc.jpeg',
                },
                large: {
                  name: 'large_a5cb6f92_289f_4caf_b096_6990cc2e5517_5762790d68.jpeg',
                  hash: 'large_a5cb6f92_289f_4caf_b096_6990cc2e5517_5762790d68_28af239dcc',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 1000,
                  size: 43.79,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_a5cb6f92_289f_4caf_b096_6990cc2e5517_5762790d68_28af239dcc.jpeg',
                },
                medium: {
                  name: 'medium_a5cb6f92_289f_4caf_b096_6990cc2e5517_5762790d68.jpeg',
                  hash: 'medium_a5cb6f92_289f_4caf_b096_6990cc2e5517_5762790d68_28af239dcc',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 29.95,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_a5cb6f92_289f_4caf_b096_6990cc2e5517_5762790d68_28af239dcc.jpeg',
                },
                small: {
                  name: 'small_a5cb6f92_289f_4caf_b096_6990cc2e5517_5762790d68.jpeg',
                  hash: 'small_a5cb6f92_289f_4caf_b096_6990cc2e5517_5762790d68_28af239dcc',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 18.47,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_a5cb6f92_289f_4caf_b096_6990cc2e5517_5762790d68_28af239dcc.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:41:04.815Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673ae06f10f9001b2ffa8e',
            },
            {
              _id: '63673ae06f10f9001b2ffa8f',
              name: '5abc2403_6b64_41e3_a4f0_fbd648088332_92d581f1bc.jpeg',
              alternativeText: '',
              caption: '',
              hash: '5abc2403_6b64_41e3_a4f0_fbd648088332_92d581f1bc_2e85f91946',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 44.52,
              width: 1108,
              height: 1477,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/5abc2403_6b64_41e3_a4f0_fbd648088332_92d581f1bc_2e85f91946.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_5abc2403_6b64_41e3_a4f0_fbd648088332_92d581f1bc.jpeg',
                  hash: 'thumbnail_5abc2403_6b64_41e3_a4f0_fbd648088332_92d581f1bc_2e85f91946',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 9.13,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_5abc2403_6b64_41e3_a4f0_fbd648088332_92d581f1bc_2e85f91946.jpeg',
                },
                large: {
                  name: 'large_5abc2403_6b64_41e3_a4f0_fbd648088332_92d581f1bc.jpeg',
                  hash: 'large_5abc2403_6b64_41e3_a4f0_fbd648088332_92d581f1bc_2e85f91946',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 1000,
                  size: 40.29,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/large_5abc2403_6b64_41e3_a4f0_fbd648088332_92d581f1bc_2e85f91946.jpeg',
                },
                medium: {
                  name: 'medium_5abc2403_6b64_41e3_a4f0_fbd648088332_92d581f1bc.jpeg',
                  hash: 'medium_5abc2403_6b64_41e3_a4f0_fbd648088332_92d581f1bc_2e85f91946',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 28.69,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_5abc2403_6b64_41e3_a4f0_fbd648088332_92d581f1bc_2e85f91946.jpeg',
                },
                small: {
                  name: 'small_5abc2403_6b64_41e3_a4f0_fbd648088332_92d581f1bc.jpeg',
                  hash: 'small_5abc2403_6b64_41e3_a4f0_fbd648088332_92d581f1bc_2e85f91946',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 18.35,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_5abc2403_6b64_41e3_a4f0_fbd648088332_92d581f1bc_2e85f91946.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:41:04.899Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673ae06f10f9001b2ffa8f',
            },
          ],
          _id: '63600d37b87e30001c208b70',
          name: 'ธนxxxxx',
          description:
            'ต้องซ่อมถึง 2 รอบกว่าจะเรียบร้อย แต่ดีครับช่างไม่เกี่ยงงานเข้าใจและแก้ไขให้จนจบงานอย่างราบรื่น ถือว่าโอเคใส่ใจลูกค้าดี',
          score: 3,
          __v: 0,
          id: '63600d37b87e30001c208b70',
        },
        {
          image: [
            {
              _id: '63673ac26f10f9001b2ffa8c',
              name: 'rn_image_picker_lib_temp_fd1870d6_5b8a_4e80_8d49_96ecbb3e4fa7_1d8941b7ae.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_fd1870d6_5b8a_4e80_8d49_96ecbb3e4fa7_1d8941b7ae_2b3143aa52',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 23.99,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_fd1870d6_5b8a_4e80_8d49_96ecbb3e4fa7_1d8941b7ae_2b3143aa52.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_fd1870d6_5b8a_4e80_8d49_96ecbb3e4fa7_1d8941b7ae.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_fd1870d6_5b8a_4e80_8d49_96ecbb3e4fa7_1d8941b7ae_2b3143aa52',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.44,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_fd1870d6_5b8a_4e80_8d49_96ecbb3e4fa7_1d8941b7ae_2b3143aa52.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_fd1870d6_5b8a_4e80_8d49_96ecbb3e4fa7_1d8941b7ae.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_fd1870d6_5b8a_4e80_8d49_96ecbb3e4fa7_1d8941b7ae_2b3143aa52',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 22.4,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_fd1870d6_5b8a_4e80_8d49_96ecbb3e4fa7_1d8941b7ae_2b3143aa52.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_fd1870d6_5b8a_4e80_8d49_96ecbb3e4fa7_1d8941b7ae.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_fd1870d6_5b8a_4e80_8d49_96ecbb3e4fa7_1d8941b7ae_2b3143aa52',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 12.41,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_fd1870d6_5b8a_4e80_8d49_96ecbb3e4fa7_1d8941b7ae_2b3143aa52.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:40:34.391Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673ac26f10f9001b2ffa8c',
            },
            {
              _id: '63673ac26f10f9001b2ffa8d',
              name: 'rn_image_picker_lib_temp_5c6129c6_b14e_4d7d_9dd4_4d19aca6f29a_9012df3acb.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_5c6129c6_b14e_4d7d_9dd4_4d19aca6f29a_9012df3acb_40dd61afbb',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 13.79,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_5c6129c6_b14e_4d7d_9dd4_4d19aca6f29a_9012df3acb_40dd61afbb.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_5c6129c6_b14e_4d7d_9dd4_4d19aca6f29a_9012df3acb.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_5c6129c6_b14e_4d7d_9dd4_4d19aca6f29a_9012df3acb_40dd61afbb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 1.67,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_5c6129c6_b14e_4d7d_9dd4_4d19aca6f29a_9012df3acb_40dd61afbb.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_5c6129c6_b14e_4d7d_9dd4_4d19aca6f29a_9012df3acb.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_5c6129c6_b14e_4d7d_9dd4_4d19aca6f29a_9012df3acb_40dd61afbb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 13.27,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_5c6129c6_b14e_4d7d_9dd4_4d19aca6f29a_9012df3acb_40dd61afbb.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_5c6129c6_b14e_4d7d_9dd4_4d19aca6f29a_9012df3acb.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_5c6129c6_b14e_4d7d_9dd4_4d19aca6f29a_9012df3acb_40dd61afbb',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 7.19,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_5c6129c6_b14e_4d7d_9dd4_4d19aca6f29a_9012df3acb_40dd61afbb.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:40:34.502Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673ac26f10f9001b2ffa8d',
            },
          ],
          _id: '63600d37b87e30001c208b6f',
          name: 'ณรงxxxxx',
          description:
            'เหมือนได้เพดานใหม่หลังจากนอนดูน้ำหยดมา 3 อาทิตย์ ช่างเก่งจริงรอบเดียวหายสวยจบปัญหาเลย',
          score: 5,
          __v: 0,
          id: '63600d37b87e30001c208b6f',
        },
        {
          image: [
            {
              _id: '63673af96f10f9001b2ffa90',
              name: 'CD_04_E34_A_3_B61_4_B34_BC_1_B_979_BEB_0_CB_5_B6_074bcae53c.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'CD_04_E34_A_3_B61_4_B34_BC_1_B_979_BEB_0_CB_5_B6_074bcae53c_9620245fb4',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 41.34,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/CD_04_E34_A_3_B61_4_B34_BC_1_B_979_BEB_0_CB_5_B6_074bcae53c_9620245fb4.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_CD_04_E34_A_3_B61_4_B34_BC_1_B_979_BEB_0_CB_5_B6_074bcae53c.jpeg',
                  hash: 'thumbnail_CD_04_E34_A_3_B61_4_B34_BC_1_B_979_BEB_0_CB_5_B6_074bcae53c_9620245fb4',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.45,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_CD_04_E34_A_3_B61_4_B34_BC_1_B_979_BEB_0_CB_5_B6_074bcae53c_9620245fb4.jpeg',
                },
                medium: {
                  name: 'medium_CD_04_E34_A_3_B61_4_B34_BC_1_B_979_BEB_0_CB_5_B6_074bcae53c.jpeg',
                  hash: 'medium_CD_04_E34_A_3_B61_4_B34_BC_1_B_979_BEB_0_CB_5_B6_074bcae53c_9620245fb4',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 37.93,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_CD_04_E34_A_3_B61_4_B34_BC_1_B_979_BEB_0_CB_5_B6_074bcae53c_9620245fb4.jpeg',
                },
                small: {
                  name: 'small_CD_04_E34_A_3_B61_4_B34_BC_1_B_979_BEB_0_CB_5_B6_074bcae53c.jpeg',
                  hash: 'small_CD_04_E34_A_3_B61_4_B34_BC_1_B_979_BEB_0_CB_5_B6_074bcae53c_9620245fb4',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 20.32,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_CD_04_E34_A_3_B61_4_B34_BC_1_B_979_BEB_0_CB_5_B6_074bcae53c_9620245fb4.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:41:29.364Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '63673af96f10f9001b2ffa90',
            },
          ],
          _id: '63600d37b87e30001c208b71',
          name: 'กฤxxxxx',
          description: 'ช่างทำงานดีมากค่ะ มาเป็นทีมงานเสร็จเร็ว ',
          score: 4,
          __v: 0,
          id: '63600d37b87e30001c208b71',
        },
        {
          image: [],
          _id: '63600d37b87e30001c208b72',
          name: 'ดิษxxxxx',
          description:
            'วันติดต่อประสานงานช้าไปนิด แต่วันช่างมาซ่อมเพดานให้ทำงานค่อนข้างมืออาชีพ ถามอะไรอธิบายได้ชัดเจน',
          score: 4,
          __v: 0,
          id: '63600d37b87e30001c208b72',
        },
        {
          image: [],
          _id: '63600d37b87e30001c208b73',
          name: 'ณภวxxxxx',
          description:
            'ฝ่าขึ้นราตอนแรกคิดว่าต้องเปลี่ยนใหม่หมด แต่ช่างช่วยซ่อมให้เหมือนได้ฝ่าใหม่ ราคาไม่แรงเลิฟมากค่ะ ',
          score: 5,
          __v: 0,
          id: '63600d37b87e30001c208b73',
        },
        {
          image: [],
          _id: '63600d37b87e30001c208b74',
          name: 'ปภัxxxx',
          description:
            'ฝ้าในห้องน้ำที่บ้านรั่วซึมค่ะ น่าจะเกิดจากฝนตกหนัก เลยเรียกช่างจากที่นี่ไปตรวจสอบให้ พบต้นตอของปัญหาที่เกิดจากหลังคาบ้านแตกจนทำให้น้ำรั่วลงมาแล้วซึมลงมาที่ด้านล่างของห้องน้ำค่ะ ช่างให้บริการแก้ไขปัญหาได้ตรงจุด ทำไมตอนนี้หลังคาไม่รั่วแล้วค่ะ ',
          score: 5,
          __v: 0,
          id: '63600d37b87e30001c208b74',
        },
        {
          image: [],
          _id: '63600d37b87e30001c208b75',
          name: 'นงxxxx',
          description: 'ช่างดูมีความเชี่ยวชาญดีค่ะ อุปกรณ์ครบ เข้ามาทำงานหลายคน รวดเร็วดีค่ะ ',
          score: 4,
          __v: 0,
          id: '63600d37b87e30001c208b75',
        },
        {
          image: [],
          _id: '63600d37b87e30001c208b78',
          name: 'อชิรxxxx',
          description:
            'ฝ้าที่บ้านมีน้ำรั่วซึมมาจากด้านบนที่มองไม่เห็น เลยเรียกช่างมาตรวจสอบให้ค่ะ พบว่ามีรอยรั่วจากตัวเชื่อมวัสดุบนแผ่นหลังคา ช่างเลยดำเนินการแก้ไขหลังคาให้ก่อนแล้วเช็กว่ามีน้ำรั่วซึมมาอีกมั้ย หลังจากนั้นจึงดำเนินการทำฝ้าให้ใหม่ค่ะ งานเรียบร้อยดีค่ะ ',
          score: 4,
          __v: 0,
          id: '63600d37b87e30001c208b78',
        },
      ],
      __v: 1,
      id: '63600d37b87e30001c208b6e',
    },
    ctaSection: {
      _id: '6367df996f10f9001b2fff35',
      title: '<p>จบทุกปัญหาฝ้ารั่ว เพดานน้ำซึม</p>',
      button: {
        _id: '6367df996f10f9001b2fff36',
        title: 'จองบริการ',
        url: 'https://fix.24x.co.th/ceiling/booking',
        __v: 0,
        id: '6367df996f10f9001b2fff36',
      },
      __v: 1,
      id: '6367df996f10f9001b2fff35',
    },
    createdAt: '2022-10-31T18:00:23.786Z',
    updatedAt: '2023-01-10T06:42:16.301Z',
    __v: 1,
    metadata: {
      twitterCardType: 'summary',
      _id: '63bd08c8c37f54001cf15d76',
      metaTitle: 'จบทุกปัญหาฝ้ารั่ว เพดานน้ำซึม',
      metaDescription:
        'ซ่อมฝ้ารั่ว เพดานน้ำซึมได้ตรงจุด หายจริง งานสวยเนี๊ยบเหมือนได้ฝ้าใหม่ คุมงบจบง่ายไม่บานปลาย ด้วยช่างมากประสบการณ์ที่พร้อมบริการคุณถึงบ้าน',
      keywords: 'ฝ้ารั่ว, ช่าง, น้ำซึมเพดาน, ช่างฝ้า, ซ่อมฝ้ารั่ว',
      __v: 0,
      id: '63bd08c8c37f54001cf15d76',
    },
    installationSection: null,
    id: '63600d37b87e30001c208b6d',
  },
  {
    _id: '6360094551f79b001dee994d',
    published_at: '2022-11-07T11:49:02.468Z',
    slug: 'roof',
    bannerSection: {
      _id: '6367dcbe6f10f9001b2ffe72',
      title: '<p><strong>จบทุกปัญหาหลังคา ด้วยทีมช่างหลังคามากประสบการณ์&nbsp;</strong></p>',
      button: {
        _id: '6367dcbe6f10f9001b2ffe73',
        title: 'จองบริการ',
        url: 'https://fix.24x.co.th/roof/booking',
        __v: 0,
        id: '6367dcbe6f10f9001b2ffe73',
      },
      __v: 1,
      image: {
        _id: '6367dc546f10f9001b2ffe6f',
        name: '24FIX_LD_BANNER-06.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_06_ec4550e53c',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 1101.97,
        width: 6001,
        height: 2634,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_06_ec4550e53c.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER-06.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_06_ec4550e53c',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 108,
            size: 6.65,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_06_ec4550e53c.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER-06.jpg',
            hash: 'large_24_FIX_LD_BANNER_06_ec4550e53c',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 439,
            size: 64.51,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_06_ec4550e53c.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER-06.jpg',
            hash: 'medium_24_FIX_LD_BANNER_06_ec4550e53c',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 329,
            size: 39.76,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_06_ec4550e53c.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER-06.jpg',
            hash: 'small_24_FIX_LD_BANNER_06_ec4550e53c',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 219,
            size: 20.84,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_06_ec4550e53c.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-11-06T16:09:56.451Z',
        updatedAt: '2022-11-06T16:42:58.599Z',
        __v: 0,
        id: '6367dc546f10f9001b2ffe6f',
      },
      mobileImage: {
        _id: '6367dc6b6f10f9001b2ffe70',
        name: '24FIX_LD_BANNER_MOBILE-06.jpg',
        alternativeText: '',
        caption: '',
        hash: '24_FIX_LD_BANNER_MOBILE_06_3f01f4ab7f',
        ext: '.jpg',
        mime: 'image/jpeg',
        size: 160.89,
        width: 1501,
        height: 930,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_LD_BANNER_MOBILE_06_3f01f4ab7f.jpg',
        formats: {
          thumbnail: {
            name: 'thumbnail_24FIX_LD_BANNER_MOBILE-06.jpg',
            hash: 'thumbnail_24_FIX_LD_BANNER_MOBILE_06_3f01f4ab7f',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 245,
            height: 152,
            size: 8.58,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_LD_BANNER_MOBILE_06_3f01f4ab7f.jpg',
          },
          large: {
            name: 'large_24FIX_LD_BANNER_MOBILE-06.jpg',
            hash: 'large_24_FIX_LD_BANNER_MOBILE_06_3f01f4ab7f',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 1000,
            height: 620,
            size: 83.64,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_LD_BANNER_MOBILE_06_3f01f4ab7f.jpg',
          },
          medium: {
            name: 'medium_24FIX_LD_BANNER_MOBILE-06.jpg',
            hash: 'medium_24_FIX_LD_BANNER_MOBILE_06_3f01f4ab7f',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 750,
            height: 465,
            size: 52.28,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_LD_BANNER_MOBILE_06_3f01f4ab7f.jpg',
          },
          small: {
            name: 'small_24FIX_LD_BANNER_MOBILE-06.jpg',
            hash: 'small_24_FIX_LD_BANNER_MOBILE_06_3f01f4ab7f',
            ext: '.jpg',
            mime: 'image/jpeg',
            width: 500,
            height: 310,
            size: 28.15,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_LD_BANNER_MOBILE_06_3f01f4ab7f.jpg',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-11-06T16:10:19.722Z',
        updatedAt: '2022-11-06T16:42:58.599Z',
        __v: 0,
        id: '6367dc6b6f10f9001b2ffe70',
      },
      id: '6367dcbe6f10f9001b2ffe72',
    },
    uspSection: [
      {
        _id: '6367dcbe6f10f9001b2ffe78',
        title: 'จบทุกปัญหาหลังคารั่วซึม ด้วยช่างหลังคามากประสบการณ์ ',
        subTitle:
          'บริการซ่อมหลังคารั่วซึมทุกรูปแบบจบปัญหาได้จริง รวมถึงต่อเติมหลังคาบ้านโดยช่างมืออาชีพ รับประกันทุกงานราคาเป็นกันเอง',
        description:
          '<p><strong>ทำไมต้องจองกับ 24FIX?</strong></p><ul><li>มีบริการหลังการขายและรับประกันสูงสุด 60 วัน</li><li>ทีมช่างเข้าตรวจหน้างานก่อนให้บริการภายใน 2 วัน</li><li>ราคางานซ่อมที่ได้มาตรฐาน คุ้มค่ากับคุณภาพบริการ</li></ul>',
        __v: 0,
        image: {
          _id: '6367dca56f10f9001b2ffe71',
          name: 'Service_Desktop-13.jpg',
          alternativeText: '',
          caption: '',
          hash: 'Service_Desktop_13_61bd572f49',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 288.48,
          width: 2121,
          height: 1425,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/Service_Desktop_13_61bd572f49.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_Service_Desktop-13.jpg',
              hash: 'thumbnail_Service_Desktop_13_61bd572f49',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 232,
              height: 156,
              size: 8.18,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_Service_Desktop_13_61bd572f49.jpg',
            },
            large: {
              name: 'large_Service_Desktop-13.jpg',
              hash: 'large_Service_Desktop_13_61bd572f49',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 1000,
              height: 672,
              size: 71.71,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/large_Service_Desktop_13_61bd572f49.jpg',
            },
            medium: {
              name: 'medium_Service_Desktop-13.jpg',
              hash: 'medium_Service_Desktop_13_61bd572f49',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 504,
              size: 46.67,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_Service_Desktop_13_61bd572f49.jpg',
            },
            small: {
              name: 'small_Service_Desktop-13.jpg',
              hash: 'small_Service_Desktop_13_61bd572f49',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 336,
              size: 25.26,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_Service_Desktop_13_61bd572f49.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-11-06T16:11:17.968Z',
          updatedAt: '2022-11-06T16:42:58.599Z',
          __v: 0,
          id: '6367dca56f10f9001b2ffe71',
        },
        id: '6367dcbe6f10f9001b2ffe78',
      },
    ],
    faqSection: [
      {
        _id: '63614a43b87e30001c208c96',
        question: 'ทำไมถึงต้องมีการสำรวจหน้างาน',
        answer:
          '<p>การสำรวจหน้างาน จะสามารถทำให้เราได้ร่วมวางแผนกับคุณลูกค้า เพื่อให้รายละเอียดงานครบถ้วนและอยู่ในงบประมาณที่ได้ตกลงกันไว้</p>',
        __v: 0,
        id: '63614a43b87e30001c208c96',
      },
      {
        _id: '63614a43b87e30001c208c97',
        question: 'บริการอะไรบ้างที่ต้องมีการสำรวจหน้างานก่อน',
        answer:
          '<p>งานซ่อมทุกประเภท เราจะแนะนำให้ตรวจหน้างานก่อน เพื่อป้องกันการผิดพลาดในการเตรียมอุปกรณ์ และการประเมิณราคา&nbsp;</p>',
        __v: 0,
        id: '63614a43b87e30001c208c97',
      },
      {
        _id: '63614a43b87e30001c208c98',
        question: 'ค่าใช้จ่ายในการสำรวจ นำมาเป็นส่วนลดได้ไหม',
        answer: '<p>ค่าสำรวจสามารถนำไปลดได้ต่อเมื่อยอดงานบริการ มากกว่า 3,000 บาทขึ้นไป</p>',
        __v: 0,
        id: '63614a43b87e30001c208c98',
      },
      {
        _id: '63614a43b87e30001c208c99',
        answer:
          '<p>ปัจจัยที่มีผลต่อราคาค่าบริการ มีดังนี้ครับ</p><ul><li>ข้อจำกัด สถานที่หน้างาน (ความสูงของบ้าน, พื้นที่สามารถวางบันไดได้หรือไม่)</li><li>ความเสียหายของหน้างาน</li><li>ประเภทหลังคา</li><li>ขนาดพื้นที่ในการบริการ (ยิ่งใหญ่ยิ่งถูก)</li></ul>',
        question: 'ปัจจัยที่มีผลต่อราคาค่าบริการ',
        __v: 0,
        id: '63614a43b87e30001c208c99',
      },
      {
        _id: '63614a43b87e30001c208c9a',
        question: 'มีการรับประกันอย่างไร',
        answer:
          '<p>การรับประกันงานผลงาน 60 วัน หลังจากการให้บริการ ทางบริษัทจะรับประกันผลงานที่เกิดจากการติดตั้ง (หลุดปลิว, รั่วซึม หรือบิดเบี้ยว) ตามขอบเขตการให้บริการในเอกสารเสนอราคาเท่านั้น</p>',
        __v: 0,
        id: '63614a43b87e30001c208c9a',
      },
      {
        _id: '63614a43b87e30001c208c9b',
        question: 'พื้นที่ที่ให้บริการมีอะไรบ้าง',
        answer: '<p>พื้นที่ให้บริการครอบคลุมในเขตกรุงเทพมหานคร นนทบุรี ปทุมธานี และสมุทรปราการ</p>',
        __v: 0,
        id: '63614a43b87e30001c208c9b',
      },
      {
        _id: '63614a43b87e30001c208c9c',
        answer:
          '<p>ซ่อมแซมหลังคาน้ำรั่วซึม<br>งานติดตั้ง เปลี่ยน หลังคาทุกประเภท\\</p><ul><li>รางน้ำฝน</li><li>แฟลชชิ่ง</li><li>ฉนวนกันความร้อน</li><li>ท่อระบายน้ำ</li></ul>',
        question: 'งานบริการหลังคา ครอบคลุมเรื่องอะไรบ้าง',
        __v: 0,
        id: '63614a43b87e30001c208c9c',
      },
      {
        _id: '63614a43b87e30001c208c9d',
        question: 'มีบริการจัดหาวัสดุด้วยไหม',
        answer:
          '<p>เรามีบริการจัดหาวัสดุให้ ถ้าทางลูกค้าไม่สะดวกจัดหาวัสดุเอง ซึ่งจะใช้ระยะเวลาในการจัดหาประมาณ 2 อาทิตย์ขึ้นไป&nbsp;</p>',
        __v: 0,
        id: '63614a43b87e30001c208c9d',
      },
      {
        _id: '63614a43b87e30001c208c9e',
        question: 'ราคาค่าบริการครอบคลุมอะไรบ้าง',
        answer:
          '<p>ค่าแรงและค่าวัสดุสิ้นเปลือง ซึ่งสามารถอ่านเพิ่มเติมได้จากหน้าบริการแต่ละการบริการเพิ่มเติมได้ ก่อนหน้าชำระค่าบริการ เช่น &nbsp;งานติดตั้งเพิ่มจุดปลั๊กไฟ ราคารวมค่าแรง และวัสดุดังต่อไปนี้</p>',
        __v: 0,
        id: '63614a43b87e30001c208c9e',
      },
      {
        _id: '63614a43b87e30001c208c9f',
        question: 'คิวเรียกช่างเร็วสุดเมื่อไหร่',
        answer:
          '<p>ช่างเข้าสำรวจหน้างานภายใน 2-3 วัน หลังอนุมัติงานสำรวจ และ 2 วันนับจากวันที่ลูกค้าชำระค่าบริการ</p>',
        __v: 0,
        id: '63614a43b87e30001c208c9f',
      },
      {
        _id: '63614a43b87e30001c208ca0',
        answer:
          '<p>ลูกค้าสามารถติดตามสถานะงานผ่านทางเว็บไซต์ได้ตลอดเวลา และยังสามารถใช้โค้ดส่วนลดสำหรับลูกค้าที่ซื้อผ่านบนเว็บไซต์อีกด้วย</p>',
        question: 'เรียกบริการผ่านเว็บไซต์ดีอย่างไร',
        __v: 0,
        id: '63614a43b87e30001c208ca0',
      },
      {
        _id: '63614a43b87e30001c208ca1',
        question: 'ใบเสนอราคาจะได้เมื่อไหร่ หลังจากที่ช่างเข้าสำรวจหน้างานเรียบร้อยแล้ว',
        answer:
          '<p>ใบเสนอราคาจะถูกส่งให้ลูกค้าตรวจสอบ ภายใน 24 ชม. หลังจากวันที่ช่างเข้าตรวจหน้างาน</p>',
        __v: 0,
        id: '63614a43b87e30001c208ca1',
      },
    ],
    promotionSection: {
      _id: '6367432d6f10f9001b2ffc0f',
      title: 'โปรโมชั่น',
      promotions: [
        {
          _id: '6367432d6f10f9001b2ffc10',
          url: 'https://fix.24x.co.th/voucher/firstfix-1',
          __v: 0,
          image: {
            _id: '637614b137fd76001b532030',
            name: '24FIX_NOV_BANNER4-02 (1).jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 94.2,
            width: 1500,
            height: 490,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 245,
                height: 80,
                size: 6.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              large: {
                name: 'large_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 327,
                size: 50.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              medium: {
                name: 'medium_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 245,
                size: 32.89,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
              small: {
                name: 'small_24FIX_NOV_BANNER4-02 (1).jpg',
                hash: 'small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 163,
                size: 18.03,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_4_02_1_76b86fc7ab.jpg',
              },
            },
            provider: 'aws-s3',
            related: ['636a17dc1e519e001c14731c'],
            createdAt: '2022-11-17T11:02:09.052Z',
            updatedAt: '2022-11-21T05:30:58.272Z',
            __v: 0,
            id: '637614b137fd76001b532030',
          },
          mobileImage: {
            _id: '636a6d86e6895d001ce68cc3',
            name: '24FIX_NOV_BANNER1-01.jpg',
            alternativeText: '',
            caption: '',
            hash: '24_FIX_NOV_BANNER_1_01_3663796871',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 149.63,
            width: 1500,
            height: 1021,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/24_FIX_NOV_BANNER_1_01_3663796871.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_24FIX_NOV_BANNER1-01.jpg',
                hash: 'thumbnail_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 229,
                height: 156,
                size: 8.94,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              large: {
                name: 'large_24FIX_NOV_BANNER1-01.jpg',
                hash: 'large_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 1000,
                height: 681,
                size: 78.97,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              medium: {
                name: 'medium_24FIX_NOV_BANNER1-01.jpg',
                hash: 'medium_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 511,
                size: 51.21,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
              small: {
                name: 'small_24FIX_NOV_BANNER1-01.jpg',
                hash: 'small_24_FIX_NOV_BANNER_1_01_3663796871',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 340,
                size: 27.91,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_FIX_NOV_BANNER_1_01_3663796871.jpg',
              },
            },
            provider: 'aws-s3',
            related: [],
            createdAt: '2022-11-08T14:53:58.508Z',
            updatedAt: '2022-11-08T16:06:16.745Z',
            __v: 0,
            id: '636a6d86e6895d001ce68cc3',
          },
          id: '6367432d6f10f9001b2ffc10',
        },
      ],
      __v: 1,
      button: null,
      id: '6367432d6f10f9001b2ffc0f',
    },
    stepSection: null,
    successStorySection: {
      contents: [
        {
          relatedArticles: [],
          categories: [
            '60d1fe825749bf001bbb11e4',
            '62a76933e9dde5001b3c6b15',
            '62de67ecb31a7a001bba2d60',
          ],
          _id: '60fef2feea7297001be8c5f3',
          title: 'รีวิวผลงานจริง ล้างแอร์บ้านคุณเมย์ รัชนก อินทนนท์',
          slug: 'pro-may-onsite-review',
          shortDescription:
            'เพราะประเทศไทยมีแต่ฤดูร้อน ร้อนมาก และร้อนที่สุด! ดังนั้นการดูแล ทำความสะอาด ล้างแอร์ ก็ควรทำอย่างสม่ำเสมอนะ\n#งานล้างแอร์ #ล้างแอร์ฆ่าเชื้อ #เมย์ รัชนก อินทนนท์ #แอร์ไม่เย็น #ตรวจสภาพแอร์ #ล้างแอร์ #ซ่อมแอร์ ',
          views: 3549,
          published_at: '2021-07-26T17:38:13.448Z',
          contents: [
            {
              __component: 'article.content',
              id: '60fef2feea7297001be8c5f4',
            },
            {
              __component: 'article.images',
              id: '60fef2feea7297001be8c5f5',
            },
            {
              __component: 'article.content',
              id: '60fef2feea7297001be8c5f6',
            },
            {
              __component: 'article.images',
              id: '60fef2feea7297001be8c5f7',
            },
            {
              __component: 'article.content',
              id: '62cd0500df69b2001b4a8f1a',
            },
            {
              __component: 'article.images',
              id: '62cd0687df69b2001b4a8f39',
            },
            {
              __component: 'article.content',
              id: '62cd0687df69b2001b4a8f3a',
            },
            {
              __component: 'article.images',
              id: '62cd0687df69b2001b4a8f3b',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fbc',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fbd',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fbe',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fbf',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc0',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc1',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc2',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc3',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc4',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc5',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc6',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc7',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fc8',
            },
            {
              __component: 'article.images',
              id: '62cd0a50df69b2001b4a8fc9',
            },
            {
              __component: 'article.content',
              id: '62cd0a50df69b2001b4a8fca',
            },
          ],
          link: null,
          createdAt: '2021-07-26T17:38:06.604Z',
          updatedAt: '2022-07-25T10:08:01.825Z',
          __v: 2,
          coverImage: {
            _id: '60feef59ea7297001be8c5ed',
            name: '20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
            alternativeText: '',
            caption: '',
            hash: '20210510_On_site_Review_Artboard_v2_e9212db564',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 657.65,
            width: 2501,
            height: 1667,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'thumbnail_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 12.97,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              large: {
                name: 'large_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'large_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 1000,
                height: 667,
                size: 146.8,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              medium: {
                name: 'medium_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'medium_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 750,
                height: 500,
                size: 92.52,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
              small: {
                name: 'small_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
                hash: 'small_20210510_On_site_Review_Artboard_v2_e9212db564',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 46.42,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['60fef2feea7297001be8c5f3'],
            createdAt: '2021-07-26T17:22:33.885Z',
            updatedAt: '2021-07-30T03:43:47.943Z',
            __v: 0,
            id: '60feef59ea7297001be8c5ed',
          },
          metadata: null,
          id: '60fef2feea7297001be8c5f3',
        },
        {
          relatedArticles: ['60fef2feea7297001be8c5f3', '62cd8d63df69b2001b4a9b5c'],
          categories: [
            '62a76933e9dde5001b3c6b15',
            '60d1fe825749bf001bbb11e4',
            '62de67ecb31a7a001bba2d60',
          ],
          _id: '62cda1d7df69b2001b4a9c2a',
          published_at: '2022-07-12T16:36:03.404Z',
          slug: '911-assistant-rama-ix-porsche-service',
          shortDescription:
            'คุณลูกค้าได้ติดต่อให้ช่างอุ่นใจเข้ามาตรวจสอบปัญหาชักโครกมีกลิ่นเเละน้ำรั่วซึม ซึ่งช่างอุ่นใจได้รับโจทย์ในงานซ่อมแบ่งเป็น 2 ส่วนได้แก่ การซ่อมโถชักโครกและโถปัสสาวะชาย\n#งานเปลี่ยนสุขภัณฑ์ #รีวิว #กลิ่นโถส้วม',
          views: 244,
          title: 'รีวิวผลงานจริง @911 ASSISTANT RAMA IX (Porsche Service)',
          contents: [
            {
              __component: 'article.content',
              id: '62cda1d7df69b2001b4a9c2b',
            },
            {
              __component: 'article.content',
              id: '62cda1d7df69b2001b4a9c2c',
            },
          ],
          link: null,
          createdAt: '2022-07-12T16:31:19.223Z',
          updatedAt: '2022-07-25T10:08:01.825Z',
          __v: 1,
          coverImage: {
            _id: '62cd994fdf69b2001b4a9bbe',
            name: '144302486_851532738754884_6271739837459506095_n (Small).jpg',
            alternativeText: '',
            caption: '',
            hash: '144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 75.25,
            width: 720,
            height: 480,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
            formats: {
              thumbnail: {
                name: 'thumbnail_144302486_851532738754884_6271739837459506095_n (Small).jpg',
                hash: 'thumbnail_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 11.42,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
              },
              small: {
                name: 'small_144302486_851532738754884_6271739837459506095_n (Small).jpg',
                hash: 'small_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 40.06,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
              },
            },
            provider: 'aws-s3',
            related: ['62cda1d7df69b2001b4a9c2a'],
            createdAt: '2022-07-12T15:54:55.834Z',
            updatedAt: '2022-07-12T16:31:19.369Z',
            __v: 0,
            id: '62cd994fdf69b2001b4a9bbe',
          },
          metadata: null,
          id: '62cda1d7df69b2001b4a9c2a',
        },
        {
          relatedArticles: ['60fef2feea7297001be8c5f3'],
          categories: ['60d1fe825749bf001bbb11e4', '62a76933e9dde5001b3c6b15'],
          _id: '60fef555ea7297001be8c617',
          published_at: '2021-07-26T17:58:58.311Z',
          slug: 'ac-with-installation',
          shortDescription:
            '#ซื้อแอร์วันนี้แถมฟรีติดตั้ง\n\n☀ ถ้าจะบอกว่าเมืองไทย ‘อากาศร้อน’ เฉพาะในช่วงหน้าร้อนก็คงจะไม่ถูก เพราะไม่ว่าฤดูไหนๆ จะร้อน หนาว ฝน อากาศก็ร้อนอยู่ดี!\nวันนี้มาดับร้อนกันดีกว่า ❄ ด้วยบริการซื้อแอร์พร้อมติดตั้งฟรี โดยทีมช่างมืออาชีพ 24 FIX 😊',
          title: 'บริการซื้อแอร์พร้อมติดตั้ง',
          contents: [
            {
              __component: 'article.content',
              id: '60fef7daea7297001be8c649',
            },
            {
              __component: 'article.images',
              id: '60fef7daea7297001be8c64a',
            },
          ],
          link: null,
          createdAt: '2021-07-26T17:48:05.531Z',
          updatedAt: '2022-07-13T05:50:55.237Z',
          __v: 0,
          views: 1124,
          coverImage: {
            _id: '60fef76eea7297001be8c634',
            name: '117956473_738009603440532_2359157732673622296_n.jpeg',
            alternativeText: '',
            caption: '',
            hash: '117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 253.58,
            width: 1801,
            height: 1201,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
            formats: {
              thumbnail: {
                name: 'thumbnail_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'thumbnail_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 8.33,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              large: {
                name: 'large_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'large_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 1000,
                height: 667,
                size: 83.31,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/large_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              medium: {
                name: 'medium_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'medium_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 750,
                height: 500,
                size: 50.16,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
              small: {
                name: 'small_117956473_738009603440532_2359157732673622296_n.jpeg',
                hash: 'small_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
                ext: '.jpeg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 26.25,
                path: null,
                url: 'https://d2jl6hozakvcbj.cloudfront.net/small_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
              },
            },
            provider: 'aws-s3',
            related: ['60fef555ea7297001be8c617'],
            createdAt: '2021-07-26T17:57:02.195Z',
            updatedAt: '2021-07-30T03:43:47.943Z',
            __v: 0,
            id: '60fef76eea7297001be8c634',
          },
          metadata: null,
          id: '60fef555ea7297001be8c617',
        },
      ],
      _id: '6368f0991e519e001c146fa1',
      title: 'ผลงานของเรา',
      __v: 0,
      button: null,
      id: '6368f0991e519e001c146fa1',
    },
    reviewSection: {
      _id: '6360094551f79b001dee994e',
      title: 'รีวิวจากผู้ใช้บริการของเรา',
      reviewContent: [
        {
          image: [
            {
              _id: '636737176f10f9001b2ff9f4',
              name: 'rn_image_picker_lib_temp_1b6adea3_2dd1_4dfe_a294_14cbe662ca18_9e87228ca8.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_1b6adea3_2dd1_4dfe_a294_14cbe662ca18_9e87228ca8_993a8f6c11',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 92.82,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_1b6adea3_2dd1_4dfe_a294_14cbe662ca18_9e87228ca8_993a8f6c11.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_1b6adea3_2dd1_4dfe_a294_14cbe662ca18_9e87228ca8.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_1b6adea3_2dd1_4dfe_a294_14cbe662ca18_9e87228ca8_993a8f6c11',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 4.79,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_1b6adea3_2dd1_4dfe_a294_14cbe662ca18_9e87228ca8_993a8f6c11.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_1b6adea3_2dd1_4dfe_a294_14cbe662ca18_9e87228ca8.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_1b6adea3_2dd1_4dfe_a294_14cbe662ca18_9e87228ca8_993a8f6c11',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 81.08,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_1b6adea3_2dd1_4dfe_a294_14cbe662ca18_9e87228ca8_993a8f6c11.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_1b6adea3_2dd1_4dfe_a294_14cbe662ca18_9e87228ca8.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_1b6adea3_2dd1_4dfe_a294_14cbe662ca18_9e87228ca8_993a8f6c11',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 36.74,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_1b6adea3_2dd1_4dfe_a294_14cbe662ca18_9e87228ca8_993a8f6c11.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:24:55.009Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636737176f10f9001b2ff9f4',
            },
            {
              _id: '636737176f10f9001b2ff9f5',
              name: 'rn_image_picker_lib_temp_776e6d25_246a_4ce7_9e3f_ccd66b797729_6413009e83.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_776e6d25_246a_4ce7_9e3f_ccd66b797729_6413009e83_74fba91aea',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 60.26,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_776e6d25_246a_4ce7_9e3f_ccd66b797729_6413009e83_74fba91aea.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_776e6d25_246a_4ce7_9e3f_ccd66b797729_6413009e83.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_776e6d25_246a_4ce7_9e3f_ccd66b797729_6413009e83_74fba91aea',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 4.23,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_776e6d25_246a_4ce7_9e3f_ccd66b797729_6413009e83_74fba91aea.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_776e6d25_246a_4ce7_9e3f_ccd66b797729_6413009e83.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_776e6d25_246a_4ce7_9e3f_ccd66b797729_6413009e83_74fba91aea',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 54.47,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_776e6d25_246a_4ce7_9e3f_ccd66b797729_6413009e83_74fba91aea.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_776e6d25_246a_4ce7_9e3f_ccd66b797729_6413009e83.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_776e6d25_246a_4ce7_9e3f_ccd66b797729_6413009e83_74fba91aea',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 27.41,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_776e6d25_246a_4ce7_9e3f_ccd66b797729_6413009e83_74fba91aea.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:24:55.059Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636737176f10f9001b2ff9f5',
            },
          ],
          _id: '6360094551f79b001dee9953',
          name: 'ธนัxxxx',
          description:
            'หาข้อมูลเรื่องช่างที่สามารถแก้ไขงานหลังคารั่วได้ แล้วมาเจอรีวิวของที่นี่ ดูมีความน่าเชื่อถือเลยติดต่อสอบถามเข้ามาเพื่อใช้บริการกับที่นี่ เจ้าหน้าที่ให้บริการและให้คำปรึกษาค่อนข้างดีครับ',
          score: 5,
          __v: 0,
          id: '6360094551f79b001dee9953',
        },
        {
          image: [
            {
              _id: '636737376f10f9001b2ff9f6',
              name: 'rn_image_picker_lib_temp_a8cc8a13_baa4_46fc_8047_ba6499652edd_9058a2d7d8.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_a8cc8a13_baa4_46fc_8047_ba6499652edd_9058a2d7d8_60fd5c7d11',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 33.23,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_a8cc8a13_baa4_46fc_8047_ba6499652edd_9058a2d7d8_60fd5c7d11.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_a8cc8a13_baa4_46fc_8047_ba6499652edd_9058a2d7d8.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_a8cc8a13_baa4_46fc_8047_ba6499652edd_9058a2d7d8_60fd5c7d11',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 2.2,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_a8cc8a13_baa4_46fc_8047_ba6499652edd_9058a2d7d8_60fd5c7d11.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_a8cc8a13_baa4_46fc_8047_ba6499652edd_9058a2d7d8.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_a8cc8a13_baa4_46fc_8047_ba6499652edd_9058a2d7d8_60fd5c7d11',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 29.9,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_a8cc8a13_baa4_46fc_8047_ba6499652edd_9058a2d7d8_60fd5c7d11.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_a8cc8a13_baa4_46fc_8047_ba6499652edd_9058a2d7d8.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_a8cc8a13_baa4_46fc_8047_ba6499652edd_9058a2d7d8_60fd5c7d11',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 13.94,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_a8cc8a13_baa4_46fc_8047_ba6499652edd_9058a2d7d8_60fd5c7d11.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:25:27.316Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636737376f10f9001b2ff9f6',
            },
            {
              _id: '636737376f10f9001b2ff9f7',
              name: 'rn_image_picker_lib_temp_e202c285_6e07_4a4c_a021_ad1977adc1f1_714629cdbb.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_e202c285_6e07_4a4c_a021_ad1977adc1f1_714629cdbb_8663245162',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 38.96,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_e202c285_6e07_4a4c_a021_ad1977adc1f1_714629cdbb_8663245162.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_e202c285_6e07_4a4c_a021_ad1977adc1f1_714629cdbb.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_e202c285_6e07_4a4c_a021_ad1977adc1f1_714629cdbb_8663245162',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.28,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_e202c285_6e07_4a4c_a021_ad1977adc1f1_714629cdbb_8663245162.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_e202c285_6e07_4a4c_a021_ad1977adc1f1_714629cdbb.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_e202c285_6e07_4a4c_a021_ad1977adc1f1_714629cdbb_8663245162',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 35.07,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_e202c285_6e07_4a4c_a021_ad1977adc1f1_714629cdbb_8663245162.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_e202c285_6e07_4a4c_a021_ad1977adc1f1_714629cdbb.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_e202c285_6e07_4a4c_a021_ad1977adc1f1_714629cdbb_8663245162',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 18.22,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_e202c285_6e07_4a4c_a021_ad1977adc1f1_714629cdbb_8663245162.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:25:27.346Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636737376f10f9001b2ff9f7',
            },
          ],
          _id: '6360094551f79b001dee9954',
          name: 'ปาลิxxxx',
          description: 'ช่างเชี่ยวชาญดีค่ะ  งานออกมาโอเคเลยค่ะ',
          score: 5,
          __v: 0,
          id: '6360094551f79b001dee9954',
        },
        {
          image: [
            {
              _id: '636737726f10f9001b2ff9f8',
              name: 'rn_image_picker_lib_temp_0c2518c8_508b_4974_8dda_1e5050ac997b_e7feb918a1.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_0c2518c8_508b_4974_8dda_1e5050ac997b_e7feb918a1_f79759cc0e',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 95.66,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_0c2518c8_508b_4974_8dda_1e5050ac997b_e7feb918a1_f79759cc0e.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_0c2518c8_508b_4974_8dda_1e5050ac997b_e7feb918a1.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_0c2518c8_508b_4974_8dda_1e5050ac997b_e7feb918a1_f79759cc0e',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 5.45,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_0c2518c8_508b_4974_8dda_1e5050ac997b_e7feb918a1_f79759cc0e.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_0c2518c8_508b_4974_8dda_1e5050ac997b_e7feb918a1.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_0c2518c8_508b_4974_8dda_1e5050ac997b_e7feb918a1_f79759cc0e',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 84.37,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_0c2518c8_508b_4974_8dda_1e5050ac997b_e7feb918a1_f79759cc0e.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_0c2518c8_508b_4974_8dda_1e5050ac997b_e7feb918a1.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_0c2518c8_508b_4974_8dda_1e5050ac997b_e7feb918a1_f79759cc0e',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 40.69,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_0c2518c8_508b_4974_8dda_1e5050ac997b_e7feb918a1_f79759cc0e.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:26:26.937Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636737726f10f9001b2ff9f8',
            },
            {
              _id: '636737726f10f9001b2ff9f9',
              name: 'rn_image_picker_lib_temp_58437c7e_6050_4fa6_8d62_9c8c87a38cf9_06e1e7a485.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_58437c7e_6050_4fa6_8d62_9c8c87a38cf9_06e1e7a485_7e7f1b183e',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 39.43,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_58437c7e_6050_4fa6_8d62_9c8c87a38cf9_06e1e7a485_7e7f1b183e.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_58437c7e_6050_4fa6_8d62_9c8c87a38cf9_06e1e7a485.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_58437c7e_6050_4fa6_8d62_9c8c87a38cf9_06e1e7a485_7e7f1b183e',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.41,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_58437c7e_6050_4fa6_8d62_9c8c87a38cf9_06e1e7a485_7e7f1b183e.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_58437c7e_6050_4fa6_8d62_9c8c87a38cf9_06e1e7a485.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_58437c7e_6050_4fa6_8d62_9c8c87a38cf9_06e1e7a485_7e7f1b183e',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 36.07,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_58437c7e_6050_4fa6_8d62_9c8c87a38cf9_06e1e7a485_7e7f1b183e.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_58437c7e_6050_4fa6_8d62_9c8c87a38cf9_06e1e7a485.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_58437c7e_6050_4fa6_8d62_9c8c87a38cf9_06e1e7a485_7e7f1b183e',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 18.93,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_58437c7e_6050_4fa6_8d62_9c8c87a38cf9_06e1e7a485_7e7f1b183e.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:26:26.984Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636737726f10f9001b2ff9f9',
            },
          ],
          _id: '6360094551f79b001dee9956',
          name: 'หัตxxxx',
          description:
            'เห็นรีวิวจากบนหน้าเพจค่ะ ช่างดูมีประสบการณ์ในเรื่องของการซ่อมหลังคารั่ว เลยตัดสินใจใช้บริการที่นี่ค่ะ',
          score: 4,
          __v: 0,
          id: '6360094551f79b001dee9956',
        },
        {
          image: [
            {
              _id: '636736e16f10f9001b2ff9f1',
              name: 'rn_image_picker_lib_temp_2722d1b5_ab0e_43eb_94a8_455bed308685_4884bd7aad.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_2722d1b5_ab0e_43eb_94a8_455bed308685_4884bd7aad_98fdad7243',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 55.04,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_2722d1b5_ab0e_43eb_94a8_455bed308685_4884bd7aad_98fdad7243.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_2722d1b5_ab0e_43eb_94a8_455bed308685_4884bd7aad.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_2722d1b5_ab0e_43eb_94a8_455bed308685_4884bd7aad_98fdad7243',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.69,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_2722d1b5_ab0e_43eb_94a8_455bed308685_4884bd7aad_98fdad7243.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_2722d1b5_ab0e_43eb_94a8_455bed308685_4884bd7aad.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_2722d1b5_ab0e_43eb_94a8_455bed308685_4884bd7aad_98fdad7243',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 48.67,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_2722d1b5_ab0e_43eb_94a8_455bed308685_4884bd7aad_98fdad7243.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_2722d1b5_ab0e_43eb_94a8_455bed308685_4884bd7aad.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_2722d1b5_ab0e_43eb_94a8_455bed308685_4884bd7aad_98fdad7243',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 23.57,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_2722d1b5_ab0e_43eb_94a8_455bed308685_4884bd7aad_98fdad7243.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:24:01.792Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636736e16f10f9001b2ff9f1',
            },
            {
              _id: '636736e16f10f9001b2ff9f2',
              name: 'rn_image_picker_lib_temp_71dd74ab_8c67_4ec2_bedc_9f5eaaa7fc58_2b074f231f.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_71dd74ab_8c67_4ec2_bedc_9f5eaaa7fc58_2b074f231f_05731d2eb5',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 46.54,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_71dd74ab_8c67_4ec2_bedc_9f5eaaa7fc58_2b074f231f_05731d2eb5.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_71dd74ab_8c67_4ec2_bedc_9f5eaaa7fc58_2b074f231f.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_71dd74ab_8c67_4ec2_bedc_9f5eaaa7fc58_2b074f231f_05731d2eb5',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 3.49,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_71dd74ab_8c67_4ec2_bedc_9f5eaaa7fc58_2b074f231f_05731d2eb5.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_71dd74ab_8c67_4ec2_bedc_9f5eaaa7fc58_2b074f231f.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_71dd74ab_8c67_4ec2_bedc_9f5eaaa7fc58_2b074f231f_05731d2eb5',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 43.16,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_71dd74ab_8c67_4ec2_bedc_9f5eaaa7fc58_2b074f231f_05731d2eb5.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_71dd74ab_8c67_4ec2_bedc_9f5eaaa7fc58_2b074f231f.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_71dd74ab_8c67_4ec2_bedc_9f5eaaa7fc58_2b074f231f_05731d2eb5',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 22.57,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_71dd74ab_8c67_4ec2_bedc_9f5eaaa7fc58_2b074f231f_05731d2eb5.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:24:01.817Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636736e16f10f9001b2ff9f2',
            },
          ],
          _id: '6360094551f79b001dee994f',
          name: 'ปานxxxxxx',
          description:
            'หลังคาที่บ้านรั่วแก้จากที่อื่นมาหลายครั้งแล้วไม่หาย เลยมาลองใช้บริการที่นี่ หลังคาไม่รั่วซ้ำแล้วค่ะ',
          score: 4,
          __v: 0,
          id: '6360094551f79b001dee994f',
        },
        {
          image: [
            {
              _id: '636736f96f10f9001b2ff9f3',
              name: 'rn_image_picker_lib_temp_dbb97718_8044_4c80_8452_c974b485fe21_e6c51922bd.jpeg',
              alternativeText: '',
              caption: '',
              hash: 'rn_image_picker_lib_temp_dbb97718_8044_4c80_8452_c974b485fe21_e6c51922bd_b5708cfba7',
              ext: '.jpeg',
              mime: 'image/jpeg',
              size: 51.39,
              width: 600,
              height: 800,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/rn_image_picker_lib_temp_dbb97718_8044_4c80_8452_c974b485fe21_e6c51922bd_b5708cfba7.jpeg',
              formats: {
                thumbnail: {
                  name: 'thumbnail_rn_image_picker_lib_temp_dbb97718_8044_4c80_8452_c974b485fe21_e6c51922bd.jpeg',
                  hash: 'thumbnail_rn_image_picker_lib_temp_dbb97718_8044_4c80_8452_c974b485fe21_e6c51922bd_b5708cfba7',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 117,
                  height: 156,
                  size: 4.15,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_rn_image_picker_lib_temp_dbb97718_8044_4c80_8452_c974b485fe21_e6c51922bd_b5708cfba7.jpeg',
                },
                medium: {
                  name: 'medium_rn_image_picker_lib_temp_dbb97718_8044_4c80_8452_c974b485fe21_e6c51922bd.jpeg',
                  hash: 'medium_rn_image_picker_lib_temp_dbb97718_8044_4c80_8452_c974b485fe21_e6c51922bd_b5708cfba7',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 563,
                  height: 750,
                  size: 46.86,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_rn_image_picker_lib_temp_dbb97718_8044_4c80_8452_c974b485fe21_e6c51922bd_b5708cfba7.jpeg',
                },
                small: {
                  name: 'small_rn_image_picker_lib_temp_dbb97718_8044_4c80_8452_c974b485fe21_e6c51922bd.jpeg',
                  hash: 'small_rn_image_picker_lib_temp_dbb97718_8044_4c80_8452_c974b485fe21_e6c51922bd_b5708cfba7',
                  ext: '.jpeg',
                  mime: 'image/jpeg',
                  width: 375,
                  height: 500,
                  size: 24.68,
                  path: null,
                  url: 'https://d2jl6hozakvcbj.cloudfront.net/small_rn_image_picker_lib_temp_dbb97718_8044_4c80_8452_c974b485fe21_e6c51922bd_b5708cfba7.jpeg',
                },
              },
              provider: 'aws-s3',
              related: [],
              createdAt: '2022-11-06T04:24:25.062Z',
              updatedAt: '2022-11-06T16:42:58.599Z',
              __v: 0,
              id: '636736f96f10f9001b2ff9f3',
            },
          ],
          _id: '6360094551f79b001dee9950',
          name: 'พงศ์xxxxxx',
          description: 'ช่างพูดจาดี ทำงานเรียบร้อยดีครับ',
          score: 5,
          __v: 0,
          id: '6360094551f79b001dee9950',
        },
        {
          image: [],
          _id: '6360094551f79b001dee9951',
          name: 'มนัสxxxxxx',
          description: 'รางน้ำฝนที่บ้านตันค่ะ เลยเรียกใช้บริการช่างจากที่นี่ บริการดีค่ะ',
          score: 4,
          __v: 0,
          id: '6360094551f79b001dee9951',
        },
        {
          image: [],
          _id: '6360094551f79b001dee9952',
          name: 'โชติxxxx',
          description: 'พนักงานให้คำปรึกษาดีค่ะ ช่างเก็บงานเรียบร้อยค่ะ',
          score: 5,
          __v: 0,
          id: '6360094551f79b001dee9952',
        },
        {
          image: [],
          _id: '6360094551f79b001dee9955',
          name: 'วรxxxx',
          description: 'ราคาค่อนข้างดี เลยใช้บริการกับที่นี่ ถูกกว่าเจ้าอื่นๆ ครับ',
          score: 4,
          __v: 0,
          id: '6360094551f79b001dee9955',
        },
        {
          image: [],
          _id: '6360094551f79b001dee9957',
          name: 'กฤตxxxx',
          description:
            'แอดมินให้คำปรึกษาดีครับ ช่างเข้ามาแก้ไขงานหลังคารั่วให้ที่บ้าน เข้างานตรงเวลา ทำงานเรียบร้อยครับ',
          score: 5,
          __v: 0,
          id: '6360094551f79b001dee9957',
        },
        {
          image: [],
          _id: '6360094551f79b001dee9958',
          name: 'ไตรxxxx',
          description:
            'ช่วงหน้าฝนฝนตกหนักมากๆๆ ครับ ฝ้าที่ชั้นสองภายในบ้านเลยรั่ว แต่หาจุดเองไม่เจอ เลยเรียกช่างมาสำรวจหน้างานให้ที่บ้าน ช่างมีอุปกรณ์ค่อนข้างครบในการตรวจสอบ พอสำรวจหน้างานแล้วเจ้าหน้าที่ก็ประสานต่อให้ นัดวันเวลาให้ช่างเข้ามาซ่อม ใช้เวลาไม่นานช่างก็มาซ่อมให้ ตอนนี้ฝ้าไม่รั่วแล้วครับ เยี่ยมมากครับ',
          score: 4,
          __v: 0,
          id: '6360094551f79b001dee9958',
        },
      ],
      __v: 1,
      id: '6360094551f79b001dee994e',
    },
    ctaSection: {
      _id: '6367dcbe6f10f9001b2ffe94',
      title: '<p>จบทุกปัญหาหลังคา ด้วยทีมช่างมากประสบการณ์&nbsp;</p>',
      button: {
        _id: '6367dcbe6f10f9001b2ffe95',
        url: 'https://fix.24x.co.th/roof/booking',
        title: 'จองบริการ',
        __v: 0,
        id: '6367dcbe6f10f9001b2ffe95',
      },
      __v: 1,
      id: '6367dcbe6f10f9001b2ffe94',
    },
    createdAt: '2022-10-31T17:43:33.897Z',
    updatedAt: '2023-01-11T09:50:04.917Z',
    __v: 1,
    metadata: {
      twitterCardType: 'summary',
      _id: '63bd06f9c37f54001cf15cd6',
      metaTitle: 'จบทุกปัญหาหลังคา',
      metaDescription:
        'บริการซ่อมหลังคารั่วซึมทุกรูปแบบจบปัญหาได้จริง รวมถึงต่อเติมหลังคาบ้านโดยช่างมืออาชีพ รับประกันทุกงานราคาเป็นกันเอง',
      keywords:
        'ซ่อม หลังคา, ซ่อม หลังคา รั่ว, ช่าง ซ่อม หลังคา, ซ่อม หลังคา รั่ว ราคา, ซ่อม หลังคา รั่ว ราคา pantip, ซ่อม หลังคา รั่ว โฮม โปร, ช่าง ซ่อม หลังคา ใกล้ ฉัน, แก้ หลังคา รั่ว, ซ่อม หลังคา บ้าน',
      __v: 0,
      id: '63bd06f9c37f54001cf15cd6',
    },
    installationSection: null,
    id: '6360094551f79b001dee994d',
  },
]
